window.solutionsData1 = {
    "nm": "Animation F",
    "ddd": 0,
    "h": 732,
    "w": 764,
    "meta": {
        "g": "@lottiefiles/toolkit-js 0.76.0"
    },
    "layers": [
        {
            "ty": 0,
            "nm": "Loading",
            "sr": 1,
            "st": 0,
            "op": 18001,
            "ip": 0,
            "ln": "230",
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100
                    ]
                },
                "p": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "r": {
                    "a": 0,
                    "k": 0
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 0,
                    "k": 100
                }
            },
            "w": 764,
            "h": 732,
            "refId": "1",
            "ind": 1
        },
        {
            "ty": 0,
            "nm": "Tags",
            "sr": 1,
            "st": 87,
            "op": 18088,
            "ip": 87,
            "ln": "229",
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100
                    ]
                },
                "p": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "r": {
                    "a": 0,
                    "k": 0
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 0,
                    "k": 100
                }
            },
            "w": 764,
            "h": 732,
            "refId": "2",
            "ind": 2
        },
        {
            "ty": 0,
            "nm": "Window",
            "sr": 1,
            "st": 0,
            "op": 18001,
            "ip": 0,
            "ln": "228",
            "hasMask": false,
            "ao": 0,
            "ks": {
                "a": {
                    "a": 0,
                    "k": [
                        278,
                        266
                    ]
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100
                    ]
                },
                "p": {
                    "a": 0,
                    "k": [
                        382,
                        366
                    ]
                },
                "r": {
                    "a": 0,
                    "k": 0
                },
                "sa": {
                    "a": 0,
                    "k": 0
                },
                "o": {
                    "a": 0,
                    "k": 100
                }
            },
            "w": 556,
            "h": 532,
            "refId": "5",
            "ind": 3
        }
    ],
    "v": "5.7.0",
    "fr": 30,
    "op": 120,
    "ip": 0,
    "assets": [
        {
            "nm": "Loadinf",
            "id": "1",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Shape Layer 9",
                    "sr": 1,
                    "st": -108,
                    "op": 89,
                    "ip": 1,
                    "ln": "214",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                212.087,
                                124.589
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                576.087,
                                492.089
                            ]
                        },
                        "r": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        0
                                    ],
                                    "t": 0.999
                                },
                                {
                                    "s": [
                                        207.82
                                    ],
                                    "t": 92.998
                                }
                            ]
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Ellipse 1",
                            "it": [
                                {
                                    "ty": "el",
                                    "nm": "Ellipse Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            30.939,
                                            30.939
                                        ]
                                    }
                                },
                                {
                                    "ty": "tm",
                                    "nm": "Trim Paths 1",
                                    "e": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    0
                                                ],
                                                "t": 2.999
                                            },
                                            {
                                                "s": [
                                                    100
                                                ],
                                                "t": 68.999
                                            }
                                        ]
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    0
                                                ],
                                                "t": 19.999
                                            },
                                            {
                                                "s": [
                                                    100
                                                ],
                                                "t": 87.998
                                            }
                                        ]
                                    },
                                    "m": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 2",
                                    "lc": 2,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 3
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            212.087,
                                            124.589
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 8",
                    "sr": 1,
                    "st": -108,
                    "op": 89,
                    "ip": 1,
                    "ln": "213",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                212.087,
                                124.589
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                576.087,
                                432.089
                            ]
                        },
                        "r": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        0
                                    ],
                                    "t": 0.999
                                },
                                {
                                    "s": [
                                        207.82
                                    ],
                                    "t": 92.998
                                }
                            ]
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Ellipse 1",
                            "it": [
                                {
                                    "ty": "el",
                                    "nm": "Ellipse Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            30.939,
                                            30.939
                                        ]
                                    }
                                },
                                {
                                    "ty": "tm",
                                    "nm": "Trim Paths 1",
                                    "e": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    0
                                                ],
                                                "t": 2.999
                                            },
                                            {
                                                "s": [
                                                    100
                                                ],
                                                "t": 68.999
                                            }
                                        ]
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    0
                                                ],
                                                "t": 19.999
                                            },
                                            {
                                                "s": [
                                                    100
                                                ],
                                                "t": 87.998
                                            }
                                        ]
                                    },
                                    "m": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 2",
                                    "lc": 2,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 3
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            212.087,
                                            124.589
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 2
                },
                {
                    "ty": 4,
                    "nm": "Shape Layer 7",
                    "sr": 1,
                    "st": -108,
                    "op": 89,
                    "ip": 1,
                    "ln": "212",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                212.087,
                                124.589
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                576.087,
                                369.589
                            ]
                        },
                        "r": {
                            "a": 1,
                            "k": [
                                {
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "s": [
                                        0
                                    ],
                                    "t": 0.999
                                },
                                {
                                    "s": [
                                        207.82
                                    ],
                                    "t": 92.998
                                }
                            ]
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Ellipse 1",
                            "it": [
                                {
                                    "ty": "el",
                                    "nm": "Ellipse Path 1",
                                    "d": 1,
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            30.939,
                                            30.939
                                        ]
                                    }
                                },
                                {
                                    "ty": "tm",
                                    "nm": "Trim Paths 1",
                                    "e": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    0
                                                ],
                                                "t": 2.999
                                            },
                                            {
                                                "s": [
                                                    100
                                                ],
                                                "t": 68.999
                                            }
                                        ]
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "o": {
                                                    "x": 0.167,
                                                    "y": 0.167
                                                },
                                                "i": {
                                                    "x": 0.833,
                                                    "y": 0.833
                                                },
                                                "s": [
                                                    0
                                                ],
                                                "t": 19.999
                                            },
                                            {
                                                "s": [
                                                    100
                                                ],
                                                "t": 87.998
                                            }
                                        ]
                                    },
                                    "m": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 2",
                                    "lc": 2,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 3
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            212.087,
                                            124.589
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 3
                }
            ]
        },
        {
            "nm": "Tags",
            "id": "2",
            "fr": 30,
            "layers": [
                {
                    "ty": 0,
                    "nm": "Frame 1948758193.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "181",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                45,
                                17
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                574,
                                429.46
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 90,
                    "h": 34,
                    "refId": "3",
                    "ind": 1
                },
                {
                    "ty": 0,
                    "nm": "Frame 1948758193.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "180",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                45,
                                17
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                574,
                                369.855
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 90,
                    "h": 34,
                    "refId": "3",
                    "ind": 2
                },
                {
                    "ty": 0,
                    "nm": "Frame 1948758195.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "179",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                45.5,
                                17
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                574.5,
                                490.582
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "w": 91,
                    "h": 34,
                    "refId": "4",
                    "ind": 3
                }
            ]
        },
        {
            "nm": "Frame 1948758193.svg",
            "id": "3",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Frame 1948758193.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "66",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                45,
                                17
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                45,
                                17
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -33.827,
                                                    6.282
                                                ],
                                                [
                                                    -29.219,
                                                    -6.498
                                                ],
                                                [
                                                    -26.357,
                                                    -6.498
                                                ],
                                                [
                                                    -21.749,
                                                    6.282
                                                ],
                                                [
                                                    -24.197,
                                                    6.282
                                                ],
                                                [
                                                    -25.259,
                                                    3.258
                                                ],
                                                [
                                                    -30.317,
                                                    3.258
                                                ],
                                                [
                                                    -31.379,
                                                    6.282
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -29.633,
                                                    1.26
                                                ],
                                                [
                                                    -25.943,
                                                    1.26
                                                ],
                                                [
                                                    -27.779,
                                                    -4.14
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    0.36
                                                ],
                                                [
                                                    0,
                                                    0.792
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.12,
                                                    -0.12
                                                ],
                                                [
                                                    -0.228,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.696,
                                                    0
                                                ],
                                                [
                                                    -0.42,
                                                    -0.36
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.24
                                                ],
                                                [
                                                    0.132,
                                                    0.12
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -18.283,
                                                    6.282
                                                ],
                                                [
                                                    -19.957,
                                                    5.742
                                                ],
                                                [
                                                    -20.587,
                                                    4.014
                                                ],
                                                [
                                                    -20.587,
                                                    -6.498
                                                ],
                                                [
                                                    -18.283,
                                                    -6.498
                                                ],
                                                [
                                                    -18.283,
                                                    3.78
                                                ],
                                                [
                                                    -18.103,
                                                    4.32
                                                ],
                                                [
                                                    -17.563,
                                                    4.5
                                                ],
                                                [
                                                    -16.861,
                                                    4.5
                                                ],
                                                [
                                                    -16.861,
                                                    6.282
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    0.36
                                                ],
                                                [
                                                    0,
                                                    0.792
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.12,
                                                    -0.12
                                                ],
                                                [
                                                    -0.228,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.696,
                                                    0
                                                ],
                                                [
                                                    -0.42,
                                                    -0.36
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.24
                                                ],
                                                [
                                                    0.132,
                                                    0.12
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -13.115,
                                                    6.282
                                                ],
                                                [
                                                    -14.789,
                                                    5.742
                                                ],
                                                [
                                                    -15.419,
                                                    4.014
                                                ],
                                                [
                                                    -15.419,
                                                    -6.498
                                                ],
                                                [
                                                    -13.115,
                                                    -6.498
                                                ],
                                                [
                                                    -13.115,
                                                    3.78
                                                ],
                                                [
                                                    -12.935,
                                                    4.32
                                                ],
                                                [
                                                    -12.395,
                                                    4.5
                                                ],
                                                [
                                                    -11.693,
                                                    4.5
                                                ],
                                                [
                                                    -11.693,
                                                    6.282
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.948,
                                                    0
                                                ],
                                                [
                                                    0.72,
                                                    0.408
                                                ],
                                                [
                                                    0.396,
                                                    0.756
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    -0.384,
                                                    0.744
                                                ],
                                                [
                                                    -0.708,
                                                    0.408
                                                ],
                                                [
                                                    -0.948,
                                                    0
                                                ],
                                                [
                                                    -0.708,
                                                    -0.42
                                                ],
                                                [
                                                    -0.384,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.02
                                                ],
                                                [
                                                    0.396,
                                                    -0.756
                                                ],
                                                [
                                                    0.708,
                                                    -0.42
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.948,
                                                    0
                                                ],
                                                [
                                                    -0.708,
                                                    -0.42
                                                ],
                                                [
                                                    -0.384,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.02
                                                ],
                                                [
                                                    0.396,
                                                    -0.756
                                                ],
                                                [
                                                    0.72,
                                                    -0.42
                                                ],
                                                [
                                                    0.948,
                                                    0
                                                ],
                                                [
                                                    0.708,
                                                    0.408
                                                ],
                                                [
                                                    0.396,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    -0.384,
                                                    0.756
                                                ],
                                                [
                                                    -0.708,
                                                    0.408
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -6.04,
                                                    6.498
                                                ],
                                                [
                                                    -8.542,
                                                    5.886
                                                ],
                                                [
                                                    -10.198,
                                                    4.122
                                                ],
                                                [
                                                    -10.774,
                                                    1.476
                                                ],
                                                [
                                                    -10.198,
                                                    -1.17
                                                ],
                                                [
                                                    -8.542,
                                                    -2.916
                                                ],
                                                [
                                                    -6.04,
                                                    -3.546
                                                ],
                                                [
                                                    -3.556,
                                                    -2.916
                                                ],
                                                [
                                                    -1.918,
                                                    -1.17
                                                ],
                                                [
                                                    -1.324,
                                                    1.476
                                                ],
                                                [
                                                    -1.918,
                                                    4.122
                                                ],
                                                [
                                                    -3.556,
                                                    5.886
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.744,
                                                    0
                                                ],
                                                [
                                                    -0.396,
                                                    0.552
                                                ],
                                                [
                                                    0,
                                                    0.996
                                                ],
                                                [
                                                    0.408,
                                                    0.552
                                                ],
                                                [
                                                    0.744,
                                                    0
                                                ],
                                                [
                                                    0.408,
                                                    -0.564
                                                ],
                                                [
                                                    0,
                                                    -0.984
                                                ],
                                                [
                                                    -0.408,
                                                    -0.552
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.744,
                                                    0
                                                ],
                                                [
                                                    0.408,
                                                    -0.552
                                                ],
                                                [
                                                    0,
                                                    -0.984
                                                ],
                                                [
                                                    -0.396,
                                                    -0.564
                                                ],
                                                [
                                                    -0.744,
                                                    0
                                                ],
                                                [
                                                    -0.408,
                                                    0.552
                                                ],
                                                [
                                                    0,
                                                    0.996
                                                ],
                                                [
                                                    0.408,
                                                    0.552
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -6.04,
                                                    4.626
                                                ],
                                                [
                                                    -4.33,
                                                    3.798
                                                ],
                                                [
                                                    -3.718,
                                                    1.476
                                                ],
                                                [
                                                    -4.33,
                                                    -0.828
                                                ],
                                                [
                                                    -6.04,
                                                    -1.674
                                                ],
                                                [
                                                    -7.768,
                                                    -0.828
                                                ],
                                                [
                                                    -8.38,
                                                    1.476
                                                ],
                                                [
                                                    -7.768,
                                                    3.798
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.136,
                                                    6.282
                                                ],
                                                [
                                                    -0.762,
                                                    -3.33
                                                ],
                                                [
                                                    1.596,
                                                    -3.33
                                                ],
                                                [
                                                    3.468,
                                                    3.672
                                                ],
                                                [
                                                    5.394,
                                                    -3.33
                                                ],
                                                [
                                                    7.41,
                                                    -3.33
                                                ],
                                                [
                                                    9.354,
                                                    3.672
                                                ],
                                                [
                                                    11.226,
                                                    -3.33
                                                ],
                                                [
                                                    13.584,
                                                    -3.33
                                                ],
                                                [
                                                    10.686,
                                                    6.282
                                                ],
                                                [
                                                    8.31,
                                                    6.282
                                                ],
                                                [
                                                    6.402,
                                                    -0.162
                                                ],
                                                [
                                                    4.512,
                                                    6.282
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.104,
                                                    0
                                                ],
                                                [
                                                    0.708,
                                                    0.408
                                                ],
                                                [
                                                    0.384,
                                                    0.756
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    -0.384,
                                                    0.744
                                                ],
                                                [
                                                    -0.696,
                                                    0.42
                                                ],
                                                [
                                                    -0.936,
                                                    0
                                                ],
                                                [
                                                    -0.684,
                                                    -0.408
                                                ],
                                                [
                                                    -0.372,
                                                    -0.768
                                                ],
                                                [
                                                    0,
                                                    -1.08
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.408,
                                                    -0.432
                                                ],
                                                [
                                                    -0.684,
                                                    0
                                                ],
                                                [
                                                    -0.336,
                                                    0.228
                                                ],
                                                [
                                                    -0.132,
                                                    0.42
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.78,
                                                    -0.54
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.96,
                                                    0
                                                ],
                                                [
                                                    -0.708,
                                                    -0.42
                                                ],
                                                [
                                                    -0.384,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.008
                                                ],
                                                [
                                                    0.384,
                                                    -0.756
                                                ],
                                                [
                                                    0.708,
                                                    -0.42
                                                ],
                                                [
                                                    0.912,
                                                    0
                                                ],
                                                [
                                                    0.696,
                                                    0.408
                                                ],
                                                [
                                                    0.372,
                                                    0.768
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.048,
                                                    0.84
                                                ],
                                                [
                                                    0.42,
                                                    0.42
                                                ],
                                                [
                                                    0.516,
                                                    0
                                                ],
                                                [
                                                    0.348,
                                                    -0.24
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.264,
                                                    0.936
                                                ],
                                                [
                                                    -0.768,
                                                    0.54
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.868,
                                                    6.498
                                                ],
                                                [
                                                    16.366,
                                                    5.886
                                                ],
                                                [
                                                    14.728,
                                                    4.122
                                                ],
                                                [
                                                    14.152,
                                                    1.476
                                                ],
                                                [
                                                    14.728,
                                                    -1.152
                                                ],
                                                [
                                                    16.348,
                                                    -2.916
                                                ],
                                                [
                                                    18.814,
                                                    -3.546
                                                ],
                                                [
                                                    21.208,
                                                    -2.934
                                                ],
                                                [
                                                    22.81,
                                                    -1.17
                                                ],
                                                [
                                                    23.368,
                                                    1.602
                                                ],
                                                [
                                                    23.368,
                                                    2.124
                                                ],
                                                [
                                                    16.546,
                                                    2.124
                                                ],
                                                [
                                                    17.23,
                                                    4.032
                                                ],
                                                [
                                                    18.886,
                                                    4.662
                                                ],
                                                [
                                                    20.164,
                                                    4.32
                                                ],
                                                [
                                                    20.884,
                                                    3.33
                                                ],
                                                [
                                                    23.242,
                                                    3.474
                                                ],
                                                [
                                                    21.676,
                                                    5.688
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.096,
                                                    -0.744
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.396,
                                                    0.372
                                                ],
                                                [
                                                    0.612,
                                                    0
                                                ],
                                                [
                                                    0.408,
                                                    -0.396
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.048,
                                                    -0.78
                                                ],
                                                [
                                                    -0.396,
                                                    -0.384
                                                ],
                                                [
                                                    -0.612,
                                                    0
                                                ],
                                                [
                                                    -0.396,
                                                    0.396
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    16.546,
                                                    0.576
                                                ],
                                                [
                                                    20.992,
                                                    0.576
                                                ],
                                                [
                                                    20.326,
                                                    -1.152
                                                ],
                                                [
                                                    18.814,
                                                    -1.728
                                                ],
                                                [
                                                    17.284,
                                                    -1.134
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.6,
                                                    0.408
                                                ],
                                                [
                                                    0.324,
                                                    0.756
                                                ],
                                                [
                                                    0,
                                                    1.02
                                                ],
                                                [
                                                    -0.324,
                                                    0.756
                                                ],
                                                [
                                                    -0.6,
                                                    0.408
                                                ],
                                                [
                                                    -0.804,
                                                    0
                                                ],
                                                [
                                                    -0.504,
                                                    -0.276
                                                ],
                                                [
                                                    -0.264,
                                                    -0.504
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.528,
                                                    -0.288
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.816,
                                                    0
                                                ],
                                                [
                                                    -0.588,
                                                    -0.408
                                                ],
                                                [
                                                    -0.324,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.02
                                                ],
                                                [
                                                    0.324,
                                                    -0.756
                                                ],
                                                [
                                                    0.6,
                                                    -0.408
                                                ],
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.516,
                                                    0.276
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.264,
                                                    0.516
                                                ],
                                                [
                                                    -0.528,
                                                    0.288
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    28.589,
                                                    6.498
                                                ],
                                                [
                                                    26.465,
                                                    5.886
                                                ],
                                                [
                                                    25.097,
                                                    4.14
                                                ],
                                                [
                                                    24.611,
                                                    1.476
                                                ],
                                                [
                                                    25.097,
                                                    -1.188
                                                ],
                                                [
                                                    26.483,
                                                    -2.934
                                                ],
                                                [
                                                    28.589,
                                                    -3.546
                                                ],
                                                [
                                                    30.353,
                                                    -3.132
                                                ],
                                                [
                                                    31.523,
                                                    -1.962
                                                ],
                                                [
                                                    31.523,
                                                    -6.498
                                                ],
                                                [
                                                    33.827,
                                                    -6.498
                                                ],
                                                [
                                                    33.827,
                                                    6.282
                                                ],
                                                [
                                                    31.631,
                                                    6.282
                                                ],
                                                [
                                                    31.577,
                                                    4.86
                                                ],
                                                [
                                                    30.389,
                                                    6.066
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.696,
                                                    0
                                                ],
                                                [
                                                    -0.324,
                                                    0.24
                                                ],
                                                [
                                                    -0.168,
                                                    0.468
                                                ],
                                                [
                                                    0,
                                                    0.672
                                                ],
                                                [
                                                    0.18,
                                                    0.468
                                                ],
                                                [
                                                    0.336,
                                                    0.24
                                                ],
                                                [
                                                    0.48,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    -0.564
                                                ],
                                                [
                                                    0,
                                                    -0.984
                                                ],
                                                [
                                                    -0.408,
                                                    -0.576
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.48,
                                                    0
                                                ],
                                                [
                                                    0.336,
                                                    -0.24
                                                ],
                                                [
                                                    0.18,
                                                    -0.48
                                                ],
                                                [
                                                    0,
                                                    -0.684
                                                ],
                                                [
                                                    -0.168,
                                                    -0.468
                                                ],
                                                [
                                                    -0.324,
                                                    -0.24
                                                ],
                                                [
                                                    -0.696,
                                                    0
                                                ],
                                                [
                                                    -0.408,
                                                    0.552
                                                ],
                                                [
                                                    0,
                                                    0.96
                                                ],
                                                [
                                                    0.42,
                                                    0.564
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29.291,
                                                    4.626
                                                ],
                                                [
                                                    30.497,
                                                    4.266
                                                ],
                                                [
                                                    31.253,
                                                    3.204
                                                ],
                                                [
                                                    31.523,
                                                    1.476
                                                ],
                                                [
                                                    31.253,
                                                    -0.252
                                                ],
                                                [
                                                    30.497,
                                                    -1.314
                                                ],
                                                [
                                                    29.291,
                                                    -1.674
                                                ],
                                                [
                                                    27.617,
                                                    -0.828
                                                ],
                                                [
                                                    27.005,
                                                    1.476
                                                ],
                                                [
                                                    27.617,
                                                    3.78
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.1373,
                                            0.6235,
                                            0.0039
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            44.169,
                                            16.718
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -9.389,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -9.389
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    9.389,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    9.389
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    9.389,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    9.389
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -9.389,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -9.389
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -28,
                                                    -17
                                                ],
                                                [
                                                    28,
                                                    -17
                                                ],
                                                [
                                                    45,
                                                    0
                                                ],
                                                [
                                                    45,
                                                    0
                                                ],
                                                [
                                                    28,
                                                    17
                                                ],
                                                [
                                                    -28,
                                                    17
                                                ],
                                                [
                                                    -45,
                                                    0
                                                ],
                                                [
                                                    -45,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.949,
                                            1,
                                            0.9333
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            45,
                                            17
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                }
            ]
        },
        {
            "nm": "Frame 1948758195.svg",
            "id": "4",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "Frame 1948758195.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "53",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                45.5,
                                17
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                45.5,
                                17
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.804,
                                                    -0.552
                                                ],
                                                [
                                                    0,
                                                    -1.2
                                                ],
                                                [
                                                    0.228,
                                                    -0.408
                                                ],
                                                [
                                                    0.432,
                                                    -0.228
                                                ],
                                                [
                                                    0.6,
                                                    -0.024
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.588,
                                                    -0.564
                                                ],
                                                [
                                                    0,
                                                    -0.924
                                                ],
                                                [
                                                    0.816,
                                                    -0.588
                                                ],
                                                [
                                                    1.488,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.56,
                                                    0
                                                ],
                                                [
                                                    0.816,
                                                    0.552
                                                ],
                                                [
                                                    0,
                                                    0.54
                                                ],
                                                [
                                                    -0.216,
                                                    0.396
                                                ],
                                                [
                                                    -0.42,
                                                    0.228
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.092,
                                                    0.036
                                                ],
                                                [
                                                    0.588,
                                                    0.552
                                                ],
                                                [
                                                    0,
                                                    1.176
                                                ],
                                                [
                                                    -0.804,
                                                    0.576
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -33.726,
                                                    6.282
                                                ],
                                                [
                                                    -33.726,
                                                    -6.498
                                                ],
                                                [
                                                    -28.938,
                                                    -6.498
                                                ],
                                                [
                                                    -25.392,
                                                    -5.67
                                                ],
                                                [
                                                    -24.168,
                                                    -3.042
                                                ],
                                                [
                                                    -24.51,
                                                    -1.62
                                                ],
                                                [
                                                    -25.482,
                                                    -0.684
                                                ],
                                                [
                                                    -27.012,
                                                    -0.306
                                                ],
                                                [
                                                    -27.03,
                                                    -0.342
                                                ],
                                                [
                                                    -24.51,
                                                    0.558
                                                ],
                                                [
                                                    -23.628,
                                                    2.772
                                                ],
                                                [
                                                    -24.852,
                                                    5.418
                                                ],
                                                [
                                                    -28.29,
                                                    6.282
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.42,
                                                    0.3
                                                ],
                                                [
                                                    0,
                                                    0.588
                                                ],
                                                [
                                                    0.42,
                                                    0.312
                                                ],
                                                [
                                                    0.744,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.732,
                                                    0
                                                ],
                                                [
                                                    0.432,
                                                    -0.3
                                                ],
                                                [
                                                    0,
                                                    -0.588
                                                ],
                                                [
                                                    -0.42,
                                                    -0.312
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -31.386,
                                                    4.302
                                                ],
                                                [
                                                    -28.398,
                                                    4.302
                                                ],
                                                [
                                                    -26.67,
                                                    3.852
                                                ],
                                                [
                                                    -26.022,
                                                    2.52
                                                ],
                                                [
                                                    -26.652,
                                                    1.17
                                                ],
                                                [
                                                    -28.398,
                                                    0.702
                                                ],
                                                [
                                                    -31.386,
                                                    0.702
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.432,
                                                    0.288
                                                ],
                                                [
                                                    0,
                                                    0.552
                                                ],
                                                [
                                                    0.42,
                                                    0.276
                                                ],
                                                [
                                                    0.792,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.768,
                                                    0
                                                ],
                                                [
                                                    0.432,
                                                    -0.288
                                                ],
                                                [
                                                    0,
                                                    -0.576
                                                ],
                                                [
                                                    -0.42,
                                                    -0.276
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -31.386,
                                                    -1.134
                                                ],
                                                [
                                                    -29.01,
                                                    -1.134
                                                ],
                                                [
                                                    -27.21,
                                                    -1.566
                                                ],
                                                [
                                                    -26.562,
                                                    -2.826
                                                ],
                                                [
                                                    -27.192,
                                                    -4.104
                                                ],
                                                [
                                                    -29.01,
                                                    -4.518
                                                ],
                                                [
                                                    -31.386,
                                                    -4.518
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    0.36
                                                ],
                                                [
                                                    0,
                                                    0.792
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.12,
                                                    -0.12
                                                ],
                                                [
                                                    -0.228,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.696,
                                                    0
                                                ],
                                                [
                                                    -0.42,
                                                    -0.36
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.24
                                                ],
                                                [
                                                    0.132,
                                                    0.12
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -19.368,
                                                    6.282
                                                ],
                                                [
                                                    -21.042,
                                                    5.742
                                                ],
                                                [
                                                    -21.672,
                                                    4.014
                                                ],
                                                [
                                                    -21.672,
                                                    -6.498
                                                ],
                                                [
                                                    -19.368,
                                                    -6.498
                                                ],
                                                [
                                                    -19.368,
                                                    3.78
                                                ],
                                                [
                                                    -19.188,
                                                    4.32
                                                ],
                                                [
                                                    -18.648,
                                                    4.5
                                                ],
                                                [
                                                    -17.946,
                                                    4.5
                                                ],
                                                [
                                                    -17.946,
                                                    6.282
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.948,
                                                    0
                                                ],
                                                [
                                                    0.72,
                                                    0.408
                                                ],
                                                [
                                                    0.396,
                                                    0.756
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    -0.384,
                                                    0.744
                                                ],
                                                [
                                                    -0.708,
                                                    0.408
                                                ],
                                                [
                                                    -0.948,
                                                    0
                                                ],
                                                [
                                                    -0.708,
                                                    -0.42
                                                ],
                                                [
                                                    -0.384,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.02
                                                ],
                                                [
                                                    0.396,
                                                    -0.756
                                                ],
                                                [
                                                    0.708,
                                                    -0.42
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.948,
                                                    0
                                                ],
                                                [
                                                    -0.708,
                                                    -0.42
                                                ],
                                                [
                                                    -0.384,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.02
                                                ],
                                                [
                                                    0.396,
                                                    -0.756
                                                ],
                                                [
                                                    0.72,
                                                    -0.42
                                                ],
                                                [
                                                    0.948,
                                                    0
                                                ],
                                                [
                                                    0.708,
                                                    0.408
                                                ],
                                                [
                                                    0.396,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    -0.384,
                                                    0.756
                                                ],
                                                [
                                                    -0.708,
                                                    0.408
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -12.293,
                                                    6.498
                                                ],
                                                [
                                                    -14.795,
                                                    5.886
                                                ],
                                                [
                                                    -16.451,
                                                    4.122
                                                ],
                                                [
                                                    -17.027,
                                                    1.476
                                                ],
                                                [
                                                    -16.451,
                                                    -1.17
                                                ],
                                                [
                                                    -14.795,
                                                    -2.916
                                                ],
                                                [
                                                    -12.293,
                                                    -3.546
                                                ],
                                                [
                                                    -9.809,
                                                    -2.916
                                                ],
                                                [
                                                    -8.171,
                                                    -1.17
                                                ],
                                                [
                                                    -7.577,
                                                    1.476
                                                ],
                                                [
                                                    -8.171,
                                                    4.122
                                                ],
                                                [
                                                    -9.809,
                                                    5.886
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.744,
                                                    0
                                                ],
                                                [
                                                    -0.396,
                                                    0.552
                                                ],
                                                [
                                                    0,
                                                    0.996
                                                ],
                                                [
                                                    0.408,
                                                    0.552
                                                ],
                                                [
                                                    0.744,
                                                    0
                                                ],
                                                [
                                                    0.408,
                                                    -0.564
                                                ],
                                                [
                                                    0,
                                                    -0.984
                                                ],
                                                [
                                                    -0.408,
                                                    -0.552
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.744,
                                                    0
                                                ],
                                                [
                                                    0.408,
                                                    -0.552
                                                ],
                                                [
                                                    0,
                                                    -0.984
                                                ],
                                                [
                                                    -0.396,
                                                    -0.564
                                                ],
                                                [
                                                    -0.744,
                                                    0
                                                ],
                                                [
                                                    -0.408,
                                                    0.552
                                                ],
                                                [
                                                    0,
                                                    0.996
                                                ],
                                                [
                                                    0.408,
                                                    0.552
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -12.293,
                                                    4.626
                                                ],
                                                [
                                                    -10.583,
                                                    3.798
                                                ],
                                                [
                                                    -9.971,
                                                    1.476
                                                ],
                                                [
                                                    -10.583,
                                                    -0.828
                                                ],
                                                [
                                                    -12.293,
                                                    -1.674
                                                ],
                                                [
                                                    -14.021,
                                                    -0.828
                                                ],
                                                [
                                                    -14.633,
                                                    1.476
                                                ],
                                                [
                                                    -14.021,
                                                    3.798
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.828,
                                                    0
                                                ],
                                                [
                                                    0.708,
                                                    0.408
                                                ],
                                                [
                                                    0.396,
                                                    0.756
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    -0.384,
                                                    0.744
                                                ],
                                                [
                                                    -0.708,
                                                    0.42
                                                ],
                                                [
                                                    -0.96,
                                                    0
                                                ],
                                                [
                                                    -0.636,
                                                    -0.288
                                                ],
                                                [
                                                    -0.396,
                                                    -0.54
                                                ],
                                                [
                                                    -0.096,
                                                    -0.768
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.384,
                                                    0.312
                                                ],
                                                [
                                                    0.552,
                                                    0
                                                ],
                                                [
                                                    0.408,
                                                    -0.564
                                                ],
                                                [
                                                    0,
                                                    -0.984
                                                ],
                                                [
                                                    -0.408,
                                                    -0.552
                                                ],
                                                [
                                                    -0.744,
                                                    0
                                                ],
                                                [
                                                    -0.372,
                                                    0.324
                                                ],
                                                [
                                                    -0.084,
                                                    0.684
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.396,
                                                    -0.564
                                                ],
                                                [
                                                    0.636,
                                                    -0.312
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.96,
                                                    0
                                                ],
                                                [
                                                    -0.708,
                                                    -0.42
                                                ],
                                                [
                                                    -0.384,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.008
                                                ],
                                                [
                                                    0.396,
                                                    -0.756
                                                ],
                                                [
                                                    0.708,
                                                    -0.42
                                                ],
                                                [
                                                    0.816,
                                                    0
                                                ],
                                                [
                                                    0.636,
                                                    0.288
                                                ],
                                                [
                                                    0.408,
                                                    0.528
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.096,
                                                    -0.612
                                                ],
                                                [
                                                    -0.372,
                                                    -0.324
                                                ],
                                                [
                                                    -0.744,
                                                    0
                                                ],
                                                [
                                                    -0.408,
                                                    0.552
                                                ],
                                                [
                                                    0,
                                                    0.996
                                                ],
                                                [
                                                    0.408,
                                                    0.552
                                                ],
                                                [
                                                    0.564,
                                                    0
                                                ],
                                                [
                                                    0.384,
                                                    -0.324
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.096,
                                                    0.768
                                                ],
                                                [
                                                    -0.396,
                                                    0.564
                                                ],
                                                [
                                                    -0.636,
                                                    0.3
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -1.623,
                                                    6.498
                                                ],
                                                [
                                                    -4.125,
                                                    5.886
                                                ],
                                                [
                                                    -5.781,
                                                    4.122
                                                ],
                                                [
                                                    -6.357,
                                                    1.476
                                                ],
                                                [
                                                    -5.781,
                                                    -1.152
                                                ],
                                                [
                                                    -4.125,
                                                    -2.916
                                                ],
                                                [
                                                    -1.623,
                                                    -3.546
                                                ],
                                                [
                                                    0.555,
                                                    -3.114
                                                ],
                                                [
                                                    2.103,
                                                    -1.872
                                                ],
                                                [
                                                    2.859,
                                                    0.072
                                                ],
                                                [
                                                    0.483,
                                                    0.198
                                                ],
                                                [
                                                    -0.237,
                                                    -1.188
                                                ],
                                                [
                                                    -1.623,
                                                    -1.674
                                                ],
                                                [
                                                    -3.351,
                                                    -0.828
                                                ],
                                                [
                                                    -3.963,
                                                    1.476
                                                ],
                                                [
                                                    -3.351,
                                                    3.798
                                                ],
                                                [
                                                    -1.623,
                                                    4.626
                                                ],
                                                [
                                                    -0.219,
                                                    4.14
                                                ],
                                                [
                                                    0.483,
                                                    2.628
                                                ],
                                                [
                                                    2.859,
                                                    2.736
                                                ],
                                                [
                                                    2.121,
                                                    4.734
                                                ],
                                                [
                                                    0.573,
                                                    6.048
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.467,
                                                    6.282
                                                ],
                                                [
                                                    4.467,
                                                    -6.498
                                                ],
                                                [
                                                    6.771,
                                                    -6.498
                                                ],
                                                [
                                                    6.771,
                                                    1.008
                                                ],
                                                [
                                                    10.713,
                                                    -3.33
                                                ],
                                                [
                                                    13.557,
                                                    -3.33
                                                ],
                                                [
                                                    9.795,
                                                    0.666
                                                ],
                                                [
                                                    13.683,
                                                    6.282
                                                ],
                                                [
                                                    11.091,
                                                    6.282
                                                ],
                                                [
                                                    8.283,
                                                    2.034
                                                ],
                                                [
                                                    6.771,
                                                    3.636
                                                ],
                                                [
                                                    6.771,
                                                    6.282
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.104,
                                                    0
                                                ],
                                                [
                                                    0.708,
                                                    0.408
                                                ],
                                                [
                                                    0.384,
                                                    0.756
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    -0.384,
                                                    0.744
                                                ],
                                                [
                                                    -0.696,
                                                    0.42
                                                ],
                                                [
                                                    -0.936,
                                                    0
                                                ],
                                                [
                                                    -0.684,
                                                    -0.408
                                                ],
                                                [
                                                    -0.372,
                                                    -0.768
                                                ],
                                                [
                                                    0,
                                                    -1.08
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.408,
                                                    -0.432
                                                ],
                                                [
                                                    -0.684,
                                                    0
                                                ],
                                                [
                                                    -0.336,
                                                    0.228
                                                ],
                                                [
                                                    -0.132,
                                                    0.42
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.78,
                                                    -0.54
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.96,
                                                    0
                                                ],
                                                [
                                                    -0.708,
                                                    -0.42
                                                ],
                                                [
                                                    -0.384,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.008
                                                ],
                                                [
                                                    0.384,
                                                    -0.756
                                                ],
                                                [
                                                    0.708,
                                                    -0.42
                                                ],
                                                [
                                                    0.912,
                                                    0
                                                ],
                                                [
                                                    0.696,
                                                    0.408
                                                ],
                                                [
                                                    0.372,
                                                    0.768
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.048,
                                                    0.84
                                                ],
                                                [
                                                    0.42,
                                                    0.42
                                                ],
                                                [
                                                    0.516,
                                                    0
                                                ],
                                                [
                                                    0.348,
                                                    -0.24
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.264,
                                                    0.936
                                                ],
                                                [
                                                    -0.768,
                                                    0.54
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.767,
                                                    6.498
                                                ],
                                                [
                                                    16.265,
                                                    5.886
                                                ],
                                                [
                                                    14.627,
                                                    4.122
                                                ],
                                                [
                                                    14.051,
                                                    1.476
                                                ],
                                                [
                                                    14.627,
                                                    -1.152
                                                ],
                                                [
                                                    16.247,
                                                    -2.916
                                                ],
                                                [
                                                    18.713,
                                                    -3.546
                                                ],
                                                [
                                                    21.107,
                                                    -2.934
                                                ],
                                                [
                                                    22.709,
                                                    -1.17
                                                ],
                                                [
                                                    23.267,
                                                    1.602
                                                ],
                                                [
                                                    23.267,
                                                    2.124
                                                ],
                                                [
                                                    16.445,
                                                    2.124
                                                ],
                                                [
                                                    17.129,
                                                    4.032
                                                ],
                                                [
                                                    18.785,
                                                    4.662
                                                ],
                                                [
                                                    20.063,
                                                    4.32
                                                ],
                                                [
                                                    20.783,
                                                    3.33
                                                ],
                                                [
                                                    23.141,
                                                    3.474
                                                ],
                                                [
                                                    21.575,
                                                    5.688
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.096,
                                                    -0.744
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.396,
                                                    0.372
                                                ],
                                                [
                                                    0.612,
                                                    0
                                                ],
                                                [
                                                    0.408,
                                                    -0.396
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.048,
                                                    -0.78
                                                ],
                                                [
                                                    -0.396,
                                                    -0.384
                                                ],
                                                [
                                                    -0.612,
                                                    0
                                                ],
                                                [
                                                    -0.396,
                                                    0.396
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    16.445,
                                                    0.576
                                                ],
                                                [
                                                    20.891,
                                                    0.576
                                                ],
                                                [
                                                    20.225,
                                                    -1.152
                                                ],
                                                [
                                                    18.713,
                                                    -1.728
                                                ],
                                                [
                                                    17.183,
                                                    -1.134
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.6,
                                                    0.408
                                                ],
                                                [
                                                    0.324,
                                                    0.756
                                                ],
                                                [
                                                    0,
                                                    1.02
                                                ],
                                                [
                                                    -0.324,
                                                    0.756
                                                ],
                                                [
                                                    -0.6,
                                                    0.408
                                                ],
                                                [
                                                    -0.804,
                                                    0
                                                ],
                                                [
                                                    -0.504,
                                                    -0.276
                                                ],
                                                [
                                                    -0.264,
                                                    -0.504
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.528,
                                                    -0.288
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.816,
                                                    0
                                                ],
                                                [
                                                    -0.588,
                                                    -0.408
                                                ],
                                                [
                                                    -0.324,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.02
                                                ],
                                                [
                                                    0.324,
                                                    -0.756
                                                ],
                                                [
                                                    0.6,
                                                    -0.408
                                                ],
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.516,
                                                    0.276
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.264,
                                                    0.516
                                                ],
                                                [
                                                    -0.528,
                                                    0.288
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    28.488,
                                                    6.498
                                                ],
                                                [
                                                    26.364,
                                                    5.886
                                                ],
                                                [
                                                    24.996,
                                                    4.14
                                                ],
                                                [
                                                    24.51,
                                                    1.476
                                                ],
                                                [
                                                    24.996,
                                                    -1.188
                                                ],
                                                [
                                                    26.382,
                                                    -2.934
                                                ],
                                                [
                                                    28.488,
                                                    -3.546
                                                ],
                                                [
                                                    30.252,
                                                    -3.132
                                                ],
                                                [
                                                    31.422,
                                                    -1.962
                                                ],
                                                [
                                                    31.422,
                                                    -6.498
                                                ],
                                                [
                                                    33.726,
                                                    -6.498
                                                ],
                                                [
                                                    33.726,
                                                    6.282
                                                ],
                                                [
                                                    31.53,
                                                    6.282
                                                ],
                                                [
                                                    31.476,
                                                    4.86
                                                ],
                                                [
                                                    30.288,
                                                    6.066
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.696,
                                                    0
                                                ],
                                                [
                                                    -0.324,
                                                    0.24
                                                ],
                                                [
                                                    -0.168,
                                                    0.468
                                                ],
                                                [
                                                    0,
                                                    0.672
                                                ],
                                                [
                                                    0.18,
                                                    0.468
                                                ],
                                                [
                                                    0.336,
                                                    0.24
                                                ],
                                                [
                                                    0.48,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    -0.564
                                                ],
                                                [
                                                    0,
                                                    -0.984
                                                ],
                                                [
                                                    -0.408,
                                                    -0.576
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.48,
                                                    0
                                                ],
                                                [
                                                    0.336,
                                                    -0.24
                                                ],
                                                [
                                                    0.18,
                                                    -0.48
                                                ],
                                                [
                                                    0,
                                                    -0.684
                                                ],
                                                [
                                                    -0.168,
                                                    -0.468
                                                ],
                                                [
                                                    -0.324,
                                                    -0.24
                                                ],
                                                [
                                                    -0.696,
                                                    0
                                                ],
                                                [
                                                    -0.408,
                                                    0.552
                                                ],
                                                [
                                                    0,
                                                    0.96
                                                ],
                                                [
                                                    0.42,
                                                    0.564
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29.19,
                                                    4.626
                                                ],
                                                [
                                                    30.396,
                                                    4.266
                                                ],
                                                [
                                                    31.152,
                                                    3.204
                                                ],
                                                [
                                                    31.422,
                                                    1.476
                                                ],
                                                [
                                                    31.152,
                                                    -0.252
                                                ],
                                                [
                                                    30.396,
                                                    -1.314
                                                ],
                                                [
                                                    29.19,
                                                    -1.674
                                                ],
                                                [
                                                    27.516,
                                                    -0.828
                                                ],
                                                [
                                                    26.904,
                                                    1.476
                                                ],
                                                [
                                                    27.516,
                                                    3.78
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.6235,
                                            0.0039,
                                            0.0039
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            45.166,
                                            16.718
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -9.389,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -9.389
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    9.389,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    9.389
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    9.389,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    9.389
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -9.389,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -9.389
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -28.5,
                                                    -17
                                                ],
                                                [
                                                    28.5,
                                                    -17
                                                ],
                                                [
                                                    45.5,
                                                    0
                                                ],
                                                [
                                                    45.5,
                                                    0
                                                ],
                                                [
                                                    28.5,
                                                    17
                                                ],
                                                [
                                                    -28.5,
                                                    17
                                                ],
                                                [
                                                    -45.5,
                                                    0
                                                ],
                                                [
                                                    -45.5,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            0.8745,
                                            0.8745
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            45.5,
                                            17
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                }
            ]
        },
        {
            "nm": "svg 1.svg",
            "id": "5",
            "fr": 30,
            "layers": [
                {
                    "ty": 4,
                    "nm": "svg 1.svg",
                    "sr": 1,
                    "st": 0,
                    "op": 18001,
                    "ip": 0,
                    "ln": "39",
                    "hasMask": false,
                    "ao": 0,
                    "ks": {
                        "a": {
                            "a": 0,
                            "k": [
                                278,
                                266
                            ]
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100
                            ]
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                278,
                                266
                            ]
                        },
                        "r": {
                            "a": 0,
                            "k": 0
                        },
                        "sa": {
                            "a": 0,
                            "k": 0
                        },
                        "o": {
                            "a": 0,
                            "k": 100
                        }
                    },
                    "shapes": [
                        {
                            "ty": "gr",
                            "nm": "Group 1",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -90.09,
                                                    5.04
                                                ],
                                                [
                                                    -90.09,
                                                    -7.74
                                                ],
                                                [
                                                    -82.062,
                                                    -7.74
                                                ],
                                                [
                                                    -82.062,
                                                    -6.228
                                                ],
                                                [
                                                    -88.542,
                                                    -6.228
                                                ],
                                                [
                                                    -88.542,
                                                    -2.106
                                                ],
                                                [
                                                    -82.277,
                                                    -2.106
                                                ],
                                                [
                                                    -82.277,
                                                    -0.63
                                                ],
                                                [
                                                    -88.542,
                                                    -0.63
                                                ],
                                                [
                                                    -88.542,
                                                    3.528
                                                ],
                                                [
                                                    -81.917,
                                                    3.528
                                                ],
                                                [
                                                    -81.917,
                                                    5.04
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -80.599,
                                                    5.04
                                                ],
                                                [
                                                    -77.089,
                                                    0.144
                                                ],
                                                [
                                                    -80.419,
                                                    -4.5
                                                ],
                                                [
                                                    -78.655,
                                                    -4.5
                                                ],
                                                [
                                                    -76.153,
                                                    -0.9
                                                ],
                                                [
                                                    -73.723,
                                                    -4.5
                                                ],
                                                [
                                                    -71.923,
                                                    -4.5
                                                ],
                                                [
                                                    -75.217,
                                                    0.18
                                                ],
                                                [
                                                    -71.761,
                                                    5.04
                                                ],
                                                [
                                                    -73.525,
                                                    5.04
                                                ],
                                                [
                                                    -76.153,
                                                    1.188
                                                ],
                                                [
                                                    -78.799,
                                                    5.04
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.552,
                                                    0.36
                                                ],
                                                [
                                                    -0.732,
                                                    0
                                                ],
                                                [
                                                    -0.6,
                                                    -0.468
                                                ],
                                                [
                                                    -0.288,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -0.876
                                                ],
                                                [
                                                    0.3,
                                                    -0.756
                                                ],
                                                [
                                                    0.612,
                                                    -0.468
                                                ],
                                                [
                                                    0.948,
                                                    0
                                                ],
                                                [
                                                    0.432,
                                                    0.168
                                                ],
                                                [
                                                    0.3,
                                                    0.3
                                                ],
                                                [
                                                    0.108,
                                                    0.408
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.24,
                                                    -0.708
                                                ],
                                                [
                                                    0.564,
                                                    -0.372
                                                ],
                                                [
                                                    0.948,
                                                    0
                                                ],
                                                [
                                                    0.612,
                                                    0.468
                                                ],
                                                [
                                                    0.3,
                                                    0.756
                                                ],
                                                [
                                                    0,
                                                    0.876
                                                ],
                                                [
                                                    -0.288,
                                                    0.756
                                                ],
                                                [
                                                    -0.6,
                                                    0.468
                                                ],
                                                [
                                                    -0.492,
                                                    0
                                                ],
                                                [
                                                    -0.42,
                                                    -0.168
                                                ],
                                                [
                                                    -0.288,
                                                    -0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -70.231,
                                                    7.74
                                                ],
                                                [
                                                    -70.231,
                                                    -4.5
                                                ],
                                                [
                                                    -68.827,
                                                    -4.5
                                                ],
                                                [
                                                    -68.791,
                                                    -2.448
                                                ],
                                                [
                                                    -69.007,
                                                    -2.556
                                                ],
                                                [
                                                    -67.819,
                                                    -4.158
                                                ],
                                                [
                                                    -65.875,
                                                    -4.716
                                                ],
                                                [
                                                    -63.553,
                                                    -4.014
                                                ],
                                                [
                                                    -62.203,
                                                    -2.178
                                                ],
                                                [
                                                    -61.753,
                                                    0.27
                                                ],
                                                [
                                                    -62.203,
                                                    2.718
                                                ],
                                                [
                                                    -63.553,
                                                    4.554
                                                ],
                                                [
                                                    -65.875,
                                                    5.256
                                                ],
                                                [
                                                    -67.261,
                                                    5.004
                                                ],
                                                [
                                                    -68.341,
                                                    4.302
                                                ],
                                                [
                                                    -68.935,
                                                    3.24
                                                ],
                                                [
                                                    -68.719,
                                                    2.988
                                                ],
                                                [
                                                    -68.719,
                                                    7.74
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.552,
                                                    0
                                                ],
                                                [
                                                    -0.48,
                                                    0.624
                                                ],
                                                [
                                                    0,
                                                    1.116
                                                ],
                                                [
                                                    0.48,
                                                    0.624
                                                ],
                                                [
                                                    0.828,
                                                    0
                                                ],
                                                [
                                                    0.408,
                                                    -0.264
                                                ],
                                                [
                                                    0.228,
                                                    -0.528
                                                ],
                                                [
                                                    0,
                                                    -0.78
                                                ],
                                                [
                                                    -0.216,
                                                    -0.528
                                                ],
                                                [
                                                    -0.408,
                                                    -0.264
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.828,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    -0.624
                                                ],
                                                [
                                                    0,
                                                    -1.116
                                                ],
                                                [
                                                    -0.48,
                                                    -0.624
                                                ],
                                                [
                                                    -0.552,
                                                    0
                                                ],
                                                [
                                                    -0.396,
                                                    0.264
                                                ],
                                                [
                                                    -0.216,
                                                    0.528
                                                ],
                                                [
                                                    0,
                                                    0.78
                                                ],
                                                [
                                                    0.216,
                                                    0.528
                                                ],
                                                [
                                                    0.408,
                                                    0.264
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -66.019,
                                                    3.816
                                                ],
                                                [
                                                    -64.057,
                                                    2.88
                                                ],
                                                [
                                                    -63.337,
                                                    0.27
                                                ],
                                                [
                                                    -64.057,
                                                    -2.34
                                                ],
                                                [
                                                    -66.019,
                                                    -3.276
                                                ],
                                                [
                                                    -67.459,
                                                    -2.88
                                                ],
                                                [
                                                    -68.395,
                                                    -1.692
                                                ],
                                                [
                                                    -68.719,
                                                    0.27
                                                ],
                                                [
                                                    -68.395,
                                                    2.232
                                                ],
                                                [
                                                    -67.459,
                                                    3.42
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.876,
                                                    0
                                                ],
                                                [
                                                    0.66,
                                                    0.408
                                                ],
                                                [
                                                    0.36,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    -0.36,
                                                    0.744
                                                ],
                                                [
                                                    -0.66,
                                                    0.408
                                                ],
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.648,
                                                    -0.408
                                                ],
                                                [
                                                    -0.36,
                                                    -0.744
                                                ],
                                                [
                                                    0,
                                                    -1.02
                                                ],
                                                [
                                                    0.36,
                                                    -0.756
                                                ],
                                                [
                                                    0.66,
                                                    -0.408
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.66,
                                                    -0.408
                                                ],
                                                [
                                                    -0.36,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.02
                                                ],
                                                [
                                                    0.36,
                                                    -0.744
                                                ],
                                                [
                                                    0.66,
                                                    -0.408
                                                ],
                                                [
                                                    0.876,
                                                    0
                                                ],
                                                [
                                                    0.66,
                                                    0.408
                                                ],
                                                [
                                                    0.36,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    -0.36,
                                                    0.744
                                                ],
                                                [
                                                    -0.648,
                                                    0.408
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -55.976,
                                                    5.256
                                                ],
                                                [
                                                    -58.28,
                                                    4.644
                                                ],
                                                [
                                                    -59.81,
                                                    2.916
                                                ],
                                                [
                                                    -60.35,
                                                    0.27
                                                ],
                                                [
                                                    -59.81,
                                                    -2.376
                                                ],
                                                [
                                                    -58.28,
                                                    -4.104
                                                ],
                                                [
                                                    -55.976,
                                                    -4.716
                                                ],
                                                [
                                                    -53.69,
                                                    -4.104
                                                ],
                                                [
                                                    -52.16,
                                                    -2.376
                                                ],
                                                [
                                                    -51.62,
                                                    0.27
                                                ],
                                                [
                                                    -52.16,
                                                    2.916
                                                ],
                                                [
                                                    -53.69,
                                                    4.644
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.48,
                                                    0.624
                                                ],
                                                [
                                                    0,
                                                    1.104
                                                ],
                                                [
                                                    0.492,
                                                    0.624
                                                ],
                                                [
                                                    0.876,
                                                    0
                                                ],
                                                [
                                                    0.492,
                                                    -0.636
                                                ],
                                                [
                                                    0,
                                                    -1.104
                                                ],
                                                [
                                                    -0.492,
                                                    -0.636
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.876,
                                                    0
                                                ],
                                                [
                                                    0.492,
                                                    -0.636
                                                ],
                                                [
                                                    0,
                                                    -1.104
                                                ],
                                                [
                                                    -0.48,
                                                    -0.636
                                                ],
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.492,
                                                    0.624
                                                ],
                                                [
                                                    0,
                                                    1.104
                                                ],
                                                [
                                                    0.492,
                                                    0.624
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -55.976,
                                                    3.816
                                                ],
                                                [
                                                    -53.942,
                                                    2.88
                                                ],
                                                [
                                                    -53.204,
                                                    0.27
                                                ],
                                                [
                                                    -53.942,
                                                    -2.322
                                                ],
                                                [
                                                    -55.976,
                                                    -3.276
                                                ],
                                                [
                                                    -58.028,
                                                    -2.322
                                                ],
                                                [
                                                    -58.766,
                                                    0.27
                                                ],
                                                [
                                                    -58.028,
                                                    2.88
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.396,
                                                    0.372
                                                ],
                                                [
                                                    -0.672,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.324,
                                                    -0.18
                                                ],
                                                [
                                                    0.168,
                                                    -0.348
                                                ],
                                                [
                                                    0,
                                                    -0.528
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.12,
                                                    -0.816
                                                ],
                                                [
                                                    0.408,
                                                    -0.384
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.48,
                                                    0
                                                ],
                                                [
                                                    -0.312,
                                                    0.168
                                                ],
                                                [
                                                    -0.156,
                                                    0.336
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -49.559,
                                                    5.04
                                                ],
                                                [
                                                    -49.559,
                                                    -4.5
                                                ],
                                                [
                                                    -48.227,
                                                    -4.5
                                                ],
                                                [
                                                    -48.155,
                                                    -2.088
                                                ],
                                                [
                                                    -48.299,
                                                    -2.142
                                                ],
                                                [
                                                    -47.525,
                                                    -3.924
                                                ],
                                                [
                                                    -45.905,
                                                    -4.5
                                                ],
                                                [
                                                    -44.969,
                                                    -4.5
                                                ],
                                                [
                                                    -44.969,
                                                    -3.06
                                                ],
                                                [
                                                    -45.887,
                                                    -3.06
                                                ],
                                                [
                                                    -47.093,
                                                    -2.79
                                                ],
                                                [
                                                    -47.813,
                                                    -2.016
                                                ],
                                                [
                                                    -48.047,
                                                    -0.72
                                                ],
                                                [
                                                    -48.047,
                                                    5.04
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    0.396
                                                ],
                                                [
                                                    0,
                                                    0.84
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    -0.168
                                                ],
                                                [
                                                    -0.397,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.864,
                                                    0
                                                ],
                                                [
                                                    -0.408,
                                                    -0.396
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.432
                                                ],
                                                [
                                                    0.193,
                                                    0.168
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -40.144,
                                                    5.04
                                                ],
                                                [
                                                    -42.07,
                                                    4.446
                                                ],
                                                [
                                                    -42.682,
                                                    2.592
                                                ],
                                                [
                                                    -42.682,
                                                    -6.732
                                                ],
                                                [
                                                    -41.17,
                                                    -6.732
                                                ],
                                                [
                                                    -41.17,
                                                    2.556
                                                ],
                                                [
                                                    -40.882,
                                                    3.456
                                                ],
                                                [
                                                    -39.999,
                                                    3.708
                                                ],
                                                [
                                                    -38.632,
                                                    3.708
                                                ],
                                                [
                                                    -38.632,
                                                    5.04
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -44.086,
                                                    -3.168
                                                ],
                                                [
                                                    -44.086,
                                                    -4.5
                                                ],
                                                [
                                                    -38.632,
                                                    -4.5
                                                ],
                                                [
                                                    -38.632,
                                                    -3.168
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.731,
                                                    0
                                                ],
                                                [
                                                    0.66,
                                                    0.408
                                                ],
                                                [
                                                    0.36,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    -0.36,
                                                    0.744
                                                ],
                                                [
                                                    -0.648,
                                                    0.408
                                                ],
                                                [
                                                    -0.888,
                                                    0
                                                ],
                                                [
                                                    -0.564,
                                                    -0.264
                                                ],
                                                [
                                                    -0.36,
                                                    -0.492
                                                ],
                                                [
                                                    -0.107,
                                                    -0.708
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.444,
                                                    0.336
                                                ],
                                                [
                                                    0.647,
                                                    0
                                                ],
                                                [
                                                    0.491,
                                                    -0.636
                                                ],
                                                [
                                                    0,
                                                    -1.104
                                                ],
                                                [
                                                    -0.492,
                                                    -0.636
                                                ],
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.444,
                                                    0.36
                                                ],
                                                [
                                                    -0.108,
                                                    0.72
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.36,
                                                    -0.528
                                                ],
                                                [
                                                    0.576,
                                                    -0.288
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.888,
                                                    0
                                                ],
                                                [
                                                    -0.648,
                                                    -0.408
                                                ],
                                                [
                                                    -0.36,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.008
                                                ],
                                                [
                                                    0.36,
                                                    -0.744
                                                ],
                                                [
                                                    0.66,
                                                    -0.42
                                                ],
                                                [
                                                    0.731,
                                                    0
                                                ],
                                                [
                                                    0.576,
                                                    0.252
                                                ],
                                                [
                                                    0.36,
                                                    0.492
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.108,
                                                    -0.636
                                                ],
                                                [
                                                    -0.444,
                                                    -0.348
                                                ],
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.492,
                                                    0.624
                                                ],
                                                [
                                                    0,
                                                    1.104
                                                ],
                                                [
                                                    0.491,
                                                    0.624
                                                ],
                                                [
                                                    0.647,
                                                    0
                                                ],
                                                [
                                                    0.444,
                                                    -0.36
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.107,
                                                    0.708
                                                ],
                                                [
                                                    -0.36,
                                                    0.516
                                                ],
                                                [
                                                    -0.564,
                                                    0.288
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -28.36,
                                                    5.256
                                                ],
                                                [
                                                    -30.682,
                                                    4.644
                                                ],
                                                [
                                                    -32.194,
                                                    2.916
                                                ],
                                                [
                                                    -32.734,
                                                    0.27
                                                ],
                                                [
                                                    -32.194,
                                                    -2.358
                                                ],
                                                [
                                                    -30.682,
                                                    -4.086
                                                ],
                                                [
                                                    -28.36,
                                                    -4.716
                                                ],
                                                [
                                                    -26.416,
                                                    -4.32
                                                ],
                                                [
                                                    -25.012,
                                                    -3.204
                                                ],
                                                [
                                                    -24.311,
                                                    -1.404
                                                ],
                                                [
                                                    -25.895,
                                                    -1.296
                                                ],
                                                [
                                                    -26.722,
                                                    -2.754
                                                ],
                                                [
                                                    -28.36,
                                                    -3.276
                                                ],
                                                [
                                                    -30.412,
                                                    -2.322
                                                ],
                                                [
                                                    -31.15,
                                                    0.27
                                                ],
                                                [
                                                    -30.412,
                                                    2.88
                                                ],
                                                [
                                                    -28.36,
                                                    3.816
                                                ],
                                                [
                                                    -26.722,
                                                    3.276
                                                ],
                                                [
                                                    -25.895,
                                                    1.656
                                                ],
                                                [
                                                    -24.311,
                                                    1.764
                                                ],
                                                [
                                                    -25.012,
                                                    3.618
                                                ],
                                                [
                                                    -26.416,
                                                    4.824
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.816,
                                                    0
                                                ],
                                                [
                                                    0.576,
                                                    0.636
                                                ],
                                                [
                                                    0,
                                                    1.128
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.324,
                                                    -0.444
                                                ],
                                                [
                                                    -0.683,
                                                    0
                                                ],
                                                [
                                                    -0.433,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0.852
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.54,
                                                    -0.432
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.949,
                                                    0
                                                ],
                                                [
                                                    -0.564,
                                                    -0.648
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.924
                                                ],
                                                [
                                                    0.335,
                                                    0.432
                                                ],
                                                [
                                                    0.757,
                                                    0
                                                ],
                                                [
                                                    0.432,
                                                    -0.492
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    0.78
                                                ],
                                                [
                                                    -0.541,
                                                    0.42
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -19.304,
                                                    5.256
                                                ],
                                                [
                                                    -21.59,
                                                    4.302
                                                ],
                                                [
                                                    -22.437,
                                                    1.638
                                                ],
                                                [
                                                    -22.437,
                                                    -4.5
                                                ],
                                                [
                                                    -20.924,
                                                    -4.5
                                                ],
                                                [
                                                    -20.924,
                                                    1.224
                                                ],
                                                [
                                                    -20.438,
                                                    3.276
                                                ],
                                                [
                                                    -18.909,
                                                    3.924
                                                ],
                                                [
                                                    -17.126,
                                                    3.204
                                                ],
                                                [
                                                    -16.479,
                                                    1.188
                                                ],
                                                [
                                                    -16.479,
                                                    -4.5
                                                ],
                                                [
                                                    -14.966,
                                                    -4.5
                                                ],
                                                [
                                                    -14.966,
                                                    5.04
                                                ],
                                                [
                                                    -16.407,
                                                    5.04
                                                ],
                                                [
                                                    -16.407,
                                                    2.682
                                                ],
                                                [
                                                    -16.173,
                                                    2.808
                                                ],
                                                [
                                                    -17.27,
                                                    4.626
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.055,
                                                    0
                                                ],
                                                [
                                                    0.601,
                                                    0.276
                                                ],
                                                [
                                                    0.325,
                                                    0.48
                                                ],
                                                [
                                                    0.049,
                                                    0.624
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.372,
                                                    -0.348
                                                ],
                                                [
                                                    -0.84,
                                                    0
                                                ],
                                                [
                                                    -0.349,
                                                    0.204
                                                ],
                                                [
                                                    0,
                                                    0.468
                                                ],
                                                [
                                                    0.119,
                                                    0.168
                                                ],
                                                [
                                                    0.336,
                                                    0.12
                                                ],
                                                [
                                                    0.648,
                                                    0.12
                                                ],
                                                [
                                                    0.504,
                                                    0.252
                                                ],
                                                [
                                                    0.205,
                                                    0.36
                                                ],
                                                [
                                                    0,
                                                    0.504
                                                ],
                                                [
                                                    -0.624,
                                                    0.54
                                                ],
                                                [
                                                    -1.152,
                                                    0
                                                ],
                                                [
                                                    -0.528,
                                                    -0.3
                                                ],
                                                [
                                                    -0.275,
                                                    -0.468
                                                ],
                                                [
                                                    -0.061,
                                                    -0.516
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.156,
                                                    0.264
                                                ],
                                                [
                                                    0.312,
                                                    0.156
                                                ],
                                                [
                                                    0.528,
                                                    0
                                                ],
                                                [
                                                    0.323,
                                                    -0.264
                                                ],
                                                [
                                                    0,
                                                    -0.408
                                                ],
                                                [
                                                    -0.121,
                                                    -0.204
                                                ],
                                                [
                                                    -0.312,
                                                    -0.132
                                                ],
                                                [
                                                    -0.553,
                                                    -0.096
                                                ],
                                                [
                                                    -0.528,
                                                    -0.24
                                                ],
                                                [
                                                    -0.205,
                                                    -0.36
                                                ],
                                                [
                                                    0,
                                                    -0.504
                                                ],
                                                [
                                                    0.685,
                                                    -0.492
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.588,
                                                    -0.276
                                                ],
                                                [
                                                    -0.311,
                                                    -0.492
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.095,
                                                    0.576
                                                ],
                                                [
                                                    0.384,
                                                    0.336
                                                ],
                                                [
                                                    0.647,
                                                    0
                                                ],
                                                [
                                                    0.36,
                                                    -0.216
                                                ],
                                                [
                                                    0,
                                                    -0.252
                                                ],
                                                [
                                                    -0.108,
                                                    -0.168
                                                ],
                                                [
                                                    -0.336,
                                                    -0.132
                                                ],
                                                [
                                                    -0.888,
                                                    -0.168
                                                ],
                                                [
                                                    -0.505,
                                                    -0.252
                                                ],
                                                [
                                                    -0.203,
                                                    -0.36
                                                ],
                                                [
                                                    0,
                                                    -0.852
                                                ],
                                                [
                                                    0.636,
                                                    -0.552
                                                ],
                                                [
                                                    0.84,
                                                    0
                                                ],
                                                [
                                                    0.541,
                                                    0.288
                                                ],
                                                [
                                                    0.276,
                                                    0.468
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.024,
                                                    -0.3
                                                ],
                                                [
                                                    -0.157,
                                                    -0.264
                                                ],
                                                [
                                                    -0.313,
                                                    -0.168
                                                ],
                                                [
                                                    -0.683,
                                                    0
                                                ],
                                                [
                                                    -0.325,
                                                    0.264
                                                ],
                                                [
                                                    0,
                                                    0.312
                                                ],
                                                [
                                                    0.132,
                                                    0.192
                                                ],
                                                [
                                                    0.323,
                                                    0.12
                                                ],
                                                [
                                                    0.936,
                                                    0.156
                                                ],
                                                [
                                                    0.528,
                                                    0.24
                                                ],
                                                [
                                                    0.215,
                                                    0.348
                                                ],
                                                [
                                                    0,
                                                    0.876
                                                ],
                                                [
                                                    -0.672,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -8.784,
                                                    5.256
                                                ],
                                                [
                                                    -10.999,
                                                    4.842
                                                ],
                                                [
                                                    -12.367,
                                                    3.708
                                                ],
                                                [
                                                    -12.907,
                                                    2.034
                                                ],
                                                [
                                                    -11.322,
                                                    1.926
                                                ],
                                                [
                                                    -10.62,
                                                    3.312
                                                ],
                                                [
                                                    -8.784,
                                                    3.816
                                                ],
                                                [
                                                    -7.29,
                                                    3.51
                                                ],
                                                [
                                                    -6.751,
                                                    2.484
                                                ],
                                                [
                                                    -6.93,
                                                    1.854
                                                ],
                                                [
                                                    -7.596,
                                                    1.422
                                                ],
                                                [
                                                    -9.072,
                                                    1.044
                                                ],
                                                [
                                                    -11.16,
                                                    0.414
                                                ],
                                                [
                                                    -12.223,
                                                    -0.504
                                                ],
                                                [
                                                    -12.529,
                                                    -1.8
                                                ],
                                                [
                                                    -11.592,
                                                    -3.888
                                                ],
                                                [
                                                    -8.91,
                                                    -4.716
                                                ],
                                                [
                                                    -6.859,
                                                    -4.266
                                                ],
                                                [
                                                    -5.635,
                                                    -3.132
                                                ],
                                                [
                                                    -5.13,
                                                    -1.656
                                                ],
                                                [
                                                    -6.714,
                                                    -1.548
                                                ],
                                                [
                                                    -6.984,
                                                    -2.394
                                                ],
                                                [
                                                    -7.686,
                                                    -3.024
                                                ],
                                                [
                                                    -8.947,
                                                    -3.276
                                                ],
                                                [
                                                    -10.458,
                                                    -2.88
                                                ],
                                                [
                                                    -10.945,
                                                    -1.872
                                                ],
                                                [
                                                    -10.764,
                                                    -1.098
                                                ],
                                                [
                                                    -10.098,
                                                    -0.612
                                                ],
                                                [
                                                    -8.784,
                                                    -0.288
                                                ],
                                                [
                                                    -6.589,
                                                    0.306
                                                ],
                                                [
                                                    -5.49,
                                                    1.206
                                                ],
                                                [
                                                    -5.167,
                                                    2.484
                                                ],
                                                [
                                                    -6.193,
                                                    4.536
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    0.396
                                                ],
                                                [
                                                    0,
                                                    0.84
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    -0.168
                                                ],
                                                [
                                                    -0.396,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.864,
                                                    0
                                                ],
                                                [
                                                    -0.409,
                                                    -0.396
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.432
                                                ],
                                                [
                                                    0.192,
                                                    0.168
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0.04,
                                                    5.04
                                                ],
                                                [
                                                    -1.885,
                                                    4.446
                                                ],
                                                [
                                                    -2.497,
                                                    2.592
                                                ],
                                                [
                                                    -2.497,
                                                    -6.732
                                                ],
                                                [
                                                    -0.986,
                                                    -6.732
                                                ],
                                                [
                                                    -0.986,
                                                    2.556
                                                ],
                                                [
                                                    -0.697,
                                                    3.456
                                                ],
                                                [
                                                    0.184,
                                                    3.708
                                                ],
                                                [
                                                    1.553,
                                                    3.708
                                                ],
                                                [
                                                    1.553,
                                                    5.04
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 14",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -3.902,
                                                    -3.168
                                                ],
                                                [
                                                    -3.902,
                                                    -4.5
                                                ],
                                                [
                                                    1.553,
                                                    -4.5
                                                ],
                                                [
                                                    1.553,
                                                    -3.168
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 15",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.875,
                                                    0
                                                ],
                                                [
                                                    0.66,
                                                    0.408
                                                ],
                                                [
                                                    0.36,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    -0.36,
                                                    0.744
                                                ],
                                                [
                                                    -0.661,
                                                    0.408
                                                ],
                                                [
                                                    -0.877,
                                                    0
                                                ],
                                                [
                                                    -0.647,
                                                    -0.408
                                                ],
                                                [
                                                    -0.36,
                                                    -0.744
                                                ],
                                                [
                                                    0,
                                                    -1.02
                                                ],
                                                [
                                                    0.36,
                                                    -0.756
                                                ],
                                                [
                                                    0.661,
                                                    -0.408
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.877,
                                                    0
                                                ],
                                                [
                                                    -0.661,
                                                    -0.408
                                                ],
                                                [
                                                    -0.36,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.02
                                                ],
                                                [
                                                    0.36,
                                                    -0.744
                                                ],
                                                [
                                                    0.66,
                                                    -0.408
                                                ],
                                                [
                                                    0.875,
                                                    0
                                                ],
                                                [
                                                    0.661,
                                                    0.408
                                                ],
                                                [
                                                    0.36,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    -0.36,
                                                    0.744
                                                ],
                                                [
                                                    -0.647,
                                                    0.408
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    7.042,
                                                    5.256
                                                ],
                                                [
                                                    4.738,
                                                    4.644
                                                ],
                                                [
                                                    3.208,
                                                    2.916
                                                ],
                                                [
                                                    2.667,
                                                    0.27
                                                ],
                                                [
                                                    3.208,
                                                    -2.376
                                                ],
                                                [
                                                    4.738,
                                                    -4.104
                                                ],
                                                [
                                                    7.042,
                                                    -4.716
                                                ],
                                                [
                                                    9.327,
                                                    -4.104
                                                ],
                                                [
                                                    10.857,
                                                    -2.376
                                                ],
                                                [
                                                    11.398,
                                                    0.27
                                                ],
                                                [
                                                    10.857,
                                                    2.916
                                                ],
                                                [
                                                    9.327,
                                                    4.644
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 16",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.877,
                                                    0
                                                ],
                                                [
                                                    -0.48,
                                                    0.624
                                                ],
                                                [
                                                    0,
                                                    1.104
                                                ],
                                                [
                                                    0.492,
                                                    0.624
                                                ],
                                                [
                                                    0.875,
                                                    0
                                                ],
                                                [
                                                    0.492,
                                                    -0.636
                                                ],
                                                [
                                                    0,
                                                    -1.104
                                                ],
                                                [
                                                    -0.493,
                                                    -0.636
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.875,
                                                    0
                                                ],
                                                [
                                                    0.492,
                                                    -0.636
                                                ],
                                                [
                                                    0,
                                                    -1.104
                                                ],
                                                [
                                                    -0.48,
                                                    -0.636
                                                ],
                                                [
                                                    -0.877,
                                                    0
                                                ],
                                                [
                                                    -0.493,
                                                    0.624
                                                ],
                                                [
                                                    0,
                                                    1.104
                                                ],
                                                [
                                                    0.492,
                                                    0.624
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    7.042,
                                                    3.816
                                                ],
                                                [
                                                    9.076,
                                                    2.88
                                                ],
                                                [
                                                    9.814,
                                                    0.27
                                                ],
                                                [
                                                    9.076,
                                                    -2.322
                                                ],
                                                [
                                                    7.042,
                                                    -3.276
                                                ],
                                                [
                                                    4.99,
                                                    -2.322
                                                ],
                                                [
                                                    4.251,
                                                    0.27
                                                ],
                                                [
                                                    4.99,
                                                    2.88
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 17",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.263,
                                                    0.372
                                                ],
                                                [
                                                    -0.396,
                                                    0.204
                                                ],
                                                [
                                                    -0.48,
                                                    0
                                                ],
                                                [
                                                    -0.517,
                                                    -0.456
                                                ],
                                                [
                                                    -0.131,
                                                    -0.816
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.252,
                                                    0.372
                                                ],
                                                [
                                                    -0.409,
                                                    0.204
                                                ],
                                                [
                                                    -0.528,
                                                    0
                                                ],
                                                [
                                                    -0.468,
                                                    -0.288
                                                ],
                                                [
                                                    -0.241,
                                                    -0.54
                                                ],
                                                [
                                                    0,
                                                    -0.768
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.336,
                                                    0.432
                                                ],
                                                [
                                                    0.659,
                                                    0
                                                ],
                                                [
                                                    0.337,
                                                    -0.216
                                                ],
                                                [
                                                    0.181,
                                                    -0.408
                                                ],
                                                [
                                                    0,
                                                    -0.576
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.3,
                                                    0.48
                                                ],
                                                [
                                                    0.709,
                                                    0
                                                ],
                                                [
                                                    0.336,
                                                    -0.216
                                                ],
                                                [
                                                    0.192,
                                                    -0.408
                                                ],
                                                [
                                                    0,
                                                    -0.564
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.108,
                                                    -0.528
                                                ],
                                                [
                                                    0.276,
                                                    -0.384
                                                ],
                                                [
                                                    0.396,
                                                    -0.216
                                                ],
                                                [
                                                    0.828,
                                                    0
                                                ],
                                                [
                                                    0.528,
                                                    0.456
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.095,
                                                    -0.552
                                                ],
                                                [
                                                    0.263,
                                                    -0.384
                                                ],
                                                [
                                                    0.408,
                                                    -0.204
                                                ],
                                                [
                                                    0.683,
                                                    0
                                                ],
                                                [
                                                    0.468,
                                                    0.276
                                                ],
                                                [
                                                    0.24,
                                                    0.54
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.864
                                                ],
                                                [
                                                    -0.336,
                                                    -0.444
                                                ],
                                                [
                                                    -0.444,
                                                    0
                                                ],
                                                [
                                                    -0.323,
                                                    0.216
                                                ],
                                                [
                                                    -0.179,
                                                    0.396
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.852
                                                ],
                                                [
                                                    -0.301,
                                                    -0.48
                                                ],
                                                [
                                                    -0.444,
                                                    0
                                                ],
                                                [
                                                    -0.323,
                                                    0.216
                                                ],
                                                [
                                                    -0.179,
                                                    0.408
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    13.458,
                                                    5.04
                                                ],
                                                [
                                                    13.458,
                                                    -4.5
                                                ],
                                                [
                                                    14.844,
                                                    -4.5
                                                ],
                                                [
                                                    14.898,
                                                    -2.088
                                                ],
                                                [
                                                    14.682,
                                                    -2.16
                                                ],
                                                [
                                                    15.24,
                                                    -3.51
                                                ],
                                                [
                                                    16.249,
                                                    -4.392
                                                ],
                                                [
                                                    17.563,
                                                    -4.716
                                                ],
                                                [
                                                    19.579,
                                                    -4.032
                                                ],
                                                [
                                                    20.568,
                                                    -2.124
                                                ],
                                                [
                                                    20.281,
                                                    -2.142
                                                ],
                                                [
                                                    20.803,
                                                    -3.528
                                                ],
                                                [
                                                    21.811,
                                                    -4.41
                                                ],
                                                [
                                                    23.215,
                                                    -4.716
                                                ],
                                                [
                                                    24.943,
                                                    -4.284
                                                ],
                                                [
                                                    26.005,
                                                    -3.06
                                                ],
                                                [
                                                    26.365,
                                                    -1.098
                                                ],
                                                [
                                                    26.365,
                                                    5.04
                                                ],
                                                [
                                                    24.853,
                                                    5.04
                                                ],
                                                [
                                                    24.853,
                                                    -0.774
                                                ],
                                                [
                                                    24.348,
                                                    -2.718
                                                ],
                                                [
                                                    22.855,
                                                    -3.384
                                                ],
                                                [
                                                    21.684,
                                                    -3.06
                                                ],
                                                [
                                                    20.928,
                                                    -2.124
                                                ],
                                                [
                                                    20.659,
                                                    -0.666
                                                ],
                                                [
                                                    20.659,
                                                    5.04
                                                ],
                                                [
                                                    19.146,
                                                    5.04
                                                ],
                                                [
                                                    19.146,
                                                    -0.666
                                                ],
                                                [
                                                    18.697,
                                                    -2.664
                                                ],
                                                [
                                                    17.184,
                                                    -3.384
                                                ],
                                                [
                                                    16.014,
                                                    -3.06
                                                ],
                                                [
                                                    15.24,
                                                    -2.124
                                                ],
                                                [
                                                    14.971,
                                                    -0.666
                                                ],
                                                [
                                                    14.971,
                                                    5.04
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 18",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.008,
                                                    0
                                                ],
                                                [
                                                    0.66,
                                                    0.408
                                                ],
                                                [
                                                    0.36,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    -0.347,
                                                    0.744
                                                ],
                                                [
                                                    -0.636,
                                                    0.408
                                                ],
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.636,
                                                    -0.396
                                                ],
                                                [
                                                    -0.349,
                                                    -0.744
                                                ],
                                                [
                                                    0,
                                                    -1.068
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.48,
                                                    -0.516
                                                ],
                                                [
                                                    -0.828,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    0.288
                                                ],
                                                [
                                                    -0.156,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.709,
                                                    -0.552
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.899,
                                                    0
                                                ],
                                                [
                                                    -0.648,
                                                    -0.408
                                                ],
                                                [
                                                    -0.347,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.008
                                                ],
                                                [
                                                    0.36,
                                                    -0.744
                                                ],
                                                [
                                                    0.649,
                                                    -0.42
                                                ],
                                                [
                                                    0.827,
                                                    0
                                                ],
                                                [
                                                    0.636,
                                                    0.384
                                                ],
                                                [
                                                    0.36,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.06,
                                                    1.02
                                                ],
                                                [
                                                    0.492,
                                                    0.516
                                                ],
                                                [
                                                    0.625,
                                                    0
                                                ],
                                                [
                                                    0.409,
                                                    -0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.252,
                                                    0.852
                                                ],
                                                [
                                                    -0.696,
                                                    0.54
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    32.758,
                                                    5.256
                                                ],
                                                [
                                                    30.419,
                                                    4.644
                                                ],
                                                [
                                                    28.906,
                                                    2.916
                                                ],
                                                [
                                                    28.385,
                                                    0.27
                                                ],
                                                [
                                                    28.906,
                                                    -2.358
                                                ],
                                                [
                                                    30.4,
                                                    -4.086
                                                ],
                                                [
                                                    32.687,
                                                    -4.716
                                                ],
                                                [
                                                    34.883,
                                                    -4.122
                                                ],
                                                [
                                                    36.359,
                                                    -2.43
                                                ],
                                                [
                                                    36.898,
                                                    0.288
                                                ],
                                                [
                                                    36.898,
                                                    0.738
                                                ],
                                                [
                                                    29.969,
                                                    0.738
                                                ],
                                                [
                                                    30.779,
                                                    3.042
                                                ],
                                                [
                                                    32.758,
                                                    3.816
                                                ],
                                                [
                                                    34.288,
                                                    3.384
                                                ],
                                                [
                                                    35.135,
                                                    2.214
                                                ],
                                                [
                                                    36.755,
                                                    2.34
                                                ],
                                                [
                                                    35.314,
                                                    4.446
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 19",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.131,
                                                    -0.888
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.468,
                                                    0.432
                                                ],
                                                [
                                                    0.708,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    -0.456
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.072,
                                                    -0.924
                                                ],
                                                [
                                                    -0.455,
                                                    -0.432
                                                ],
                                                [
                                                    -0.733,
                                                    0
                                                ],
                                                [
                                                    -0.468,
                                                    0.444
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29.969,
                                                    -0.594
                                                ],
                                                [
                                                    35.243,
                                                    -0.594
                                                ],
                                                [
                                                    34.432,
                                                    -2.628
                                                ],
                                                [
                                                    32.687,
                                                    -3.276
                                                ],
                                                [
                                                    30.868,
                                                    -2.592
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 20",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    0.372
                                                ],
                                                [
                                                    -0.672,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.323,
                                                    -0.18
                                                ],
                                                [
                                                    0.168,
                                                    -0.348
                                                ],
                                                [
                                                    0,
                                                    -0.528
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.121,
                                                    -0.816
                                                ],
                                                [
                                                    0.409,
                                                    -0.384
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.479,
                                                    0
                                                ],
                                                [
                                                    -0.313,
                                                    0.168
                                                ],
                                                [
                                                    -0.157,
                                                    0.336
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    38.947,
                                                    5.04
                                                ],
                                                [
                                                    38.947,
                                                    -4.5
                                                ],
                                                [
                                                    40.279,
                                                    -4.5
                                                ],
                                                [
                                                    40.35,
                                                    -2.088
                                                ],
                                                [
                                                    40.206,
                                                    -2.142
                                                ],
                                                [
                                                    40.98,
                                                    -3.924
                                                ],
                                                [
                                                    42.6,
                                                    -4.5
                                                ],
                                                [
                                                    43.536,
                                                    -4.5
                                                ],
                                                [
                                                    43.536,
                                                    -3.06
                                                ],
                                                [
                                                    42.618,
                                                    -3.06
                                                ],
                                                [
                                                    41.413,
                                                    -2.79
                                                ],
                                                [
                                                    40.693,
                                                    -2.016
                                                ],
                                                [
                                                    40.458,
                                                    -0.72
                                                ],
                                                [
                                                    40.458,
                                                    5.04
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 21",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    0.396
                                                ],
                                                [
                                                    0,
                                                    0.84
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    -0.168
                                                ],
                                                [
                                                    -0.395,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.863,
                                                    0
                                                ],
                                                [
                                                    -0.409,
                                                    -0.396
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.432
                                                ],
                                                [
                                                    0.191,
                                                    0.168
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    53.758,
                                                    5.04
                                                ],
                                                [
                                                    51.833,
                                                    4.446
                                                ],
                                                [
                                                    51.221,
                                                    2.592
                                                ],
                                                [
                                                    51.221,
                                                    -6.732
                                                ],
                                                [
                                                    52.732,
                                                    -6.732
                                                ],
                                                [
                                                    52.732,
                                                    2.556
                                                ],
                                                [
                                                    53.021,
                                                    3.456
                                                ],
                                                [
                                                    53.902,
                                                    3.708
                                                ],
                                                [
                                                    55.271,
                                                    3.708
                                                ],
                                                [
                                                    55.271,
                                                    5.04
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 22",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    49.816,
                                                    -3.168
                                                ],
                                                [
                                                    49.816,
                                                    -4.5
                                                ],
                                                [
                                                    55.271,
                                                    -4.5
                                                ],
                                                [
                                                    55.271,
                                                    -3.168
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 23",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.539,
                                                    0
                                                ],
                                                [
                                                    0.588,
                                                    0.456
                                                ],
                                                [
                                                    0,
                                                    0.816
                                                ],
                                                [
                                                    -0.48,
                                                    0.468
                                                ],
                                                [
                                                    -1.043,
                                                    0.192
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.384,
                                                    0.396
                                                ],
                                                [
                                                    0.757,
                                                    0
                                                ],
                                                [
                                                    0.384,
                                                    -0.3
                                                ],
                                                [
                                                    0.144,
                                                    -0.552
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.684,
                                                    0.552
                                                ],
                                                [
                                                    -1.079,
                                                    0
                                                ],
                                                [
                                                    -0.649,
                                                    -0.696
                                                ],
                                                [
                                                    0,
                                                    -1.212
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.071,
                                                    -0.096
                                                ],
                                                [
                                                    -0.181,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.108,
                                                    0
                                                ],
                                                [
                                                    0.12,
                                                    0
                                                ],
                                                [
                                                    0.276,
                                                    0.132
                                                ],
                                                [
                                                    0.12,
                                                    0.288
                                                ],
                                                [
                                                    0,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.323,
                                                    -0.336
                                                ],
                                                [
                                                    0.48,
                                                    -0.192
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.984,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.456
                                                ],
                                                [
                                                    0,
                                                    -0.816
                                                ],
                                                [
                                                    0.479,
                                                    -0.468
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.804
                                                ],
                                                [
                                                    -0.371,
                                                    -0.396
                                                ],
                                                [
                                                    -0.659,
                                                    0
                                                ],
                                                [
                                                    -0.385,
                                                    0.288
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.179,
                                                    -0.9
                                                ],
                                                [
                                                    0.696,
                                                    -0.564
                                                ],
                                                [
                                                    1.224,
                                                    0
                                                ],
                                                [
                                                    0.648,
                                                    0.684
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.216
                                                ],
                                                [
                                                    0.084,
                                                    0.084
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.047,
                                                    0.012
                                                ],
                                                [
                                                    -0.108,
                                                    0.012
                                                ],
                                                [
                                                    -0.432,
                                                    0
                                                ],
                                                [
                                                    -0.263,
                                                    -0.144
                                                ],
                                                [
                                                    -0.121,
                                                    -0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.084,
                                                    0.408
                                                ],
                                                [
                                                    -0.324,
                                                    0.324
                                                ],
                                                [
                                                    -0.479,
                                                    0.18
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    59.714,
                                                    5.256
                                                ],
                                                [
                                                    57.355,
                                                    4.572
                                                ],
                                                [
                                                    56.492,
                                                    2.664
                                                ],
                                                [
                                                    57.212,
                                                    0.738
                                                ],
                                                [
                                                    59.497,
                                                    -0.252
                                                ],
                                                [
                                                    62.882,
                                                    -0.882
                                                ],
                                                [
                                                    62.305,
                                                    -2.682
                                                ],
                                                [
                                                    60.613,
                                                    -3.276
                                                ],
                                                [
                                                    59.048,
                                                    -2.826
                                                ],
                                                [
                                                    58.256,
                                                    -1.566
                                                ],
                                                [
                                                    56.654,
                                                    -1.692
                                                ],
                                                [
                                                    57.95,
                                                    -3.87
                                                ],
                                                [
                                                    60.613,
                                                    -4.716
                                                ],
                                                [
                                                    63.422,
                                                    -3.672
                                                ],
                                                [
                                                    64.394,
                                                    -0.828
                                                ],
                                                [
                                                    64.394,
                                                    3.114
                                                ],
                                                [
                                                    64.501,
                                                    3.582
                                                ],
                                                [
                                                    64.898,
                                                    3.708
                                                ],
                                                [
                                                    65.275,
                                                    3.708
                                                ],
                                                [
                                                    65.275,
                                                    5.04
                                                ],
                                                [
                                                    65.042,
                                                    5.058
                                                ],
                                                [
                                                    64.7,
                                                    5.076
                                                ],
                                                [
                                                    63.637,
                                                    4.878
                                                ],
                                                [
                                                    63.062,
                                                    4.23
                                                ],
                                                [
                                                    62.882,
                                                    3.06
                                                ],
                                                [
                                                    63.062,
                                                    3.096
                                                ],
                                                [
                                                    62.45,
                                                    4.212
                                                ],
                                                [
                                                    61.243,
                                                    4.986
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 24",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.552,
                                                    0
                                                ],
                                                [
                                                    -0.444,
                                                    0.24
                                                ],
                                                [
                                                    -0.24,
                                                    0.42
                                                ],
                                                [
                                                    0,
                                                    0.528
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.252,
                                                    -0.252
                                                ],
                                                [
                                                    0,
                                                    -0.396
                                                ],
                                                [
                                                    -0.312,
                                                    -0.252
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.636,
                                                    0
                                                ],
                                                [
                                                    0.456,
                                                    -0.252
                                                ],
                                                [
                                                    0.241,
                                                    -0.432
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.649,
                                                    0.12
                                                ],
                                                [
                                                    -0.241,
                                                    0.24
                                                ],
                                                [
                                                    0,
                                                    0.444
                                                ],
                                                [
                                                    0.324,
                                                    0.24
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    59.857,
                                                    3.924
                                                ],
                                                [
                                                    61.478,
                                                    3.564
                                                ],
                                                [
                                                    62.521,
                                                    2.556
                                                ],
                                                [
                                                    62.882,
                                                    1.116
                                                ],
                                                [
                                                    62.882,
                                                    0.432
                                                ],
                                                [
                                                    59.786,
                                                    1.008
                                                ],
                                                [
                                                    58.436,
                                                    1.566
                                                ],
                                                [
                                                    58.076,
                                                    2.52
                                                ],
                                                [
                                                    58.544,
                                                    3.564
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 25",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.84,
                                                    0
                                                ],
                                                [
                                                    0.517,
                                                    0.288
                                                ],
                                                [
                                                    0.276,
                                                    0.516
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.504,
                                                    0.312
                                                ],
                                                [
                                                    -0.66,
                                                    0
                                                ],
                                                [
                                                    -0.611,
                                                    -0.408
                                                ],
                                                [
                                                    -0.336,
                                                    -0.744
                                                ],
                                                [
                                                    0,
                                                    -1.02
                                                ],
                                                [
                                                    0.336,
                                                    -0.744
                                                ],
                                                [
                                                    0.612,
                                                    -0.408
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.66,
                                                    0
                                                ],
                                                [
                                                    -0.515,
                                                    -0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.239,
                                                    -0.396
                                                ],
                                                [
                                                    0.504,
                                                    -0.324
                                                ],
                                                [
                                                    0.84,
                                                    0
                                                ],
                                                [
                                                    0.612,
                                                    0.408
                                                ],
                                                [
                                                    0.336,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    1.02
                                                ],
                                                [
                                                    -0.336,
                                                    0.744
                                                ],
                                                [
                                                    -0.611,
                                                    0.408
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    71.288,
                                                    5.256
                                                ],
                                                [
                                                    69.523,
                                                    4.824
                                                ],
                                                [
                                                    68.335,
                                                    3.6
                                                ],
                                                [
                                                    68.281,
                                                    5.04
                                                ],
                                                [
                                                    66.913,
                                                    5.04
                                                ],
                                                [
                                                    66.913,
                                                    -7.74
                                                ],
                                                [
                                                    68.426,
                                                    -7.74
                                                ],
                                                [
                                                    68.426,
                                                    -3.168
                                                ],
                                                [
                                                    69.542,
                                                    -4.23
                                                ],
                                                [
                                                    71.288,
                                                    -4.716
                                                ],
                                                [
                                                    73.465,
                                                    -4.104
                                                ],
                                                [
                                                    74.887,
                                                    -2.376
                                                ],
                                                [
                                                    75.391,
                                                    0.27
                                                ],
                                                [
                                                    74.887,
                                                    2.916
                                                ],
                                                [
                                                    73.465,
                                                    4.644
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 26",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.575,
                                                    0
                                                ],
                                                [
                                                    -0.468,
                                                    0.636
                                                ],
                                                [
                                                    0,
                                                    1.092
                                                ],
                                                [
                                                    0.469,
                                                    0.624
                                                ],
                                                [
                                                    0.78,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    -0.288
                                                ],
                                                [
                                                    0.229,
                                                    -0.528
                                                ],
                                                [
                                                    0,
                                                    -0.744
                                                ],
                                                [
                                                    -0.215,
                                                    -0.54
                                                ],
                                                [
                                                    -0.408,
                                                    -0.288
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.804,
                                                    0
                                                ],
                                                [
                                                    0.469,
                                                    -0.636
                                                ],
                                                [
                                                    0,
                                                    -1.104
                                                ],
                                                [
                                                    -0.468,
                                                    -0.636
                                                ],
                                                [
                                                    -0.588,
                                                    0
                                                ],
                                                [
                                                    -0.42,
                                                    0.276
                                                ],
                                                [
                                                    -0.215,
                                                    0.528
                                                ],
                                                [
                                                    0,
                                                    0.72
                                                ],
                                                [
                                                    0.229,
                                                    0.528
                                                ],
                                                [
                                                    0.42,
                                                    0.288
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    71.197,
                                                    3.816
                                                ],
                                                [
                                                    73.105,
                                                    2.862
                                                ],
                                                [
                                                    73.807,
                                                    0.27
                                                ],
                                                [
                                                    73.105,
                                                    -2.322
                                                ],
                                                [
                                                    71.234,
                                                    -3.276
                                                ],
                                                [
                                                    69.721,
                                                    -2.844
                                                ],
                                                [
                                                    68.749,
                                                    -1.638
                                                ],
                                                [
                                                    68.426,
                                                    0.27
                                                ],
                                                [
                                                    68.749,
                                                    2.16
                                                ],
                                                [
                                                    69.704,
                                                    3.384
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 27",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.347,
                                                    0.288
                                                ],
                                                [
                                                    0,
                                                    0.624
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.097,
                                                    -0.108
                                                ],
                                                [
                                                    -0.192,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.552,
                                                    0
                                                ],
                                                [
                                                    -0.349,
                                                    -0.288
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.192
                                                ],
                                                [
                                                    0.107,
                                                    0.096
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    79.402,
                                                    5.04
                                                ],
                                                [
                                                    78.053,
                                                    4.608
                                                ],
                                                [
                                                    77.531,
                                                    3.24
                                                ],
                                                [
                                                    77.531,
                                                    -7.74
                                                ],
                                                [
                                                    79.042,
                                                    -7.74
                                                ],
                                                [
                                                    79.042,
                                                    3.114
                                                ],
                                                [
                                                    79.187,
                                                    3.564
                                                ],
                                                [
                                                    79.637,
                                                    3.708
                                                ],
                                                [
                                                    80.465,
                                                    3.708
                                                ],
                                                [
                                                    80.465,
                                                    5.04
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 28",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.008,
                                                    0
                                                ],
                                                [
                                                    0.661,
                                                    0.408
                                                ],
                                                [
                                                    0.36,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    -0.349,
                                                    0.744
                                                ],
                                                [
                                                    -0.636,
                                                    0.408
                                                ],
                                                [
                                                    -0.877,
                                                    0
                                                ],
                                                [
                                                    -0.636,
                                                    -0.396
                                                ],
                                                [
                                                    -0.347,
                                                    -0.744
                                                ],
                                                [
                                                    0,
                                                    -1.068
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.479,
                                                    -0.516
                                                ],
                                                [
                                                    -0.828,
                                                    0
                                                ],
                                                [
                                                    -0.397,
                                                    0.288
                                                ],
                                                [
                                                    -0.157,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.708,
                                                    -0.552
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.901,
                                                    0
                                                ],
                                                [
                                                    -0.647,
                                                    -0.408
                                                ],
                                                [
                                                    -0.349,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.008
                                                ],
                                                [
                                                    0.36,
                                                    -0.744
                                                ],
                                                [
                                                    0.648,
                                                    -0.42
                                                ],
                                                [
                                                    0.828,
                                                    0
                                                ],
                                                [
                                                    0.636,
                                                    0.384
                                                ],
                                                [
                                                    0.361,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.059,
                                                    1.02
                                                ],
                                                [
                                                    0.493,
                                                    0.516
                                                ],
                                                [
                                                    0.624,
                                                    0
                                                ],
                                                [
                                                    0.407,
                                                    -0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.252,
                                                    0.852
                                                ],
                                                [
                                                    -0.697,
                                                    0.54
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    85.95,
                                                    5.256
                                                ],
                                                [
                                                    83.609,
                                                    4.644
                                                ],
                                                [
                                                    82.098,
                                                    2.916
                                                ],
                                                [
                                                    81.576,
                                                    0.27
                                                ],
                                                [
                                                    82.098,
                                                    -2.358
                                                ],
                                                [
                                                    83.592,
                                                    -4.086
                                                ],
                                                [
                                                    85.878,
                                                    -4.716
                                                ],
                                                [
                                                    88.074,
                                                    -4.122
                                                ],
                                                [
                                                    89.549,
                                                    -2.43
                                                ],
                                                [
                                                    90.09,
                                                    0.288
                                                ],
                                                [
                                                    90.09,
                                                    0.738
                                                ],
                                                [
                                                    83.16,
                                                    0.738
                                                ],
                                                [
                                                    83.969,
                                                    3.042
                                                ],
                                                [
                                                    85.95,
                                                    3.816
                                                ],
                                                [
                                                    87.48,
                                                    3.384
                                                ],
                                                [
                                                    88.326,
                                                    2.214
                                                ],
                                                [
                                                    89.945,
                                                    2.34
                                                ],
                                                [
                                                    88.506,
                                                    4.446
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 29",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.132,
                                                    -0.888
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.468,
                                                    0.432
                                                ],
                                                [
                                                    0.707,
                                                    0
                                                ],
                                                [
                                                    0.481,
                                                    -0.456
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.073,
                                                    -0.924
                                                ],
                                                [
                                                    -0.457,
                                                    -0.432
                                                ],
                                                [
                                                    -0.732,
                                                    0
                                                ],
                                                [
                                                    -0.467,
                                                    0.444
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    83.16,
                                                    -0.594
                                                ],
                                                [
                                                    88.434,
                                                    -0.594
                                                ],
                                                [
                                                    87.624,
                                                    -2.628
                                                ],
                                                [
                                                    85.878,
                                                    -3.276
                                                ],
                                                [
                                                    84.059,
                                                    -2.592
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            140.745,
                                            391.96
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 2",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -6.351,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -6.351
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    6.351,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    6.351
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    6.351,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    6.351
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -6.351,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -6.351
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -171,
                                                    -21.5
                                                ],
                                                [
                                                    171,
                                                    -21.5
                                                ],
                                                [
                                                    182.5,
                                                    -10
                                                ],
                                                [
                                                    182.5,
                                                    10
                                                ],
                                                [
                                                    171,
                                                    21.5
                                                ],
                                                [
                                                    -171,
                                                    21.5
                                                ],
                                                [
                                                    -182.5,
                                                    10
                                                ],
                                                [
                                                    -182.5,
                                                    -10
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8392,
                                            0.8392,
                                            0.8392
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            221,
                                            391
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 3",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.984,
                                                    0
                                                ],
                                                [
                                                    0.732,
                                                    0.384
                                                ],
                                                [
                                                    0.396,
                                                    0.708
                                                ],
                                                [
                                                    0,
                                                    0.972
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.564,
                                                    -0.564
                                                ],
                                                [
                                                    -1.044,
                                                    0
                                                ],
                                                [
                                                    -0.564,
                                                    0.564
                                                ],
                                                [
                                                    0,
                                                    1.032
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.396,
                                                    -0.72
                                                ],
                                                [
                                                    0.72,
                                                    -0.384
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.984,
                                                    0
                                                ],
                                                [
                                                    -0.72,
                                                    -0.384
                                                ],
                                                [
                                                    -0.384,
                                                    -0.72
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    1.032
                                                ],
                                                [
                                                    0.576,
                                                    0.564
                                                ],
                                                [
                                                    1.032,
                                                    0
                                                ],
                                                [
                                                    0.576,
                                                    -0.564
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.972
                                                ],
                                                [
                                                    -0.384,
                                                    0.708
                                                ],
                                                [
                                                    -0.72,
                                                    0.384
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -77.324,
                                                    5.337
                                                ],
                                                [
                                                    -79.898,
                                                    4.761
                                                ],
                                                [
                                                    -81.572,
                                                    3.123
                                                ],
                                                [
                                                    -82.148,
                                                    0.585
                                                ],
                                                [
                                                    -82.148,
                                                    -7.731
                                                ],
                                                [
                                                    -80.6,
                                                    -7.731
                                                ],
                                                [
                                                    -80.6,
                                                    0.585
                                                ],
                                                [
                                                    -79.754,
                                                    2.979
                                                ],
                                                [
                                                    -77.324,
                                                    3.825
                                                ],
                                                [
                                                    -74.93,
                                                    2.979
                                                ],
                                                [
                                                    -74.066,
                                                    0.585
                                                ],
                                                [
                                                    -74.066,
                                                    -7.731
                                                ],
                                                [
                                                    -72.518,
                                                    -7.731
                                                ],
                                                [
                                                    -72.518,
                                                    0.585
                                                ],
                                                [
                                                    -73.112,
                                                    3.123
                                                ],
                                                [
                                                    -74.768,
                                                    4.761
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.552,
                                                    0.36
                                                ],
                                                [
                                                    -0.732,
                                                    0
                                                ],
                                                [
                                                    -0.6,
                                                    -0.468
                                                ],
                                                [
                                                    -0.288,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -0.876
                                                ],
                                                [
                                                    0.3,
                                                    -0.756
                                                ],
                                                [
                                                    0.612,
                                                    -0.468
                                                ],
                                                [
                                                    0.948,
                                                    0
                                                ],
                                                [
                                                    0.432,
                                                    0.168
                                                ],
                                                [
                                                    0.3,
                                                    0.3
                                                ],
                                                [
                                                    0.108,
                                                    0.408
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.24,
                                                    -0.708
                                                ],
                                                [
                                                    0.564,
                                                    -0.372
                                                ],
                                                [
                                                    0.948,
                                                    0
                                                ],
                                                [
                                                    0.612,
                                                    0.468
                                                ],
                                                [
                                                    0.3,
                                                    0.756
                                                ],
                                                [
                                                    0,
                                                    0.876
                                                ],
                                                [
                                                    -0.288,
                                                    0.756
                                                ],
                                                [
                                                    -0.6,
                                                    0.468
                                                ],
                                                [
                                                    -0.492,
                                                    0
                                                ],
                                                [
                                                    -0.42,
                                                    -0.168
                                                ],
                                                [
                                                    -0.288,
                                                    -0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -69.683,
                                                    7.749
                                                ],
                                                [
                                                    -69.683,
                                                    -4.491
                                                ],
                                                [
                                                    -68.279,
                                                    -4.491
                                                ],
                                                [
                                                    -68.243,
                                                    -2.439
                                                ],
                                                [
                                                    -68.459,
                                                    -2.547
                                                ],
                                                [
                                                    -67.271,
                                                    -4.149
                                                ],
                                                [
                                                    -65.327,
                                                    -4.707
                                                ],
                                                [
                                                    -63.005,
                                                    -4.005
                                                ],
                                                [
                                                    -61.655,
                                                    -2.169
                                                ],
                                                [
                                                    -61.205,
                                                    0.279
                                                ],
                                                [
                                                    -61.655,
                                                    2.727
                                                ],
                                                [
                                                    -63.005,
                                                    4.563
                                                ],
                                                [
                                                    -65.327,
                                                    5.265
                                                ],
                                                [
                                                    -66.713,
                                                    5.013
                                                ],
                                                [
                                                    -67.793,
                                                    4.311
                                                ],
                                                [
                                                    -68.387,
                                                    3.249
                                                ],
                                                [
                                                    -68.171,
                                                    2.997
                                                ],
                                                [
                                                    -68.171,
                                                    7.749
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.552,
                                                    0
                                                ],
                                                [
                                                    -0.48,
                                                    0.624
                                                ],
                                                [
                                                    0,
                                                    1.116
                                                ],
                                                [
                                                    0.48,
                                                    0.624
                                                ],
                                                [
                                                    0.828,
                                                    0
                                                ],
                                                [
                                                    0.408,
                                                    -0.264
                                                ],
                                                [
                                                    0.228,
                                                    -0.528
                                                ],
                                                [
                                                    0,
                                                    -0.78
                                                ],
                                                [
                                                    -0.216,
                                                    -0.528
                                                ],
                                                [
                                                    -0.408,
                                                    -0.264
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.828,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    -0.624
                                                ],
                                                [
                                                    0,
                                                    -1.116
                                                ],
                                                [
                                                    -0.48,
                                                    -0.624
                                                ],
                                                [
                                                    -0.552,
                                                    0
                                                ],
                                                [
                                                    -0.396,
                                                    0.264
                                                ],
                                                [
                                                    -0.216,
                                                    0.528
                                                ],
                                                [
                                                    0,
                                                    0.78
                                                ],
                                                [
                                                    0.216,
                                                    0.528
                                                ],
                                                [
                                                    0.408,
                                                    0.264
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -65.471,
                                                    3.825
                                                ],
                                                [
                                                    -63.509,
                                                    2.889
                                                ],
                                                [
                                                    -62.789,
                                                    0.279
                                                ],
                                                [
                                                    -63.509,
                                                    -2.331
                                                ],
                                                [
                                                    -65.471,
                                                    -3.267
                                                ],
                                                [
                                                    -66.911,
                                                    -2.871
                                                ],
                                                [
                                                    -67.847,
                                                    -1.683
                                                ],
                                                [
                                                    -68.171,
                                                    0.279
                                                ],
                                                [
                                                    -67.847,
                                                    2.241
                                                ],
                                                [
                                                    -66.911,
                                                    3.429
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.612,
                                                    0.408
                                                ],
                                                [
                                                    0.324,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    1.02
                                                ],
                                                [
                                                    -0.324,
                                                    0.744
                                                ],
                                                [
                                                    -0.6,
                                                    0.408
                                                ],
                                                [
                                                    -0.828,
                                                    0
                                                ],
                                                [
                                                    -0.528,
                                                    -0.276
                                                ],
                                                [
                                                    -0.264,
                                                    -0.492
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.54,
                                                    -0.3
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.828,
                                                    0
                                                ],
                                                [
                                                    -0.6,
                                                    -0.408
                                                ],
                                                [
                                                    -0.324,
                                                    -0.744
                                                ],
                                                [
                                                    0,
                                                    -1.02
                                                ],
                                                [
                                                    0.324,
                                                    -0.744
                                                ],
                                                [
                                                    0.612,
                                                    -0.408
                                                ],
                                                [
                                                    0.636,
                                                    0
                                                ],
                                                [
                                                    0.528,
                                                    0.264
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.264,
                                                    0.516
                                                ],
                                                [
                                                    -0.54,
                                                    0.288
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -55.77,
                                                    5.265
                                                ],
                                                [
                                                    -57.93,
                                                    4.653
                                                ],
                                                [
                                                    -59.316,
                                                    2.925
                                                ],
                                                [
                                                    -59.802,
                                                    0.279
                                                ],
                                                [
                                                    -59.316,
                                                    -2.367
                                                ],
                                                [
                                                    -57.93,
                                                    -4.095
                                                ],
                                                [
                                                    -55.77,
                                                    -4.707
                                                ],
                                                [
                                                    -54.024,
                                                    -4.293
                                                ],
                                                [
                                                    -52.836,
                                                    -3.159
                                                ],
                                                [
                                                    -52.836,
                                                    -7.731
                                                ],
                                                [
                                                    -51.324,
                                                    -7.731
                                                ],
                                                [
                                                    -51.324,
                                                    5.049
                                                ],
                                                [
                                                    -52.692,
                                                    5.049
                                                ],
                                                [
                                                    -52.746,
                                                    3.609
                                                ],
                                                [
                                                    -53.952,
                                                    4.833
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.84,
                                                    0
                                                ],
                                                [
                                                    -0.384,
                                                    0.288
                                                ],
                                                [
                                                    -0.204,
                                                    0.528
                                                ],
                                                [
                                                    0,
                                                    0.72
                                                ],
                                                [
                                                    0.204,
                                                    0.528
                                                ],
                                                [
                                                    0.396,
                                                    0.276
                                                ],
                                                [
                                                    0.564,
                                                    0
                                                ],
                                                [
                                                    0.504,
                                                    -0.636
                                                ],
                                                [
                                                    0,
                                                    -1.104
                                                ],
                                                [
                                                    -0.492,
                                                    -0.636
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.564,
                                                    0
                                                ],
                                                [
                                                    0.396,
                                                    -0.288
                                                ],
                                                [
                                                    0.204,
                                                    -0.54
                                                ],
                                                [
                                                    0,
                                                    -0.744
                                                ],
                                                [
                                                    -0.204,
                                                    -0.528
                                                ],
                                                [
                                                    -0.384,
                                                    -0.288
                                                ],
                                                [
                                                    -0.84,
                                                    0
                                                ],
                                                [
                                                    -0.492,
                                                    0.624
                                                ],
                                                [
                                                    0,
                                                    1.092
                                                ],
                                                [
                                                    0.504,
                                                    0.636
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -55.464,
                                                    3.825
                                                ],
                                                [
                                                    -54.042,
                                                    3.393
                                                ],
                                                [
                                                    -53.142,
                                                    2.169
                                                ],
                                                [
                                                    -52.836,
                                                    0.279
                                                ],
                                                [
                                                    -53.142,
                                                    -1.629
                                                ],
                                                [
                                                    -54.042,
                                                    -2.835
                                                ],
                                                [
                                                    -55.464,
                                                    -3.267
                                                ],
                                                [
                                                    -57.48,
                                                    -2.313
                                                ],
                                                [
                                                    -58.218,
                                                    0.279
                                                ],
                                                [
                                                    -57.48,
                                                    2.871
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.54,
                                                    0
                                                ],
                                                [
                                                    0.588,
                                                    0.456
                                                ],
                                                [
                                                    0,
                                                    0.816
                                                ],
                                                [
                                                    -0.48,
                                                    0.468
                                                ],
                                                [
                                                    -1.044,
                                                    0.192
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.384,
                                                    0.396
                                                ],
                                                [
                                                    0.756,
                                                    0
                                                ],
                                                [
                                                    0.384,
                                                    -0.3
                                                ],
                                                [
                                                    0.144,
                                                    -0.552
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.684,
                                                    0.552
                                                ],
                                                [
                                                    -1.08,
                                                    0
                                                ],
                                                [
                                                    -0.648,
                                                    -0.696
                                                ],
                                                [
                                                    0,
                                                    -1.212
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.072,
                                                    -0.096
                                                ],
                                                [
                                                    -0.18,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.108,
                                                    0
                                                ],
                                                [
                                                    0.12,
                                                    0
                                                ],
                                                [
                                                    0.276,
                                                    0.132
                                                ],
                                                [
                                                    0.12,
                                                    0.288
                                                ],
                                                [
                                                    0,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.324,
                                                    -0.336
                                                ],
                                                [
                                                    0.48,
                                                    -0.192
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.984,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.456
                                                ],
                                                [
                                                    0,
                                                    -0.816
                                                ],
                                                [
                                                    0.48,
                                                    -0.468
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.804
                                                ],
                                                [
                                                    -0.372,
                                                    -0.396
                                                ],
                                                [
                                                    -0.66,
                                                    0
                                                ],
                                                [
                                                    -0.384,
                                                    0.288
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.18,
                                                    -0.9
                                                ],
                                                [
                                                    0.696,
                                                    -0.564
                                                ],
                                                [
                                                    1.224,
                                                    0
                                                ],
                                                [
                                                    0.648,
                                                    0.684
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.216
                                                ],
                                                [
                                                    0.084,
                                                    0.084
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.048,
                                                    0.012
                                                ],
                                                [
                                                    -0.108,
                                                    0.012
                                                ],
                                                [
                                                    -0.432,
                                                    0
                                                ],
                                                [
                                                    -0.264,
                                                    -0.144
                                                ],
                                                [
                                                    -0.12,
                                                    -0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.084,
                                                    0.408
                                                ],
                                                [
                                                    -0.324,
                                                    0.324
                                                ],
                                                [
                                                    -0.48,
                                                    0.18
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -46.051,
                                                    5.265
                                                ],
                                                [
                                                    -48.409,
                                                    4.581
                                                ],
                                                [
                                                    -49.273,
                                                    2.673
                                                ],
                                                [
                                                    -48.553,
                                                    0.747
                                                ],
                                                [
                                                    -46.267,
                                                    -0.243
                                                ],
                                                [
                                                    -42.883,
                                                    -0.873
                                                ],
                                                [
                                                    -43.459,
                                                    -2.673
                                                ],
                                                [
                                                    -45.151,
                                                    -3.267
                                                ],
                                                [
                                                    -46.717,
                                                    -2.817
                                                ],
                                                [
                                                    -47.509,
                                                    -1.557
                                                ],
                                                [
                                                    -49.111,
                                                    -1.683
                                                ],
                                                [
                                                    -47.815,
                                                    -3.861
                                                ],
                                                [
                                                    -45.151,
                                                    -4.707
                                                ],
                                                [
                                                    -42.343,
                                                    -3.663
                                                ],
                                                [
                                                    -41.371,
                                                    -0.819
                                                ],
                                                [
                                                    -41.371,
                                                    3.123
                                                ],
                                                [
                                                    -41.263,
                                                    3.591
                                                ],
                                                [
                                                    -40.867,
                                                    3.717
                                                ],
                                                [
                                                    -40.489,
                                                    3.717
                                                ],
                                                [
                                                    -40.489,
                                                    5.049
                                                ],
                                                [
                                                    -40.723,
                                                    5.067
                                                ],
                                                [
                                                    -41.065,
                                                    5.085
                                                ],
                                                [
                                                    -42.127,
                                                    4.887
                                                ],
                                                [
                                                    -42.703,
                                                    4.239
                                                ],
                                                [
                                                    -42.883,
                                                    3.069
                                                ],
                                                [
                                                    -42.703,
                                                    3.105
                                                ],
                                                [
                                                    -43.315,
                                                    4.221
                                                ],
                                                [
                                                    -44.521,
                                                    4.995
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.552,
                                                    0
                                                ],
                                                [
                                                    -0.444,
                                                    0.24
                                                ],
                                                [
                                                    -0.24,
                                                    0.42
                                                ],
                                                [
                                                    0,
                                                    0.528
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.252,
                                                    -0.252
                                                ],
                                                [
                                                    0,
                                                    -0.396
                                                ],
                                                [
                                                    -0.312,
                                                    -0.252
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.636,
                                                    0
                                                ],
                                                [
                                                    0.456,
                                                    -0.252
                                                ],
                                                [
                                                    0.24,
                                                    -0.432
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.648,
                                                    0.12
                                                ],
                                                [
                                                    -0.24,
                                                    0.24
                                                ],
                                                [
                                                    0,
                                                    0.444
                                                ],
                                                [
                                                    0.324,
                                                    0.24
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -45.907,
                                                    3.933
                                                ],
                                                [
                                                    -44.287,
                                                    3.573
                                                ],
                                                [
                                                    -43.243,
                                                    2.565
                                                ],
                                                [
                                                    -42.883,
                                                    1.125
                                                ],
                                                [
                                                    -42.883,
                                                    0.441
                                                ],
                                                [
                                                    -45.979,
                                                    1.017
                                                ],
                                                [
                                                    -47.329,
                                                    1.575
                                                ],
                                                [
                                                    -47.689,
                                                    2.529
                                                ],
                                                [
                                                    -47.221,
                                                    3.573
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    0.396
                                                ],
                                                [
                                                    0,
                                                    0.84
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    -0.168
                                                ],
                                                [
                                                    -0.396,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.864,
                                                    0
                                                ],
                                                [
                                                    -0.408,
                                                    -0.396
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.432
                                                ],
                                                [
                                                    0.192,
                                                    0.168
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -36.115,
                                                    5.049
                                                ],
                                                [
                                                    -38.041,
                                                    4.455
                                                ],
                                                [
                                                    -38.653,
                                                    2.601
                                                ],
                                                [
                                                    -38.653,
                                                    -6.723
                                                ],
                                                [
                                                    -37.141,
                                                    -6.723
                                                ],
                                                [
                                                    -37.141,
                                                    2.565
                                                ],
                                                [
                                                    -36.853,
                                                    3.465
                                                ],
                                                [
                                                    -35.971,
                                                    3.717
                                                ],
                                                [
                                                    -34.603,
                                                    3.717
                                                ],
                                                [
                                                    -34.603,
                                                    5.049
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -40.057,
                                                    -3.159
                                                ],
                                                [
                                                    -40.057,
                                                    -4.491
                                                ],
                                                [
                                                    -34.603,
                                                    -4.491
                                                ],
                                                [
                                                    -34.603,
                                                    -3.159
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.008,
                                                    0
                                                ],
                                                [
                                                    0.66,
                                                    0.408
                                                ],
                                                [
                                                    0.36,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    -0.348,
                                                    0.744
                                                ],
                                                [
                                                    -0.636,
                                                    0.408
                                                ],
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.636,
                                                    -0.396
                                                ],
                                                [
                                                    -0.348,
                                                    -0.744
                                                ],
                                                [
                                                    0,
                                                    -1.068
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.48,
                                                    -0.516
                                                ],
                                                [
                                                    -0.828,
                                                    0
                                                ],
                                                [
                                                    -0.396,
                                                    0.288
                                                ],
                                                [
                                                    -0.156,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.708,
                                                    -0.552
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.9,
                                                    0
                                                ],
                                                [
                                                    -0.648,
                                                    -0.408
                                                ],
                                                [
                                                    -0.348,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.008
                                                ],
                                                [
                                                    0.36,
                                                    -0.744
                                                ],
                                                [
                                                    0.648,
                                                    -0.42
                                                ],
                                                [
                                                    0.828,
                                                    0
                                                ],
                                                [
                                                    0.636,
                                                    0.384
                                                ],
                                                [
                                                    0.36,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.06,
                                                    1.02
                                                ],
                                                [
                                                    0.492,
                                                    0.516
                                                ],
                                                [
                                                    0.624,
                                                    0
                                                ],
                                                [
                                                    0.408,
                                                    -0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.252,
                                                    0.852
                                                ],
                                                [
                                                    -0.696,
                                                    0.54
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -29.114,
                                                    5.265
                                                ],
                                                [
                                                    -31.454,
                                                    4.653
                                                ],
                                                [
                                                    -32.966,
                                                    2.925
                                                ],
                                                [
                                                    -33.488,
                                                    0.279
                                                ],
                                                [
                                                    -32.966,
                                                    -2.349
                                                ],
                                                [
                                                    -31.472,
                                                    -4.077
                                                ],
                                                [
                                                    -29.186,
                                                    -4.707
                                                ],
                                                [
                                                    -26.99,
                                                    -4.113
                                                ],
                                                [
                                                    -25.514,
                                                    -2.421
                                                ],
                                                [
                                                    -24.974,
                                                    0.297
                                                ],
                                                [
                                                    -24.974,
                                                    0.747
                                                ],
                                                [
                                                    -31.904,
                                                    0.747
                                                ],
                                                [
                                                    -31.094,
                                                    3.051
                                                ],
                                                [
                                                    -29.114,
                                                    3.825
                                                ],
                                                [
                                                    -27.584,
                                                    3.393
                                                ],
                                                [
                                                    -26.738,
                                                    2.223
                                                ],
                                                [
                                                    -25.118,
                                                    2.349
                                                ],
                                                [
                                                    -26.558,
                                                    4.455
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.132,
                                                    -0.888
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.468,
                                                    0.432
                                                ],
                                                [
                                                    0.708,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    -0.456
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.072,
                                                    -0.924
                                                ],
                                                [
                                                    -0.456,
                                                    -0.432
                                                ],
                                                [
                                                    -0.732,
                                                    0
                                                ],
                                                [
                                                    -0.468,
                                                    0.444
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -31.904,
                                                    -0.585
                                                ],
                                                [
                                                    -26.63,
                                                    -0.585
                                                ],
                                                [
                                                    -27.44,
                                                    -2.619
                                                ],
                                                [
                                                    -29.186,
                                                    -3.267
                                                ],
                                                [
                                                    -31.004,
                                                    -2.583
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    0.396
                                                ],
                                                [
                                                    0,
                                                    0.84
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    -0.168
                                                ],
                                                [
                                                    -0.396,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.864,
                                                    0
                                                ],
                                                [
                                                    -0.408,
                                                    -0.396
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.432
                                                ],
                                                [
                                                    0.192,
                                                    0.168
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -14.758,
                                                    5.049
                                                ],
                                                [
                                                    -16.684,
                                                    4.455
                                                ],
                                                [
                                                    -17.296,
                                                    2.601
                                                ],
                                                [
                                                    -17.296,
                                                    -6.723
                                                ],
                                                [
                                                    -15.784,
                                                    -6.723
                                                ],
                                                [
                                                    -15.784,
                                                    2.565
                                                ],
                                                [
                                                    -15.496,
                                                    3.465
                                                ],
                                                [
                                                    -14.614,
                                                    3.717
                                                ],
                                                [
                                                    -13.246,
                                                    3.717
                                                ],
                                                [
                                                    -13.246,
                                                    5.049
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -18.7,
                                                    -3.159
                                                ],
                                                [
                                                    -18.7,
                                                    -4.491
                                                ],
                                                [
                                                    -13.246,
                                                    -4.491
                                                ],
                                                [
                                                    -13.246,
                                                    -3.159
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 14",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -11.483,
                                                    5.049
                                                ],
                                                [
                                                    -11.483,
                                                    -4.491
                                                ],
                                                [
                                                    -9.971,
                                                    -4.491
                                                ],
                                                [
                                                    -9.971,
                                                    5.049
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 15",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -11.519,
                                                    -5.985
                                                ],
                                                [
                                                    -11.519,
                                                    -7.749
                                                ],
                                                [
                                                    -9.935,
                                                    -7.749
                                                ],
                                                [
                                                    -9.935,
                                                    -5.985
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 16",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.732,
                                                    0
                                                ],
                                                [
                                                    0.66,
                                                    0.408
                                                ],
                                                [
                                                    0.36,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    -0.36,
                                                    0.744
                                                ],
                                                [
                                                    -0.648,
                                                    0.408
                                                ],
                                                [
                                                    -0.888,
                                                    0
                                                ],
                                                [
                                                    -0.564,
                                                    -0.264
                                                ],
                                                [
                                                    -0.36,
                                                    -0.492
                                                ],
                                                [
                                                    -0.108,
                                                    -0.708
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.444,
                                                    0.336
                                                ],
                                                [
                                                    0.648,
                                                    0
                                                ],
                                                [
                                                    0.492,
                                                    -0.636
                                                ],
                                                [
                                                    0,
                                                    -1.104
                                                ],
                                                [
                                                    -0.492,
                                                    -0.636
                                                ],
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.444,
                                                    0.36
                                                ],
                                                [
                                                    -0.108,
                                                    0.72
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.36,
                                                    -0.528
                                                ],
                                                [
                                                    0.576,
                                                    -0.288
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.888,
                                                    0
                                                ],
                                                [
                                                    -0.648,
                                                    -0.408
                                                ],
                                                [
                                                    -0.36,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.008
                                                ],
                                                [
                                                    0.36,
                                                    -0.744
                                                ],
                                                [
                                                    0.66,
                                                    -0.42
                                                ],
                                                [
                                                    0.732,
                                                    0
                                                ],
                                                [
                                                    0.576,
                                                    0.252
                                                ],
                                                [
                                                    0.36,
                                                    0.492
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.108,
                                                    -0.636
                                                ],
                                                [
                                                    -0.444,
                                                    -0.348
                                                ],
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.492,
                                                    0.624
                                                ],
                                                [
                                                    0,
                                                    1.104
                                                ],
                                                [
                                                    0.492,
                                                    0.624
                                                ],
                                                [
                                                    0.648,
                                                    0
                                                ],
                                                [
                                                    0.444,
                                                    -0.36
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.108,
                                                    0.708
                                                ],
                                                [
                                                    -0.36,
                                                    0.516
                                                ],
                                                [
                                                    -0.564,
                                                    0.288
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -3.538,
                                                    5.265
                                                ],
                                                [
                                                    -5.86,
                                                    4.653
                                                ],
                                                [
                                                    -7.372,
                                                    2.925
                                                ],
                                                [
                                                    -7.912,
                                                    0.279
                                                ],
                                                [
                                                    -7.372,
                                                    -2.349
                                                ],
                                                [
                                                    -5.86,
                                                    -4.077
                                                ],
                                                [
                                                    -3.538,
                                                    -4.707
                                                ],
                                                [
                                                    -1.594,
                                                    -4.311
                                                ],
                                                [
                                                    -0.19,
                                                    -3.195
                                                ],
                                                [
                                                    0.512,
                                                    -1.395
                                                ],
                                                [
                                                    -1.072,
                                                    -1.287
                                                ],
                                                [
                                                    -1.9,
                                                    -2.745
                                                ],
                                                [
                                                    -3.538,
                                                    -3.267
                                                ],
                                                [
                                                    -5.59,
                                                    -2.313
                                                ],
                                                [
                                                    -6.328,
                                                    0.279
                                                ],
                                                [
                                                    -5.59,
                                                    2.889
                                                ],
                                                [
                                                    -3.538,
                                                    3.825
                                                ],
                                                [
                                                    -1.9,
                                                    3.285
                                                ],
                                                [
                                                    -1.072,
                                                    1.665
                                                ],
                                                [
                                                    0.512,
                                                    1.773
                                                ],
                                                [
                                                    -0.19,
                                                    3.627
                                                ],
                                                [
                                                    -1.594,
                                                    4.833
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 17",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.386,
                                                    5.049
                                                ],
                                                [
                                                    2.386,
                                                    -7.731
                                                ],
                                                [
                                                    3.898,
                                                    -7.731
                                                ],
                                                [
                                                    3.898,
                                                    0.639
                                                ],
                                                [
                                                    8.542,
                                                    -4.491
                                                ],
                                                [
                                                    10.558,
                                                    -4.491
                                                ],
                                                [
                                                    6.796,
                                                    -0.441
                                                ],
                                                [
                                                    10.72,
                                                    5.049
                                                ],
                                                [
                                                    8.884,
                                                    5.049
                                                ],
                                                [
                                                    5.77,
                                                    0.585
                                                ],
                                                [
                                                    3.898,
                                                    2.565
                                                ],
                                                [
                                                    3.898,
                                                    5.049
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 18",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.008,
                                                    0
                                                ],
                                                [
                                                    0.66,
                                                    0.408
                                                ],
                                                [
                                                    0.36,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    -0.348,
                                                    0.744
                                                ],
                                                [
                                                    -0.636,
                                                    0.408
                                                ],
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.636,
                                                    -0.396
                                                ],
                                                [
                                                    -0.348,
                                                    -0.744
                                                ],
                                                [
                                                    0,
                                                    -1.068
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.48,
                                                    -0.516
                                                ],
                                                [
                                                    -0.828,
                                                    0
                                                ],
                                                [
                                                    -0.396,
                                                    0.288
                                                ],
                                                [
                                                    -0.156,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.708,
                                                    -0.552
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.9,
                                                    0
                                                ],
                                                [
                                                    -0.648,
                                                    -0.408
                                                ],
                                                [
                                                    -0.348,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.008
                                                ],
                                                [
                                                    0.36,
                                                    -0.744
                                                ],
                                                [
                                                    0.648,
                                                    -0.42
                                                ],
                                                [
                                                    0.828,
                                                    0
                                                ],
                                                [
                                                    0.636,
                                                    0.384
                                                ],
                                                [
                                                    0.36,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.06,
                                                    1.02
                                                ],
                                                [
                                                    0.492,
                                                    0.516
                                                ],
                                                [
                                                    0.624,
                                                    0
                                                ],
                                                [
                                                    0.408,
                                                    -0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.252,
                                                    0.852
                                                ],
                                                [
                                                    -0.696,
                                                    0.54
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.833,
                                                    5.265
                                                ],
                                                [
                                                    13.493,
                                                    4.653
                                                ],
                                                [
                                                    11.981,
                                                    2.925
                                                ],
                                                [
                                                    11.459,
                                                    0.279
                                                ],
                                                [
                                                    11.981,
                                                    -2.349
                                                ],
                                                [
                                                    13.475,
                                                    -4.077
                                                ],
                                                [
                                                    15.761,
                                                    -4.707
                                                ],
                                                [
                                                    17.957,
                                                    -4.113
                                                ],
                                                [
                                                    19.433,
                                                    -2.421
                                                ],
                                                [
                                                    19.973,
                                                    0.297
                                                ],
                                                [
                                                    19.973,
                                                    0.747
                                                ],
                                                [
                                                    13.043,
                                                    0.747
                                                ],
                                                [
                                                    13.853,
                                                    3.051
                                                ],
                                                [
                                                    15.833,
                                                    3.825
                                                ],
                                                [
                                                    17.363,
                                                    3.393
                                                ],
                                                [
                                                    18.209,
                                                    2.223
                                                ],
                                                [
                                                    19.829,
                                                    2.349
                                                ],
                                                [
                                                    18.389,
                                                    4.455
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 19",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.132,
                                                    -0.888
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.468,
                                                    0.432
                                                ],
                                                [
                                                    0.708,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    -0.456
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.072,
                                                    -0.924
                                                ],
                                                [
                                                    -0.456,
                                                    -0.432
                                                ],
                                                [
                                                    -0.732,
                                                    0
                                                ],
                                                [
                                                    -0.468,
                                                    0.444
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    13.043,
                                                    -0.585
                                                ],
                                                [
                                                    18.317,
                                                    -0.585
                                                ],
                                                [
                                                    17.507,
                                                    -2.619
                                                ],
                                                [
                                                    15.761,
                                                    -3.267
                                                ],
                                                [
                                                    13.943,
                                                    -2.583
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 20",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    0.396
                                                ],
                                                [
                                                    0,
                                                    0.84
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    -0.168
                                                ],
                                                [
                                                    -0.396,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.864,
                                                    0
                                                ],
                                                [
                                                    -0.408,
                                                    -0.396
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.432
                                                ],
                                                [
                                                    0.192,
                                                    0.168
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    25.144,
                                                    5.049
                                                ],
                                                [
                                                    23.218,
                                                    4.455
                                                ],
                                                [
                                                    22.606,
                                                    2.601
                                                ],
                                                [
                                                    22.606,
                                                    -6.723
                                                ],
                                                [
                                                    24.118,
                                                    -6.723
                                                ],
                                                [
                                                    24.118,
                                                    2.565
                                                ],
                                                [
                                                    24.406,
                                                    3.465
                                                ],
                                                [
                                                    25.288,
                                                    3.717
                                                ],
                                                [
                                                    26.656,
                                                    3.717
                                                ],
                                                [
                                                    26.656,
                                                    5.049
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 21",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    21.202,
                                                    -3.159
                                                ],
                                                [
                                                    21.202,
                                                    -4.491
                                                ],
                                                [
                                                    26.656,
                                                    -4.491
                                                ],
                                                [
                                                    26.656,
                                                    -3.159
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 22",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.056,
                                                    0
                                                ],
                                                [
                                                    0.6,
                                                    0.276
                                                ],
                                                [
                                                    0.324,
                                                    0.48
                                                ],
                                                [
                                                    0.048,
                                                    0.624
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.372,
                                                    -0.348
                                                ],
                                                [
                                                    -0.84,
                                                    0
                                                ],
                                                [
                                                    -0.348,
                                                    0.204
                                                ],
                                                [
                                                    0,
                                                    0.468
                                                ],
                                                [
                                                    0.12,
                                                    0.168
                                                ],
                                                [
                                                    0.336,
                                                    0.12
                                                ],
                                                [
                                                    0.648,
                                                    0.12
                                                ],
                                                [
                                                    0.504,
                                                    0.252
                                                ],
                                                [
                                                    0.204,
                                                    0.36
                                                ],
                                                [
                                                    0,
                                                    0.504
                                                ],
                                                [
                                                    -0.624,
                                                    0.54
                                                ],
                                                [
                                                    -1.152,
                                                    0
                                                ],
                                                [
                                                    -0.528,
                                                    -0.3
                                                ],
                                                [
                                                    -0.276,
                                                    -0.468
                                                ],
                                                [
                                                    -0.06,
                                                    -0.516
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.156,
                                                    0.264
                                                ],
                                                [
                                                    0.312,
                                                    0.156
                                                ],
                                                [
                                                    0.528,
                                                    0
                                                ],
                                                [
                                                    0.324,
                                                    -0.264
                                                ],
                                                [
                                                    0,
                                                    -0.408
                                                ],
                                                [
                                                    -0.12,
                                                    -0.204
                                                ],
                                                [
                                                    -0.312,
                                                    -0.132
                                                ],
                                                [
                                                    -0.552,
                                                    -0.096
                                                ],
                                                [
                                                    -0.528,
                                                    -0.24
                                                ],
                                                [
                                                    -0.204,
                                                    -0.36
                                                ],
                                                [
                                                    0,
                                                    -0.504
                                                ],
                                                [
                                                    0.684,
                                                    -0.492
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.588,
                                                    -0.276
                                                ],
                                                [
                                                    -0.312,
                                                    -0.492
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.096,
                                                    0.576
                                                ],
                                                [
                                                    0.384,
                                                    0.336
                                                ],
                                                [
                                                    0.648,
                                                    0
                                                ],
                                                [
                                                    0.36,
                                                    -0.216
                                                ],
                                                [
                                                    0,
                                                    -0.252
                                                ],
                                                [
                                                    -0.108,
                                                    -0.168
                                                ],
                                                [
                                                    -0.336,
                                                    -0.132
                                                ],
                                                [
                                                    -0.888,
                                                    -0.168
                                                ],
                                                [
                                                    -0.504,
                                                    -0.252
                                                ],
                                                [
                                                    -0.204,
                                                    -0.36
                                                ],
                                                [
                                                    0,
                                                    -0.852
                                                ],
                                                [
                                                    0.636,
                                                    -0.552
                                                ],
                                                [
                                                    0.84,
                                                    0
                                                ],
                                                [
                                                    0.54,
                                                    0.288
                                                ],
                                                [
                                                    0.276,
                                                    0.468
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.024,
                                                    -0.3
                                                ],
                                                [
                                                    -0.156,
                                                    -0.264
                                                ],
                                                [
                                                    -0.312,
                                                    -0.168
                                                ],
                                                [
                                                    -0.684,
                                                    0
                                                ],
                                                [
                                                    -0.324,
                                                    0.264
                                                ],
                                                [
                                                    0,
                                                    0.312
                                                ],
                                                [
                                                    0.132,
                                                    0.192
                                                ],
                                                [
                                                    0.324,
                                                    0.12
                                                ],
                                                [
                                                    0.936,
                                                    0.156
                                                ],
                                                [
                                                    0.528,
                                                    0.24
                                                ],
                                                [
                                                    0.216,
                                                    0.348
                                                ],
                                                [
                                                    0,
                                                    0.876
                                                ],
                                                [
                                                    -0.672,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    36.675,
                                                    5.265
                                                ],
                                                [
                                                    34.461,
                                                    4.851
                                                ],
                                                [
                                                    33.093,
                                                    3.717
                                                ],
                                                [
                                                    32.553,
                                                    2.043
                                                ],
                                                [
                                                    34.137,
                                                    1.935
                                                ],
                                                [
                                                    34.839,
                                                    3.321
                                                ],
                                                [
                                                    36.675,
                                                    3.825
                                                ],
                                                [
                                                    38.169,
                                                    3.519
                                                ],
                                                [
                                                    38.709,
                                                    2.493
                                                ],
                                                [
                                                    38.529,
                                                    1.863
                                                ],
                                                [
                                                    37.863,
                                                    1.431
                                                ],
                                                [
                                                    36.387,
                                                    1.053
                                                ],
                                                [
                                                    34.299,
                                                    0.423
                                                ],
                                                [
                                                    33.237,
                                                    -0.495
                                                ],
                                                [
                                                    32.931,
                                                    -1.791
                                                ],
                                                [
                                                    33.867,
                                                    -3.879
                                                ],
                                                [
                                                    36.549,
                                                    -4.707
                                                ],
                                                [
                                                    38.601,
                                                    -4.257
                                                ],
                                                [
                                                    39.825,
                                                    -3.123
                                                ],
                                                [
                                                    40.329,
                                                    -1.647
                                                ],
                                                [
                                                    38.745,
                                                    -1.539
                                                ],
                                                [
                                                    38.475,
                                                    -2.385
                                                ],
                                                [
                                                    37.773,
                                                    -3.015
                                                ],
                                                [
                                                    36.513,
                                                    -3.267
                                                ],
                                                [
                                                    35.001,
                                                    -2.871
                                                ],
                                                [
                                                    34.515,
                                                    -1.863
                                                ],
                                                [
                                                    34.695,
                                                    -1.089
                                                ],
                                                [
                                                    35.361,
                                                    -0.603
                                                ],
                                                [
                                                    36.675,
                                                    -0.279
                                                ],
                                                [
                                                    38.871,
                                                    0.315
                                                ],
                                                [
                                                    39.969,
                                                    1.215
                                                ],
                                                [
                                                    40.293,
                                                    2.493
                                                ],
                                                [
                                                    39.267,
                                                    4.545
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 23",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    0.396
                                                ],
                                                [
                                                    0,
                                                    0.84
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    -0.168
                                                ],
                                                [
                                                    -0.396,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.864,
                                                    0
                                                ],
                                                [
                                                    -0.408,
                                                    -0.396
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.432
                                                ],
                                                [
                                                    0.192,
                                                    0.168
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    45.5,
                                                    5.049
                                                ],
                                                [
                                                    43.574,
                                                    4.455
                                                ],
                                                [
                                                    42.962,
                                                    2.601
                                                ],
                                                [
                                                    42.962,
                                                    -6.723
                                                ],
                                                [
                                                    44.474,
                                                    -6.723
                                                ],
                                                [
                                                    44.474,
                                                    2.565
                                                ],
                                                [
                                                    44.762,
                                                    3.465
                                                ],
                                                [
                                                    45.644,
                                                    3.717
                                                ],
                                                [
                                                    47.012,
                                                    3.717
                                                ],
                                                [
                                                    47.012,
                                                    5.049
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 24",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    41.558,
                                                    -3.159
                                                ],
                                                [
                                                    41.558,
                                                    -4.491
                                                ],
                                                [
                                                    47.012,
                                                    -4.491
                                                ],
                                                [
                                                    47.012,
                                                    -3.159
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 25",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.54,
                                                    0
                                                ],
                                                [
                                                    0.588,
                                                    0.456
                                                ],
                                                [
                                                    0,
                                                    0.816
                                                ],
                                                [
                                                    -0.48,
                                                    0.468
                                                ],
                                                [
                                                    -1.044,
                                                    0.192
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.384,
                                                    0.396
                                                ],
                                                [
                                                    0.756,
                                                    0
                                                ],
                                                [
                                                    0.384,
                                                    -0.3
                                                ],
                                                [
                                                    0.144,
                                                    -0.552
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.684,
                                                    0.552
                                                ],
                                                [
                                                    -1.08,
                                                    0
                                                ],
                                                [
                                                    -0.648,
                                                    -0.696
                                                ],
                                                [
                                                    0,
                                                    -1.212
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.072,
                                                    -0.096
                                                ],
                                                [
                                                    -0.18,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.108,
                                                    0
                                                ],
                                                [
                                                    0.12,
                                                    0
                                                ],
                                                [
                                                    0.276,
                                                    0.132
                                                ],
                                                [
                                                    0.12,
                                                    0.288
                                                ],
                                                [
                                                    0,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.324,
                                                    -0.336
                                                ],
                                                [
                                                    0.48,
                                                    -0.192
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.984,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.456
                                                ],
                                                [
                                                    0,
                                                    -0.816
                                                ],
                                                [
                                                    0.48,
                                                    -0.468
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.804
                                                ],
                                                [
                                                    -0.372,
                                                    -0.396
                                                ],
                                                [
                                                    -0.66,
                                                    0
                                                ],
                                                [
                                                    -0.384,
                                                    0.288
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.18,
                                                    -0.9
                                                ],
                                                [
                                                    0.696,
                                                    -0.564
                                                ],
                                                [
                                                    1.224,
                                                    0
                                                ],
                                                [
                                                    0.648,
                                                    0.684
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.216
                                                ],
                                                [
                                                    0.084,
                                                    0.084
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.048,
                                                    0.012
                                                ],
                                                [
                                                    -0.108,
                                                    0.012
                                                ],
                                                [
                                                    -0.432,
                                                    0
                                                ],
                                                [
                                                    -0.264,
                                                    -0.144
                                                ],
                                                [
                                                    -0.12,
                                                    -0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.084,
                                                    0.408
                                                ],
                                                [
                                                    -0.324,
                                                    0.324
                                                ],
                                                [
                                                    -0.48,
                                                    0.18
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    51.455,
                                                    5.265
                                                ],
                                                [
                                                    49.097,
                                                    4.581
                                                ],
                                                [
                                                    48.233,
                                                    2.673
                                                ],
                                                [
                                                    48.953,
                                                    0.747
                                                ],
                                                [
                                                    51.239,
                                                    -0.243
                                                ],
                                                [
                                                    54.623,
                                                    -0.873
                                                ],
                                                [
                                                    54.047,
                                                    -2.673
                                                ],
                                                [
                                                    52.355,
                                                    -3.267
                                                ],
                                                [
                                                    50.789,
                                                    -2.817
                                                ],
                                                [
                                                    49.997,
                                                    -1.557
                                                ],
                                                [
                                                    48.395,
                                                    -1.683
                                                ],
                                                [
                                                    49.691,
                                                    -3.861
                                                ],
                                                [
                                                    52.355,
                                                    -4.707
                                                ],
                                                [
                                                    55.163,
                                                    -3.663
                                                ],
                                                [
                                                    56.135,
                                                    -0.819
                                                ],
                                                [
                                                    56.135,
                                                    3.123
                                                ],
                                                [
                                                    56.243,
                                                    3.591
                                                ],
                                                [
                                                    56.639,
                                                    3.717
                                                ],
                                                [
                                                    57.017,
                                                    3.717
                                                ],
                                                [
                                                    57.017,
                                                    5.049
                                                ],
                                                [
                                                    56.783,
                                                    5.067
                                                ],
                                                [
                                                    56.441,
                                                    5.085
                                                ],
                                                [
                                                    55.379,
                                                    4.887
                                                ],
                                                [
                                                    54.803,
                                                    4.239
                                                ],
                                                [
                                                    54.623,
                                                    3.069
                                                ],
                                                [
                                                    54.803,
                                                    3.105
                                                ],
                                                [
                                                    54.191,
                                                    4.221
                                                ],
                                                [
                                                    52.985,
                                                    4.995
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 26",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.552,
                                                    0
                                                ],
                                                [
                                                    -0.444,
                                                    0.24
                                                ],
                                                [
                                                    -0.24,
                                                    0.42
                                                ],
                                                [
                                                    0,
                                                    0.528
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.252,
                                                    -0.252
                                                ],
                                                [
                                                    0,
                                                    -0.396
                                                ],
                                                [
                                                    -0.312,
                                                    -0.252
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.636,
                                                    0
                                                ],
                                                [
                                                    0.456,
                                                    -0.252
                                                ],
                                                [
                                                    0.24,
                                                    -0.432
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.648,
                                                    0.12
                                                ],
                                                [
                                                    -0.24,
                                                    0.24
                                                ],
                                                [
                                                    0,
                                                    0.444
                                                ],
                                                [
                                                    0.324,
                                                    0.24
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    51.599,
                                                    3.933
                                                ],
                                                [
                                                    53.219,
                                                    3.573
                                                ],
                                                [
                                                    54.263,
                                                    2.565
                                                ],
                                                [
                                                    54.623,
                                                    1.125
                                                ],
                                                [
                                                    54.623,
                                                    0.441
                                                ],
                                                [
                                                    51.527,
                                                    1.017
                                                ],
                                                [
                                                    50.177,
                                                    1.575
                                                ],
                                                [
                                                    49.817,
                                                    2.529
                                                ],
                                                [
                                                    50.285,
                                                    3.573
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 27",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    0.396
                                                ],
                                                [
                                                    0,
                                                    0.84
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    -0.168
                                                ],
                                                [
                                                    -0.396,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.864,
                                                    0
                                                ],
                                                [
                                                    -0.408,
                                                    -0.396
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.432
                                                ],
                                                [
                                                    0.192,
                                                    0.168
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    61.39,
                                                    5.049
                                                ],
                                                [
                                                    59.464,
                                                    4.455
                                                ],
                                                [
                                                    58.852,
                                                    2.601
                                                ],
                                                [
                                                    58.852,
                                                    -6.723
                                                ],
                                                [
                                                    60.364,
                                                    -6.723
                                                ],
                                                [
                                                    60.364,
                                                    2.565
                                                ],
                                                [
                                                    60.652,
                                                    3.465
                                                ],
                                                [
                                                    61.534,
                                                    3.717
                                                ],
                                                [
                                                    62.902,
                                                    3.717
                                                ],
                                                [
                                                    62.902,
                                                    5.049
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 28",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    57.448,
                                                    -3.159
                                                ],
                                                [
                                                    57.448,
                                                    -4.491
                                                ],
                                                [
                                                    62.902,
                                                    -4.491
                                                ],
                                                [
                                                    62.902,
                                                    -3.159
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 29",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.816,
                                                    0
                                                ],
                                                [
                                                    0.576,
                                                    0.636
                                                ],
                                                [
                                                    0,
                                                    1.128
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.324,
                                                    -0.444
                                                ],
                                                [
                                                    -0.684,
                                                    0
                                                ],
                                                [
                                                    -0.432,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0.852
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.54,
                                                    -0.432
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.948,
                                                    0
                                                ],
                                                [
                                                    -0.564,
                                                    -0.648
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.924
                                                ],
                                                [
                                                    0.336,
                                                    0.432
                                                ],
                                                [
                                                    0.756,
                                                    0
                                                ],
                                                [
                                                    0.432,
                                                    -0.492
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    0.78
                                                ],
                                                [
                                                    -0.54,
                                                    0.42
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    67.974,
                                                    5.265
                                                ],
                                                [
                                                    65.688,
                                                    4.311
                                                ],
                                                [
                                                    64.842,
                                                    1.647
                                                ],
                                                [
                                                    64.842,
                                                    -4.491
                                                ],
                                                [
                                                    66.354,
                                                    -4.491
                                                ],
                                                [
                                                    66.354,
                                                    1.233
                                                ],
                                                [
                                                    66.84,
                                                    3.285
                                                ],
                                                [
                                                    68.37,
                                                    3.933
                                                ],
                                                [
                                                    70.152,
                                                    3.213
                                                ],
                                                [
                                                    70.8,
                                                    1.197
                                                ],
                                                [
                                                    70.8,
                                                    -4.491
                                                ],
                                                [
                                                    72.312,
                                                    -4.491
                                                ],
                                                [
                                                    72.312,
                                                    5.049
                                                ],
                                                [
                                                    70.872,
                                                    5.049
                                                ],
                                                [
                                                    70.872,
                                                    2.691
                                                ],
                                                [
                                                    71.106,
                                                    2.817
                                                ],
                                                [
                                                    70.008,
                                                    4.635
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 30",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.056,
                                                    0
                                                ],
                                                [
                                                    0.6,
                                                    0.276
                                                ],
                                                [
                                                    0.324,
                                                    0.48
                                                ],
                                                [
                                                    0.048,
                                                    0.624
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.372,
                                                    -0.348
                                                ],
                                                [
                                                    -0.84,
                                                    0
                                                ],
                                                [
                                                    -0.348,
                                                    0.204
                                                ],
                                                [
                                                    0,
                                                    0.468
                                                ],
                                                [
                                                    0.12,
                                                    0.168
                                                ],
                                                [
                                                    0.336,
                                                    0.12
                                                ],
                                                [
                                                    0.648,
                                                    0.12
                                                ],
                                                [
                                                    0.504,
                                                    0.252
                                                ],
                                                [
                                                    0.204,
                                                    0.36
                                                ],
                                                [
                                                    0,
                                                    0.504
                                                ],
                                                [
                                                    -0.624,
                                                    0.54
                                                ],
                                                [
                                                    -1.152,
                                                    0
                                                ],
                                                [
                                                    -0.528,
                                                    -0.3
                                                ],
                                                [
                                                    -0.276,
                                                    -0.468
                                                ],
                                                [
                                                    -0.06,
                                                    -0.516
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.156,
                                                    0.264
                                                ],
                                                [
                                                    0.312,
                                                    0.156
                                                ],
                                                [
                                                    0.528,
                                                    0
                                                ],
                                                [
                                                    0.324,
                                                    -0.264
                                                ],
                                                [
                                                    0,
                                                    -0.408
                                                ],
                                                [
                                                    -0.12,
                                                    -0.204
                                                ],
                                                [
                                                    -0.312,
                                                    -0.132
                                                ],
                                                [
                                                    -0.552,
                                                    -0.096
                                                ],
                                                [
                                                    -0.528,
                                                    -0.24
                                                ],
                                                [
                                                    -0.204,
                                                    -0.36
                                                ],
                                                [
                                                    0,
                                                    -0.504
                                                ],
                                                [
                                                    0.684,
                                                    -0.492
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.588,
                                                    -0.276
                                                ],
                                                [
                                                    -0.312,
                                                    -0.492
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.096,
                                                    0.576
                                                ],
                                                [
                                                    0.384,
                                                    0.336
                                                ],
                                                [
                                                    0.648,
                                                    0
                                                ],
                                                [
                                                    0.36,
                                                    -0.216
                                                ],
                                                [
                                                    0,
                                                    -0.252
                                                ],
                                                [
                                                    -0.108,
                                                    -0.168
                                                ],
                                                [
                                                    -0.336,
                                                    -0.132
                                                ],
                                                [
                                                    -0.888,
                                                    -0.168
                                                ],
                                                [
                                                    -0.504,
                                                    -0.252
                                                ],
                                                [
                                                    -0.204,
                                                    -0.36
                                                ],
                                                [
                                                    0,
                                                    -0.852
                                                ],
                                                [
                                                    0.636,
                                                    -0.552
                                                ],
                                                [
                                                    0.84,
                                                    0
                                                ],
                                                [
                                                    0.54,
                                                    0.288
                                                ],
                                                [
                                                    0.276,
                                                    0.468
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.024,
                                                    -0.3
                                                ],
                                                [
                                                    -0.156,
                                                    -0.264
                                                ],
                                                [
                                                    -0.312,
                                                    -0.168
                                                ],
                                                [
                                                    -0.684,
                                                    0
                                                ],
                                                [
                                                    -0.324,
                                                    0.264
                                                ],
                                                [
                                                    0,
                                                    0.312
                                                ],
                                                [
                                                    0.132,
                                                    0.192
                                                ],
                                                [
                                                    0.324,
                                                    0.12
                                                ],
                                                [
                                                    0.936,
                                                    0.156
                                                ],
                                                [
                                                    0.528,
                                                    0.24
                                                ],
                                                [
                                                    0.216,
                                                    0.348
                                                ],
                                                [
                                                    0,
                                                    0.876
                                                ],
                                                [
                                                    -0.672,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    78.493,
                                                    5.265
                                                ],
                                                [
                                                    76.279,
                                                    4.851
                                                ],
                                                [
                                                    74.911,
                                                    3.717
                                                ],
                                                [
                                                    74.371,
                                                    2.043
                                                ],
                                                [
                                                    75.955,
                                                    1.935
                                                ],
                                                [
                                                    76.657,
                                                    3.321
                                                ],
                                                [
                                                    78.493,
                                                    3.825
                                                ],
                                                [
                                                    79.987,
                                                    3.519
                                                ],
                                                [
                                                    80.527,
                                                    2.493
                                                ],
                                                [
                                                    80.347,
                                                    1.863
                                                ],
                                                [
                                                    79.681,
                                                    1.431
                                                ],
                                                [
                                                    78.205,
                                                    1.053
                                                ],
                                                [
                                                    76.117,
                                                    0.423
                                                ],
                                                [
                                                    75.055,
                                                    -0.495
                                                ],
                                                [
                                                    74.749,
                                                    -1.791
                                                ],
                                                [
                                                    75.685,
                                                    -3.879
                                                ],
                                                [
                                                    78.367,
                                                    -4.707
                                                ],
                                                [
                                                    80.419,
                                                    -4.257
                                                ],
                                                [
                                                    81.643,
                                                    -3.123
                                                ],
                                                [
                                                    82.147,
                                                    -1.647
                                                ],
                                                [
                                                    80.563,
                                                    -1.539
                                                ],
                                                [
                                                    80.293,
                                                    -2.385
                                                ],
                                                [
                                                    79.591,
                                                    -3.015
                                                ],
                                                [
                                                    78.331,
                                                    -3.267
                                                ],
                                                [
                                                    76.819,
                                                    -2.871
                                                ],
                                                [
                                                    76.333,
                                                    -1.863
                                                ],
                                                [
                                                    76.513,
                                                    -1.089
                                                ],
                                                [
                                                    77.179,
                                                    -0.603
                                                ],
                                                [
                                                    78.493,
                                                    -0.279
                                                ],
                                                [
                                                    80.689,
                                                    0.315
                                                ],
                                                [
                                                    81.787,
                                                    1.215
                                                ],
                                                [
                                                    82.111,
                                                    2.493
                                                ],
                                                [
                                                    81.085,
                                                    4.545
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            132.534,
                                            331.951
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 4",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -6.351,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -6.351
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    6.351,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    6.351
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    6.351,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    6.351
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -6.351,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -6.351
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -171,
                                                    -21.5
                                                ],
                                                [
                                                    171,
                                                    -21.5
                                                ],
                                                [
                                                    182.5,
                                                    -10
                                                ],
                                                [
                                                    182.5,
                                                    10
                                                ],
                                                [
                                                    171,
                                                    21.5
                                                ],
                                                [
                                                    -171,
                                                    21.5
                                                ],
                                                [
                                                    -182.5,
                                                    10
                                                ],
                                                [
                                                    -182.5,
                                                    -10
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8392,
                                            0.8392,
                                            0.8392
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            221,
                                            331
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 5",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.648,
                                                    -0.312
                                                ],
                                                [
                                                    -0.348,
                                                    -0.588
                                                ],
                                                [
                                                    0,
                                                    -0.792
                                                ],
                                                [
                                                    0.276,
                                                    -0.456
                                                ],
                                                [
                                                    0.42,
                                                    -0.264
                                                ],
                                                [
                                                    0.456,
                                                    -0.024
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.444,
                                                    -0.36
                                                ],
                                                [
                                                    -0.072,
                                                    -0.792
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.336,
                                                    0.252
                                                ],
                                                [
                                                    0.744,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.9,
                                                    0
                                                ],
                                                [
                                                    0.648,
                                                    0.312
                                                ],
                                                [
                                                    0.36,
                                                    0.576
                                                ],
                                                [
                                                    0,
                                                    0.576
                                                ],
                                                [
                                                    -0.264,
                                                    0.444
                                                ],
                                                [
                                                    -0.42,
                                                    0.264
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.78,
                                                    0
                                                ],
                                                [
                                                    0.456,
                                                    0.36
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.048,
                                                    -0.528
                                                ],
                                                [
                                                    -0.324,
                                                    -0.252
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -76.387,
                                                    5.049
                                                ],
                                                [
                                                    -76.387,
                                                    -7.731
                                                ],
                                                [
                                                    -71.545,
                                                    -7.731
                                                ],
                                                [
                                                    -69.223,
                                                    -7.263
                                                ],
                                                [
                                                    -67.729,
                                                    -5.913
                                                ],
                                                [
                                                    -67.189,
                                                    -3.861
                                                ],
                                                [
                                                    -67.603,
                                                    -2.313
                                                ],
                                                [
                                                    -68.629,
                                                    -1.251
                                                ],
                                                [
                                                    -69.943,
                                                    -0.819
                                                ],
                                                [
                                                    -70.051,
                                                    -0.981
                                                ],
                                                [
                                                    -68.215,
                                                    -0.441
                                                ],
                                                [
                                                    -67.423,
                                                    1.287
                                                ],
                                                [
                                                    -67.063,
                                                    5.049
                                                ],
                                                [
                                                    -68.629,
                                                    5.049
                                                ],
                                                [
                                                    -68.953,
                                                    1.449
                                                ],
                                                [
                                                    -69.529,
                                                    0.279
                                                ],
                                                [
                                                    -71.131,
                                                    -0.099
                                                ],
                                                [
                                                    -74.839,
                                                    -0.099
                                                ],
                                                [
                                                    -74.839,
                                                    5.049
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.456,
                                                    0.396
                                                ],
                                                [
                                                    0,
                                                    0.732
                                                ],
                                                [
                                                    0.468,
                                                    0.396
                                                ],
                                                [
                                                    0.888,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.78,
                                                    0
                                                ],
                                                [
                                                    0.456,
                                                    -0.396
                                                ],
                                                [
                                                    0,
                                                    -0.744
                                                ],
                                                [
                                                    -0.468,
                                                    -0.408
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -74.839,
                                                    -1.611
                                                ],
                                                [
                                                    -71.347,
                                                    -1.611
                                                ],
                                                [
                                                    -69.493,
                                                    -2.205
                                                ],
                                                [
                                                    -68.809,
                                                    -3.897
                                                ],
                                                [
                                                    -69.511,
                                                    -5.607
                                                ],
                                                [
                                                    -71.545,
                                                    -6.219
                                                ],
                                                [
                                                    -74.839,
                                                    -6.219
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.008,
                                                    0
                                                ],
                                                [
                                                    0.66,
                                                    0.408
                                                ],
                                                [
                                                    0.36,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    -0.348,
                                                    0.744
                                                ],
                                                [
                                                    -0.636,
                                                    0.408
                                                ],
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.636,
                                                    -0.396
                                                ],
                                                [
                                                    -0.348,
                                                    -0.744
                                                ],
                                                [
                                                    0,
                                                    -1.068
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.48,
                                                    -0.516
                                                ],
                                                [
                                                    -0.828,
                                                    0
                                                ],
                                                [
                                                    -0.396,
                                                    0.288
                                                ],
                                                [
                                                    -0.156,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.708,
                                                    -0.552
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.9,
                                                    0
                                                ],
                                                [
                                                    -0.648,
                                                    -0.408
                                                ],
                                                [
                                                    -0.348,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.008
                                                ],
                                                [
                                                    0.36,
                                                    -0.744
                                                ],
                                                [
                                                    0.648,
                                                    -0.42
                                                ],
                                                [
                                                    0.828,
                                                    0
                                                ],
                                                [
                                                    0.636,
                                                    0.384
                                                ],
                                                [
                                                    0.36,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.06,
                                                    1.02
                                                ],
                                                [
                                                    0.492,
                                                    0.516
                                                ],
                                                [
                                                    0.624,
                                                    0
                                                ],
                                                [
                                                    0.408,
                                                    -0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.252,
                                                    0.852
                                                ],
                                                [
                                                    -0.696,
                                                    0.54
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -60.994,
                                                    5.265
                                                ],
                                                [
                                                    -63.334,
                                                    4.653
                                                ],
                                                [
                                                    -64.846,
                                                    2.925
                                                ],
                                                [
                                                    -65.368,
                                                    0.279
                                                ],
                                                [
                                                    -64.846,
                                                    -2.349
                                                ],
                                                [
                                                    -63.352,
                                                    -4.077
                                                ],
                                                [
                                                    -61.066,
                                                    -4.707
                                                ],
                                                [
                                                    -58.87,
                                                    -4.113
                                                ],
                                                [
                                                    -57.394,
                                                    -2.421
                                                ],
                                                [
                                                    -56.854,
                                                    0.297
                                                ],
                                                [
                                                    -56.854,
                                                    0.747
                                                ],
                                                [
                                                    -63.784,
                                                    0.747
                                                ],
                                                [
                                                    -62.974,
                                                    3.051
                                                ],
                                                [
                                                    -60.994,
                                                    3.825
                                                ],
                                                [
                                                    -59.464,
                                                    3.393
                                                ],
                                                [
                                                    -58.618,
                                                    2.223
                                                ],
                                                [
                                                    -56.998,
                                                    2.349
                                                ],
                                                [
                                                    -58.438,
                                                    4.455
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.132,
                                                    -0.888
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.468,
                                                    0.432
                                                ],
                                                [
                                                    0.708,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    -0.456
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.072,
                                                    -0.924
                                                ],
                                                [
                                                    -0.456,
                                                    -0.432
                                                ],
                                                [
                                                    -0.732,
                                                    0
                                                ],
                                                [
                                                    -0.468,
                                                    0.444
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -63.784,
                                                    -0.585
                                                ],
                                                [
                                                    -58.51,
                                                    -0.585
                                                ],
                                                [
                                                    -59.32,
                                                    -2.619
                                                ],
                                                [
                                                    -61.066,
                                                    -3.267
                                                ],
                                                [
                                                    -62.884,
                                                    -2.583
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.54,
                                                    0
                                                ],
                                                [
                                                    0.588,
                                                    0.456
                                                ],
                                                [
                                                    0,
                                                    0.816
                                                ],
                                                [
                                                    -0.48,
                                                    0.468
                                                ],
                                                [
                                                    -1.044,
                                                    0.192
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.384,
                                                    0.396
                                                ],
                                                [
                                                    0.756,
                                                    0
                                                ],
                                                [
                                                    0.384,
                                                    -0.3
                                                ],
                                                [
                                                    0.144,
                                                    -0.552
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.684,
                                                    0.552
                                                ],
                                                [
                                                    -1.08,
                                                    0
                                                ],
                                                [
                                                    -0.648,
                                                    -0.696
                                                ],
                                                [
                                                    0,
                                                    -1.212
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.072,
                                                    -0.096
                                                ],
                                                [
                                                    -0.18,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.108,
                                                    0
                                                ],
                                                [
                                                    0.12,
                                                    0
                                                ],
                                                [
                                                    0.276,
                                                    0.132
                                                ],
                                                [
                                                    0.12,
                                                    0.288
                                                ],
                                                [
                                                    0,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.324,
                                                    -0.336
                                                ],
                                                [
                                                    0.48,
                                                    -0.192
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.984,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.456
                                                ],
                                                [
                                                    0,
                                                    -0.816
                                                ],
                                                [
                                                    0.48,
                                                    -0.468
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.804
                                                ],
                                                [
                                                    -0.372,
                                                    -0.396
                                                ],
                                                [
                                                    -0.66,
                                                    0
                                                ],
                                                [
                                                    -0.384,
                                                    0.288
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.18,
                                                    -0.9
                                                ],
                                                [
                                                    0.696,
                                                    -0.564
                                                ],
                                                [
                                                    1.224,
                                                    0
                                                ],
                                                [
                                                    0.648,
                                                    0.684
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.216
                                                ],
                                                [
                                                    0.084,
                                                    0.084
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.048,
                                                    0.012
                                                ],
                                                [
                                                    -0.108,
                                                    0.012
                                                ],
                                                [
                                                    -0.432,
                                                    0
                                                ],
                                                [
                                                    -0.264,
                                                    -0.144
                                                ],
                                                [
                                                    -0.12,
                                                    -0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.084,
                                                    0.408
                                                ],
                                                [
                                                    -0.324,
                                                    0.324
                                                ],
                                                [
                                                    -0.48,
                                                    0.18
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -51.986,
                                                    5.265
                                                ],
                                                [
                                                    -54.344,
                                                    4.581
                                                ],
                                                [
                                                    -55.208,
                                                    2.673
                                                ],
                                                [
                                                    -54.488,
                                                    0.747
                                                ],
                                                [
                                                    -52.202,
                                                    -0.243
                                                ],
                                                [
                                                    -48.818,
                                                    -0.873
                                                ],
                                                [
                                                    -49.394,
                                                    -2.673
                                                ],
                                                [
                                                    -51.086,
                                                    -3.267
                                                ],
                                                [
                                                    -52.652,
                                                    -2.817
                                                ],
                                                [
                                                    -53.444,
                                                    -1.557
                                                ],
                                                [
                                                    -55.046,
                                                    -1.683
                                                ],
                                                [
                                                    -53.75,
                                                    -3.861
                                                ],
                                                [
                                                    -51.086,
                                                    -4.707
                                                ],
                                                [
                                                    -48.278,
                                                    -3.663
                                                ],
                                                [
                                                    -47.306,
                                                    -0.819
                                                ],
                                                [
                                                    -47.306,
                                                    3.123
                                                ],
                                                [
                                                    -47.198,
                                                    3.591
                                                ],
                                                [
                                                    -46.802,
                                                    3.717
                                                ],
                                                [
                                                    -46.424,
                                                    3.717
                                                ],
                                                [
                                                    -46.424,
                                                    5.049
                                                ],
                                                [
                                                    -46.658,
                                                    5.067
                                                ],
                                                [
                                                    -47,
                                                    5.085
                                                ],
                                                [
                                                    -48.062,
                                                    4.887
                                                ],
                                                [
                                                    -48.638,
                                                    4.239
                                                ],
                                                [
                                                    -48.818,
                                                    3.069
                                                ],
                                                [
                                                    -48.638,
                                                    3.105
                                                ],
                                                [
                                                    -49.25,
                                                    4.221
                                                ],
                                                [
                                                    -50.456,
                                                    4.995
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.552,
                                                    0
                                                ],
                                                [
                                                    -0.444,
                                                    0.24
                                                ],
                                                [
                                                    -0.24,
                                                    0.42
                                                ],
                                                [
                                                    0,
                                                    0.528
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.252,
                                                    -0.252
                                                ],
                                                [
                                                    0,
                                                    -0.396
                                                ],
                                                [
                                                    -0.312,
                                                    -0.252
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.636,
                                                    0
                                                ],
                                                [
                                                    0.456,
                                                    -0.252
                                                ],
                                                [
                                                    0.24,
                                                    -0.432
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.648,
                                                    0.12
                                                ],
                                                [
                                                    -0.24,
                                                    0.24
                                                ],
                                                [
                                                    0,
                                                    0.444
                                                ],
                                                [
                                                    0.324,
                                                    0.24
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -51.842,
                                                    3.933
                                                ],
                                                [
                                                    -50.222,
                                                    3.573
                                                ],
                                                [
                                                    -49.178,
                                                    2.565
                                                ],
                                                [
                                                    -48.818,
                                                    1.125
                                                ],
                                                [
                                                    -48.818,
                                                    0.441
                                                ],
                                                [
                                                    -51.914,
                                                    1.017
                                                ],
                                                [
                                                    -53.264,
                                                    1.575
                                                ],
                                                [
                                                    -53.624,
                                                    2.529
                                                ],
                                                [
                                                    -53.156,
                                                    3.573
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.612,
                                                    0.408
                                                ],
                                                [
                                                    0.324,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    1.02
                                                ],
                                                [
                                                    -0.324,
                                                    0.744
                                                ],
                                                [
                                                    -0.6,
                                                    0.408
                                                ],
                                                [
                                                    -0.828,
                                                    0
                                                ],
                                                [
                                                    -0.528,
                                                    -0.276
                                                ],
                                                [
                                                    -0.264,
                                                    -0.492
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.54,
                                                    -0.3
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.828,
                                                    0
                                                ],
                                                [
                                                    -0.6,
                                                    -0.408
                                                ],
                                                [
                                                    -0.324,
                                                    -0.744
                                                ],
                                                [
                                                    0,
                                                    -1.02
                                                ],
                                                [
                                                    0.324,
                                                    -0.744
                                                ],
                                                [
                                                    0.612,
                                                    -0.408
                                                ],
                                                [
                                                    0.636,
                                                    0
                                                ],
                                                [
                                                    0.528,
                                                    0.264
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.264,
                                                    0.516
                                                ],
                                                [
                                                    -0.54,
                                                    0.288
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -41.367,
                                                    5.265
                                                ],
                                                [
                                                    -43.527,
                                                    4.653
                                                ],
                                                [
                                                    -44.913,
                                                    2.925
                                                ],
                                                [
                                                    -45.399,
                                                    0.279
                                                ],
                                                [
                                                    -44.913,
                                                    -2.367
                                                ],
                                                [
                                                    -43.527,
                                                    -4.095
                                                ],
                                                [
                                                    -41.367,
                                                    -4.707
                                                ],
                                                [
                                                    -39.621,
                                                    -4.293
                                                ],
                                                [
                                                    -38.433,
                                                    -3.159
                                                ],
                                                [
                                                    -38.433,
                                                    -7.731
                                                ],
                                                [
                                                    -36.921,
                                                    -7.731
                                                ],
                                                [
                                                    -36.921,
                                                    5.049
                                                ],
                                                [
                                                    -38.289,
                                                    5.049
                                                ],
                                                [
                                                    -38.343,
                                                    3.609
                                                ],
                                                [
                                                    -39.549,
                                                    4.833
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.84,
                                                    0
                                                ],
                                                [
                                                    -0.384,
                                                    0.288
                                                ],
                                                [
                                                    -0.204,
                                                    0.528
                                                ],
                                                [
                                                    0,
                                                    0.72
                                                ],
                                                [
                                                    0.204,
                                                    0.528
                                                ],
                                                [
                                                    0.396,
                                                    0.276
                                                ],
                                                [
                                                    0.564,
                                                    0
                                                ],
                                                [
                                                    0.504,
                                                    -0.636
                                                ],
                                                [
                                                    0,
                                                    -1.104
                                                ],
                                                [
                                                    -0.492,
                                                    -0.636
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.564,
                                                    0
                                                ],
                                                [
                                                    0.396,
                                                    -0.288
                                                ],
                                                [
                                                    0.204,
                                                    -0.54
                                                ],
                                                [
                                                    0,
                                                    -0.744
                                                ],
                                                [
                                                    -0.204,
                                                    -0.528
                                                ],
                                                [
                                                    -0.384,
                                                    -0.288
                                                ],
                                                [
                                                    -0.84,
                                                    0
                                                ],
                                                [
                                                    -0.492,
                                                    0.624
                                                ],
                                                [
                                                    0,
                                                    1.092
                                                ],
                                                [
                                                    0.504,
                                                    0.636
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -41.061,
                                                    3.825
                                                ],
                                                [
                                                    -39.639,
                                                    3.393
                                                ],
                                                [
                                                    -38.739,
                                                    2.169
                                                ],
                                                [
                                                    -38.433,
                                                    0.279
                                                ],
                                                [
                                                    -38.739,
                                                    -1.629
                                                ],
                                                [
                                                    -39.639,
                                                    -2.835
                                                ],
                                                [
                                                    -41.061,
                                                    -3.267
                                                ],
                                                [
                                                    -43.077,
                                                    -2.313
                                                ],
                                                [
                                                    -43.815,
                                                    0.279
                                                ],
                                                [
                                                    -43.077,
                                                    2.871
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    0.396
                                                ],
                                                [
                                                    0,
                                                    0.84
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    -0.168
                                                ],
                                                [
                                                    -0.396,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.864,
                                                    0
                                                ],
                                                [
                                                    -0.408,
                                                    -0.396
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.432
                                                ],
                                                [
                                                    0.192,
                                                    0.168
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -26.054,
                                                    5.049
                                                ],
                                                [
                                                    -27.98,
                                                    4.455
                                                ],
                                                [
                                                    -28.592,
                                                    2.601
                                                ],
                                                [
                                                    -28.592,
                                                    -6.723
                                                ],
                                                [
                                                    -27.08,
                                                    -6.723
                                                ],
                                                [
                                                    -27.08,
                                                    2.565
                                                ],
                                                [
                                                    -26.792,
                                                    3.465
                                                ],
                                                [
                                                    -25.91,
                                                    3.717
                                                ],
                                                [
                                                    -24.542,
                                                    3.717
                                                ],
                                                [
                                                    -24.542,
                                                    5.049
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -29.996,
                                                    -3.159
                                                ],
                                                [
                                                    -29.996,
                                                    -4.491
                                                ],
                                                [
                                                    -24.542,
                                                    -4.491
                                                ],
                                                [
                                                    -24.542,
                                                    -3.159
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -22.779,
                                                    5.049
                                                ],
                                                [
                                                    -22.779,
                                                    -4.491
                                                ],
                                                [
                                                    -21.267,
                                                    -4.491
                                                ],
                                                [
                                                    -21.267,
                                                    5.049
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -22.815,
                                                    -5.985
                                                ],
                                                [
                                                    -22.815,
                                                    -7.749
                                                ],
                                                [
                                                    -21.231,
                                                    -7.749
                                                ],
                                                [
                                                    -21.231,
                                                    -5.985
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.732,
                                                    0
                                                ],
                                                [
                                                    0.66,
                                                    0.408
                                                ],
                                                [
                                                    0.36,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    -0.36,
                                                    0.744
                                                ],
                                                [
                                                    -0.648,
                                                    0.408
                                                ],
                                                [
                                                    -0.888,
                                                    0
                                                ],
                                                [
                                                    -0.564,
                                                    -0.264
                                                ],
                                                [
                                                    -0.36,
                                                    -0.492
                                                ],
                                                [
                                                    -0.108,
                                                    -0.708
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.444,
                                                    0.336
                                                ],
                                                [
                                                    0.648,
                                                    0
                                                ],
                                                [
                                                    0.492,
                                                    -0.636
                                                ],
                                                [
                                                    0,
                                                    -1.104
                                                ],
                                                [
                                                    -0.492,
                                                    -0.636
                                                ],
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.444,
                                                    0.36
                                                ],
                                                [
                                                    -0.108,
                                                    0.72
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.36,
                                                    -0.528
                                                ],
                                                [
                                                    0.576,
                                                    -0.288
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.888,
                                                    0
                                                ],
                                                [
                                                    -0.648,
                                                    -0.408
                                                ],
                                                [
                                                    -0.36,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.008
                                                ],
                                                [
                                                    0.36,
                                                    -0.744
                                                ],
                                                [
                                                    0.66,
                                                    -0.42
                                                ],
                                                [
                                                    0.732,
                                                    0
                                                ],
                                                [
                                                    0.576,
                                                    0.252
                                                ],
                                                [
                                                    0.36,
                                                    0.492
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.108,
                                                    -0.636
                                                ],
                                                [
                                                    -0.444,
                                                    -0.348
                                                ],
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.492,
                                                    0.624
                                                ],
                                                [
                                                    0,
                                                    1.104
                                                ],
                                                [
                                                    0.492,
                                                    0.624
                                                ],
                                                [
                                                    0.648,
                                                    0
                                                ],
                                                [
                                                    0.444,
                                                    -0.36
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.108,
                                                    0.708
                                                ],
                                                [
                                                    -0.36,
                                                    0.516
                                                ],
                                                [
                                                    -0.564,
                                                    0.288
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -14.834,
                                                    5.265
                                                ],
                                                [
                                                    -17.156,
                                                    4.653
                                                ],
                                                [
                                                    -18.668,
                                                    2.925
                                                ],
                                                [
                                                    -19.208,
                                                    0.279
                                                ],
                                                [
                                                    -18.668,
                                                    -2.349
                                                ],
                                                [
                                                    -17.156,
                                                    -4.077
                                                ],
                                                [
                                                    -14.834,
                                                    -4.707
                                                ],
                                                [
                                                    -12.89,
                                                    -4.311
                                                ],
                                                [
                                                    -11.486,
                                                    -3.195
                                                ],
                                                [
                                                    -10.784,
                                                    -1.395
                                                ],
                                                [
                                                    -12.368,
                                                    -1.287
                                                ],
                                                [
                                                    -13.196,
                                                    -2.745
                                                ],
                                                [
                                                    -14.834,
                                                    -3.267
                                                ],
                                                [
                                                    -16.886,
                                                    -2.313
                                                ],
                                                [
                                                    -17.624,
                                                    0.279
                                                ],
                                                [
                                                    -16.886,
                                                    2.889
                                                ],
                                                [
                                                    -14.834,
                                                    3.825
                                                ],
                                                [
                                                    -13.196,
                                                    3.285
                                                ],
                                                [
                                                    -12.368,
                                                    1.665
                                                ],
                                                [
                                                    -10.784,
                                                    1.773
                                                ],
                                                [
                                                    -11.486,
                                                    3.627
                                                ],
                                                [
                                                    -12.89,
                                                    4.833
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 14",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -8.91,
                                                    5.049
                                                ],
                                                [
                                                    -8.91,
                                                    -7.731
                                                ],
                                                [
                                                    -7.398,
                                                    -7.731
                                                ],
                                                [
                                                    -7.398,
                                                    0.639
                                                ],
                                                [
                                                    -2.754,
                                                    -4.491
                                                ],
                                                [
                                                    -0.738,
                                                    -4.491
                                                ],
                                                [
                                                    -4.5,
                                                    -0.441
                                                ],
                                                [
                                                    -0.576,
                                                    5.049
                                                ],
                                                [
                                                    -2.412,
                                                    5.049
                                                ],
                                                [
                                                    -5.526,
                                                    0.585
                                                ],
                                                [
                                                    -7.398,
                                                    2.565
                                                ],
                                                [
                                                    -7.398,
                                                    5.049
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 15",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.008,
                                                    0
                                                ],
                                                [
                                                    0.66,
                                                    0.408
                                                ],
                                                [
                                                    0.36,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    -0.348,
                                                    0.744
                                                ],
                                                [
                                                    -0.636,
                                                    0.408
                                                ],
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.636,
                                                    -0.396
                                                ],
                                                [
                                                    -0.348,
                                                    -0.744
                                                ],
                                                [
                                                    0,
                                                    -1.068
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.48,
                                                    -0.516
                                                ],
                                                [
                                                    -0.828,
                                                    0
                                                ],
                                                [
                                                    -0.396,
                                                    0.288
                                                ],
                                                [
                                                    -0.156,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.708,
                                                    -0.552
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.9,
                                                    0
                                                ],
                                                [
                                                    -0.648,
                                                    -0.408
                                                ],
                                                [
                                                    -0.348,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.008
                                                ],
                                                [
                                                    0.36,
                                                    -0.744
                                                ],
                                                [
                                                    0.648,
                                                    -0.42
                                                ],
                                                [
                                                    0.828,
                                                    0
                                                ],
                                                [
                                                    0.636,
                                                    0.384
                                                ],
                                                [
                                                    0.36,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.06,
                                                    1.02
                                                ],
                                                [
                                                    0.492,
                                                    0.516
                                                ],
                                                [
                                                    0.624,
                                                    0
                                                ],
                                                [
                                                    0.408,
                                                    -0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.252,
                                                    0.852
                                                ],
                                                [
                                                    -0.696,
                                                    0.54
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.537,
                                                    5.265
                                                ],
                                                [
                                                    2.197,
                                                    4.653
                                                ],
                                                [
                                                    0.685,
                                                    2.925
                                                ],
                                                [
                                                    0.163,
                                                    0.279
                                                ],
                                                [
                                                    0.685,
                                                    -2.349
                                                ],
                                                [
                                                    2.179,
                                                    -4.077
                                                ],
                                                [
                                                    4.465,
                                                    -4.707
                                                ],
                                                [
                                                    6.661,
                                                    -4.113
                                                ],
                                                [
                                                    8.137,
                                                    -2.421
                                                ],
                                                [
                                                    8.677,
                                                    0.297
                                                ],
                                                [
                                                    8.677,
                                                    0.747
                                                ],
                                                [
                                                    1.747,
                                                    0.747
                                                ],
                                                [
                                                    2.557,
                                                    3.051
                                                ],
                                                [
                                                    4.537,
                                                    3.825
                                                ],
                                                [
                                                    6.067,
                                                    3.393
                                                ],
                                                [
                                                    6.913,
                                                    2.223
                                                ],
                                                [
                                                    8.533,
                                                    2.349
                                                ],
                                                [
                                                    7.093,
                                                    4.455
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 16",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.132,
                                                    -0.888
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.468,
                                                    0.432
                                                ],
                                                [
                                                    0.708,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    -0.456
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.072,
                                                    -0.924
                                                ],
                                                [
                                                    -0.456,
                                                    -0.432
                                                ],
                                                [
                                                    -0.732,
                                                    0
                                                ],
                                                [
                                                    -0.468,
                                                    0.444
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    1.747,
                                                    -0.585
                                                ],
                                                [
                                                    7.021,
                                                    -0.585
                                                ],
                                                [
                                                    6.211,
                                                    -2.619
                                                ],
                                                [
                                                    4.465,
                                                    -3.267
                                                ],
                                                [
                                                    2.647,
                                                    -2.583
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 17",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    0.396
                                                ],
                                                [
                                                    0,
                                                    0.84
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    -0.168
                                                ],
                                                [
                                                    -0.396,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.864,
                                                    0
                                                ],
                                                [
                                                    -0.408,
                                                    -0.396
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.432
                                                ],
                                                [
                                                    0.192,
                                                    0.168
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    13.848,
                                                    5.049
                                                ],
                                                [
                                                    11.922,
                                                    4.455
                                                ],
                                                [
                                                    11.31,
                                                    2.601
                                                ],
                                                [
                                                    11.31,
                                                    -6.723
                                                ],
                                                [
                                                    12.822,
                                                    -6.723
                                                ],
                                                [
                                                    12.822,
                                                    2.565
                                                ],
                                                [
                                                    13.11,
                                                    3.465
                                                ],
                                                [
                                                    13.992,
                                                    3.717
                                                ],
                                                [
                                                    15.36,
                                                    3.717
                                                ],
                                                [
                                                    15.36,
                                                    5.049
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 18",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.906,
                                                    -3.159
                                                ],
                                                [
                                                    9.906,
                                                    -4.491
                                                ],
                                                [
                                                    15.36,
                                                    -4.491
                                                ],
                                                [
                                                    15.36,
                                                    -3.159
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 19",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.336
                                                ],
                                                [
                                                    -0.42,
                                                    0.156
                                                ],
                                                [
                                                    -0.504,
                                                    0
                                                ],
                                                [
                                                    -0.468,
                                                    -0.312
                                                ],
                                                [
                                                    -0.24,
                                                    -0.552
                                                ],
                                                [
                                                    0,
                                                    -0.708
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.336,
                                                    0.444
                                                ],
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.468,
                                                    -0.468
                                                ],
                                                [
                                                    0,
                                                    -0.888
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.12,
                                                    -0.528
                                                ],
                                                [
                                                    0.288,
                                                    -0.336
                                                ],
                                                [
                                                    0.42,
                                                    -0.168
                                                ],
                                                [
                                                    0.684,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    0.3
                                                ],
                                                [
                                                    0.252,
                                                    0.54
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.924
                                                ],
                                                [
                                                    -0.324,
                                                    -0.444
                                                ],
                                                [
                                                    -0.768,
                                                    0
                                                ],
                                                [
                                                    -0.468,
                                                    0.468
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    21.905,
                                                    5.049
                                                ],
                                                [
                                                    21.905,
                                                    -7.731
                                                ],
                                                [
                                                    23.417,
                                                    -7.731
                                                ],
                                                [
                                                    23.417,
                                                    -2.385
                                                ],
                                                [
                                                    23.237,
                                                    -2.421
                                                ],
                                                [
                                                    23.849,
                                                    -3.717
                                                ],
                                                [
                                                    24.911,
                                                    -4.455
                                                ],
                                                [
                                                    26.297,
                                                    -4.707
                                                ],
                                                [
                                                    28.025,
                                                    -4.239
                                                ],
                                                [
                                                    29.105,
                                                    -2.961
                                                ],
                                                [
                                                    29.483,
                                                    -1.089
                                                ],
                                                [
                                                    29.483,
                                                    5.049
                                                ],
                                                [
                                                    27.971,
                                                    5.049
                                                ],
                                                [
                                                    27.971,
                                                    -0.657
                                                ],
                                                [
                                                    27.467,
                                                    -2.709
                                                ],
                                                [
                                                    25.973,
                                                    -3.375
                                                ],
                                                [
                                                    24.119,
                                                    -2.673
                                                ],
                                                [
                                                    23.417,
                                                    -0.639
                                                ],
                                                [
                                                    23.417,
                                                    5.049
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 20",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    32.258,
                                                    5.049
                                                ],
                                                [
                                                    32.258,
                                                    -4.491
                                                ],
                                                [
                                                    33.77,
                                                    -4.491
                                                ],
                                                [
                                                    33.77,
                                                    5.049
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 21",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    32.222,
                                                    -5.985
                                                ],
                                                [
                                                    32.222,
                                                    -7.749
                                                ],
                                                [
                                                    33.806,
                                                    -7.749
                                                ],
                                                [
                                                    33.806,
                                                    -5.985
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 22",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.056,
                                                    0
                                                ],
                                                [
                                                    0.6,
                                                    0.276
                                                ],
                                                [
                                                    0.324,
                                                    0.48
                                                ],
                                                [
                                                    0.048,
                                                    0.624
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.372,
                                                    -0.348
                                                ],
                                                [
                                                    -0.84,
                                                    0
                                                ],
                                                [
                                                    -0.348,
                                                    0.204
                                                ],
                                                [
                                                    0,
                                                    0.468
                                                ],
                                                [
                                                    0.12,
                                                    0.168
                                                ],
                                                [
                                                    0.336,
                                                    0.12
                                                ],
                                                [
                                                    0.648,
                                                    0.12
                                                ],
                                                [
                                                    0.504,
                                                    0.252
                                                ],
                                                [
                                                    0.204,
                                                    0.36
                                                ],
                                                [
                                                    0,
                                                    0.504
                                                ],
                                                [
                                                    -0.624,
                                                    0.54
                                                ],
                                                [
                                                    -1.152,
                                                    0
                                                ],
                                                [
                                                    -0.528,
                                                    -0.3
                                                ],
                                                [
                                                    -0.276,
                                                    -0.468
                                                ],
                                                [
                                                    -0.06,
                                                    -0.516
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.156,
                                                    0.264
                                                ],
                                                [
                                                    0.312,
                                                    0.156
                                                ],
                                                [
                                                    0.528,
                                                    0
                                                ],
                                                [
                                                    0.324,
                                                    -0.264
                                                ],
                                                [
                                                    0,
                                                    -0.408
                                                ],
                                                [
                                                    -0.12,
                                                    -0.204
                                                ],
                                                [
                                                    -0.312,
                                                    -0.132
                                                ],
                                                [
                                                    -0.552,
                                                    -0.096
                                                ],
                                                [
                                                    -0.528,
                                                    -0.24
                                                ],
                                                [
                                                    -0.204,
                                                    -0.36
                                                ],
                                                [
                                                    0,
                                                    -0.504
                                                ],
                                                [
                                                    0.684,
                                                    -0.492
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.588,
                                                    -0.276
                                                ],
                                                [
                                                    -0.312,
                                                    -0.492
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.096,
                                                    0.576
                                                ],
                                                [
                                                    0.384,
                                                    0.336
                                                ],
                                                [
                                                    0.648,
                                                    0
                                                ],
                                                [
                                                    0.36,
                                                    -0.216
                                                ],
                                                [
                                                    0,
                                                    -0.252
                                                ],
                                                [
                                                    -0.108,
                                                    -0.168
                                                ],
                                                [
                                                    -0.336,
                                                    -0.132
                                                ],
                                                [
                                                    -0.888,
                                                    -0.168
                                                ],
                                                [
                                                    -0.504,
                                                    -0.252
                                                ],
                                                [
                                                    -0.204,
                                                    -0.36
                                                ],
                                                [
                                                    0,
                                                    -0.852
                                                ],
                                                [
                                                    0.636,
                                                    -0.552
                                                ],
                                                [
                                                    0.84,
                                                    0
                                                ],
                                                [
                                                    0.54,
                                                    0.288
                                                ],
                                                [
                                                    0.276,
                                                    0.468
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.024,
                                                    -0.3
                                                ],
                                                [
                                                    -0.156,
                                                    -0.264
                                                ],
                                                [
                                                    -0.312,
                                                    -0.168
                                                ],
                                                [
                                                    -0.684,
                                                    0
                                                ],
                                                [
                                                    -0.324,
                                                    0.264
                                                ],
                                                [
                                                    0,
                                                    0.312
                                                ],
                                                [
                                                    0.132,
                                                    0.192
                                                ],
                                                [
                                                    0.324,
                                                    0.12
                                                ],
                                                [
                                                    0.936,
                                                    0.156
                                                ],
                                                [
                                                    0.528,
                                                    0.24
                                                ],
                                                [
                                                    0.216,
                                                    0.348
                                                ],
                                                [
                                                    0,
                                                    0.876
                                                ],
                                                [
                                                    -0.672,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    39.951,
                                                    5.265
                                                ],
                                                [
                                                    37.737,
                                                    4.851
                                                ],
                                                [
                                                    36.369,
                                                    3.717
                                                ],
                                                [
                                                    35.829,
                                                    2.043
                                                ],
                                                [
                                                    37.413,
                                                    1.935
                                                ],
                                                [
                                                    38.115,
                                                    3.321
                                                ],
                                                [
                                                    39.951,
                                                    3.825
                                                ],
                                                [
                                                    41.445,
                                                    3.519
                                                ],
                                                [
                                                    41.985,
                                                    2.493
                                                ],
                                                [
                                                    41.805,
                                                    1.863
                                                ],
                                                [
                                                    41.139,
                                                    1.431
                                                ],
                                                [
                                                    39.663,
                                                    1.053
                                                ],
                                                [
                                                    37.575,
                                                    0.423
                                                ],
                                                [
                                                    36.513,
                                                    -0.495
                                                ],
                                                [
                                                    36.207,
                                                    -1.791
                                                ],
                                                [
                                                    37.143,
                                                    -3.879
                                                ],
                                                [
                                                    39.825,
                                                    -4.707
                                                ],
                                                [
                                                    41.877,
                                                    -4.257
                                                ],
                                                [
                                                    43.101,
                                                    -3.123
                                                ],
                                                [
                                                    43.605,
                                                    -1.647
                                                ],
                                                [
                                                    42.021,
                                                    -1.539
                                                ],
                                                [
                                                    41.751,
                                                    -2.385
                                                ],
                                                [
                                                    41.049,
                                                    -3.015
                                                ],
                                                [
                                                    39.789,
                                                    -3.267
                                                ],
                                                [
                                                    38.277,
                                                    -2.871
                                                ],
                                                [
                                                    37.791,
                                                    -1.863
                                                ],
                                                [
                                                    37.971,
                                                    -1.089
                                                ],
                                                [
                                                    38.637,
                                                    -0.603
                                                ],
                                                [
                                                    39.951,
                                                    -0.279
                                                ],
                                                [
                                                    42.147,
                                                    0.315
                                                ],
                                                [
                                                    43.245,
                                                    1.215
                                                ],
                                                [
                                                    43.569,
                                                    2.493
                                                ],
                                                [
                                                    42.543,
                                                    4.545
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 23",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.42,
                                                    0.396
                                                ],
                                                [
                                                    0,
                                                    0.84
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    -0.168
                                                ],
                                                [
                                                    -0.396,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.864,
                                                    0
                                                ],
                                                [
                                                    -0.408,
                                                    -0.396
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.432
                                                ],
                                                [
                                                    0.192,
                                                    0.168
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    48.776,
                                                    5.049
                                                ],
                                                [
                                                    46.85,
                                                    4.455
                                                ],
                                                [
                                                    46.238,
                                                    2.601
                                                ],
                                                [
                                                    46.238,
                                                    -6.723
                                                ],
                                                [
                                                    47.75,
                                                    -6.723
                                                ],
                                                [
                                                    47.75,
                                                    2.565
                                                ],
                                                [
                                                    48.038,
                                                    3.465
                                                ],
                                                [
                                                    48.92,
                                                    3.717
                                                ],
                                                [
                                                    50.288,
                                                    3.717
                                                ],
                                                [
                                                    50.288,
                                                    5.049
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 24",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    44.834,
                                                    -3.159
                                                ],
                                                [
                                                    44.834,
                                                    -4.491
                                                ],
                                                [
                                                    50.288,
                                                    -4.491
                                                ],
                                                [
                                                    50.288,
                                                    -3.159
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 25",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.876,
                                                    0
                                                ],
                                                [
                                                    0.66,
                                                    0.408
                                                ],
                                                [
                                                    0.36,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    -0.36,
                                                    0.744
                                                ],
                                                [
                                                    -0.66,
                                                    0.408
                                                ],
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.648,
                                                    -0.408
                                                ],
                                                [
                                                    -0.36,
                                                    -0.744
                                                ],
                                                [
                                                    0,
                                                    -1.02
                                                ],
                                                [
                                                    0.36,
                                                    -0.756
                                                ],
                                                [
                                                    0.66,
                                                    -0.408
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.66,
                                                    -0.408
                                                ],
                                                [
                                                    -0.36,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.02
                                                ],
                                                [
                                                    0.36,
                                                    -0.744
                                                ],
                                                [
                                                    0.66,
                                                    -0.408
                                                ],
                                                [
                                                    0.876,
                                                    0
                                                ],
                                                [
                                                    0.66,
                                                    0.408
                                                ],
                                                [
                                                    0.36,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    -0.36,
                                                    0.744
                                                ],
                                                [
                                                    -0.648,
                                                    0.408
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    55.777,
                                                    5.265
                                                ],
                                                [
                                                    53.473,
                                                    4.653
                                                ],
                                                [
                                                    51.943,
                                                    2.925
                                                ],
                                                [
                                                    51.403,
                                                    0.279
                                                ],
                                                [
                                                    51.943,
                                                    -2.367
                                                ],
                                                [
                                                    53.473,
                                                    -4.095
                                                ],
                                                [
                                                    55.777,
                                                    -4.707
                                                ],
                                                [
                                                    58.063,
                                                    -4.095
                                                ],
                                                [
                                                    59.593,
                                                    -2.367
                                                ],
                                                [
                                                    60.133,
                                                    0.279
                                                ],
                                                [
                                                    59.593,
                                                    2.925
                                                ],
                                                [
                                                    58.063,
                                                    4.653
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 26",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.48,
                                                    0.624
                                                ],
                                                [
                                                    0,
                                                    1.104
                                                ],
                                                [
                                                    0.492,
                                                    0.624
                                                ],
                                                [
                                                    0.876,
                                                    0
                                                ],
                                                [
                                                    0.492,
                                                    -0.636
                                                ],
                                                [
                                                    0,
                                                    -1.104
                                                ],
                                                [
                                                    -0.492,
                                                    -0.636
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.876,
                                                    0
                                                ],
                                                [
                                                    0.492,
                                                    -0.636
                                                ],
                                                [
                                                    0,
                                                    -1.104
                                                ],
                                                [
                                                    -0.48,
                                                    -0.636
                                                ],
                                                [
                                                    -0.876,
                                                    0
                                                ],
                                                [
                                                    -0.492,
                                                    0.624
                                                ],
                                                [
                                                    0,
                                                    1.104
                                                ],
                                                [
                                                    0.492,
                                                    0.624
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    55.777,
                                                    3.825
                                                ],
                                                [
                                                    57.811,
                                                    2.889
                                                ],
                                                [
                                                    58.549,
                                                    0.279
                                                ],
                                                [
                                                    57.811,
                                                    -2.313
                                                ],
                                                [
                                                    55.777,
                                                    -3.267
                                                ],
                                                [
                                                    53.725,
                                                    -2.313
                                                ],
                                                [
                                                    52.987,
                                                    0.279
                                                ],
                                                [
                                                    53.725,
                                                    2.889
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 27",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.396,
                                                    0.372
                                                ],
                                                [
                                                    -0.672,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.324,
                                                    -0.18
                                                ],
                                                [
                                                    0.168,
                                                    -0.348
                                                ],
                                                [
                                                    0,
                                                    -0.528
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.12,
                                                    -0.816
                                                ],
                                                [
                                                    0.408,
                                                    -0.384
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.48,
                                                    0
                                                ],
                                                [
                                                    -0.312,
                                                    0.168
                                                ],
                                                [
                                                    -0.156,
                                                    0.336
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    62.194,
                                                    5.049
                                                ],
                                                [
                                                    62.194,
                                                    -4.491
                                                ],
                                                [
                                                    63.526,
                                                    -4.491
                                                ],
                                                [
                                                    63.598,
                                                    -2.079
                                                ],
                                                [
                                                    63.454,
                                                    -2.133
                                                ],
                                                [
                                                    64.228,
                                                    -3.915
                                                ],
                                                [
                                                    65.848,
                                                    -4.491
                                                ],
                                                [
                                                    66.784,
                                                    -4.491
                                                ],
                                                [
                                                    66.784,
                                                    -3.051
                                                ],
                                                [
                                                    65.866,
                                                    -3.051
                                                ],
                                                [
                                                    64.66,
                                                    -2.781
                                                ],
                                                [
                                                    63.94,
                                                    -2.007
                                                ],
                                                [
                                                    63.706,
                                                    -0.711
                                                ],
                                                [
                                                    63.706,
                                                    5.049
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 28",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.156,
                                                    0.108
                                                ],
                                                [
                                                    -0.084,
                                                    0.228
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.36,
                                                    -0.24
                                                ],
                                                [
                                                    0.636,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.336,
                                                    0
                                                ],
                                                [
                                                    0.168,
                                                    -0.096
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.18,
                                                    0.516
                                                ],
                                                [
                                                    -0.36,
                                                    0.24
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    68.971,
                                                    7.749
                                                ],
                                                [
                                                    68.971,
                                                    6.417
                                                ],
                                                [
                                                    70.069,
                                                    6.417
                                                ],
                                                [
                                                    70.807,
                                                    6.255
                                                ],
                                                [
                                                    71.185,
                                                    5.769
                                                ],
                                                [
                                                    71.527,
                                                    4.869
                                                ],
                                                [
                                                    71.005,
                                                    4.869
                                                ],
                                                [
                                                    67.513,
                                                    -4.491
                                                ],
                                                [
                                                    69.169,
                                                    -4.491
                                                ],
                                                [
                                                    72.013,
                                                    3.465
                                                ],
                                                [
                                                    74.731,
                                                    -4.491
                                                ],
                                                [
                                                    76.387,
                                                    -4.491
                                                ],
                                                [
                                                    72.517,
                                                    6.255
                                                ],
                                                [
                                                    71.707,
                                                    7.389
                                                ],
                                                [
                                                    70.213,
                                                    7.749
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            127.043,
                                            271.951
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 6",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -6.351,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -6.351
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    6.351,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    6.351
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    6.351,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    6.351
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -6.351,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -6.351
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -171,
                                                    -21.5
                                                ],
                                                [
                                                    171,
                                                    -21.5
                                                ],
                                                [
                                                    182.5,
                                                    -10
                                                ],
                                                [
                                                    182.5,
                                                    10
                                                ],
                                                [
                                                    171,
                                                    21.5
                                                ],
                                                [
                                                    -171,
                                                    21.5
                                                ],
                                                [
                                                    -182.5,
                                                    10
                                                ],
                                                [
                                                    -182.5,
                                                    -10
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8392,
                                            0.8392,
                                            0.8392
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            221,
                                            271
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 7",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -61.88,
                                                    5.312
                                                ],
                                                [
                                                    -61.88,
                                                    -4
                                                ],
                                                [
                                                    -65.272,
                                                    -4
                                                ],
                                                [
                                                    -65.272,
                                                    -6.048
                                                ],
                                                [
                                                    -56.024,
                                                    -6.048
                                                ],
                                                [
                                                    -56.024,
                                                    -4
                                                ],
                                                [
                                                    -59.432,
                                                    -4
                                                ],
                                                [
                                                    -59.432,
                                                    5.312
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.152,
                                                    0
                                                ],
                                                [
                                                    0.832,
                                                    0.48
                                                ],
                                                [
                                                    0.448,
                                                    0.885
                                                ],
                                                [
                                                    0,
                                                    1.216
                                                ],
                                                [
                                                    -0.438,
                                                    0.885
                                                ],
                                                [
                                                    -0.822,
                                                    0.48
                                                ],
                                                [
                                                    -1.152,
                                                    0
                                                ],
                                                [
                                                    -0.822,
                                                    -0.491
                                                ],
                                                [
                                                    -0.438,
                                                    -0.896
                                                ],
                                                [
                                                    0,
                                                    -1.216
                                                ],
                                                [
                                                    0.448,
                                                    -0.885
                                                ],
                                                [
                                                    0.832,
                                                    -0.48
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.152,
                                                    0
                                                ],
                                                [
                                                    -0.822,
                                                    -0.48
                                                ],
                                                [
                                                    -0.438,
                                                    -0.885
                                                ],
                                                [
                                                    0,
                                                    -1.216
                                                ],
                                                [
                                                    0.448,
                                                    -0.896
                                                ],
                                                [
                                                    0.832,
                                                    -0.491
                                                ],
                                                [
                                                    1.152,
                                                    0
                                                ],
                                                [
                                                    0.832,
                                                    0.48
                                                ],
                                                [
                                                    0.448,
                                                    0.885
                                                ],
                                                [
                                                    0,
                                                    1.216
                                                ],
                                                [
                                                    -0.438,
                                                    0.885
                                                ],
                                                [
                                                    -0.822,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -50.302,
                                                    5.568
                                                ],
                                                [
                                                    -53.278,
                                                    4.848
                                                ],
                                                [
                                                    -55.182,
                                                    2.8
                                                ],
                                                [
                                                    -55.838,
                                                    -0.352
                                                ],
                                                [
                                                    -55.182,
                                                    -3.504
                                                ],
                                                [
                                                    -53.278,
                                                    -5.568
                                                ],
                                                [
                                                    -50.302,
                                                    -6.304
                                                ],
                                                [
                                                    -47.342,
                                                    -5.568
                                                ],
                                                [
                                                    -45.438,
                                                    -3.504
                                                ],
                                                [
                                                    -44.766,
                                                    -0.352
                                                ],
                                                [
                                                    -45.438,
                                                    2.8
                                                ],
                                                [
                                                    -47.342,
                                                    4.848
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.619,
                                                    0
                                                ],
                                                [
                                                    -0.448,
                                                    0.299
                                                ],
                                                [
                                                    -0.235,
                                                    0.576
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ],
                                                [
                                                    0.245,
                                                    0.576
                                                ],
                                                [
                                                    0.458,
                                                    0.309
                                                ],
                                                [
                                                    0.64,
                                                    0
                                                ],
                                                [
                                                    0.448,
                                                    -0.309
                                                ],
                                                [
                                                    0.245,
                                                    -0.587
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.235,
                                                    -0.576
                                                ],
                                                [
                                                    -0.448,
                                                    -0.309
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.64,
                                                    0
                                                ],
                                                [
                                                    0.458,
                                                    -0.309
                                                ],
                                                [
                                                    0.245,
                                                    -0.576
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.235,
                                                    -0.587
                                                ],
                                                [
                                                    -0.448,
                                                    -0.309
                                                ],
                                                [
                                                    -0.63,
                                                    0
                                                ],
                                                [
                                                    -0.448,
                                                    0.309
                                                ],
                                                [
                                                    -0.235,
                                                    0.576
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ],
                                                [
                                                    0.245,
                                                    0.576
                                                ],
                                                [
                                                    0.458,
                                                    0.299
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -50.318,
                                                    3.52
                                                ],
                                                [
                                                    -48.686,
                                                    3.072
                                                ],
                                                [
                                                    -47.646,
                                                    1.744
                                                ],
                                                [
                                                    -47.278,
                                                    -0.352
                                                ],
                                                [
                                                    -47.646,
                                                    -2.448
                                                ],
                                                [
                                                    -48.686,
                                                    -3.792
                                                ],
                                                [
                                                    -50.318,
                                                    -4.256
                                                ],
                                                [
                                                    -51.934,
                                                    -3.792
                                                ],
                                                [
                                                    -52.974,
                                                    -2.448
                                                ],
                                                [
                                                    -53.326,
                                                    -0.352
                                                ],
                                                [
                                                    -52.974,
                                                    1.744
                                                ],
                                                [
                                                    -51.934,
                                                    3.072
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.152,
                                                    0
                                                ],
                                                [
                                                    0.832,
                                                    0.48
                                                ],
                                                [
                                                    0.448,
                                                    0.885
                                                ],
                                                [
                                                    0,
                                                    1.216
                                                ],
                                                [
                                                    -0.437,
                                                    0.885
                                                ],
                                                [
                                                    -0.821,
                                                    0.48
                                                ],
                                                [
                                                    -1.152,
                                                    0
                                                ],
                                                [
                                                    -0.821,
                                                    -0.491
                                                ],
                                                [
                                                    -0.437,
                                                    -0.896
                                                ],
                                                [
                                                    0,
                                                    -1.216
                                                ],
                                                [
                                                    0.448,
                                                    -0.885
                                                ],
                                                [
                                                    0.832,
                                                    -0.48
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.152,
                                                    0
                                                ],
                                                [
                                                    -0.821,
                                                    -0.48
                                                ],
                                                [
                                                    -0.437,
                                                    -0.885
                                                ],
                                                [
                                                    0,
                                                    -1.216
                                                ],
                                                [
                                                    0.448,
                                                    -0.896
                                                ],
                                                [
                                                    0.832,
                                                    -0.491
                                                ],
                                                [
                                                    1.152,
                                                    0
                                                ],
                                                [
                                                    0.832,
                                                    0.48
                                                ],
                                                [
                                                    0.448,
                                                    0.885
                                                ],
                                                [
                                                    0,
                                                    1.216
                                                ],
                                                [
                                                    -0.437,
                                                    0.885
                                                ],
                                                [
                                                    -0.821,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -37.881,
                                                    5.568
                                                ],
                                                [
                                                    -40.857,
                                                    4.848
                                                ],
                                                [
                                                    -42.761,
                                                    2.8
                                                ],
                                                [
                                                    -43.417,
                                                    -0.352
                                                ],
                                                [
                                                    -42.761,
                                                    -3.504
                                                ],
                                                [
                                                    -40.857,
                                                    -5.568
                                                ],
                                                [
                                                    -37.881,
                                                    -6.304
                                                ],
                                                [
                                                    -34.921,
                                                    -5.568
                                                ],
                                                [
                                                    -33.017,
                                                    -3.504
                                                ],
                                                [
                                                    -32.345,
                                                    -0.352
                                                ],
                                                [
                                                    -33.017,
                                                    2.8
                                                ],
                                                [
                                                    -34.921,
                                                    4.848
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.618,
                                                    0
                                                ],
                                                [
                                                    -0.448,
                                                    0.299
                                                ],
                                                [
                                                    -0.234,
                                                    0.576
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ],
                                                [
                                                    0.246,
                                                    0.576
                                                ],
                                                [
                                                    0.459,
                                                    0.309
                                                ],
                                                [
                                                    0.64,
                                                    0
                                                ],
                                                [
                                                    0.448,
                                                    -0.309
                                                ],
                                                [
                                                    0.246,
                                                    -0.587
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.234,
                                                    -0.576
                                                ],
                                                [
                                                    -0.448,
                                                    -0.309
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.64,
                                                    0
                                                ],
                                                [
                                                    0.459,
                                                    -0.309
                                                ],
                                                [
                                                    0.246,
                                                    -0.576
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.234,
                                                    -0.587
                                                ],
                                                [
                                                    -0.448,
                                                    -0.309
                                                ],
                                                [
                                                    -0.629,
                                                    0
                                                ],
                                                [
                                                    -0.448,
                                                    0.309
                                                ],
                                                [
                                                    -0.234,
                                                    0.576
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ],
                                                [
                                                    0.246,
                                                    0.576
                                                ],
                                                [
                                                    0.459,
                                                    0.299
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -37.897,
                                                    3.52
                                                ],
                                                [
                                                    -36.265,
                                                    3.072
                                                ],
                                                [
                                                    -35.225,
                                                    1.744
                                                ],
                                                [
                                                    -34.857,
                                                    -0.352
                                                ],
                                                [
                                                    -35.225,
                                                    -2.448
                                                ],
                                                [
                                                    -36.265,
                                                    -3.792
                                                ],
                                                [
                                                    -37.897,
                                                    -4.256
                                                ],
                                                [
                                                    -39.513,
                                                    -3.792
                                                ],
                                                [
                                                    -40.553,
                                                    -2.448
                                                ],
                                                [
                                                    -40.905,
                                                    -0.352
                                                ],
                                                [
                                                    -40.553,
                                                    1.744
                                                ],
                                                [
                                                    -39.513,
                                                    3.072
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -30.701,
                                                    5.312
                                                ],
                                                [
                                                    -30.701,
                                                    -6.048
                                                ],
                                                [
                                                    -28.27,
                                                    -6.048
                                                ],
                                                [
                                                    -28.27,
                                                    4.656
                                                ],
                                                [
                                                    -29.613,
                                                    3.264
                                                ],
                                                [
                                                    -23.037,
                                                    3.264
                                                ],
                                                [
                                                    -23.037,
                                                    5.312
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.608,
                                                    -0.277
                                                ],
                                                [
                                                    -0.331,
                                                    -0.512
                                                ],
                                                [
                                                    0,
                                                    -0.693
                                                ],
                                                [
                                                    0.224,
                                                    -0.405
                                                ],
                                                [
                                                    0.384,
                                                    -0.256
                                                ],
                                                [
                                                    0.491,
                                                    -0.064
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    -0.331
                                                ],
                                                [
                                                    -0.053,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.245,
                                                    0.203
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.832,
                                                    0
                                                ],
                                                [
                                                    0.619,
                                                    0.277
                                                ],
                                                [
                                                    0.331,
                                                    0.501
                                                ],
                                                [
                                                    0,
                                                    0.523
                                                ],
                                                [
                                                    -0.213,
                                                    0.405
                                                ],
                                                [
                                                    -0.373,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.757,
                                                    0
                                                ],
                                                [
                                                    0.395,
                                                    0.32
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.032,
                                                    -0.437
                                                ],
                                                [
                                                    -0.235,
                                                    -0.213
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -17.639,
                                                    5.312
                                                ],
                                                [
                                                    -17.639,
                                                    -6.048
                                                ],
                                                [
                                                    -12.663,
                                                    -6.048
                                                ],
                                                [
                                                    -10.503,
                                                    -5.632
                                                ],
                                                [
                                                    -9.079,
                                                    -4.448
                                                ],
                                                [
                                                    -8.583,
                                                    -2.656
                                                ],
                                                [
                                                    -8.919,
                                                    -1.264
                                                ],
                                                [
                                                    -9.815,
                                                    -0.272
                                                ],
                                                [
                                                    -11.111,
                                                    0.208
                                                ],
                                                [
                                                    -11.159,
                                                    0.064
                                                ],
                                                [
                                                    -9.431,
                                                    0.56
                                                ],
                                                [
                                                    -8.759,
                                                    2.048
                                                ],
                                                [
                                                    -8.471,
                                                    5.312
                                                ],
                                                [
                                                    -10.951,
                                                    5.312
                                                ],
                                                [
                                                    -11.159,
                                                    2.432
                                                ],
                                                [
                                                    -11.575,
                                                    1.472
                                                ],
                                                [
                                                    -12.791,
                                                    1.152
                                                ],
                                                [
                                                    -15.207,
                                                    1.152
                                                ],
                                                [
                                                    -15.207,
                                                    5.312
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.32,
                                                    0.267
                                                ],
                                                [
                                                    0,
                                                    0.501
                                                ],
                                                [
                                                    0.331,
                                                    0.256
                                                ],
                                                [
                                                    0.629,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.587,
                                                    0
                                                ],
                                                [
                                                    0.331,
                                                    -0.277
                                                ],
                                                [
                                                    0,
                                                    -0.512
                                                ],
                                                [
                                                    -0.331,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -15.207,
                                                    -0.88
                                                ],
                                                [
                                                    -12.935,
                                                    -0.88
                                                ],
                                                [
                                                    -11.575,
                                                    -1.28
                                                ],
                                                [
                                                    -11.079,
                                                    -2.448
                                                ],
                                                [
                                                    -11.575,
                                                    -3.6
                                                ],
                                                [
                                                    -13.015,
                                                    -4
                                                ],
                                                [
                                                    -15.207,
                                                    -4
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -6.483,
                                                    5.312
                                                ],
                                                [
                                                    -6.483,
                                                    -6.048
                                                ],
                                                [
                                                    1.421,
                                                    -6.048
                                                ],
                                                [
                                                    1.421,
                                                    -4
                                                ],
                                                [
                                                    -4.051,
                                                    -4
                                                ],
                                                [
                                                    -4.051,
                                                    -1.392
                                                ],
                                                [
                                                    1.229,
                                                    -1.392
                                                ],
                                                [
                                                    1.229,
                                                    0.624
                                                ],
                                                [
                                                    -4.051,
                                                    0.624
                                                ],
                                                [
                                                    -4.051,
                                                    3.264
                                                ],
                                                [
                                                    1.549,
                                                    3.264
                                                ],
                                                [
                                                    1.549,
                                                    5.312
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.352,
                                                    -0.064
                                                ],
                                                [
                                                    0.416,
                                                    0
                                                ],
                                                [
                                                    0.822,
                                                    0.501
                                                ],
                                                [
                                                    0.448,
                                                    0.885
                                                ],
                                                [
                                                    0,
                                                    1.152
                                                ],
                                                [
                                                    -0.416,
                                                    0.896
                                                ],
                                                [
                                                    -0.81,
                                                    0.523
                                                ],
                                                [
                                                    -1.184,
                                                    0
                                                ],
                                                [
                                                    -0.81,
                                                    -0.523
                                                ],
                                                [
                                                    -0.416,
                                                    -0.896
                                                ],
                                                [
                                                    0,
                                                    -1.131
                                                ],
                                                [
                                                    0.363,
                                                    -0.8
                                                ],
                                                [
                                                    0.662,
                                                    -0.533
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.245,
                                                    0.117
                                                ],
                                                [
                                                    -0.341,
                                                    0.064
                                                ],
                                                [
                                                    -1.12,
                                                    0
                                                ],
                                                [
                                                    -0.821,
                                                    -0.512
                                                ],
                                                [
                                                    -0.448,
                                                    -0.896
                                                ],
                                                [
                                                    0,
                                                    -1.131
                                                ],
                                                [
                                                    0.427,
                                                    -0.896
                                                ],
                                                [
                                                    0.822,
                                                    -0.523
                                                ],
                                                [
                                                    1.184,
                                                    0
                                                ],
                                                [
                                                    0.822,
                                                    0.523
                                                ],
                                                [
                                                    0.416,
                                                    0.896
                                                ],
                                                [
                                                    0,
                                                    1.056
                                                ],
                                                [
                                                    -0.352,
                                                    0.8
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    11.358,
                                                    6.304
                                                ],
                                                [
                                                    10.478,
                                                    5.2
                                                ],
                                                [
                                                    9.582,
                                                    5.472
                                                ],
                                                [
                                                    8.446,
                                                    5.568
                                                ],
                                                [
                                                    5.534,
                                                    4.816
                                                ],
                                                [
                                                    3.63,
                                                    2.72
                                                ],
                                                [
                                                    2.958,
                                                    -0.352
                                                ],
                                                [
                                                    3.582,
                                                    -3.392
                                                ],
                                                [
                                                    5.438,
                                                    -5.52
                                                ],
                                                [
                                                    8.446,
                                                    -6.304
                                                ],
                                                [
                                                    11.438,
                                                    -5.52
                                                ],
                                                [
                                                    13.294,
                                                    -3.392
                                                ],
                                                [
                                                    13.918,
                                                    -0.352
                                                ],
                                                [
                                                    13.374,
                                                    2.432
                                                ],
                                                [
                                                    11.854,
                                                    4.432
                                                ],
                                                [
                                                    13.358,
                                                    6.304
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.682,
                                                    0
                                                ],
                                                [
                                                    -0.117,
                                                    0.011
                                                ],
                                                [
                                                    -0.106,
                                                    0.043
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.16,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0.704
                                                ],
                                                [
                                                    0.214,
                                                    0.587
                                                ],
                                                [
                                                    0.438,
                                                    0.363
                                                ],
                                                [
                                                    0.683,
                                                    0
                                                ],
                                                [
                                                    0.438,
                                                    -0.363
                                                ],
                                                [
                                                    0.214,
                                                    -0.597
                                                ],
                                                [
                                                    0,
                                                    -0.693
                                                ],
                                                [
                                                    -0.202,
                                                    -0.597
                                                ],
                                                [
                                                    -0.437,
                                                    -0.363
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.139,
                                                    0
                                                ],
                                                [
                                                    0.118,
                                                    -0.021
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.299
                                                ],
                                                [
                                                    0.171,
                                                    -0.48
                                                ],
                                                [
                                                    0,
                                                    -0.693
                                                ],
                                                [
                                                    -0.202,
                                                    -0.597
                                                ],
                                                [
                                                    -0.437,
                                                    -0.363
                                                ],
                                                [
                                                    -0.693,
                                                    0
                                                ],
                                                [
                                                    -0.437,
                                                    0.363
                                                ],
                                                [
                                                    -0.202,
                                                    0.587
                                                ],
                                                [
                                                    0,
                                                    0.683
                                                ],
                                                [
                                                    0.214,
                                                    0.587
                                                ],
                                                [
                                                    0.448,
                                                    0.352
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    8.446,
                                                    3.52
                                                ],
                                                [
                                                    8.83,
                                                    3.504
                                                ],
                                                [
                                                    9.166,
                                                    3.408
                                                ],
                                                [
                                                    7.582,
                                                    1.472
                                                ],
                                                [
                                                    9.598,
                                                    1.472
                                                ],
                                                [
                                                    10.43,
                                                    2.576
                                                ],
                                                [
                                                    11.15,
                                                    1.424
                                                ],
                                                [
                                                    11.406,
                                                    -0.352
                                                ],
                                                [
                                                    11.086,
                                                    -2.272
                                                ],
                                                [
                                                    10.126,
                                                    -3.712
                                                ],
                                                [
                                                    8.446,
                                                    -4.256
                                                ],
                                                [
                                                    6.75,
                                                    -3.712
                                                ],
                                                [
                                                    5.774,
                                                    -2.272
                                                ],
                                                [
                                                    5.47,
                                                    -0.352
                                                ],
                                                [
                                                    5.774,
                                                    1.568
                                                ],
                                                [
                                                    6.75,
                                                    2.992
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.95,
                                                    0
                                                ],
                                                [
                                                    0.704,
                                                    0.352
                                                ],
                                                [
                                                    0.384,
                                                    0.651
                                                ],
                                                [
                                                    0,
                                                    0.885
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.384,
                                                    -0.405
                                                ],
                                                [
                                                    -0.725,
                                                    0
                                                ],
                                                [
                                                    -0.384,
                                                    0.395
                                                ],
                                                [
                                                    0,
                                                    0.736
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.384,
                                                    -0.661
                                                ],
                                                [
                                                    0.704,
                                                    -0.352
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.96,
                                                    0
                                                ],
                                                [
                                                    -0.693,
                                                    -0.352
                                                ],
                                                [
                                                    -0.384,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.736
                                                ],
                                                [
                                                    0.395,
                                                    0.395
                                                ],
                                                [
                                                    0.726,
                                                    0
                                                ],
                                                [
                                                    0.384,
                                                    -0.405
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.885
                                                ],
                                                [
                                                    -0.373,
                                                    0.651
                                                ],
                                                [
                                                    -0.704,
                                                    0.352
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    20.215,
                                                    5.568
                                                ],
                                                [
                                                    17.719,
                                                    5.04
                                                ],
                                                [
                                                    16.103,
                                                    3.536
                                                ],
                                                [
                                                    15.527,
                                                    1.216
                                                ],
                                                [
                                                    15.527,
                                                    -6.048
                                                ],
                                                [
                                                    17.959,
                                                    -6.048
                                                ],
                                                [
                                                    17.959,
                                                    1.216
                                                ],
                                                [
                                                    18.535,
                                                    2.928
                                                ],
                                                [
                                                    20.215,
                                                    3.52
                                                ],
                                                [
                                                    21.879,
                                                    2.928
                                                ],
                                                [
                                                    22.455,
                                                    1.216
                                                ],
                                                [
                                                    22.455,
                                                    -6.048
                                                ],
                                                [
                                                    24.887,
                                                    -6.048
                                                ],
                                                [
                                                    24.887,
                                                    1.216
                                                ],
                                                [
                                                    24.311,
                                                    3.536
                                                ],
                                                [
                                                    22.695,
                                                    5.04
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    27.252,
                                                    5.312
                                                ],
                                                [
                                                    27.252,
                                                    -6.048
                                                ],
                                                [
                                                    35.156,
                                                    -6.048
                                                ],
                                                [
                                                    35.156,
                                                    -4
                                                ],
                                                [
                                                    29.684,
                                                    -4
                                                ],
                                                [
                                                    29.684,
                                                    -1.392
                                                ],
                                                [
                                                    34.964,
                                                    -1.392
                                                ],
                                                [
                                                    34.964,
                                                    0.624
                                                ],
                                                [
                                                    29.684,
                                                    0.624
                                                ],
                                                [
                                                    29.684,
                                                    3.264
                                                ],
                                                [
                                                    35.284,
                                                    3.264
                                                ],
                                                [
                                                    35.284,
                                                    5.312
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 14",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.896,
                                                    0
                                                ],
                                                [
                                                    0.704,
                                                    0.331
                                                ],
                                                [
                                                    0.394,
                                                    0.597
                                                ],
                                                [
                                                    0.053,
                                                    0.811
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    -0.32
                                                ],
                                                [
                                                    -0.331,
                                                    -0.16
                                                ],
                                                [
                                                    -0.491,
                                                    0
                                                ],
                                                [
                                                    -0.278,
                                                    0.096
                                                ],
                                                [
                                                    -0.15,
                                                    0.192
                                                ],
                                                [
                                                    0,
                                                    0.288
                                                ],
                                                [
                                                    0.128,
                                                    0.192
                                                ],
                                                [
                                                    0.362,
                                                    0.16
                                                ],
                                                [
                                                    0.704,
                                                    0.16
                                                ],
                                                [
                                                    0.597,
                                                    0.277
                                                ],
                                                [
                                                    0.266,
                                                    0.416
                                                ],
                                                [
                                                    0,
                                                    0.64
                                                ],
                                                [
                                                    -0.331,
                                                    0.512
                                                ],
                                                [
                                                    -0.64,
                                                    0.288
                                                ],
                                                [
                                                    -0.886,
                                                    0
                                                ],
                                                [
                                                    -0.651,
                                                    -0.331
                                                ],
                                                [
                                                    -0.363,
                                                    -0.576
                                                ],
                                                [
                                                    -0.075,
                                                    -0.747
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.181,
                                                    0.288
                                                ],
                                                [
                                                    0.309,
                                                    0.16
                                                ],
                                                [
                                                    0.437,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.245
                                                ],
                                                [
                                                    0,
                                                    -0.395
                                                ],
                                                [
                                                    -0.139,
                                                    -0.192
                                                ],
                                                [
                                                    -0.331,
                                                    -0.139
                                                ],
                                                [
                                                    -0.619,
                                                    -0.128
                                                ],
                                                [
                                                    -0.608,
                                                    -0.331
                                                ],
                                                [
                                                    -0.256,
                                                    -0.448
                                                ],
                                                [
                                                    0,
                                                    -0.576
                                                ],
                                                [
                                                    0.362,
                                                    -0.523
                                                ],
                                                [
                                                    0.661,
                                                    -0.277
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.982,
                                                    0
                                                ],
                                                [
                                                    -0.704,
                                                    -0.331
                                                ],
                                                [
                                                    -0.395,
                                                    -0.597
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.064,
                                                    0.448
                                                ],
                                                [
                                                    0.202,
                                                    0.309
                                                ],
                                                [
                                                    0.341,
                                                    0.16
                                                ],
                                                [
                                                    0.405,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.096
                                                ],
                                                [
                                                    0.149,
                                                    -0.203
                                                ],
                                                [
                                                    0,
                                                    -0.267
                                                ],
                                                [
                                                    -0.128,
                                                    -0.203
                                                ],
                                                [
                                                    -0.363,
                                                    -0.171
                                                ],
                                                [
                                                    -0.971,
                                                    -0.224
                                                ],
                                                [
                                                    -0.587,
                                                    -0.277
                                                ],
                                                [
                                                    -0.267,
                                                    -0.427
                                                ],
                                                [
                                                    0,
                                                    -0.683
                                                ],
                                                [
                                                    0.341,
                                                    -0.512
                                                ],
                                                [
                                                    0.64,
                                                    -0.288
                                                ],
                                                [
                                                    0.938,
                                                    0
                                                ],
                                                [
                                                    0.65,
                                                    0.331
                                                ],
                                                [
                                                    0.373,
                                                    0.576
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.032,
                                                    -0.395
                                                ],
                                                [
                                                    -0.182,
                                                    -0.299
                                                ],
                                                [
                                                    -0.31,
                                                    -0.16
                                                ],
                                                [
                                                    -0.555,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    0.245
                                                ],
                                                [
                                                    0,
                                                    0.277
                                                ],
                                                [
                                                    0.149,
                                                    0.181
                                                ],
                                                [
                                                    0.341,
                                                    0.139
                                                ],
                                                [
                                                    1.056,
                                                    0.213
                                                ],
                                                [
                                                    0.618,
                                                    0.32
                                                ],
                                                [
                                                    0.256,
                                                    0.448
                                                ],
                                                [
                                                    0,
                                                    0.704
                                                ],
                                                [
                                                    -0.352,
                                                    0.512
                                                ],
                                                [
                                                    -0.651,
                                                    0.277
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    41.701,
                                                    5.568
                                                ],
                                                [
                                                    39.173,
                                                    5.072
                                                ],
                                                [
                                                    37.525,
                                                    3.68
                                                ],
                                                [
                                                    36.853,
                                                    1.568
                                                ],
                                                [
                                                    39.301,
                                                    1.456
                                                ],
                                                [
                                                    39.685,
                                                    2.608
                                                ],
                                                [
                                                    40.485,
                                                    3.312
                                                ],
                                                [
                                                    41.733,
                                                    3.552
                                                ],
                                                [
                                                    42.757,
                                                    3.408
                                                ],
                                                [
                                                    43.413,
                                                    2.976
                                                ],
                                                [
                                                    43.637,
                                                    2.24
                                                ],
                                                [
                                                    43.445,
                                                    1.552
                                                ],
                                                [
                                                    42.709,
                                                    1.008
                                                ],
                                                [
                                                    41.109,
                                                    0.512
                                                ],
                                                [
                                                    38.757,
                                                    -0.24
                                                ],
                                                [
                                                    37.477,
                                                    -1.28
                                                ],
                                                [
                                                    37.077,
                                                    -2.88
                                                ],
                                                [
                                                    37.573,
                                                    -4.672
                                                ],
                                                [
                                                    39.045,
                                                    -5.872
                                                ],
                                                [
                                                    41.333,
                                                    -6.304
                                                ],
                                                [
                                                    43.717,
                                                    -5.808
                                                ],
                                                [
                                                    45.237,
                                                    -4.448
                                                ],
                                                [
                                                    45.909,
                                                    -2.464
                                                ],
                                                [
                                                    43.477,
                                                    -2.336
                                                ],
                                                [
                                                    43.157,
                                                    -3.36
                                                ],
                                                [
                                                    42.421,
                                                    -4.048
                                                ],
                                                [
                                                    41.301,
                                                    -4.288
                                                ],
                                                [
                                                    39.989,
                                                    -3.92
                                                ],
                                                [
                                                    39.525,
                                                    -2.96
                                                ],
                                                [
                                                    39.733,
                                                    -2.256
                                                ],
                                                [
                                                    40.453,
                                                    -1.776
                                                ],
                                                [
                                                    41.893,
                                                    -1.376
                                                ],
                                                [
                                                    44.389,
                                                    -0.56
                                                ],
                                                [
                                                    45.701,
                                                    0.592
                                                ],
                                                [
                                                    46.085,
                                                    2.128
                                                ],
                                                [
                                                    45.541,
                                                    3.968
                                                ],
                                                [
                                                    44.021,
                                                    5.152
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 15",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    49.839,
                                                    5.312
                                                ],
                                                [
                                                    49.839,
                                                    -4
                                                ],
                                                [
                                                    46.447,
                                                    -4
                                                ],
                                                [
                                                    46.447,
                                                    -6.048
                                                ],
                                                [
                                                    55.695,
                                                    -6.048
                                                ],
                                                [
                                                    55.695,
                                                    -4
                                                ],
                                                [
                                                    52.287,
                                                    -4
                                                ],
                                                [
                                                    52.287,
                                                    5.312
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 16",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.896,
                                                    0
                                                ],
                                                [
                                                    0.704,
                                                    0.331
                                                ],
                                                [
                                                    0.395,
                                                    0.597
                                                ],
                                                [
                                                    0.054,
                                                    0.811
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    -0.32
                                                ],
                                                [
                                                    -0.33,
                                                    -0.16
                                                ],
                                                [
                                                    -0.49,
                                                    0
                                                ],
                                                [
                                                    -0.277,
                                                    0.096
                                                ],
                                                [
                                                    -0.149,
                                                    0.192
                                                ],
                                                [
                                                    0,
                                                    0.288
                                                ],
                                                [
                                                    0.128,
                                                    0.192
                                                ],
                                                [
                                                    0.363,
                                                    0.16
                                                ],
                                                [
                                                    0.704,
                                                    0.16
                                                ],
                                                [
                                                    0.598,
                                                    0.277
                                                ],
                                                [
                                                    0.267,
                                                    0.416
                                                ],
                                                [
                                                    0,
                                                    0.64
                                                ],
                                                [
                                                    -0.33,
                                                    0.512
                                                ],
                                                [
                                                    -0.64,
                                                    0.288
                                                ],
                                                [
                                                    -0.885,
                                                    0
                                                ],
                                                [
                                                    -0.65,
                                                    -0.331
                                                ],
                                                [
                                                    -0.362,
                                                    -0.576
                                                ],
                                                [
                                                    -0.074,
                                                    -0.747
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.182,
                                                    0.288
                                                ],
                                                [
                                                    0.31,
                                                    0.16
                                                ],
                                                [
                                                    0.438,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.245
                                                ],
                                                [
                                                    0,
                                                    -0.395
                                                ],
                                                [
                                                    -0.138,
                                                    -0.192
                                                ],
                                                [
                                                    -0.33,
                                                    -0.139
                                                ],
                                                [
                                                    -0.618,
                                                    -0.128
                                                ],
                                                [
                                                    -0.608,
                                                    -0.331
                                                ],
                                                [
                                                    -0.256,
                                                    -0.448
                                                ],
                                                [
                                                    0,
                                                    -0.576
                                                ],
                                                [
                                                    0.363,
                                                    -0.523
                                                ],
                                                [
                                                    0.662,
                                                    -0.277
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.981,
                                                    0
                                                ],
                                                [
                                                    -0.704,
                                                    -0.331
                                                ],
                                                [
                                                    -0.394,
                                                    -0.597
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.064,
                                                    0.448
                                                ],
                                                [
                                                    0.203,
                                                    0.309
                                                ],
                                                [
                                                    0.342,
                                                    0.16
                                                ],
                                                [
                                                    0.406,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.096
                                                ],
                                                [
                                                    0.15,
                                                    -0.203
                                                ],
                                                [
                                                    0,
                                                    -0.267
                                                ],
                                                [
                                                    -0.128,
                                                    -0.203
                                                ],
                                                [
                                                    -0.362,
                                                    -0.171
                                                ],
                                                [
                                                    -0.97,
                                                    -0.224
                                                ],
                                                [
                                                    -0.586,
                                                    -0.277
                                                ],
                                                [
                                                    -0.266,
                                                    -0.427
                                                ],
                                                [
                                                    0,
                                                    -0.683
                                                ],
                                                [
                                                    0.342,
                                                    -0.512
                                                ],
                                                [
                                                    0.64,
                                                    -0.288
                                                ],
                                                [
                                                    0.939,
                                                    0
                                                ],
                                                [
                                                    0.651,
                                                    0.331
                                                ],
                                                [
                                                    0.374,
                                                    0.576
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.032,
                                                    -0.395
                                                ],
                                                [
                                                    -0.181,
                                                    -0.299
                                                ],
                                                [
                                                    -0.309,
                                                    -0.16
                                                ],
                                                [
                                                    -0.554,
                                                    0
                                                ],
                                                [
                                                    -0.309,
                                                    0.245
                                                ],
                                                [
                                                    0,
                                                    0.277
                                                ],
                                                [
                                                    0.15,
                                                    0.181
                                                ],
                                                [
                                                    0.342,
                                                    0.139
                                                ],
                                                [
                                                    1.056,
                                                    0.213
                                                ],
                                                [
                                                    0.619,
                                                    0.32
                                                ],
                                                [
                                                    0.256,
                                                    0.448
                                                ],
                                                [
                                                    0,
                                                    0.704
                                                ],
                                                [
                                                    -0.352,
                                                    0.512
                                                ],
                                                [
                                                    -0.65,
                                                    0.277
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    60.888,
                                                    5.568
                                                ],
                                                [
                                                    58.36,
                                                    5.072
                                                ],
                                                [
                                                    56.712,
                                                    3.68
                                                ],
                                                [
                                                    56.04,
                                                    1.568
                                                ],
                                                [
                                                    58.488,
                                                    1.456
                                                ],
                                                [
                                                    58.872,
                                                    2.608
                                                ],
                                                [
                                                    59.672,
                                                    3.312
                                                ],
                                                [
                                                    60.92,
                                                    3.552
                                                ],
                                                [
                                                    61.944,
                                                    3.408
                                                ],
                                                [
                                                    62.6,
                                                    2.976
                                                ],
                                                [
                                                    62.824,
                                                    2.24
                                                ],
                                                [
                                                    62.632,
                                                    1.552
                                                ],
                                                [
                                                    61.896,
                                                    1.008
                                                ],
                                                [
                                                    60.296,
                                                    0.512
                                                ],
                                                [
                                                    57.944,
                                                    -0.24
                                                ],
                                                [
                                                    56.664,
                                                    -1.28
                                                ],
                                                [
                                                    56.264,
                                                    -2.88
                                                ],
                                                [
                                                    56.76,
                                                    -4.672
                                                ],
                                                [
                                                    58.232,
                                                    -5.872
                                                ],
                                                [
                                                    60.52,
                                                    -6.304
                                                ],
                                                [
                                                    62.904,
                                                    -5.808
                                                ],
                                                [
                                                    64.424,
                                                    -4.448
                                                ],
                                                [
                                                    65.096,
                                                    -2.464
                                                ],
                                                [
                                                    62.664,
                                                    -2.336
                                                ],
                                                [
                                                    62.344,
                                                    -3.36
                                                ],
                                                [
                                                    61.608,
                                                    -4.048
                                                ],
                                                [
                                                    60.488,
                                                    -4.288
                                                ],
                                                [
                                                    59.176,
                                                    -3.92
                                                ],
                                                [
                                                    58.712,
                                                    -2.96
                                                ],
                                                [
                                                    58.92,
                                                    -2.256
                                                ],
                                                [
                                                    59.64,
                                                    -1.776
                                                ],
                                                [
                                                    61.08,
                                                    -1.376
                                                ],
                                                [
                                                    63.576,
                                                    -0.56
                                                ],
                                                [
                                                    64.888,
                                                    0.592
                                                ],
                                                [
                                                    65.272,
                                                    2.128
                                                ],
                                                [
                                                    64.728,
                                                    3.968
                                                ],
                                                [
                                                    63.208,
                                                    5.152
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4588,
                                            0.4588,
                                            0.4588
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            103.448,
                                            229.688
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 8",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.672,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    -1.056
                                                ],
                                                [
                                                    0.213,
                                                    -0.373
                                                ],
                                                [
                                                    0.395,
                                                    -0.213
                                                ],
                                                [
                                                    0.544,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.555,
                                                    -0.523
                                                ],
                                                [
                                                    0,
                                                    -0.832
                                                ],
                                                [
                                                    0.672,
                                                    -0.523
                                                ],
                                                [
                                                    1.237,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.344,
                                                    0
                                                ],
                                                [
                                                    0.672,
                                                    0.491
                                                ],
                                                [
                                                    0,
                                                    0.491
                                                ],
                                                [
                                                    -0.213,
                                                    0.373
                                                ],
                                                [
                                                    -0.395,
                                                    0.203
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.971,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    0.512
                                                ],
                                                [
                                                    0,
                                                    1.035
                                                ],
                                                [
                                                    -0.672,
                                                    0.523
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -163.887,
                                                    4.48
                                                ],
                                                [
                                                    -163.887,
                                                    -6.88
                                                ],
                                                [
                                                    -159.983,
                                                    -6.88
                                                ],
                                                [
                                                    -156.959,
                                                    -6.144
                                                ],
                                                [
                                                    -155.951,
                                                    -3.824
                                                ],
                                                [
                                                    -156.271,
                                                    -2.528
                                                ],
                                                [
                                                    -157.183,
                                                    -1.648
                                                ],
                                                [
                                                    -158.591,
                                                    -1.344
                                                ],
                                                [
                                                    -158.607,
                                                    -1.44
                                                ],
                                                [
                                                    -156.319,
                                                    -0.656
                                                ],
                                                [
                                                    -155.471,
                                                    1.36
                                                ],
                                                [
                                                    -156.479,
                                                    3.696
                                                ],
                                                [
                                                    -159.343,
                                                    4.48
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.32
                                                ],
                                                [
                                                    0,
                                                    0.597
                                                ],
                                                [
                                                    0.427,
                                                    0.331
                                                ],
                                                [
                                                    0.779,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.779,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.597
                                                ],
                                                [
                                                    -0.416,
                                                    -0.341
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -162.511,
                                                    3.136
                                                ],
                                                [
                                                    -159.343,
                                                    3.136
                                                ],
                                                [
                                                    -157.551,
                                                    2.656
                                                ],
                                                [
                                                    -156.911,
                                                    1.28
                                                ],
                                                [
                                                    -157.551,
                                                    -0.112
                                                ],
                                                [
                                                    -159.343,
                                                    -0.624
                                                ],
                                                [
                                                    -162.511,
                                                    -0.624
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.448,
                                                    0.309
                                                ],
                                                [
                                                    0,
                                                    0.565
                                                ],
                                                [
                                                    0.437,
                                                    0.288
                                                ],
                                                [
                                                    0.864,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.832,
                                                    0
                                                ],
                                                [
                                                    0.448,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.597
                                                ],
                                                [
                                                    -0.427,
                                                    -0.299
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -162.511,
                                                    -1.968
                                                ],
                                                [
                                                    -159.983,
                                                    -1.968
                                                ],
                                                [
                                                    -158.063,
                                                    -2.432
                                                ],
                                                [
                                                    -157.391,
                                                    -3.76
                                                ],
                                                [
                                                    -158.047,
                                                    -5.088
                                                ],
                                                [
                                                    -159.983,
                                                    -5.536
                                                ],
                                                [
                                                    -162.511,
                                                    -5.536
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.309,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.086,
                                                    -0.096
                                                ],
                                                [
                                                    -0.171,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.491,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    -0.256
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.171
                                                ],
                                                [
                                                    0.096,
                                                    0.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -151.696,
                                                    4.48
                                                ],
                                                [
                                                    -152.896,
                                                    4.096
                                                ],
                                                [
                                                    -153.36,
                                                    2.88
                                                ],
                                                [
                                                    -153.36,
                                                    -6.88
                                                ],
                                                [
                                                    -152.016,
                                                    -6.88
                                                ],
                                                [
                                                    -152.016,
                                                    2.768
                                                ],
                                                [
                                                    -151.888,
                                                    3.168
                                                ],
                                                [
                                                    -151.488,
                                                    3.296
                                                ],
                                                [
                                                    -150.752,
                                                    3.296
                                                ],
                                                [
                                                    -150.752,
                                                    4.48
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.778,
                                                    0
                                                ],
                                                [
                                                    0.586,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.32,
                                                    0.661
                                                ],
                                                [
                                                    -0.587,
                                                    0.363
                                                ],
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.363
                                                ],
                                                [
                                                    -0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.907
                                                ],
                                                [
                                                    0.32,
                                                    -0.672
                                                ],
                                                [
                                                    0.586,
                                                    -0.363
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.587,
                                                    -0.363
                                                ],
                                                [
                                                    -0.32,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.907
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.586,
                                                    -0.363
                                                ],
                                                [
                                                    0.778,
                                                    0
                                                ],
                                                [
                                                    0.586,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.32,
                                                    0.661
                                                ],
                                                [
                                                    -0.576,
                                                    0.363
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -145.876,
                                                    4.672
                                                ],
                                                [
                                                    -147.924,
                                                    4.128
                                                ],
                                                [
                                                    -149.284,
                                                    2.592
                                                ],
                                                [
                                                    -149.764,
                                                    0.24
                                                ],
                                                [
                                                    -149.284,
                                                    -2.112
                                                ],
                                                [
                                                    -147.924,
                                                    -3.648
                                                ],
                                                [
                                                    -145.876,
                                                    -4.192
                                                ],
                                                [
                                                    -143.844,
                                                    -3.648
                                                ],
                                                [
                                                    -142.484,
                                                    -2.112
                                                ],
                                                [
                                                    -142.004,
                                                    0.24
                                                ],
                                                [
                                                    -142.484,
                                                    2.592
                                                ],
                                                [
                                                    -143.844,
                                                    4.128
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0.981
                                                ],
                                                [
                                                    0.437,
                                                    0.555
                                                ],
                                                [
                                                    0.778,
                                                    0
                                                ],
                                                [
                                                    0.437,
                                                    -0.565
                                                ],
                                                [
                                                    0,
                                                    -0.981
                                                ],
                                                [
                                                    -0.438,
                                                    -0.565
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.778,
                                                    0
                                                ],
                                                [
                                                    0.437,
                                                    -0.565
                                                ],
                                                [
                                                    0,
                                                    -0.981
                                                ],
                                                [
                                                    -0.427,
                                                    -0.565
                                                ],
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.438,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0.981
                                                ],
                                                [
                                                    0.437,
                                                    0.555
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -145.876,
                                                    3.392
                                                ],
                                                [
                                                    -144.068,
                                                    2.56
                                                ],
                                                [
                                                    -143.412,
                                                    0.24
                                                ],
                                                [
                                                    -144.068,
                                                    -2.064
                                                ],
                                                [
                                                    -145.876,
                                                    -2.912
                                                ],
                                                [
                                                    -147.7,
                                                    -2.064
                                                ],
                                                [
                                                    -148.356,
                                                    0.24
                                                ],
                                                [
                                                    -147.7,
                                                    2.56
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.651,
                                                    0
                                                ],
                                                [
                                                    0.587,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.32,
                                                    0.661
                                                ],
                                                [
                                                    -0.576,
                                                    0.363
                                                ],
                                                [
                                                    -0.789,
                                                    0
                                                ],
                                                [
                                                    -0.501,
                                                    -0.235
                                                ],
                                                [
                                                    -0.32,
                                                    -0.437
                                                ],
                                                [
                                                    -0.096,
                                                    -0.629
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.395,
                                                    0.299
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0.438,
                                                    -0.565
                                                ],
                                                [
                                                    0,
                                                    -0.981
                                                ],
                                                [
                                                    -0.437,
                                                    -0.565
                                                ],
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.394,
                                                    0.32
                                                ],
                                                [
                                                    -0.096,
                                                    0.64
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.469
                                                ],
                                                [
                                                    0.512,
                                                    -0.256
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.789,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.363
                                                ],
                                                [
                                                    -0.32,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.587,
                                                    -0.373
                                                ],
                                                [
                                                    0.651,
                                                    0
                                                ],
                                                [
                                                    0.512,
                                                    0.224
                                                ],
                                                [
                                                    0.32,
                                                    0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.096,
                                                    -0.565
                                                ],
                                                [
                                                    -0.394,
                                                    -0.309
                                                ],
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.437,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0.981
                                                ],
                                                [
                                                    0.438,
                                                    0.555
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0.395,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.096,
                                                    0.629
                                                ],
                                                [
                                                    -0.32,
                                                    0.459
                                                ],
                                                [
                                                    -0.501,
                                                    0.256
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -136.861,
                                                    4.672
                                                ],
                                                [
                                                    -138.925,
                                                    4.128
                                                ],
                                                [
                                                    -140.269,
                                                    2.592
                                                ],
                                                [
                                                    -140.749,
                                                    0.24
                                                ],
                                                [
                                                    -140.269,
                                                    -2.096
                                                ],
                                                [
                                                    -138.925,
                                                    -3.632
                                                ],
                                                [
                                                    -136.861,
                                                    -4.192
                                                ],
                                                [
                                                    -135.133,
                                                    -3.84
                                                ],
                                                [
                                                    -133.885,
                                                    -2.848
                                                ],
                                                [
                                                    -133.261,
                                                    -1.248
                                                ],
                                                [
                                                    -134.669,
                                                    -1.152
                                                ],
                                                [
                                                    -135.405,
                                                    -2.448
                                                ],
                                                [
                                                    -136.861,
                                                    -2.912
                                                ],
                                                [
                                                    -138.685,
                                                    -2.064
                                                ],
                                                [
                                                    -139.341,
                                                    0.24
                                                ],
                                                [
                                                    -138.685,
                                                    2.56
                                                ],
                                                [
                                                    -136.861,
                                                    3.392
                                                ],
                                                [
                                                    -135.405,
                                                    2.912
                                                ],
                                                [
                                                    -134.669,
                                                    1.472
                                                ],
                                                [
                                                    -133.261,
                                                    1.568
                                                ],
                                                [
                                                    -133.885,
                                                    3.216
                                                ],
                                                [
                                                    -135.133,
                                                    4.288
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -131.595,
                                                    4.48
                                                ],
                                                [
                                                    -131.595,
                                                    -6.88
                                                ],
                                                [
                                                    -130.251,
                                                    -6.88
                                                ],
                                                [
                                                    -130.251,
                                                    0.56
                                                ],
                                                [
                                                    -126.123,
                                                    -4
                                                ],
                                                [
                                                    -124.331,
                                                    -4
                                                ],
                                                [
                                                    -127.675,
                                                    -0.4
                                                ],
                                                [
                                                    -124.187,
                                                    4.48
                                                ],
                                                [
                                                    -125.819,
                                                    4.48
                                                ],
                                                [
                                                    -128.587,
                                                    0.512
                                                ],
                                                [
                                                    -130.251,
                                                    2.272
                                                ],
                                                [
                                                    -130.251,
                                                    4.48
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.896,
                                                    0
                                                ],
                                                [
                                                    0.587,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.309,
                                                    0.661
                                                ],
                                                [
                                                    -0.565,
                                                    0.363
                                                ],
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    -0.352
                                                ],
                                                [
                                                    -0.309,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.949
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    -0.459
                                                ],
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.256
                                                ],
                                                [
                                                    -0.139,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.629,
                                                    -0.491
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.8,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.363
                                                ],
                                                [
                                                    -0.309,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.576,
                                                    -0.373
                                                ],
                                                [
                                                    0.736,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    0.341
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.053,
                                                    0.907
                                                ],
                                                [
                                                    0.437,
                                                    0.459
                                                ],
                                                [
                                                    0.555,
                                                    0
                                                ],
                                                [
                                                    0.363,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    0.757
                                                ],
                                                [
                                                    -0.619,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -119.642,
                                                    4.672
                                                ],
                                                [
                                                    -121.722,
                                                    4.128
                                                ],
                                                [
                                                    -123.066,
                                                    2.592
                                                ],
                                                [
                                                    -123.53,
                                                    0.24
                                                ],
                                                [
                                                    -123.066,
                                                    -2.096
                                                ],
                                                [
                                                    -121.738,
                                                    -3.632
                                                ],
                                                [
                                                    -119.706,
                                                    -4.192
                                                ],
                                                [
                                                    -117.754,
                                                    -3.664
                                                ],
                                                [
                                                    -116.442,
                                                    -2.16
                                                ],
                                                [
                                                    -115.962,
                                                    0.256
                                                ],
                                                [
                                                    -115.962,
                                                    0.656
                                                ],
                                                [
                                                    -122.122,
                                                    0.656
                                                ],
                                                [
                                                    -121.402,
                                                    2.704
                                                ],
                                                [
                                                    -119.642,
                                                    3.392
                                                ],
                                                [
                                                    -118.282,
                                                    3.008
                                                ],
                                                [
                                                    -117.53,
                                                    1.968
                                                ],
                                                [
                                                    -116.09,
                                                    2.08
                                                ],
                                                [
                                                    -117.37,
                                                    3.952
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.117,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    0.384
                                                ],
                                                [
                                                    0.629,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    -0.405
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.821
                                                ],
                                                [
                                                    -0.405,
                                                    -0.384
                                                ],
                                                [
                                                    -0.651,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.395
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -122.122,
                                                    -0.528
                                                ],
                                                [
                                                    -117.434,
                                                    -0.528
                                                ],
                                                [
                                                    -118.154,
                                                    -2.336
                                                ],
                                                [
                                                    -119.706,
                                                    -2.912
                                                ],
                                                [
                                                    -121.322,
                                                    -2.304
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.598,
                                                    0
                                                ],
                                                [
                                                    0.544,
                                                    0.363
                                                ],
                                                [
                                                    0.288,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.907
                                                ],
                                                [
                                                    -0.288,
                                                    0.661
                                                ],
                                                [
                                                    -0.533,
                                                    0.363
                                                ],
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.469,
                                                    -0.245
                                                ],
                                                [
                                                    -0.234,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    -0.267
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.533,
                                                    -0.363
                                                ],
                                                [
                                                    -0.288,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.907
                                                ],
                                                [
                                                    0.288,
                                                    -0.661
                                                ],
                                                [
                                                    0.544,
                                                    -0.363
                                                ],
                                                [
                                                    0.566,
                                                    0
                                                ],
                                                [
                                                    0.47,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.234,
                                                    0.459
                                                ],
                                                [
                                                    -0.48,
                                                    0.256
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -111.134,
                                                    4.672
                                                ],
                                                [
                                                    -113.054,
                                                    4.128
                                                ],
                                                [
                                                    -114.286,
                                                    2.592
                                                ],
                                                [
                                                    -114.718,
                                                    0.24
                                                ],
                                                [
                                                    -114.286,
                                                    -2.112
                                                ],
                                                [
                                                    -113.054,
                                                    -3.648
                                                ],
                                                [
                                                    -111.134,
                                                    -4.192
                                                ],
                                                [
                                                    -109.582,
                                                    -3.824
                                                ],
                                                [
                                                    -108.526,
                                                    -2.816
                                                ],
                                                [
                                                    -108.526,
                                                    -6.88
                                                ],
                                                [
                                                    -107.182,
                                                    -6.88
                                                ],
                                                [
                                                    -107.182,
                                                    4.48
                                                ],
                                                [
                                                    -108.398,
                                                    4.48
                                                ],
                                                [
                                                    -108.446,
                                                    3.2
                                                ],
                                                [
                                                    -109.518,
                                                    4.288
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.746,
                                                    0
                                                ],
                                                [
                                                    -0.341,
                                                    0.256
                                                ],
                                                [
                                                    -0.181,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0.64
                                                ],
                                                [
                                                    0.182,
                                                    0.469
                                                ],
                                                [
                                                    0.352,
                                                    0.245
                                                ],
                                                [
                                                    0.502,
                                                    0
                                                ],
                                                [
                                                    0.448,
                                                    -0.565
                                                ],
                                                [
                                                    0,
                                                    -0.981
                                                ],
                                                [
                                                    -0.437,
                                                    -0.565
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.502,
                                                    0
                                                ],
                                                [
                                                    0.352,
                                                    -0.256
                                                ],
                                                [
                                                    0.182,
                                                    -0.48
                                                ],
                                                [
                                                    0,
                                                    -0.661
                                                ],
                                                [
                                                    -0.181,
                                                    -0.469
                                                ],
                                                [
                                                    -0.341,
                                                    -0.256
                                                ],
                                                [
                                                    -0.746,
                                                    0
                                                ],
                                                [
                                                    -0.437,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0.971
                                                ],
                                                [
                                                    0.448,
                                                    0.565
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -110.862,
                                                    3.392
                                                ],
                                                [
                                                    -109.598,
                                                    3.008
                                                ],
                                                [
                                                    -108.798,
                                                    1.92
                                                ],
                                                [
                                                    -108.526,
                                                    0.24
                                                ],
                                                [
                                                    -108.798,
                                                    -1.456
                                                ],
                                                [
                                                    -109.598,
                                                    -2.528
                                                ],
                                                [
                                                    -110.862,
                                                    -2.912
                                                ],
                                                [
                                                    -112.654,
                                                    -2.064
                                                ],
                                                [
                                                    -113.31,
                                                    0.24
                                                ],
                                                [
                                                    -112.654,
                                                    2.544
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.331
                                                ],
                                                [
                                                    -0.597,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.16
                                                ],
                                                [
                                                    0.149,
                                                    -0.309
                                                ],
                                                [
                                                    0,
                                                    -0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.107,
                                                    -0.725
                                                ],
                                                [
                                                    0.363,
                                                    -0.341
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    0
                                                ],
                                                [
                                                    -0.277,
                                                    0.149
                                                ],
                                                [
                                                    -0.139,
                                                    0.299
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -100.626,
                                                    4.48
                                                ],
                                                [
                                                    -100.626,
                                                    -4
                                                ],
                                                [
                                                    -99.442,
                                                    -4
                                                ],
                                                [
                                                    -99.378,
                                                    -1.856
                                                ],
                                                [
                                                    -99.506,
                                                    -1.904
                                                ],
                                                [
                                                    -98.818,
                                                    -3.488
                                                ],
                                                [
                                                    -97.378,
                                                    -4
                                                ],
                                                [
                                                    -96.546,
                                                    -4
                                                ],
                                                [
                                                    -96.546,
                                                    -2.72
                                                ],
                                                [
                                                    -97.362,
                                                    -2.72
                                                ],
                                                [
                                                    -98.434,
                                                    -2.48
                                                ],
                                                [
                                                    -99.074,
                                                    -1.792
                                                ],
                                                [
                                                    -99.282,
                                                    -0.64
                                                ],
                                                [
                                                    -99.282,
                                                    4.48
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 14",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.896,
                                                    0
                                                ],
                                                [
                                                    0.587,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.309,
                                                    0.661
                                                ],
                                                [
                                                    -0.565,
                                                    0.363
                                                ],
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    -0.352
                                                ],
                                                [
                                                    -0.309,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.949
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    -0.459
                                                ],
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.256
                                                ],
                                                [
                                                    -0.139,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.629,
                                                    -0.491
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.8,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.363
                                                ],
                                                [
                                                    -0.309,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.576,
                                                    -0.373
                                                ],
                                                [
                                                    0.736,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    0.341
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.053,
                                                    0.907
                                                ],
                                                [
                                                    0.437,
                                                    0.459
                                                ],
                                                [
                                                    0.555,
                                                    0
                                                ],
                                                [
                                                    0.363,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    0.757
                                                ],
                                                [
                                                    -0.619,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -91.892,
                                                    4.672
                                                ],
                                                [
                                                    -93.972,
                                                    4.128
                                                ],
                                                [
                                                    -95.316,
                                                    2.592
                                                ],
                                                [
                                                    -95.78,
                                                    0.24
                                                ],
                                                [
                                                    -95.316,
                                                    -2.096
                                                ],
                                                [
                                                    -93.988,
                                                    -3.632
                                                ],
                                                [
                                                    -91.956,
                                                    -4.192
                                                ],
                                                [
                                                    -90.004,
                                                    -3.664
                                                ],
                                                [
                                                    -88.692,
                                                    -2.16
                                                ],
                                                [
                                                    -88.212,
                                                    0.256
                                                ],
                                                [
                                                    -88.212,
                                                    0.656
                                                ],
                                                [
                                                    -94.372,
                                                    0.656
                                                ],
                                                [
                                                    -93.652,
                                                    2.704
                                                ],
                                                [
                                                    -91.892,
                                                    3.392
                                                ],
                                                [
                                                    -90.532,
                                                    3.008
                                                ],
                                                [
                                                    -89.78,
                                                    1.968
                                                ],
                                                [
                                                    -88.34,
                                                    2.08
                                                ],
                                                [
                                                    -89.62,
                                                    3.952
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 15",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.117,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    0.384
                                                ],
                                                [
                                                    0.629,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    -0.405
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.821
                                                ],
                                                [
                                                    -0.405,
                                                    -0.384
                                                ],
                                                [
                                                    -0.651,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.395
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -94.372,
                                                    -0.528
                                                ],
                                                [
                                                    -89.684,
                                                    -0.528
                                                ],
                                                [
                                                    -90.404,
                                                    -2.336
                                                ],
                                                [
                                                    -91.956,
                                                    -2.912
                                                ],
                                                [
                                                    -93.572,
                                                    -2.304
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 16",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.266,
                                                    -0.267
                                                ],
                                                [
                                                    0.384,
                                                    -0.149
                                                ],
                                                [
                                                    0.437,
                                                    0
                                                ],
                                                [
                                                    0.544,
                                                    0.416
                                                ],
                                                [
                                                    0.266,
                                                    0.672
                                                ],
                                                [
                                                    0,
                                                    0.779
                                                ],
                                                [
                                                    -0.256,
                                                    0.672
                                                ],
                                                [
                                                    -0.534,
                                                    0.416
                                                ],
                                                [
                                                    -0.843,
                                                    0
                                                ],
                                                [
                                                    -0.491,
                                                    -0.331
                                                ],
                                                [
                                                    -0.203,
                                                    -0.629
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.096,
                                                    0.363
                                                ],
                                                [
                                                    -0.256,
                                                    0.267
                                                ],
                                                [
                                                    -0.374,
                                                    0.149
                                                ],
                                                [
                                                    -0.843,
                                                    0
                                                ],
                                                [
                                                    -0.534,
                                                    -0.416
                                                ],
                                                [
                                                    -0.256,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.779
                                                ],
                                                [
                                                    0.266,
                                                    -0.672
                                                ],
                                                [
                                                    0.544,
                                                    -0.416
                                                ],
                                                [
                                                    0.661,
                                                    0
                                                ],
                                                [
                                                    0.501,
                                                    0.32
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -79.431,
                                                    6.88
                                                ],
                                                [
                                                    -80.775,
                                                    6.88
                                                ],
                                                [
                                                    -80.775,
                                                    2.656
                                                ],
                                                [
                                                    -80.583,
                                                    2.88
                                                ],
                                                [
                                                    -81.127,
                                                    3.824
                                                ],
                                                [
                                                    -82.087,
                                                    4.448
                                                ],
                                                [
                                                    -83.303,
                                                    4.672
                                                ],
                                                [
                                                    -85.383,
                                                    4.048
                                                ],
                                                [
                                                    -86.583,
                                                    2.416
                                                ],
                                                [
                                                    -86.967,
                                                    0.24
                                                ],
                                                [
                                                    -86.583,
                                                    -1.936
                                                ],
                                                [
                                                    -85.383,
                                                    -3.568
                                                ],
                                                [
                                                    -83.303,
                                                    -4.192
                                                ],
                                                [
                                                    -81.575,
                                                    -3.696
                                                ],
                                                [
                                                    -80.519,
                                                    -2.272
                                                ],
                                                [
                                                    -80.711,
                                                    -2.176
                                                ],
                                                [
                                                    -80.679,
                                                    -4
                                                ],
                                                [
                                                    -79.431,
                                                    -4
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 17",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.235
                                                ],
                                                [
                                                    -0.192,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0.693
                                                ],
                                                [
                                                    0.202,
                                                    0.469
                                                ],
                                                [
                                                    0.362,
                                                    0.235
                                                ],
                                                [
                                                    0.49,
                                                    0
                                                ],
                                                [
                                                    0.426,
                                                    -0.555
                                                ],
                                                [
                                                    0,
                                                    -0.992
                                                ],
                                                [
                                                    -0.427,
                                                    -0.555
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.501,
                                                    0
                                                ],
                                                [
                                                    0.362,
                                                    -0.235
                                                ],
                                                [
                                                    0.192,
                                                    -0.469
                                                ],
                                                [
                                                    0,
                                                    -0.693
                                                ],
                                                [
                                                    -0.192,
                                                    -0.469
                                                ],
                                                [
                                                    -0.352,
                                                    -0.235
                                                ],
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0.992
                                                ],
                                                [
                                                    0.426,
                                                    0.555
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -83.175,
                                                    3.392
                                                ],
                                                [
                                                    -81.895,
                                                    3.04
                                                ],
                                                [
                                                    -81.063,
                                                    1.984
                                                ],
                                                [
                                                    -80.775,
                                                    0.24
                                                ],
                                                [
                                                    -81.079,
                                                    -1.504
                                                ],
                                                [
                                                    -81.911,
                                                    -2.56
                                                ],
                                                [
                                                    -83.175,
                                                    -2.912
                                                ],
                                                [
                                                    -84.919,
                                                    -2.08
                                                ],
                                                [
                                                    -85.56,
                                                    0.24
                                                ],
                                                [
                                                    -84.919,
                                                    2.56
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 18",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.725,
                                                    0
                                                ],
                                                [
                                                    0.512,
                                                    0.565
                                                ],
                                                [
                                                    0,
                                                    1.003
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    -0.395
                                                ],
                                                [
                                                    -0.608,
                                                    0
                                                ],
                                                [
                                                    -0.384,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0.757
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    -0.384
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.843,
                                                    0
                                                ],
                                                [
                                                    -0.501,
                                                    -0.576
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ],
                                                [
                                                    0.299,
                                                    0.384
                                                ],
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.384,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.171,
                                                    0.693
                                                ],
                                                [
                                                    -0.48,
                                                    0.373
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -74.092,
                                                    4.672
                                                ],
                                                [
                                                    -76.124,
                                                    3.824
                                                ],
                                                [
                                                    -76.876,
                                                    1.456
                                                ],
                                                [
                                                    -76.876,
                                                    -4
                                                ],
                                                [
                                                    -75.532,
                                                    -4
                                                ],
                                                [
                                                    -75.532,
                                                    1.088
                                                ],
                                                [
                                                    -75.1,
                                                    2.912
                                                ],
                                                [
                                                    -73.74,
                                                    3.488
                                                ],
                                                [
                                                    -72.156,
                                                    2.848
                                                ],
                                                [
                                                    -71.58,
                                                    1.056
                                                ],
                                                [
                                                    -71.58,
                                                    -4
                                                ],
                                                [
                                                    -70.236,
                                                    -4
                                                ],
                                                [
                                                    -70.236,
                                                    4.48
                                                ],
                                                [
                                                    -71.516,
                                                    4.48
                                                ],
                                                [
                                                    -71.516,
                                                    2.384
                                                ],
                                                [
                                                    -71.308,
                                                    2.496
                                                ],
                                                [
                                                    -72.284,
                                                    4.112
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 19",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.896,
                                                    0
                                                ],
                                                [
                                                    0.587,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.309,
                                                    0.661
                                                ],
                                                [
                                                    -0.565,
                                                    0.363
                                                ],
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    -0.352
                                                ],
                                                [
                                                    -0.309,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.949
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    -0.459
                                                ],
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.256
                                                ],
                                                [
                                                    -0.139,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.629,
                                                    -0.491
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.8,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.363
                                                ],
                                                [
                                                    -0.309,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.576,
                                                    -0.373
                                                ],
                                                [
                                                    0.736,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    0.341
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.053,
                                                    0.907
                                                ],
                                                [
                                                    0.437,
                                                    0.459
                                                ],
                                                [
                                                    0.555,
                                                    0
                                                ],
                                                [
                                                    0.363,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    0.757
                                                ],
                                                [
                                                    -0.619,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -64.517,
                                                    4.672
                                                ],
                                                [
                                                    -66.597,
                                                    4.128
                                                ],
                                                [
                                                    -67.941,
                                                    2.592
                                                ],
                                                [
                                                    -68.405,
                                                    0.24
                                                ],
                                                [
                                                    -67.941,
                                                    -2.096
                                                ],
                                                [
                                                    -66.613,
                                                    -3.632
                                                ],
                                                [
                                                    -64.581,
                                                    -4.192
                                                ],
                                                [
                                                    -62.629,
                                                    -3.664
                                                ],
                                                [
                                                    -61.317,
                                                    -2.16
                                                ],
                                                [
                                                    -60.837,
                                                    0.256
                                                ],
                                                [
                                                    -60.837,
                                                    0.656
                                                ],
                                                [
                                                    -66.997,
                                                    0.656
                                                ],
                                                [
                                                    -66.277,
                                                    2.704
                                                ],
                                                [
                                                    -64.517,
                                                    3.392
                                                ],
                                                [
                                                    -63.157,
                                                    3.008
                                                ],
                                                [
                                                    -62.405,
                                                    1.968
                                                ],
                                                [
                                                    -60.965,
                                                    2.08
                                                ],
                                                [
                                                    -62.245,
                                                    3.952
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 20",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.117,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    0.384
                                                ],
                                                [
                                                    0.629,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    -0.405
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.821
                                                ],
                                                [
                                                    -0.405,
                                                    -0.384
                                                ],
                                                [
                                                    -0.651,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.395
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -66.997,
                                                    -0.528
                                                ],
                                                [
                                                    -62.309,
                                                    -0.528
                                                ],
                                                [
                                                    -63.029,
                                                    -2.336
                                                ],
                                                [
                                                    -64.581,
                                                    -2.912
                                                ],
                                                [
                                                    -66.197,
                                                    -2.304
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 21",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.938,
                                                    0
                                                ],
                                                [
                                                    0.533,
                                                    0.245
                                                ],
                                                [
                                                    0.288,
                                                    0.427
                                                ],
                                                [
                                                    0.042,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.331,
                                                    -0.309
                                                ],
                                                [
                                                    -0.747,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    0.181
                                                ],
                                                [
                                                    0,
                                                    0.416
                                                ],
                                                [
                                                    0.106,
                                                    0.149
                                                ],
                                                [
                                                    0.298,
                                                    0.107
                                                ],
                                                [
                                                    0.577,
                                                    0.107
                                                ],
                                                [
                                                    0.448,
                                                    0.224
                                                ],
                                                [
                                                    0.181,
                                                    0.32
                                                ],
                                                [
                                                    0,
                                                    0.448
                                                ],
                                                [
                                                    -0.555,
                                                    0.48
                                                ],
                                                [
                                                    -1.024,
                                                    0
                                                ],
                                                [
                                                    -0.47,
                                                    -0.267
                                                ],
                                                [
                                                    -0.246,
                                                    -0.416
                                                ],
                                                [
                                                    -0.054,
                                                    -0.459
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.138,
                                                    0.235
                                                ],
                                                [
                                                    0.277,
                                                    0.139
                                                ],
                                                [
                                                    0.47,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    -0.363
                                                ],
                                                [
                                                    -0.107,
                                                    -0.181
                                                ],
                                                [
                                                    -0.278,
                                                    -0.117
                                                ],
                                                [
                                                    -0.491,
                                                    -0.085
                                                ],
                                                [
                                                    -0.47,
                                                    -0.213
                                                ],
                                                [
                                                    -0.182,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.448
                                                ],
                                                [
                                                    0.608,
                                                    -0.437
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.523,
                                                    -0.245
                                                ],
                                                [
                                                    -0.278,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.086,
                                                    0.512
                                                ],
                                                [
                                                    0.341,
                                                    0.299
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    -0.224
                                                ],
                                                [
                                                    -0.096,
                                                    -0.149
                                                ],
                                                [
                                                    -0.299,
                                                    -0.117
                                                ],
                                                [
                                                    -0.789,
                                                    -0.149
                                                ],
                                                [
                                                    -0.448,
                                                    -0.224
                                                ],
                                                [
                                                    -0.182,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.757
                                                ],
                                                [
                                                    0.565,
                                                    -0.491
                                                ],
                                                [
                                                    0.746,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    0.256
                                                ],
                                                [
                                                    0.245,
                                                    0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.022,
                                                    -0.267
                                                ],
                                                [
                                                    -0.139,
                                                    -0.235
                                                ],
                                                [
                                                    -0.278,
                                                    -0.149
                                                ],
                                                [
                                                    -0.607,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0.277
                                                ],
                                                [
                                                    0.117,
                                                    0.171
                                                ],
                                                [
                                                    0.288,
                                                    0.107
                                                ],
                                                [
                                                    0.832,
                                                    0.139
                                                ],
                                                [
                                                    0.469,
                                                    0.213
                                                ],
                                                [
                                                    0.192,
                                                    0.309
                                                ],
                                                [
                                                    0,
                                                    0.779
                                                ],
                                                [
                                                    -0.598,
                                                    0.427
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -55.928,
                                                    4.672
                                                ],
                                                [
                                                    -57.896,
                                                    4.304
                                                ],
                                                [
                                                    -59.112,
                                                    3.296
                                                ],
                                                [
                                                    -59.592,
                                                    1.808
                                                ],
                                                [
                                                    -58.185,
                                                    1.712
                                                ],
                                                [
                                                    -57.56,
                                                    2.944
                                                ],
                                                [
                                                    -55.928,
                                                    3.392
                                                ],
                                                [
                                                    -54.6,
                                                    3.12
                                                ],
                                                [
                                                    -54.12,
                                                    2.208
                                                ],
                                                [
                                                    -54.28,
                                                    1.648
                                                ],
                                                [
                                                    -54.872,
                                                    1.264
                                                ],
                                                [
                                                    -56.185,
                                                    0.928
                                                ],
                                                [
                                                    -58.04,
                                                    0.368
                                                ],
                                                [
                                                    -58.984,
                                                    -0.448
                                                ],
                                                [
                                                    -59.256,
                                                    -1.6
                                                ],
                                                [
                                                    -58.424,
                                                    -3.456
                                                ],
                                                [
                                                    -56.04,
                                                    -4.192
                                                ],
                                                [
                                                    -54.216,
                                                    -3.792
                                                ],
                                                [
                                                    -53.128,
                                                    -2.784
                                                ],
                                                [
                                                    -52.68,
                                                    -1.472
                                                ],
                                                [
                                                    -54.088,
                                                    -1.376
                                                ],
                                                [
                                                    -54.328,
                                                    -2.128
                                                ],
                                                [
                                                    -54.952,
                                                    -2.688
                                                ],
                                                [
                                                    -56.073,
                                                    -2.912
                                                ],
                                                [
                                                    -57.416,
                                                    -2.56
                                                ],
                                                [
                                                    -57.848,
                                                    -1.664
                                                ],
                                                [
                                                    -57.688,
                                                    -0.976
                                                ],
                                                [
                                                    -57.096,
                                                    -0.544
                                                ],
                                                [
                                                    -55.928,
                                                    -0.256
                                                ],
                                                [
                                                    -53.976,
                                                    0.272
                                                ],
                                                [
                                                    -53,
                                                    1.072
                                                ],
                                                [
                                                    -52.712,
                                                    2.208
                                                ],
                                                [
                                                    -53.624,
                                                    4.032
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 22",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.373,
                                                    0.352
                                                ],
                                                [
                                                    0,
                                                    0.747
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.171,
                                                    -0.149
                                                ],
                                                [
                                                    -0.352,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.768,
                                                    0
                                                ],
                                                [
                                                    -0.363,
                                                    -0.352
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.384
                                                ],
                                                [
                                                    0.17,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -48.084,
                                                    4.48
                                                ],
                                                [
                                                    -49.796,
                                                    3.952
                                                ],
                                                [
                                                    -50.34,
                                                    2.304
                                                ],
                                                [
                                                    -50.34,
                                                    -5.984
                                                ],
                                                [
                                                    -48.996,
                                                    -5.984
                                                ],
                                                [
                                                    -48.996,
                                                    2.272
                                                ],
                                                [
                                                    -48.74,
                                                    3.072
                                                ],
                                                [
                                                    -47.956,
                                                    3.296
                                                ],
                                                [
                                                    -46.74,
                                                    3.296
                                                ],
                                                [
                                                    -46.74,
                                                    4.48
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 23",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -51.588,
                                                    -2.816
                                                ],
                                                [
                                                    -51.588,
                                                    -4
                                                ],
                                                [
                                                    -46.74,
                                                    -4
                                                ],
                                                [
                                                    -46.74,
                                                    -2.816
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 24",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.266,
                                                    0.32
                                                ],
                                                [
                                                    -0.373,
                                                    0.16
                                                ],
                                                [
                                                    -0.437,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    -0.288
                                                ],
                                                [
                                                    -0.202,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    -0.597
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.128,
                                                    0.352
                                                ],
                                                [
                                                    0.267,
                                                    0.181
                                                ],
                                                [
                                                    0.427,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.107,
                                                    -0.501
                                                ],
                                                [
                                                    0.267,
                                                    -0.331
                                                ],
                                                [
                                                    0.384,
                                                    -0.16
                                                ],
                                                [
                                                    0.651,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    0.288
                                                ],
                                                [
                                                    0.214,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    -0.117,
                                                    -0.363
                                                ],
                                                [
                                                    -0.266,
                                                    -0.192
                                                ],
                                                [
                                                    -0.65,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -40.923,
                                                    4.48
                                                ],
                                                [
                                                    -40.923,
                                                    -4
                                                ],
                                                [
                                                    -39.691,
                                                    -4
                                                ],
                                                [
                                                    -39.643,
                                                    -1.84
                                                ],
                                                [
                                                    -39.803,
                                                    -1.984
                                                ],
                                                [
                                                    -39.243,
                                                    -3.216
                                                ],
                                                [
                                                    -38.283,
                                                    -3.952
                                                ],
                                                [
                                                    -37.051,
                                                    -4.192
                                                ],
                                                [
                                                    -35.451,
                                                    -3.76
                                                ],
                                                [
                                                    -34.507,
                                                    -2.592
                                                ],
                                                [
                                                    -34.187,
                                                    -0.976
                                                ],
                                                [
                                                    -34.187,
                                                    4.48
                                                ],
                                                [
                                                    -35.531,
                                                    4.48
                                                ],
                                                [
                                                    -35.531,
                                                    -0.592
                                                ],
                                                [
                                                    -35.723,
                                                    -1.904
                                                ],
                                                [
                                                    -36.299,
                                                    -2.72
                                                ],
                                                [
                                                    -37.339,
                                                    -3.008
                                                ],
                                                [
                                                    -38.955,
                                                    -2.384
                                                ],
                                                [
                                                    -39.579,
                                                    -0.592
                                                ],
                                                [
                                                    -39.579,
                                                    4.48
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 25",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.896,
                                                    0
                                                ],
                                                [
                                                    0.586,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.31,
                                                    0.661
                                                ],
                                                [
                                                    -0.566,
                                                    0.363
                                                ],
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.566,
                                                    -0.352
                                                ],
                                                [
                                                    -0.31,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.949
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    -0.459
                                                ],
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.256
                                                ],
                                                [
                                                    -0.139,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.629,
                                                    -0.491
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.8,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.363
                                                ],
                                                [
                                                    -0.31,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.576,
                                                    -0.373
                                                ],
                                                [
                                                    0.736,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    0.341
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.053,
                                                    0.907
                                                ],
                                                [
                                                    0.437,
                                                    0.459
                                                ],
                                                [
                                                    0.554,
                                                    0
                                                ],
                                                [
                                                    0.362,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    0.757
                                                ],
                                                [
                                                    -0.619,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -28.501,
                                                    4.672
                                                ],
                                                [
                                                    -30.581,
                                                    4.128
                                                ],
                                                [
                                                    -31.925,
                                                    2.592
                                                ],
                                                [
                                                    -32.389,
                                                    0.24
                                                ],
                                                [
                                                    -31.925,
                                                    -2.096
                                                ],
                                                [
                                                    -30.597,
                                                    -3.632
                                                ],
                                                [
                                                    -28.565,
                                                    -4.192
                                                ],
                                                [
                                                    -26.613,
                                                    -3.664
                                                ],
                                                [
                                                    -25.301,
                                                    -2.16
                                                ],
                                                [
                                                    -24.821,
                                                    0.256
                                                ],
                                                [
                                                    -24.821,
                                                    0.656
                                                ],
                                                [
                                                    -30.981,
                                                    0.656
                                                ],
                                                [
                                                    -30.261,
                                                    2.704
                                                ],
                                                [
                                                    -28.501,
                                                    3.392
                                                ],
                                                [
                                                    -27.141,
                                                    3.008
                                                ],
                                                [
                                                    -26.389,
                                                    1.968
                                                ],
                                                [
                                                    -24.949,
                                                    2.08
                                                ],
                                                [
                                                    -26.229,
                                                    3.952
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 26",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.117,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    0.384
                                                ],
                                                [
                                                    0.629,
                                                    0
                                                ],
                                                [
                                                    0.426,
                                                    -0.405
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.821
                                                ],
                                                [
                                                    -0.406,
                                                    -0.384
                                                ],
                                                [
                                                    -0.651,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.395
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -30.981,
                                                    -0.528
                                                ],
                                                [
                                                    -26.293,
                                                    -0.528
                                                ],
                                                [
                                                    -27.013,
                                                    -2.336
                                                ],
                                                [
                                                    -28.565,
                                                    -2.912
                                                ],
                                                [
                                                    -30.181,
                                                    -2.304
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 27",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -21.091,
                                                    4.48
                                                ],
                                                [
                                                    -24.179,
                                                    -4
                                                ],
                                                [
                                                    -22.707,
                                                    -4
                                                ],
                                                [
                                                    -20.243,
                                                    3.104
                                                ],
                                                [
                                                    -17.779,
                                                    -4
                                                ],
                                                [
                                                    -16.307,
                                                    -4
                                                ],
                                                [
                                                    -19.395,
                                                    4.48
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 28",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.896,
                                                    0
                                                ],
                                                [
                                                    0.587,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.309,
                                                    0.661
                                                ],
                                                [
                                                    -0.565,
                                                    0.363
                                                ],
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    -0.352
                                                ],
                                                [
                                                    -0.309,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.949
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.426,
                                                    -0.459
                                                ],
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.256
                                                ],
                                                [
                                                    -0.138,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.63,
                                                    -0.491
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.8,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.363
                                                ],
                                                [
                                                    -0.309,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.576,
                                                    -0.373
                                                ],
                                                [
                                                    0.736,
                                                    0
                                                ],
                                                [
                                                    0.566,
                                                    0.341
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.054,
                                                    0.907
                                                ],
                                                [
                                                    0.438,
                                                    0.459
                                                ],
                                                [
                                                    0.555,
                                                    0
                                                ],
                                                [
                                                    0.363,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    0.757
                                                ],
                                                [
                                                    -0.618,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -11.783,
                                                    4.672
                                                ],
                                                [
                                                    -13.863,
                                                    4.128
                                                ],
                                                [
                                                    -15.207,
                                                    2.592
                                                ],
                                                [
                                                    -15.671,
                                                    0.24
                                                ],
                                                [
                                                    -15.207,
                                                    -2.096
                                                ],
                                                [
                                                    -13.879,
                                                    -3.632
                                                ],
                                                [
                                                    -11.847,
                                                    -4.192
                                                ],
                                                [
                                                    -9.895,
                                                    -3.664
                                                ],
                                                [
                                                    -8.583,
                                                    -2.16
                                                ],
                                                [
                                                    -8.103,
                                                    0.256
                                                ],
                                                [
                                                    -8.103,
                                                    0.656
                                                ],
                                                [
                                                    -14.263,
                                                    0.656
                                                ],
                                                [
                                                    -13.543,
                                                    2.704
                                                ],
                                                [
                                                    -11.783,
                                                    3.392
                                                ],
                                                [
                                                    -10.423,
                                                    3.008
                                                ],
                                                [
                                                    -9.671,
                                                    1.968
                                                ],
                                                [
                                                    -8.231,
                                                    2.08
                                                ],
                                                [
                                                    -9.511,
                                                    3.952
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 29",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.118,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    0.384
                                                ],
                                                [
                                                    0.63,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    -0.405
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.821
                                                ],
                                                [
                                                    -0.405,
                                                    -0.384
                                                ],
                                                [
                                                    -0.65,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.395
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -14.263,
                                                    -0.528
                                                ],
                                                [
                                                    -9.575,
                                                    -0.528
                                                ],
                                                [
                                                    -10.295,
                                                    -2.336
                                                ],
                                                [
                                                    -11.847,
                                                    -2.912
                                                ],
                                                [
                                                    -13.463,
                                                    -2.304
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 30",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.331
                                                ],
                                                [
                                                    -0.597,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.16
                                                ],
                                                [
                                                    0.149,
                                                    -0.309
                                                ],
                                                [
                                                    0,
                                                    -0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.107,
                                                    -0.725
                                                ],
                                                [
                                                    0.363,
                                                    -0.341
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    0
                                                ],
                                                [
                                                    -0.277,
                                                    0.149
                                                ],
                                                [
                                                    -0.139,
                                                    0.299
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -6.282,
                                                    4.48
                                                ],
                                                [
                                                    -6.282,
                                                    -4
                                                ],
                                                [
                                                    -5.098,
                                                    -4
                                                ],
                                                [
                                                    -5.034,
                                                    -1.856
                                                ],
                                                [
                                                    -5.162,
                                                    -1.904
                                                ],
                                                [
                                                    -4.474,
                                                    -3.488
                                                ],
                                                [
                                                    -3.034,
                                                    -4
                                                ],
                                                [
                                                    -2.202,
                                                    -4
                                                ],
                                                [
                                                    -2.202,
                                                    -2.72
                                                ],
                                                [
                                                    -3.018,
                                                    -2.72
                                                ],
                                                [
                                                    -4.09,
                                                    -2.48
                                                ],
                                                [
                                                    -4.73,
                                                    -1.792
                                                ],
                                                [
                                                    -4.938,
                                                    -0.64
                                                ],
                                                [
                                                    -4.938,
                                                    4.48
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 31",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.331
                                                ],
                                                [
                                                    -0.597,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.16
                                                ],
                                                [
                                                    0.15,
                                                    -0.309
                                                ],
                                                [
                                                    0,
                                                    -0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.107,
                                                    -0.725
                                                ],
                                                [
                                                    0.363,
                                                    -0.341
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.426,
                                                    0
                                                ],
                                                [
                                                    -0.277,
                                                    0.149
                                                ],
                                                [
                                                    -0.138,
                                                    0.299
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.78,
                                                    4.48
                                                ],
                                                [
                                                    3.78,
                                                    -4
                                                ],
                                                [
                                                    4.964,
                                                    -4
                                                ],
                                                [
                                                    5.028,
                                                    -1.856
                                                ],
                                                [
                                                    4.9,
                                                    -1.904
                                                ],
                                                [
                                                    5.588,
                                                    -3.488
                                                ],
                                                [
                                                    7.028,
                                                    -4
                                                ],
                                                [
                                                    7.86,
                                                    -4
                                                ],
                                                [
                                                    7.86,
                                                    -2.72
                                                ],
                                                [
                                                    7.044,
                                                    -2.72
                                                ],
                                                [
                                                    5.972,
                                                    -2.48
                                                ],
                                                [
                                                    5.332,
                                                    -1.792
                                                ],
                                                [
                                                    5.124,
                                                    -0.64
                                                ],
                                                [
                                                    5.124,
                                                    4.48
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 32",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.896,
                                                    0
                                                ],
                                                [
                                                    0.587,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.309,
                                                    0.661
                                                ],
                                                [
                                                    -0.565,
                                                    0.363
                                                ],
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    -0.352
                                                ],
                                                [
                                                    -0.309,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.949
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.426,
                                                    -0.459
                                                ],
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.256
                                                ],
                                                [
                                                    -0.138,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.63,
                                                    -0.491
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.8,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.363
                                                ],
                                                [
                                                    -0.309,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.576,
                                                    -0.373
                                                ],
                                                [
                                                    0.736,
                                                    0
                                                ],
                                                [
                                                    0.566,
                                                    0.341
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.054,
                                                    0.907
                                                ],
                                                [
                                                    0.438,
                                                    0.459
                                                ],
                                                [
                                                    0.555,
                                                    0
                                                ],
                                                [
                                                    0.363,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    0.757
                                                ],
                                                [
                                                    -0.618,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    12.514,
                                                    4.672
                                                ],
                                                [
                                                    10.434,
                                                    4.128
                                                ],
                                                [
                                                    9.09,
                                                    2.592
                                                ],
                                                [
                                                    8.626,
                                                    0.24
                                                ],
                                                [
                                                    9.09,
                                                    -2.096
                                                ],
                                                [
                                                    10.418,
                                                    -3.632
                                                ],
                                                [
                                                    12.45,
                                                    -4.192
                                                ],
                                                [
                                                    14.402,
                                                    -3.664
                                                ],
                                                [
                                                    15.714,
                                                    -2.16
                                                ],
                                                [
                                                    16.194,
                                                    0.256
                                                ],
                                                [
                                                    16.194,
                                                    0.656
                                                ],
                                                [
                                                    10.034,
                                                    0.656
                                                ],
                                                [
                                                    10.754,
                                                    2.704
                                                ],
                                                [
                                                    12.514,
                                                    3.392
                                                ],
                                                [
                                                    13.874,
                                                    3.008
                                                ],
                                                [
                                                    14.626,
                                                    1.968
                                                ],
                                                [
                                                    16.066,
                                                    2.08
                                                ],
                                                [
                                                    14.786,
                                                    3.952
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 33",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.118,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    0.384
                                                ],
                                                [
                                                    0.63,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    -0.405
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.821
                                                ],
                                                [
                                                    -0.405,
                                                    -0.384
                                                ],
                                                [
                                                    -0.65,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.395
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    10.034,
                                                    -0.528
                                                ],
                                                [
                                                    14.722,
                                                    -0.528
                                                ],
                                                [
                                                    14.002,
                                                    -2.336
                                                ],
                                                [
                                                    12.45,
                                                    -2.912
                                                ],
                                                [
                                                    10.834,
                                                    -2.304
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 34",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.48,
                                                    0
                                                ],
                                                [
                                                    0.522,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    -0.427,
                                                    0.416
                                                ],
                                                [
                                                    -0.928,
                                                    0.171
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.341,
                                                    0.352
                                                ],
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.341,
                                                    -0.267
                                                ],
                                                [
                                                    0.128,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.607,
                                                    0.491
                                                ],
                                                [
                                                    -0.96,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.619
                                                ],
                                                [
                                                    0,
                                                    -1.077
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.085
                                                ],
                                                [
                                                    -0.16,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.096,
                                                    0
                                                ],
                                                [
                                                    0.107,
                                                    0
                                                ],
                                                [
                                                    0.245,
                                                    0.117
                                                ],
                                                [
                                                    0.106,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.299
                                                ],
                                                [
                                                    0.426,
                                                    -0.171
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.875,
                                                    0
                                                ],
                                                [
                                                    -0.512,
                                                    -0.405
                                                ],
                                                [
                                                    0,
                                                    -0.725
                                                ],
                                                [
                                                    0.426,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.715
                                                ],
                                                [
                                                    -0.331,
                                                    -0.352
                                                ],
                                                [
                                                    -0.587,
                                                    0
                                                ],
                                                [
                                                    -0.342,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.16,
                                                    -0.8
                                                ],
                                                [
                                                    0.619,
                                                    -0.501
                                                ],
                                                [
                                                    1.088,
                                                    0
                                                ],
                                                [
                                                    0.576,
                                                    0.608
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.192
                                                ],
                                                [
                                                    0.074,
                                                    0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.043,
                                                    0.011
                                                ],
                                                [
                                                    -0.096,
                                                    0.011
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    -0.128
                                                ],
                                                [
                                                    -0.107,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    0.363
                                                ],
                                                [
                                                    -0.288,
                                                    0.288
                                                ],
                                                [
                                                    -0.427,
                                                    0.16
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    20.522,
                                                    4.672
                                                ],
                                                [
                                                    18.426,
                                                    4.064
                                                ],
                                                [
                                                    17.658,
                                                    2.368
                                                ],
                                                [
                                                    18.298,
                                                    0.656
                                                ],
                                                [
                                                    20.33,
                                                    -0.224
                                                ],
                                                [
                                                    23.338,
                                                    -0.784
                                                ],
                                                [
                                                    22.826,
                                                    -2.384
                                                ],
                                                [
                                                    21.322,
                                                    -2.912
                                                ],
                                                [
                                                    19.93,
                                                    -2.512
                                                ],
                                                [
                                                    19.226,
                                                    -1.392
                                                ],
                                                [
                                                    17.802,
                                                    -1.504
                                                ],
                                                [
                                                    18.953,
                                                    -3.44
                                                ],
                                                [
                                                    21.322,
                                                    -4.192
                                                ],
                                                [
                                                    23.818,
                                                    -3.264
                                                ],
                                                [
                                                    24.682,
                                                    -0.736
                                                ],
                                                [
                                                    24.682,
                                                    2.768
                                                ],
                                                [
                                                    24.778,
                                                    3.184
                                                ],
                                                [
                                                    25.13,
                                                    3.296
                                                ],
                                                [
                                                    25.466,
                                                    3.296
                                                ],
                                                [
                                                    25.466,
                                                    4.48
                                                ],
                                                [
                                                    25.258,
                                                    4.496
                                                ],
                                                [
                                                    24.953,
                                                    4.512
                                                ],
                                                [
                                                    24.01,
                                                    4.336
                                                ],
                                                [
                                                    23.498,
                                                    3.76
                                                ],
                                                [
                                                    23.338,
                                                    2.72
                                                ],
                                                [
                                                    23.498,
                                                    2.752
                                                ],
                                                [
                                                    22.954,
                                                    3.744
                                                ],
                                                [
                                                    21.882,
                                                    4.432
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 35",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.491,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    0.213
                                                ],
                                                [
                                                    -0.214,
                                                    0.373
                                                ],
                                                [
                                                    0,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.224,
                                                    -0.224
                                                ],
                                                [
                                                    0,
                                                    -0.352
                                                ],
                                                [
                                                    -0.278,
                                                    -0.224
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.565,
                                                    0
                                                ],
                                                [
                                                    0.405,
                                                    -0.224
                                                ],
                                                [
                                                    0.213,
                                                    -0.384
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    0.107
                                                ],
                                                [
                                                    -0.214,
                                                    0.213
                                                ],
                                                [
                                                    0,
                                                    0.395
                                                ],
                                                [
                                                    0.288,
                                                    0.213
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    20.65,
                                                    3.488
                                                ],
                                                [
                                                    22.09,
                                                    3.168
                                                ],
                                                [
                                                    23.018,
                                                    2.272
                                                ],
                                                [
                                                    23.338,
                                                    0.992
                                                ],
                                                [
                                                    23.338,
                                                    0.384
                                                ],
                                                [
                                                    20.586,
                                                    0.896
                                                ],
                                                [
                                                    19.386,
                                                    1.392
                                                ],
                                                [
                                                    19.065,
                                                    2.24
                                                ],
                                                [
                                                    19.482,
                                                    3.168
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 36",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.651,
                                                    0
                                                ],
                                                [
                                                    0.587,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.32,
                                                    0.661
                                                ],
                                                [
                                                    -0.576,
                                                    0.363
                                                ],
                                                [
                                                    -0.789,
                                                    0
                                                ],
                                                [
                                                    -0.501,
                                                    -0.235
                                                ],
                                                [
                                                    -0.32,
                                                    -0.437
                                                ],
                                                [
                                                    -0.096,
                                                    -0.629
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.395,
                                                    0.299
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0.438,
                                                    -0.565
                                                ],
                                                [
                                                    0,
                                                    -0.981
                                                ],
                                                [
                                                    -0.437,
                                                    -0.565
                                                ],
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.394,
                                                    0.32
                                                ],
                                                [
                                                    -0.096,
                                                    0.64
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.469
                                                ],
                                                [
                                                    0.512,
                                                    -0.256
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.789,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.363
                                                ],
                                                [
                                                    -0.32,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.587,
                                                    -0.373
                                                ],
                                                [
                                                    0.651,
                                                    0
                                                ],
                                                [
                                                    0.512,
                                                    0.224
                                                ],
                                                [
                                                    0.32,
                                                    0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.096,
                                                    -0.565
                                                ],
                                                [
                                                    -0.394,
                                                    -0.309
                                                ],
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.437,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0.981
                                                ],
                                                [
                                                    0.438,
                                                    0.555
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0.395,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.096,
                                                    0.629
                                                ],
                                                [
                                                    -0.32,
                                                    0.459
                                                ],
                                                [
                                                    -0.501,
                                                    0.256
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    30.264,
                                                    4.672
                                                ],
                                                [
                                                    28.2,
                                                    4.128
                                                ],
                                                [
                                                    26.856,
                                                    2.592
                                                ],
                                                [
                                                    26.376,
                                                    0.24
                                                ],
                                                [
                                                    26.856,
                                                    -2.096
                                                ],
                                                [
                                                    28.2,
                                                    -3.632
                                                ],
                                                [
                                                    30.264,
                                                    -4.192
                                                ],
                                                [
                                                    31.992,
                                                    -3.84
                                                ],
                                                [
                                                    33.24,
                                                    -2.848
                                                ],
                                                [
                                                    33.864,
                                                    -1.248
                                                ],
                                                [
                                                    32.456,
                                                    -1.152
                                                ],
                                                [
                                                    31.72,
                                                    -2.448
                                                ],
                                                [
                                                    30.264,
                                                    -2.912
                                                ],
                                                [
                                                    28.44,
                                                    -2.064
                                                ],
                                                [
                                                    27.784,
                                                    0.24
                                                ],
                                                [
                                                    28.44,
                                                    2.56
                                                ],
                                                [
                                                    30.264,
                                                    3.392
                                                ],
                                                [
                                                    31.72,
                                                    2.912
                                                ],
                                                [
                                                    32.456,
                                                    1.472
                                                ],
                                                [
                                                    33.864,
                                                    1.568
                                                ],
                                                [
                                                    33.24,
                                                    3.216
                                                ],
                                                [
                                                    31.992,
                                                    4.288
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 37",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.256,
                                                    0.299
                                                ],
                                                [
                                                    -0.373,
                                                    0.139
                                                ],
                                                [
                                                    -0.448,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    -0.277
                                                ],
                                                [
                                                    -0.213,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    -0.629
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.299,
                                                    0.395
                                                ],
                                                [
                                                    0.598,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.107,
                                                    -0.469
                                                ],
                                                [
                                                    0.256,
                                                    -0.299
                                                ],
                                                [
                                                    0.374,
                                                    -0.149
                                                ],
                                                [
                                                    0.608,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    0.267
                                                ],
                                                [
                                                    0.224,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.288,
                                                    -0.395
                                                ],
                                                [
                                                    -0.682,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    35.53,
                                                    4.48
                                                ],
                                                [
                                                    35.53,
                                                    -6.88
                                                ],
                                                [
                                                    36.874,
                                                    -6.88
                                                ],
                                                [
                                                    36.874,
                                                    -2.128
                                                ],
                                                [
                                                    36.714,
                                                    -2.16
                                                ],
                                                [
                                                    37.258,
                                                    -3.312
                                                ],
                                                [
                                                    38.202,
                                                    -3.968
                                                ],
                                                [
                                                    39.434,
                                                    -4.192
                                                ],
                                                [
                                                    40.97,
                                                    -3.776
                                                ],
                                                [
                                                    41.93,
                                                    -2.64
                                                ],
                                                [
                                                    42.266,
                                                    -0.976
                                                ],
                                                [
                                                    42.266,
                                                    4.48
                                                ],
                                                [
                                                    40.922,
                                                    4.48
                                                ],
                                                [
                                                    40.922,
                                                    -0.592
                                                ],
                                                [
                                                    40.474,
                                                    -2.416
                                                ],
                                                [
                                                    39.146,
                                                    -3.008
                                                ],
                                                [
                                                    37.498,
                                                    -2.384
                                                ],
                                                [
                                                    36.874,
                                                    -0.576
                                                ],
                                                [
                                                    36.874,
                                                    4.48
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 38",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.896,
                                                    0
                                                ],
                                                [
                                                    0.586,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.31,
                                                    0.661
                                                ],
                                                [
                                                    -0.566,
                                                    0.363
                                                ],
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.566,
                                                    -0.352
                                                ],
                                                [
                                                    -0.31,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.949
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    -0.459
                                                ],
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.256
                                                ],
                                                [
                                                    -0.139,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.629,
                                                    -0.491
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.8,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.363
                                                ],
                                                [
                                                    -0.31,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.576,
                                                    -0.373
                                                ],
                                                [
                                                    0.736,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    0.341
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.053,
                                                    0.907
                                                ],
                                                [
                                                    0.437,
                                                    0.459
                                                ],
                                                [
                                                    0.554,
                                                    0
                                                ],
                                                [
                                                    0.362,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    0.757
                                                ],
                                                [
                                                    -0.619,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    47.952,
                                                    4.672
                                                ],
                                                [
                                                    45.872,
                                                    4.128
                                                ],
                                                [
                                                    44.528,
                                                    2.592
                                                ],
                                                [
                                                    44.064,
                                                    0.24
                                                ],
                                                [
                                                    44.528,
                                                    -2.096
                                                ],
                                                [
                                                    45.856,
                                                    -3.632
                                                ],
                                                [
                                                    47.888,
                                                    -4.192
                                                ],
                                                [
                                                    49.84,
                                                    -3.664
                                                ],
                                                [
                                                    51.152,
                                                    -2.16
                                                ],
                                                [
                                                    51.632,
                                                    0.256
                                                ],
                                                [
                                                    51.632,
                                                    0.656
                                                ],
                                                [
                                                    45.472,
                                                    0.656
                                                ],
                                                [
                                                    46.192,
                                                    2.704
                                                ],
                                                [
                                                    47.952,
                                                    3.392
                                                ],
                                                [
                                                    49.312,
                                                    3.008
                                                ],
                                                [
                                                    50.064,
                                                    1.968
                                                ],
                                                [
                                                    51.504,
                                                    2.08
                                                ],
                                                [
                                                    50.224,
                                                    3.952
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 39",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.117,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    0.384
                                                ],
                                                [
                                                    0.629,
                                                    0
                                                ],
                                                [
                                                    0.426,
                                                    -0.405
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.821
                                                ],
                                                [
                                                    -0.406,
                                                    -0.384
                                                ],
                                                [
                                                    -0.651,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.395
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    45.472,
                                                    -0.528
                                                ],
                                                [
                                                    50.16,
                                                    -0.528
                                                ],
                                                [
                                                    49.44,
                                                    -2.336
                                                ],
                                                [
                                                    47.888,
                                                    -2.912
                                                ],
                                                [
                                                    46.272,
                                                    -2.304
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 40",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.598,
                                                    0
                                                ],
                                                [
                                                    0.544,
                                                    0.363
                                                ],
                                                [
                                                    0.288,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.907
                                                ],
                                                [
                                                    -0.288,
                                                    0.661
                                                ],
                                                [
                                                    -0.533,
                                                    0.363
                                                ],
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.469,
                                                    -0.245
                                                ],
                                                [
                                                    -0.234,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    -0.267
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.533,
                                                    -0.363
                                                ],
                                                [
                                                    -0.288,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.907
                                                ],
                                                [
                                                    0.288,
                                                    -0.661
                                                ],
                                                [
                                                    0.544,
                                                    -0.363
                                                ],
                                                [
                                                    0.566,
                                                    0
                                                ],
                                                [
                                                    0.47,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.234,
                                                    0.459
                                                ],
                                                [
                                                    -0.48,
                                                    0.256
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    56.46,
                                                    4.672
                                                ],
                                                [
                                                    54.54,
                                                    4.128
                                                ],
                                                [
                                                    53.308,
                                                    2.592
                                                ],
                                                [
                                                    52.876,
                                                    0.24
                                                ],
                                                [
                                                    53.308,
                                                    -2.112
                                                ],
                                                [
                                                    54.54,
                                                    -3.648
                                                ],
                                                [
                                                    56.46,
                                                    -4.192
                                                ],
                                                [
                                                    58.012,
                                                    -3.824
                                                ],
                                                [
                                                    59.068,
                                                    -2.816
                                                ],
                                                [
                                                    59.068,
                                                    -6.88
                                                ],
                                                [
                                                    60.412,
                                                    -6.88
                                                ],
                                                [
                                                    60.412,
                                                    4.48
                                                ],
                                                [
                                                    59.196,
                                                    4.48
                                                ],
                                                [
                                                    59.148,
                                                    3.2
                                                ],
                                                [
                                                    58.076,
                                                    4.288
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 41",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.746,
                                                    0
                                                ],
                                                [
                                                    -0.341,
                                                    0.256
                                                ],
                                                [
                                                    -0.181,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0.64
                                                ],
                                                [
                                                    0.182,
                                                    0.469
                                                ],
                                                [
                                                    0.352,
                                                    0.245
                                                ],
                                                [
                                                    0.502,
                                                    0
                                                ],
                                                [
                                                    0.448,
                                                    -0.565
                                                ],
                                                [
                                                    0,
                                                    -0.981
                                                ],
                                                [
                                                    -0.437,
                                                    -0.565
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.502,
                                                    0
                                                ],
                                                [
                                                    0.352,
                                                    -0.256
                                                ],
                                                [
                                                    0.182,
                                                    -0.48
                                                ],
                                                [
                                                    0,
                                                    -0.661
                                                ],
                                                [
                                                    -0.181,
                                                    -0.469
                                                ],
                                                [
                                                    -0.341,
                                                    -0.256
                                                ],
                                                [
                                                    -0.746,
                                                    0
                                                ],
                                                [
                                                    -0.437,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0.971
                                                ],
                                                [
                                                    0.448,
                                                    0.565
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    56.732,
                                                    3.392
                                                ],
                                                [
                                                    57.996,
                                                    3.008
                                                ],
                                                [
                                                    58.796,
                                                    1.92
                                                ],
                                                [
                                                    59.068,
                                                    0.24
                                                ],
                                                [
                                                    58.796,
                                                    -1.456
                                                ],
                                                [
                                                    57.996,
                                                    -2.528
                                                ],
                                                [
                                                    56.732,
                                                    -2.912
                                                ],
                                                [
                                                    54.94,
                                                    -2.064
                                                ],
                                                [
                                                    54.284,
                                                    0.24
                                                ],
                                                [
                                                    54.94,
                                                    2.544
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 42",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.373,
                                                    0.352
                                                ],
                                                [
                                                    0,
                                                    0.747
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.171,
                                                    -0.149
                                                ],
                                                [
                                                    -0.352,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.768,
                                                    0
                                                ],
                                                [
                                                    -0.363,
                                                    -0.352
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.384
                                                ],
                                                [
                                                    0.171,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    70.072,
                                                    4.48
                                                ],
                                                [
                                                    68.36,
                                                    3.952
                                                ],
                                                [
                                                    67.816,
                                                    2.304
                                                ],
                                                [
                                                    67.816,
                                                    -5.984
                                                ],
                                                [
                                                    69.16,
                                                    -5.984
                                                ],
                                                [
                                                    69.16,
                                                    2.272
                                                ],
                                                [
                                                    69.416,
                                                    3.072
                                                ],
                                                [
                                                    70.2,
                                                    3.296
                                                ],
                                                [
                                                    71.416,
                                                    3.296
                                                ],
                                                [
                                                    71.416,
                                                    4.48
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 43",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    66.568,
                                                    -2.816
                                                ],
                                                [
                                                    66.568,
                                                    -4
                                                ],
                                                [
                                                    71.416,
                                                    -4
                                                ],
                                                [
                                                    71.416,
                                                    -2.816
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 44",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.256,
                                                    0.299
                                                ],
                                                [
                                                    -0.374,
                                                    0.139
                                                ],
                                                [
                                                    -0.448,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    -0.277
                                                ],
                                                [
                                                    -0.214,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    -0.629
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.298,
                                                    0.395
                                                ],
                                                [
                                                    0.597,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.106,
                                                    -0.469
                                                ],
                                                [
                                                    0.256,
                                                    -0.299
                                                ],
                                                [
                                                    0.373,
                                                    -0.149
                                                ],
                                                [
                                                    0.608,
                                                    0
                                                ],
                                                [
                                                    0.426,
                                                    0.267
                                                ],
                                                [
                                                    0.224,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    -0.288,
                                                    -0.395
                                                ],
                                                [
                                                    -0.683,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    72.984,
                                                    4.48
                                                ],
                                                [
                                                    72.984,
                                                    -6.88
                                                ],
                                                [
                                                    74.328,
                                                    -6.88
                                                ],
                                                [
                                                    74.328,
                                                    -2.128
                                                ],
                                                [
                                                    74.168,
                                                    -2.16
                                                ],
                                                [
                                                    74.712,
                                                    -3.312
                                                ],
                                                [
                                                    75.656,
                                                    -3.968
                                                ],
                                                [
                                                    76.888,
                                                    -4.192
                                                ],
                                                [
                                                    78.424,
                                                    -3.776
                                                ],
                                                [
                                                    79.384,
                                                    -2.64
                                                ],
                                                [
                                                    79.72,
                                                    -0.976
                                                ],
                                                [
                                                    79.72,
                                                    4.48
                                                ],
                                                [
                                                    78.376,
                                                    4.48
                                                ],
                                                [
                                                    78.376,
                                                    -0.592
                                                ],
                                                [
                                                    77.928,
                                                    -2.416
                                                ],
                                                [
                                                    76.6,
                                                    -3.008
                                                ],
                                                [
                                                    74.952,
                                                    -2.384
                                                ],
                                                [
                                                    74.328,
                                                    -0.576
                                                ],
                                                [
                                                    74.328,
                                                    4.48
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 45",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.896,
                                                    0
                                                ],
                                                [
                                                    0.587,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.309,
                                                    0.661
                                                ],
                                                [
                                                    -0.565,
                                                    0.363
                                                ],
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    -0.352
                                                ],
                                                [
                                                    -0.309,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.949
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    -0.459
                                                ],
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.256
                                                ],
                                                [
                                                    -0.139,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.629,
                                                    -0.491
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.8,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.363
                                                ],
                                                [
                                                    -0.309,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.576,
                                                    -0.373
                                                ],
                                                [
                                                    0.736,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    0.341
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.053,
                                                    0.907
                                                ],
                                                [
                                                    0.437,
                                                    0.459
                                                ],
                                                [
                                                    0.555,
                                                    0
                                                ],
                                                [
                                                    0.363,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    0.757
                                                ],
                                                [
                                                    -0.619,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    85.405,
                                                    4.672
                                                ],
                                                [
                                                    83.325,
                                                    4.128
                                                ],
                                                [
                                                    81.981,
                                                    2.592
                                                ],
                                                [
                                                    81.517,
                                                    0.24
                                                ],
                                                [
                                                    81.981,
                                                    -2.096
                                                ],
                                                [
                                                    83.309,
                                                    -3.632
                                                ],
                                                [
                                                    85.341,
                                                    -4.192
                                                ],
                                                [
                                                    87.293,
                                                    -3.664
                                                ],
                                                [
                                                    88.605,
                                                    -2.16
                                                ],
                                                [
                                                    89.085,
                                                    0.256
                                                ],
                                                [
                                                    89.085,
                                                    0.656
                                                ],
                                                [
                                                    82.925,
                                                    0.656
                                                ],
                                                [
                                                    83.645,
                                                    2.704
                                                ],
                                                [
                                                    85.405,
                                                    3.392
                                                ],
                                                [
                                                    86.765,
                                                    3.008
                                                ],
                                                [
                                                    87.517,
                                                    1.968
                                                ],
                                                [
                                                    88.957,
                                                    2.08
                                                ],
                                                [
                                                    87.677,
                                                    3.952
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 46",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.117,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    0.384
                                                ],
                                                [
                                                    0.629,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    -0.405
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.821
                                                ],
                                                [
                                                    -0.405,
                                                    -0.384
                                                ],
                                                [
                                                    -0.651,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.395
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    82.925,
                                                    -0.528
                                                ],
                                                [
                                                    87.613,
                                                    -0.528
                                                ],
                                                [
                                                    86.893,
                                                    -2.336
                                                ],
                                                [
                                                    85.341,
                                                    -2.912
                                                ],
                                                [
                                                    83.725,
                                                    -2.304
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 47",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.597,
                                                    0
                                                ],
                                                [
                                                    0.544,
                                                    0.363
                                                ],
                                                [
                                                    0.288,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.907
                                                ],
                                                [
                                                    -0.288,
                                                    0.661
                                                ],
                                                [
                                                    -0.534,
                                                    0.363
                                                ],
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.47,
                                                    -0.245
                                                ],
                                                [
                                                    -0.235,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    -0.267
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.534,
                                                    -0.363
                                                ],
                                                [
                                                    -0.288,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.907
                                                ],
                                                [
                                                    0.288,
                                                    -0.661
                                                ],
                                                [
                                                    0.544,
                                                    -0.363
                                                ],
                                                [
                                                    0.565,
                                                    0
                                                ],
                                                [
                                                    0.469,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    0.459
                                                ],
                                                [
                                                    -0.48,
                                                    0.256
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    98.07,
                                                    4.672
                                                ],
                                                [
                                                    96.15,
                                                    4.128
                                                ],
                                                [
                                                    94.918,
                                                    2.592
                                                ],
                                                [
                                                    94.486,
                                                    0.24
                                                ],
                                                [
                                                    94.918,
                                                    -2.112
                                                ],
                                                [
                                                    96.15,
                                                    -3.648
                                                ],
                                                [
                                                    98.07,
                                                    -4.192
                                                ],
                                                [
                                                    99.622,
                                                    -3.824
                                                ],
                                                [
                                                    100.678,
                                                    -2.816
                                                ],
                                                [
                                                    100.678,
                                                    -6.88
                                                ],
                                                [
                                                    102.022,
                                                    -6.88
                                                ],
                                                [
                                                    102.022,
                                                    4.48
                                                ],
                                                [
                                                    100.806,
                                                    4.48
                                                ],
                                                [
                                                    100.758,
                                                    3.2
                                                ],
                                                [
                                                    99.686,
                                                    4.288
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 48",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.747,
                                                    0
                                                ],
                                                [
                                                    -0.342,
                                                    0.256
                                                ],
                                                [
                                                    -0.182,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0.64
                                                ],
                                                [
                                                    0.181,
                                                    0.469
                                                ],
                                                [
                                                    0.352,
                                                    0.245
                                                ],
                                                [
                                                    0.501,
                                                    0
                                                ],
                                                [
                                                    0.448,
                                                    -0.565
                                                ],
                                                [
                                                    0,
                                                    -0.981
                                                ],
                                                [
                                                    -0.438,
                                                    -0.565
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.501,
                                                    0
                                                ],
                                                [
                                                    0.352,
                                                    -0.256
                                                ],
                                                [
                                                    0.181,
                                                    -0.48
                                                ],
                                                [
                                                    0,
                                                    -0.661
                                                ],
                                                [
                                                    -0.182,
                                                    -0.469
                                                ],
                                                [
                                                    -0.342,
                                                    -0.256
                                                ],
                                                [
                                                    -0.747,
                                                    0
                                                ],
                                                [
                                                    -0.438,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0.971
                                                ],
                                                [
                                                    0.448,
                                                    0.565
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    98.342,
                                                    3.392
                                                ],
                                                [
                                                    99.606,
                                                    3.008
                                                ],
                                                [
                                                    100.406,
                                                    1.92
                                                ],
                                                [
                                                    100.678,
                                                    0.24
                                                ],
                                                [
                                                    100.406,
                                                    -1.456
                                                ],
                                                [
                                                    99.606,
                                                    -2.528
                                                ],
                                                [
                                                    98.342,
                                                    -2.912
                                                ],
                                                [
                                                    96.55,
                                                    -2.064
                                                ],
                                                [
                                                    95.894,
                                                    0.24
                                                ],
                                                [
                                                    96.55,
                                                    2.544
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 49",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.48,
                                                    0
                                                ],
                                                [
                                                    0.523,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    -0.427,
                                                    0.416
                                                ],
                                                [
                                                    -0.928,
                                                    0.171
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.341,
                                                    0.352
                                                ],
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.341,
                                                    -0.267
                                                ],
                                                [
                                                    0.128,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.608,
                                                    0.491
                                                ],
                                                [
                                                    -0.96,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.619
                                                ],
                                                [
                                                    0,
                                                    -1.077
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.085
                                                ],
                                                [
                                                    -0.16,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.096,
                                                    0
                                                ],
                                                [
                                                    0.107,
                                                    0
                                                ],
                                                [
                                                    0.245,
                                                    0.117
                                                ],
                                                [
                                                    0.107,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.299
                                                ],
                                                [
                                                    0.427,
                                                    -0.171
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.875,
                                                    0
                                                ],
                                                [
                                                    -0.512,
                                                    -0.405
                                                ],
                                                [
                                                    0,
                                                    -0.725
                                                ],
                                                [
                                                    0.427,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.715
                                                ],
                                                [
                                                    -0.331,
                                                    -0.352
                                                ],
                                                [
                                                    -0.587,
                                                    0
                                                ],
                                                [
                                                    -0.341,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.16,
                                                    -0.8
                                                ],
                                                [
                                                    0.619,
                                                    -0.501
                                                ],
                                                [
                                                    1.088,
                                                    0
                                                ],
                                                [
                                                    0.576,
                                                    0.608
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.192
                                                ],
                                                [
                                                    0.075,
                                                    0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.043,
                                                    0.011
                                                ],
                                                [
                                                    -0.096,
                                                    0.011
                                                ],
                                                [
                                                    -0.384,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    -0.128
                                                ],
                                                [
                                                    -0.107,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    0.363
                                                ],
                                                [
                                                    -0.288,
                                                    0.288
                                                ],
                                                [
                                                    -0.427,
                                                    0.16
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    106.709,
                                                    4.672
                                                ],
                                                [
                                                    104.613,
                                                    4.064
                                                ],
                                                [
                                                    103.845,
                                                    2.368
                                                ],
                                                [
                                                    104.485,
                                                    0.656
                                                ],
                                                [
                                                    106.517,
                                                    -0.224
                                                ],
                                                [
                                                    109.525,
                                                    -0.784
                                                ],
                                                [
                                                    109.013,
                                                    -2.384
                                                ],
                                                [
                                                    107.509,
                                                    -2.912
                                                ],
                                                [
                                                    106.117,
                                                    -2.512
                                                ],
                                                [
                                                    105.413,
                                                    -1.392
                                                ],
                                                [
                                                    103.989,
                                                    -1.504
                                                ],
                                                [
                                                    105.141,
                                                    -3.44
                                                ],
                                                [
                                                    107.509,
                                                    -4.192
                                                ],
                                                [
                                                    110.005,
                                                    -3.264
                                                ],
                                                [
                                                    110.869,
                                                    -0.736
                                                ],
                                                [
                                                    110.869,
                                                    2.768
                                                ],
                                                [
                                                    110.965,
                                                    3.184
                                                ],
                                                [
                                                    111.317,
                                                    3.296
                                                ],
                                                [
                                                    111.653,
                                                    3.296
                                                ],
                                                [
                                                    111.653,
                                                    4.48
                                                ],
                                                [
                                                    111.445,
                                                    4.496
                                                ],
                                                [
                                                    111.141,
                                                    4.512
                                                ],
                                                [
                                                    110.197,
                                                    4.336
                                                ],
                                                [
                                                    109.685,
                                                    3.76
                                                ],
                                                [
                                                    109.525,
                                                    2.72
                                                ],
                                                [
                                                    109.685,
                                                    2.752
                                                ],
                                                [
                                                    109.141,
                                                    3.744
                                                ],
                                                [
                                                    108.069,
                                                    4.432
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 50",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.491,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    0.213
                                                ],
                                                [
                                                    -0.213,
                                                    0.373
                                                ],
                                                [
                                                    0,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.224,
                                                    -0.224
                                                ],
                                                [
                                                    0,
                                                    -0.352
                                                ],
                                                [
                                                    -0.277,
                                                    -0.224
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.565,
                                                    0
                                                ],
                                                [
                                                    0.405,
                                                    -0.224
                                                ],
                                                [
                                                    0.213,
                                                    -0.384
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    0.107
                                                ],
                                                [
                                                    -0.213,
                                                    0.213
                                                ],
                                                [
                                                    0,
                                                    0.395
                                                ],
                                                [
                                                    0.288,
                                                    0.213
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    106.837,
                                                    3.488
                                                ],
                                                [
                                                    108.277,
                                                    3.168
                                                ],
                                                [
                                                    109.205,
                                                    2.272
                                                ],
                                                [
                                                    109.525,
                                                    0.992
                                                ],
                                                [
                                                    109.525,
                                                    0.384
                                                ],
                                                [
                                                    106.773,
                                                    0.896
                                                ],
                                                [
                                                    105.573,
                                                    1.392
                                                ],
                                                [
                                                    105.253,
                                                    2.24
                                                ],
                                                [
                                                    105.669,
                                                    3.168
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 51",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.373,
                                                    0.352
                                                ],
                                                [
                                                    0,
                                                    0.747
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.171,
                                                    -0.149
                                                ],
                                                [
                                                    -0.352,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.768,
                                                    0
                                                ],
                                                [
                                                    -0.363,
                                                    -0.352
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.384
                                                ],
                                                [
                                                    0.17,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    115.541,
                                                    4.48
                                                ],
                                                [
                                                    113.829,
                                                    3.952
                                                ],
                                                [
                                                    113.285,
                                                    2.304
                                                ],
                                                [
                                                    113.285,
                                                    -5.984
                                                ],
                                                [
                                                    114.629,
                                                    -5.984
                                                ],
                                                [
                                                    114.629,
                                                    2.272
                                                ],
                                                [
                                                    114.885,
                                                    3.072
                                                ],
                                                [
                                                    115.669,
                                                    3.296
                                                ],
                                                [
                                                    116.885,
                                                    3.296
                                                ],
                                                [
                                                    116.885,
                                                    4.48
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 52",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    112.037,
                                                    -2.816
                                                ],
                                                [
                                                    112.037,
                                                    -4
                                                ],
                                                [
                                                    116.885,
                                                    -4
                                                ],
                                                [
                                                    116.885,
                                                    -2.816
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 53",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.48,
                                                    0
                                                ],
                                                [
                                                    0.523,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    -0.427,
                                                    0.416
                                                ],
                                                [
                                                    -0.928,
                                                    0.171
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.341,
                                                    0.352
                                                ],
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.341,
                                                    -0.267
                                                ],
                                                [
                                                    0.128,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.608,
                                                    0.491
                                                ],
                                                [
                                                    -0.96,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.619
                                                ],
                                                [
                                                    0,
                                                    -1.077
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.085
                                                ],
                                                [
                                                    -0.16,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.096,
                                                    0
                                                ],
                                                [
                                                    0.107,
                                                    0
                                                ],
                                                [
                                                    0.245,
                                                    0.117
                                                ],
                                                [
                                                    0.107,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.299
                                                ],
                                                [
                                                    0.427,
                                                    -0.171
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.875,
                                                    0
                                                ],
                                                [
                                                    -0.512,
                                                    -0.405
                                                ],
                                                [
                                                    0,
                                                    -0.725
                                                ],
                                                [
                                                    0.427,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.715
                                                ],
                                                [
                                                    -0.331,
                                                    -0.352
                                                ],
                                                [
                                                    -0.587,
                                                    0
                                                ],
                                                [
                                                    -0.341,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.16,
                                                    -0.8
                                                ],
                                                [
                                                    0.619,
                                                    -0.501
                                                ],
                                                [
                                                    1.088,
                                                    0
                                                ],
                                                [
                                                    0.576,
                                                    0.608
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.192
                                                ],
                                                [
                                                    0.075,
                                                    0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.043,
                                                    0.011
                                                ],
                                                [
                                                    -0.096,
                                                    0.011
                                                ],
                                                [
                                                    -0.384,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    -0.128
                                                ],
                                                [
                                                    -0.107,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    0.363
                                                ],
                                                [
                                                    -0.288,
                                                    0.288
                                                ],
                                                [
                                                    -0.427,
                                                    0.16
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    120.834,
                                                    4.672
                                                ],
                                                [
                                                    118.738,
                                                    4.064
                                                ],
                                                [
                                                    117.97,
                                                    2.368
                                                ],
                                                [
                                                    118.61,
                                                    0.656
                                                ],
                                                [
                                                    120.642,
                                                    -0.224
                                                ],
                                                [
                                                    123.65,
                                                    -0.784
                                                ],
                                                [
                                                    123.138,
                                                    -2.384
                                                ],
                                                [
                                                    121.634,
                                                    -2.912
                                                ],
                                                [
                                                    120.242,
                                                    -2.512
                                                ],
                                                [
                                                    119.538,
                                                    -1.392
                                                ],
                                                [
                                                    118.114,
                                                    -1.504
                                                ],
                                                [
                                                    119.266,
                                                    -3.44
                                                ],
                                                [
                                                    121.634,
                                                    -4.192
                                                ],
                                                [
                                                    124.13,
                                                    -3.264
                                                ],
                                                [
                                                    124.994,
                                                    -0.736
                                                ],
                                                [
                                                    124.994,
                                                    2.768
                                                ],
                                                [
                                                    125.09,
                                                    3.184
                                                ],
                                                [
                                                    125.442,
                                                    3.296
                                                ],
                                                [
                                                    125.778,
                                                    3.296
                                                ],
                                                [
                                                    125.778,
                                                    4.48
                                                ],
                                                [
                                                    125.57,
                                                    4.496
                                                ],
                                                [
                                                    125.266,
                                                    4.512
                                                ],
                                                [
                                                    124.322,
                                                    4.336
                                                ],
                                                [
                                                    123.81,
                                                    3.76
                                                ],
                                                [
                                                    123.65,
                                                    2.72
                                                ],
                                                [
                                                    123.81,
                                                    2.752
                                                ],
                                                [
                                                    123.266,
                                                    3.744
                                                ],
                                                [
                                                    122.194,
                                                    4.432
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 54",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.491,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    0.213
                                                ],
                                                [
                                                    -0.213,
                                                    0.373
                                                ],
                                                [
                                                    0,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.224,
                                                    -0.224
                                                ],
                                                [
                                                    0,
                                                    -0.352
                                                ],
                                                [
                                                    -0.277,
                                                    -0.224
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.565,
                                                    0
                                                ],
                                                [
                                                    0.405,
                                                    -0.224
                                                ],
                                                [
                                                    0.213,
                                                    -0.384
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    0.107
                                                ],
                                                [
                                                    -0.213,
                                                    0.213
                                                ],
                                                [
                                                    0,
                                                    0.395
                                                ],
                                                [
                                                    0.288,
                                                    0.213
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    120.962,
                                                    3.488
                                                ],
                                                [
                                                    122.402,
                                                    3.168
                                                ],
                                                [
                                                    123.33,
                                                    2.272
                                                ],
                                                [
                                                    123.65,
                                                    0.992
                                                ],
                                                [
                                                    123.65,
                                                    0.384
                                                ],
                                                [
                                                    120.898,
                                                    0.896
                                                ],
                                                [
                                                    119.698,
                                                    1.392
                                                ],
                                                [
                                                    119.378,
                                                    2.24
                                                ],
                                                [
                                                    119.794,
                                                    3.168
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 55",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.746,
                                                    0
                                                ],
                                                [
                                                    0.458,
                                                    0.256
                                                ],
                                                [
                                                    0.245,
                                                    0.459
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.448,
                                                    0.277
                                                ],
                                                [
                                                    -0.587,
                                                    0
                                                ],
                                                [
                                                    -0.544,
                                                    -0.363
                                                ],
                                                [
                                                    -0.299,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.907
                                                ],
                                                [
                                                    0.298,
                                                    -0.661
                                                ],
                                                [
                                                    0.544,
                                                    -0.363
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.587,
                                                    0
                                                ],
                                                [
                                                    -0.459,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.213,
                                                    -0.352
                                                ],
                                                [
                                                    0.448,
                                                    -0.288
                                                ],
                                                [
                                                    0.746,
                                                    0
                                                ],
                                                [
                                                    0.544,
                                                    0.363
                                                ],
                                                [
                                                    0.298,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.907
                                                ],
                                                [
                                                    -0.299,
                                                    0.661
                                                ],
                                                [
                                                    -0.544,
                                                    0.363
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    131.122,
                                                    4.672
                                                ],
                                                [
                                                    129.554,
                                                    4.288
                                                ],
                                                [
                                                    128.498,
                                                    3.2
                                                ],
                                                [
                                                    128.45,
                                                    4.48
                                                ],
                                                [
                                                    127.234,
                                                    4.48
                                                ],
                                                [
                                                    127.234,
                                                    -6.88
                                                ],
                                                [
                                                    128.578,
                                                    -6.88
                                                ],
                                                [
                                                    128.578,
                                                    -2.816
                                                ],
                                                [
                                                    129.57,
                                                    -3.76
                                                ],
                                                [
                                                    131.122,
                                                    -4.192
                                                ],
                                                [
                                                    133.058,
                                                    -3.648
                                                ],
                                                [
                                                    134.322,
                                                    -2.112
                                                ],
                                                [
                                                    134.769,
                                                    0.24
                                                ],
                                                [
                                                    134.322,
                                                    2.592
                                                ],
                                                [
                                                    133.058,
                                                    4.128
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 56",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.512,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.565
                                                ],
                                                [
                                                    0,
                                                    0.971
                                                ],
                                                [
                                                    0.416,
                                                    0.555
                                                ],
                                                [
                                                    0.693,
                                                    0
                                                ],
                                                [
                                                    0.373,
                                                    -0.256
                                                ],
                                                [
                                                    0.202,
                                                    -0.469
                                                ],
                                                [
                                                    0,
                                                    -0.661
                                                ],
                                                [
                                                    -0.192,
                                                    -0.48
                                                ],
                                                [
                                                    -0.363,
                                                    -0.256
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.714,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    -0.565
                                                ],
                                                [
                                                    0,
                                                    -0.981
                                                ],
                                                [
                                                    -0.416,
                                                    -0.565
                                                ],
                                                [
                                                    -0.523,
                                                    0
                                                ],
                                                [
                                                    -0.374,
                                                    0.245
                                                ],
                                                [
                                                    -0.192,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0.64
                                                ],
                                                [
                                                    0.202,
                                                    0.469
                                                ],
                                                [
                                                    0.373,
                                                    0.256
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    131.042,
                                                    3.392
                                                ],
                                                [
                                                    132.738,
                                                    2.544
                                                ],
                                                [
                                                    133.362,
                                                    0.24
                                                ],
                                                [
                                                    132.738,
                                                    -2.064
                                                ],
                                                [
                                                    131.074,
                                                    -2.912
                                                ],
                                                [
                                                    129.73,
                                                    -2.528
                                                ],
                                                [
                                                    128.866,
                                                    -1.456
                                                ],
                                                [
                                                    128.578,
                                                    0.24
                                                ],
                                                [
                                                    128.866,
                                                    1.92
                                                ],
                                                [
                                                    129.714,
                                                    3.008
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 57",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.48,
                                                    0
                                                ],
                                                [
                                                    0.522,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    -0.427,
                                                    0.416
                                                ],
                                                [
                                                    -0.928,
                                                    0.171
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.341,
                                                    0.352
                                                ],
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.341,
                                                    -0.267
                                                ],
                                                [
                                                    0.128,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.608,
                                                    0.491
                                                ],
                                                [
                                                    -0.96,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.619
                                                ],
                                                [
                                                    0,
                                                    -1.077
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.085
                                                ],
                                                [
                                                    -0.16,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.096,
                                                    0
                                                ],
                                                [
                                                    0.106,
                                                    0
                                                ],
                                                [
                                                    0.245,
                                                    0.117
                                                ],
                                                [
                                                    0.106,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.299
                                                ],
                                                [
                                                    0.426,
                                                    -0.171
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.875,
                                                    0
                                                ],
                                                [
                                                    -0.512,
                                                    -0.405
                                                ],
                                                [
                                                    0,
                                                    -0.725
                                                ],
                                                [
                                                    0.426,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.715
                                                ],
                                                [
                                                    -0.331,
                                                    -0.352
                                                ],
                                                [
                                                    -0.587,
                                                    0
                                                ],
                                                [
                                                    -0.342,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.16,
                                                    -0.8
                                                ],
                                                [
                                                    0.618,
                                                    -0.501
                                                ],
                                                [
                                                    1.088,
                                                    0
                                                ],
                                                [
                                                    0.576,
                                                    0.608
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.192
                                                ],
                                                [
                                                    0.074,
                                                    0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.043,
                                                    0.011
                                                ],
                                                [
                                                    -0.096,
                                                    0.011
                                                ],
                                                [
                                                    -0.384,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    -0.128
                                                ],
                                                [
                                                    -0.107,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    0.363
                                                ],
                                                [
                                                    -0.288,
                                                    0.288
                                                ],
                                                [
                                                    -0.427,
                                                    0.16
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    139.1,
                                                    4.672
                                                ],
                                                [
                                                    137.004,
                                                    4.064
                                                ],
                                                [
                                                    136.236,
                                                    2.368
                                                ],
                                                [
                                                    136.876,
                                                    0.656
                                                ],
                                                [
                                                    138.908,
                                                    -0.224
                                                ],
                                                [
                                                    141.916,
                                                    -0.784
                                                ],
                                                [
                                                    141.404,
                                                    -2.384
                                                ],
                                                [
                                                    139.9,
                                                    -2.912
                                                ],
                                                [
                                                    138.508,
                                                    -2.512
                                                ],
                                                [
                                                    137.804,
                                                    -1.392
                                                ],
                                                [
                                                    136.38,
                                                    -1.504
                                                ],
                                                [
                                                    137.532,
                                                    -3.44
                                                ],
                                                [
                                                    139.9,
                                                    -4.192
                                                ],
                                                [
                                                    142.396,
                                                    -3.264
                                                ],
                                                [
                                                    143.26,
                                                    -0.736
                                                ],
                                                [
                                                    143.26,
                                                    2.768
                                                ],
                                                [
                                                    143.356,
                                                    3.184
                                                ],
                                                [
                                                    143.708,
                                                    3.296
                                                ],
                                                [
                                                    144.044,
                                                    3.296
                                                ],
                                                [
                                                    144.044,
                                                    4.48
                                                ],
                                                [
                                                    143.836,
                                                    4.496
                                                ],
                                                [
                                                    143.532,
                                                    4.512
                                                ],
                                                [
                                                    142.588,
                                                    4.336
                                                ],
                                                [
                                                    142.076,
                                                    3.76
                                                ],
                                                [
                                                    141.916,
                                                    2.72
                                                ],
                                                [
                                                    142.076,
                                                    2.752
                                                ],
                                                [
                                                    141.532,
                                                    3.744
                                                ],
                                                [
                                                    140.46,
                                                    4.432
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 58",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.491,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    0.213
                                                ],
                                                [
                                                    -0.214,
                                                    0.373
                                                ],
                                                [
                                                    0,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.224,
                                                    -0.224
                                                ],
                                                [
                                                    0,
                                                    -0.352
                                                ],
                                                [
                                                    -0.278,
                                                    -0.224
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.565,
                                                    0
                                                ],
                                                [
                                                    0.405,
                                                    -0.224
                                                ],
                                                [
                                                    0.213,
                                                    -0.384
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    0.107
                                                ],
                                                [
                                                    -0.214,
                                                    0.213
                                                ],
                                                [
                                                    0,
                                                    0.395
                                                ],
                                                [
                                                    0.288,
                                                    0.213
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    139.228,
                                                    3.488
                                                ],
                                                [
                                                    140.668,
                                                    3.168
                                                ],
                                                [
                                                    141.596,
                                                    2.272
                                                ],
                                                [
                                                    141.916,
                                                    0.992
                                                ],
                                                [
                                                    141.916,
                                                    0.384
                                                ],
                                                [
                                                    139.164,
                                                    0.896
                                                ],
                                                [
                                                    137.964,
                                                    1.392
                                                ],
                                                [
                                                    137.644,
                                                    2.24
                                                ],
                                                [
                                                    138.06,
                                                    3.168
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 59",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.939,
                                                    0
                                                ],
                                                [
                                                    0.534,
                                                    0.245
                                                ],
                                                [
                                                    0.288,
                                                    0.427
                                                ],
                                                [
                                                    0.043,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.33,
                                                    -0.309
                                                ],
                                                [
                                                    -0.746,
                                                    0
                                                ],
                                                [
                                                    -0.309,
                                                    0.181
                                                ],
                                                [
                                                    0,
                                                    0.416
                                                ],
                                                [
                                                    0.107,
                                                    0.149
                                                ],
                                                [
                                                    0.299,
                                                    0.107
                                                ],
                                                [
                                                    0.576,
                                                    0.107
                                                ],
                                                [
                                                    0.448,
                                                    0.224
                                                ],
                                                [
                                                    0.182,
                                                    0.32
                                                ],
                                                [
                                                    0,
                                                    0.448
                                                ],
                                                [
                                                    -0.554,
                                                    0.48
                                                ],
                                                [
                                                    -1.024,
                                                    0
                                                ],
                                                [
                                                    -0.469,
                                                    -0.267
                                                ],
                                                [
                                                    -0.245,
                                                    -0.416
                                                ],
                                                [
                                                    -0.053,
                                                    -0.459
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.139,
                                                    0.235
                                                ],
                                                [
                                                    0.278,
                                                    0.139
                                                ],
                                                [
                                                    0.47,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    -0.363
                                                ],
                                                [
                                                    -0.106,
                                                    -0.181
                                                ],
                                                [
                                                    -0.277,
                                                    -0.117
                                                ],
                                                [
                                                    -0.49,
                                                    -0.085
                                                ],
                                                [
                                                    -0.469,
                                                    -0.213
                                                ],
                                                [
                                                    -0.181,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.448
                                                ],
                                                [
                                                    0.608,
                                                    -0.437
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.522,
                                                    -0.245
                                                ],
                                                [
                                                    -0.277,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.086,
                                                    0.512
                                                ],
                                                [
                                                    0.342,
                                                    0.299
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    -0.224
                                                ],
                                                [
                                                    -0.096,
                                                    -0.149
                                                ],
                                                [
                                                    -0.298,
                                                    -0.117
                                                ],
                                                [
                                                    -0.789,
                                                    -0.149
                                                ],
                                                [
                                                    -0.448,
                                                    -0.224
                                                ],
                                                [
                                                    -0.181,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.757
                                                ],
                                                [
                                                    0.566,
                                                    -0.491
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    0.256
                                                ],
                                                [
                                                    0.246,
                                                    0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.021,
                                                    -0.267
                                                ],
                                                [
                                                    -0.138,
                                                    -0.235
                                                ],
                                                [
                                                    -0.277,
                                                    -0.149
                                                ],
                                                [
                                                    -0.608,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0.277
                                                ],
                                                [
                                                    0.118,
                                                    0.171
                                                ],
                                                [
                                                    0.288,
                                                    0.107
                                                ],
                                                [
                                                    0.832,
                                                    0.139
                                                ],
                                                [
                                                    0.47,
                                                    0.213
                                                ],
                                                [
                                                    0.192,
                                                    0.309
                                                ],
                                                [
                                                    0,
                                                    0.779
                                                ],
                                                [
                                                    -0.597,
                                                    0.427
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    148.618,
                                                    4.672
                                                ],
                                                [
                                                    146.65,
                                                    4.304
                                                ],
                                                [
                                                    145.434,
                                                    3.296
                                                ],
                                                [
                                                    144.954,
                                                    1.808
                                                ],
                                                [
                                                    146.362,
                                                    1.712
                                                ],
                                                [
                                                    146.986,
                                                    2.944
                                                ],
                                                [
                                                    148.618,
                                                    3.392
                                                ],
                                                [
                                                    149.946,
                                                    3.12
                                                ],
                                                [
                                                    150.426,
                                                    2.208
                                                ],
                                                [
                                                    150.266,
                                                    1.648
                                                ],
                                                [
                                                    149.674,
                                                    1.264
                                                ],
                                                [
                                                    148.362,
                                                    0.928
                                                ],
                                                [
                                                    146.506,
                                                    0.368
                                                ],
                                                [
                                                    145.562,
                                                    -0.448
                                                ],
                                                [
                                                    145.29,
                                                    -1.6
                                                ],
                                                [
                                                    146.122,
                                                    -3.456
                                                ],
                                                [
                                                    148.506,
                                                    -4.192
                                                ],
                                                [
                                                    150.33,
                                                    -3.792
                                                ],
                                                [
                                                    151.418,
                                                    -2.784
                                                ],
                                                [
                                                    151.866,
                                                    -1.472
                                                ],
                                                [
                                                    150.458,
                                                    -1.376
                                                ],
                                                [
                                                    150.218,
                                                    -2.128
                                                ],
                                                [
                                                    149.594,
                                                    -2.688
                                                ],
                                                [
                                                    148.474,
                                                    -2.912
                                                ],
                                                [
                                                    147.13,
                                                    -2.56
                                                ],
                                                [
                                                    146.698,
                                                    -1.664
                                                ],
                                                [
                                                    146.858,
                                                    -0.976
                                                ],
                                                [
                                                    147.45,
                                                    -0.544
                                                ],
                                                [
                                                    148.618,
                                                    -0.256
                                                ],
                                                [
                                                    150.57,
                                                    0.272
                                                ],
                                                [
                                                    151.546,
                                                    1.072
                                                ],
                                                [
                                                    151.834,
                                                    2.208
                                                ],
                                                [
                                                    150.922,
                                                    4.032
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 60",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.896,
                                                    0
                                                ],
                                                [
                                                    0.586,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.31,
                                                    0.661
                                                ],
                                                [
                                                    -0.566,
                                                    0.363
                                                ],
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.566,
                                                    -0.352
                                                ],
                                                [
                                                    -0.31,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.949
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    -0.459
                                                ],
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.256
                                                ],
                                                [
                                                    -0.139,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.629,
                                                    -0.491
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.8,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.363
                                                ],
                                                [
                                                    -0.31,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.576,
                                                    -0.373
                                                ],
                                                [
                                                    0.736,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    0.341
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.053,
                                                    0.907
                                                ],
                                                [
                                                    0.437,
                                                    0.459
                                                ],
                                                [
                                                    0.554,
                                                    0
                                                ],
                                                [
                                                    0.362,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    0.757
                                                ],
                                                [
                                                    -0.619,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    156.999,
                                                    4.672
                                                ],
                                                [
                                                    154.919,
                                                    4.128
                                                ],
                                                [
                                                    153.575,
                                                    2.592
                                                ],
                                                [
                                                    153.111,
                                                    0.24
                                                ],
                                                [
                                                    153.575,
                                                    -2.096
                                                ],
                                                [
                                                    154.903,
                                                    -3.632
                                                ],
                                                [
                                                    156.935,
                                                    -4.192
                                                ],
                                                [
                                                    158.887,
                                                    -3.664
                                                ],
                                                [
                                                    160.199,
                                                    -2.16
                                                ],
                                                [
                                                    160.679,
                                                    0.256
                                                ],
                                                [
                                                    160.679,
                                                    0.656
                                                ],
                                                [
                                                    154.519,
                                                    0.656
                                                ],
                                                [
                                                    155.239,
                                                    2.704
                                                ],
                                                [
                                                    156.999,
                                                    3.392
                                                ],
                                                [
                                                    158.359,
                                                    3.008
                                                ],
                                                [
                                                    159.111,
                                                    1.968
                                                ],
                                                [
                                                    160.551,
                                                    2.08
                                                ],
                                                [
                                                    159.271,
                                                    3.952
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 61",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.117,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    0.384
                                                ],
                                                [
                                                    0.629,
                                                    0
                                                ],
                                                [
                                                    0.426,
                                                    -0.405
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.821
                                                ],
                                                [
                                                    -0.406,
                                                    -0.384
                                                ],
                                                [
                                                    -0.651,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.395
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    154.519,
                                                    -0.528
                                                ],
                                                [
                                                    159.207,
                                                    -0.528
                                                ],
                                                [
                                                    158.487,
                                                    -2.336
                                                ],
                                                [
                                                    156.935,
                                                    -2.912
                                                ],
                                                [
                                                    155.319,
                                                    -2.304
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 62",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    162.079,
                                                    4.48
                                                ],
                                                [
                                                    162.079,
                                                    2.672
                                                ],
                                                [
                                                    163.887,
                                                    2.672
                                                ],
                                                [
                                                    163.887,
                                                    4.48
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4588,
                                            0.4588,
                                            0.4588
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            203.359,
                                            487.52
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 9",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.906,
                                                    0
                                                ],
                                                [
                                                    0.767,
                                                    0.469
                                                ],
                                                [
                                                    0.427,
                                                    0.885
                                                ],
                                                [
                                                    0,
                                                    1.227
                                                ],
                                                [
                                                    -0.426,
                                                    0.885
                                                ],
                                                [
                                                    -0.768,
                                                    0.48
                                                ],
                                                [
                                                    -1.014,
                                                    0
                                                ],
                                                [
                                                    -0.758,
                                                    -0.693
                                                ],
                                                [
                                                    -0.234,
                                                    -1.195
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.523,
                                                    0.469
                                                ],
                                                [
                                                    0.949,
                                                    0
                                                ],
                                                [
                                                    0.555,
                                                    -0.373
                                                ],
                                                [
                                                    0.31,
                                                    -0.693
                                                ],
                                                [
                                                    0,
                                                    -0.96
                                                ],
                                                [
                                                    -0.309,
                                                    -0.683
                                                ],
                                                [
                                                    -0.544,
                                                    -0.363
                                                ],
                                                [
                                                    -0.726,
                                                    0
                                                ],
                                                [
                                                    -0.544,
                                                    0.512
                                                ],
                                                [
                                                    -0.139,
                                                    0.885
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    -0.619
                                                ],
                                                [
                                                    0.672,
                                                    -0.352
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.014,
                                                    0
                                                ],
                                                [
                                                    -0.768,
                                                    -0.48
                                                ],
                                                [
                                                    -0.426,
                                                    -0.885
                                                ],
                                                [
                                                    0,
                                                    -1.227
                                                ],
                                                [
                                                    0.427,
                                                    -0.896
                                                ],
                                                [
                                                    0.767,
                                                    -0.48
                                                ],
                                                [
                                                    1.375,
                                                    0
                                                ],
                                                [
                                                    0.757,
                                                    0.693
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.16,
                                                    -0.811
                                                ],
                                                [
                                                    -0.522,
                                                    -0.469
                                                ],
                                                [
                                                    -0.726,
                                                    0
                                                ],
                                                [
                                                    -0.544,
                                                    0.363
                                                ],
                                                [
                                                    -0.309,
                                                    0.683
                                                ],
                                                [
                                                    0,
                                                    0.96
                                                ],
                                                [
                                                    0.31,
                                                    0.683
                                                ],
                                                [
                                                    0.555,
                                                    0.363
                                                ],
                                                [
                                                    0.992,
                                                    0
                                                ],
                                                [
                                                    0.544,
                                                    -0.523
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.139,
                                                    0.821
                                                ],
                                                [
                                                    -0.405,
                                                    0.619
                                                ],
                                                [
                                                    -0.661,
                                                    0.341
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -146.445,
                                                    -3.564
                                                ],
                                                [
                                                    -149.117,
                                                    -4.268
                                                ],
                                                [
                                                    -150.91,
                                                    -6.316
                                                ],
                                                [
                                                    -151.549,
                                                    -9.484
                                                ],
                                                [
                                                    -150.91,
                                                    -12.652
                                                ],
                                                [
                                                    -149.117,
                                                    -14.716
                                                ],
                                                [
                                                    -146.445,
                                                    -15.436
                                                ],
                                                [
                                                    -143.245,
                                                    -14.396
                                                ],
                                                [
                                                    -141.758,
                                                    -11.564
                                                ],
                                                [
                                                    -143.214,
                                                    -11.468
                                                ],
                                                [
                                                    -144.238,
                                                    -13.388
                                                ],
                                                [
                                                    -146.445,
                                                    -14.092
                                                ],
                                                [
                                                    -148.366,
                                                    -13.532
                                                ],
                                                [
                                                    -149.646,
                                                    -11.948
                                                ],
                                                [
                                                    -150.109,
                                                    -9.484
                                                ],
                                                [
                                                    -149.646,
                                                    -7.02
                                                ],
                                                [
                                                    -148.366,
                                                    -5.452
                                                ],
                                                [
                                                    -146.445,
                                                    -4.908
                                                ],
                                                [
                                                    -144.142,
                                                    -5.676
                                                ],
                                                [
                                                    -143.117,
                                                    -7.788
                                                ],
                                                [
                                                    -141.661,
                                                    -7.692
                                                ],
                                                [
                                                    -142.478,
                                                    -5.532
                                                ],
                                                [
                                                    -144.094,
                                                    -4.076
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.779,
                                                    0
                                                ],
                                                [
                                                    0.586,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.32,
                                                    0.661
                                                ],
                                                [
                                                    -0.587,
                                                    0.363
                                                ],
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.575,
                                                    -0.363
                                                ],
                                                [
                                                    -0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.907
                                                ],
                                                [
                                                    0.32,
                                                    -0.672
                                                ],
                                                [
                                                    0.587,
                                                    -0.363
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.587,
                                                    -0.363
                                                ],
                                                [
                                                    -0.32,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.907
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.586,
                                                    -0.363
                                                ],
                                                [
                                                    0.779,
                                                    0
                                                ],
                                                [
                                                    0.587,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.32,
                                                    0.661
                                                ],
                                                [
                                                    -0.575,
                                                    0.363
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -136.553,
                                                    -3.628
                                                ],
                                                [
                                                    -138.6,
                                                    -4.172
                                                ],
                                                [
                                                    -139.961,
                                                    -5.708
                                                ],
                                                [
                                                    -140.441,
                                                    -8.06
                                                ],
                                                [
                                                    -139.961,
                                                    -10.412
                                                ],
                                                [
                                                    -138.6,
                                                    -11.948
                                                ],
                                                [
                                                    -136.553,
                                                    -12.492
                                                ],
                                                [
                                                    -134.521,
                                                    -11.948
                                                ],
                                                [
                                                    -133.16,
                                                    -10.412
                                                ],
                                                [
                                                    -132.68,
                                                    -8.06
                                                ],
                                                [
                                                    -133.16,
                                                    -5.708
                                                ],
                                                [
                                                    -134.521,
                                                    -4.172
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.426,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0.981
                                                ],
                                                [
                                                    0.438,
                                                    0.555
                                                ],
                                                [
                                                    0.779,
                                                    0
                                                ],
                                                [
                                                    0.437,
                                                    -0.565
                                                ],
                                                [
                                                    0,
                                                    -0.981
                                                ],
                                                [
                                                    -0.438,
                                                    -0.565
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.779,
                                                    0
                                                ],
                                                [
                                                    0.438,
                                                    -0.565
                                                ],
                                                [
                                                    0,
                                                    -0.981
                                                ],
                                                [
                                                    -0.426,
                                                    -0.565
                                                ],
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.438,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0.981
                                                ],
                                                [
                                                    0.437,
                                                    0.555
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -136.553,
                                                    -4.908
                                                ],
                                                [
                                                    -134.745,
                                                    -5.74
                                                ],
                                                [
                                                    -134.089,
                                                    -8.06
                                                ],
                                                [
                                                    -134.745,
                                                    -10.364
                                                ],
                                                [
                                                    -136.553,
                                                    -11.212
                                                ],
                                                [
                                                    -138.376,
                                                    -10.364
                                                ],
                                                [
                                                    -139.033,
                                                    -8.06
                                                ],
                                                [
                                                    -138.376,
                                                    -5.74
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.267,
                                                    0.32
                                                ],
                                                [
                                                    -0.373,
                                                    0.16
                                                ],
                                                [
                                                    -0.437,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    -0.288
                                                ],
                                                [
                                                    -0.202,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    -0.597
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.128,
                                                    0.352
                                                ],
                                                [
                                                    0.267,
                                                    0.181
                                                ],
                                                [
                                                    0.427,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.107,
                                                    -0.501
                                                ],
                                                [
                                                    0.267,
                                                    -0.331
                                                ],
                                                [
                                                    0.384,
                                                    -0.16
                                                ],
                                                [
                                                    0.651,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    0.288
                                                ],
                                                [
                                                    0.214,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    -0.117,
                                                    -0.363
                                                ],
                                                [
                                                    -0.267,
                                                    -0.192
                                                ],
                                                [
                                                    -0.65,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -130.849,
                                                    -3.82
                                                ],
                                                [
                                                    -130.849,
                                                    -12.3
                                                ],
                                                [
                                                    -129.617,
                                                    -12.3
                                                ],
                                                [
                                                    -129.569,
                                                    -10.14
                                                ],
                                                [
                                                    -129.729,
                                                    -10.284
                                                ],
                                                [
                                                    -129.169,
                                                    -11.516
                                                ],
                                                [
                                                    -128.209,
                                                    -12.252
                                                ],
                                                [
                                                    -126.977,
                                                    -12.492
                                                ],
                                                [
                                                    -125.377,
                                                    -12.06
                                                ],
                                                [
                                                    -124.433,
                                                    -10.892
                                                ],
                                                [
                                                    -124.113,
                                                    -9.276
                                                ],
                                                [
                                                    -124.113,
                                                    -3.82
                                                ],
                                                [
                                                    -125.457,
                                                    -3.82
                                                ],
                                                [
                                                    -125.457,
                                                    -8.892
                                                ],
                                                [
                                                    -125.649,
                                                    -10.204
                                                ],
                                                [
                                                    -126.225,
                                                    -11.02
                                                ],
                                                [
                                                    -127.265,
                                                    -11.308
                                                ],
                                                [
                                                    -128.881,
                                                    -10.684
                                                ],
                                                [
                                                    -129.505,
                                                    -8.892
                                                ],
                                                [
                                                    -129.505,
                                                    -3.82
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.266,
                                                    0.32
                                                ],
                                                [
                                                    -0.373,
                                                    0.16
                                                ],
                                                [
                                                    -0.437,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    -0.288
                                                ],
                                                [
                                                    -0.202,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    -0.597
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.128,
                                                    0.352
                                                ],
                                                [
                                                    0.267,
                                                    0.181
                                                ],
                                                [
                                                    0.427,
                                                    0
                                                ],
                                                [
                                                    0.426,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.106,
                                                    -0.501
                                                ],
                                                [
                                                    0.267,
                                                    -0.331
                                                ],
                                                [
                                                    0.385,
                                                    -0.16
                                                ],
                                                [
                                                    0.651,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    0.288
                                                ],
                                                [
                                                    0.214,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    -0.118,
                                                    -0.363
                                                ],
                                                [
                                                    -0.266,
                                                    -0.192
                                                ],
                                                [
                                                    -0.65,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -121.865,
                                                    -3.82
                                                ],
                                                [
                                                    -121.865,
                                                    -12.3
                                                ],
                                                [
                                                    -120.632,
                                                    -12.3
                                                ],
                                                [
                                                    -120.585,
                                                    -10.14
                                                ],
                                                [
                                                    -120.744,
                                                    -10.284
                                                ],
                                                [
                                                    -120.185,
                                                    -11.516
                                                ],
                                                [
                                                    -119.225,
                                                    -12.252
                                                ],
                                                [
                                                    -117.993,
                                                    -12.492
                                                ],
                                                [
                                                    -116.393,
                                                    -12.06
                                                ],
                                                [
                                                    -115.449,
                                                    -10.892
                                                ],
                                                [
                                                    -115.129,
                                                    -9.276
                                                ],
                                                [
                                                    -115.129,
                                                    -3.82
                                                ],
                                                [
                                                    -116.473,
                                                    -3.82
                                                ],
                                                [
                                                    -116.473,
                                                    -8.892
                                                ],
                                                [
                                                    -116.664,
                                                    -10.204
                                                ],
                                                [
                                                    -117.241,
                                                    -11.02
                                                ],
                                                [
                                                    -118.281,
                                                    -11.308
                                                ],
                                                [
                                                    -119.896,
                                                    -10.684
                                                ],
                                                [
                                                    -120.521,
                                                    -8.892
                                                ],
                                                [
                                                    -120.521,
                                                    -3.82
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.896,
                                                    0
                                                ],
                                                [
                                                    0.586,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.309,
                                                    0.661
                                                ],
                                                [
                                                    -0.565,
                                                    0.363
                                                ],
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    -0.352
                                                ],
                                                [
                                                    -0.309,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.949
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    -0.459
                                                ],
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.256
                                                ],
                                                [
                                                    -0.139,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.629,
                                                    -0.491
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.8,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.363
                                                ],
                                                [
                                                    -0.309,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.576,
                                                    -0.373
                                                ],
                                                [
                                                    0.736,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    0.341
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.053,
                                                    0.907
                                                ],
                                                [
                                                    0.437,
                                                    0.459
                                                ],
                                                [
                                                    0.554,
                                                    0
                                                ],
                                                [
                                                    0.363,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    0.757
                                                ],
                                                [
                                                    -0.619,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -109.443,
                                                    -3.628
                                                ],
                                                [
                                                    -111.523,
                                                    -4.172
                                                ],
                                                [
                                                    -112.867,
                                                    -5.708
                                                ],
                                                [
                                                    -113.331,
                                                    -8.06
                                                ],
                                                [
                                                    -112.867,
                                                    -10.396
                                                ],
                                                [
                                                    -111.539,
                                                    -11.932
                                                ],
                                                [
                                                    -109.507,
                                                    -12.492
                                                ],
                                                [
                                                    -107.555,
                                                    -11.964
                                                ],
                                                [
                                                    -106.243,
                                                    -10.46
                                                ],
                                                [
                                                    -105.763,
                                                    -8.044
                                                ],
                                                [
                                                    -105.763,
                                                    -7.644
                                                ],
                                                [
                                                    -111.923,
                                                    -7.644
                                                ],
                                                [
                                                    -111.203,
                                                    -5.596
                                                ],
                                                [
                                                    -109.443,
                                                    -4.908
                                                ],
                                                [
                                                    -108.083,
                                                    -5.292
                                                ],
                                                [
                                                    -107.331,
                                                    -6.332
                                                ],
                                                [
                                                    -105.891,
                                                    -6.22
                                                ],
                                                [
                                                    -107.171,
                                                    -4.348
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.117,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    0.384
                                                ],
                                                [
                                                    0.629,
                                                    0
                                                ],
                                                [
                                                    0.426,
                                                    -0.405
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.821
                                                ],
                                                [
                                                    -0.406,
                                                    -0.384
                                                ],
                                                [
                                                    -0.651,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.395
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -111.923,
                                                    -8.828
                                                ],
                                                [
                                                    -107.235,
                                                    -8.828
                                                ],
                                                [
                                                    -107.955,
                                                    -10.636
                                                ],
                                                [
                                                    -109.507,
                                                    -11.212
                                                ],
                                                [
                                                    -111.123,
                                                    -10.604
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.651,
                                                    0
                                                ],
                                                [
                                                    0.587,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.32,
                                                    0.661
                                                ],
                                                [
                                                    -0.576,
                                                    0.363
                                                ],
                                                [
                                                    -0.789,
                                                    0
                                                ],
                                                [
                                                    -0.501,
                                                    -0.235
                                                ],
                                                [
                                                    -0.32,
                                                    -0.437
                                                ],
                                                [
                                                    -0.096,
                                                    -0.629
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.395,
                                                    0.299
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0.438,
                                                    -0.565
                                                ],
                                                [
                                                    0,
                                                    -0.981
                                                ],
                                                [
                                                    -0.437,
                                                    -0.565
                                                ],
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.394,
                                                    0.32
                                                ],
                                                [
                                                    -0.096,
                                                    0.64
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.469
                                                ],
                                                [
                                                    0.512,
                                                    -0.256
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.789,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.363
                                                ],
                                                [
                                                    -0.32,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.587,
                                                    -0.373
                                                ],
                                                [
                                                    0.651,
                                                    0
                                                ],
                                                [
                                                    0.512,
                                                    0.224
                                                ],
                                                [
                                                    0.32,
                                                    0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.096,
                                                    -0.565
                                                ],
                                                [
                                                    -0.394,
                                                    -0.309
                                                ],
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.437,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0.981
                                                ],
                                                [
                                                    0.438,
                                                    0.555
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0.395,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.096,
                                                    0.629
                                                ],
                                                [
                                                    -0.32,
                                                    0.459
                                                ],
                                                [
                                                    -0.501,
                                                    0.256
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -100.631,
                                                    -3.628
                                                ],
                                                [
                                                    -102.695,
                                                    -4.172
                                                ],
                                                [
                                                    -104.039,
                                                    -5.708
                                                ],
                                                [
                                                    -104.519,
                                                    -8.06
                                                ],
                                                [
                                                    -104.039,
                                                    -10.396
                                                ],
                                                [
                                                    -102.695,
                                                    -11.932
                                                ],
                                                [
                                                    -100.631,
                                                    -12.492
                                                ],
                                                [
                                                    -98.903,
                                                    -12.14
                                                ],
                                                [
                                                    -97.655,
                                                    -11.148
                                                ],
                                                [
                                                    -97.031,
                                                    -9.548
                                                ],
                                                [
                                                    -98.439,
                                                    -9.452
                                                ],
                                                [
                                                    -99.175,
                                                    -10.748
                                                ],
                                                [
                                                    -100.631,
                                                    -11.212
                                                ],
                                                [
                                                    -102.455,
                                                    -10.364
                                                ],
                                                [
                                                    -103.111,
                                                    -8.06
                                                ],
                                                [
                                                    -102.455,
                                                    -5.74
                                                ],
                                                [
                                                    -100.631,
                                                    -4.908
                                                ],
                                                [
                                                    -99.175,
                                                    -5.388
                                                ],
                                                [
                                                    -98.439,
                                                    -6.828
                                                ],
                                                [
                                                    -97.031,
                                                    -6.732
                                                ],
                                                [
                                                    -97.655,
                                                    -5.084
                                                ],
                                                [
                                                    -98.903,
                                                    -4.012
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.374,
                                                    0.352
                                                ],
                                                [
                                                    0,
                                                    0.747
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.17,
                                                    -0.149
                                                ],
                                                [
                                                    -0.352,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.768,
                                                    0
                                                ],
                                                [
                                                    -0.362,
                                                    -0.352
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.384
                                                ],
                                                [
                                                    0.171,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -92.589,
                                                    -3.82
                                                ],
                                                [
                                                    -94.301,
                                                    -4.348
                                                ],
                                                [
                                                    -94.845,
                                                    -5.996
                                                ],
                                                [
                                                    -94.845,
                                                    -14.284
                                                ],
                                                [
                                                    -93.501,
                                                    -14.284
                                                ],
                                                [
                                                    -93.501,
                                                    -6.028
                                                ],
                                                [
                                                    -93.245,
                                                    -5.228
                                                ],
                                                [
                                                    -92.461,
                                                    -5.004
                                                ],
                                                [
                                                    -91.245,
                                                    -5.004
                                                ],
                                                [
                                                    -91.245,
                                                    -3.82
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -96.093,
                                                    -11.116
                                                ],
                                                [
                                                    -96.093,
                                                    -12.3
                                                ],
                                                [
                                                    -91.245,
                                                    -12.3
                                                ],
                                                [
                                                    -91.245,
                                                    -11.116
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.939,
                                                    0
                                                ],
                                                [
                                                    0.534,
                                                    0.245
                                                ],
                                                [
                                                    0.288,
                                                    0.427
                                                ],
                                                [
                                                    0.042,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.331,
                                                    -0.309
                                                ],
                                                [
                                                    -0.747,
                                                    0
                                                ],
                                                [
                                                    -0.311,
                                                    0.181
                                                ],
                                                [
                                                    0,
                                                    0.416
                                                ],
                                                [
                                                    0.105,
                                                    0.149
                                                ],
                                                [
                                                    0.299,
                                                    0.107
                                                ],
                                                [
                                                    0.576,
                                                    0.107
                                                ],
                                                [
                                                    0.448,
                                                    0.224
                                                ],
                                                [
                                                    0.181,
                                                    0.32
                                                ],
                                                [
                                                    0,
                                                    0.448
                                                ],
                                                [
                                                    -0.555,
                                                    0.48
                                                ],
                                                [
                                                    -1.024,
                                                    0
                                                ],
                                                [
                                                    -0.47,
                                                    -0.267
                                                ],
                                                [
                                                    -0.247,
                                                    -0.416
                                                ],
                                                [
                                                    -0.055,
                                                    -0.459
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.138,
                                                    0.235
                                                ],
                                                [
                                                    0.277,
                                                    0.139
                                                ],
                                                [
                                                    0.469,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    -0.363
                                                ],
                                                [
                                                    -0.106,
                                                    -0.181
                                                ],
                                                [
                                                    -0.278,
                                                    -0.117
                                                ],
                                                [
                                                    -0.49,
                                                    -0.085
                                                ],
                                                [
                                                    -0.47,
                                                    -0.213
                                                ],
                                                [
                                                    -0.182,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.448
                                                ],
                                                [
                                                    0.608,
                                                    -0.437
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.522,
                                                    -0.245
                                                ],
                                                [
                                                    -0.278,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.086,
                                                    0.512
                                                ],
                                                [
                                                    0.34,
                                                    0.299
                                                ],
                                                [
                                                    0.577,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    -0.224
                                                ],
                                                [
                                                    -0.096,
                                                    -0.149
                                                ],
                                                [
                                                    -0.298,
                                                    -0.117
                                                ],
                                                [
                                                    -0.789,
                                                    -0.149
                                                ],
                                                [
                                                    -0.447,
                                                    -0.224
                                                ],
                                                [
                                                    -0.181,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.757
                                                ],
                                                [
                                                    0.565,
                                                    -0.491
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.481,
                                                    0.256
                                                ],
                                                [
                                                    0.244,
                                                    0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.023,
                                                    -0.267
                                                ],
                                                [
                                                    -0.139,
                                                    -0.235
                                                ],
                                                [
                                                    -0.278,
                                                    -0.149
                                                ],
                                                [
                                                    -0.607,
                                                    0
                                                ],
                                                [
                                                    -0.289,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0.277
                                                ],
                                                [
                                                    0.118,
                                                    0.171
                                                ],
                                                [
                                                    0.289,
                                                    0.107
                                                ],
                                                [
                                                    0.832,
                                                    0.139
                                                ],
                                                [
                                                    0.468,
                                                    0.213
                                                ],
                                                [
                                                    0.192,
                                                    0.309
                                                ],
                                                [
                                                    0,
                                                    0.779
                                                ],
                                                [
                                                    -0.598,
                                                    0.427
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -86.589,
                                                    -3.628
                                                ],
                                                [
                                                    -88.557,
                                                    -3.996
                                                ],
                                                [
                                                    -89.772,
                                                    -5.004
                                                ],
                                                [
                                                    -90.253,
                                                    -6.492
                                                ],
                                                [
                                                    -88.845,
                                                    -6.588
                                                ],
                                                [
                                                    -88.22,
                                                    -5.356
                                                ],
                                                [
                                                    -86.589,
                                                    -4.908
                                                ],
                                                [
                                                    -85.26,
                                                    -5.18
                                                ],
                                                [
                                                    -84.781,
                                                    -6.092
                                                ],
                                                [
                                                    -84.94,
                                                    -6.652
                                                ],
                                                [
                                                    -85.533,
                                                    -7.036
                                                ],
                                                [
                                                    -86.845,
                                                    -7.372
                                                ],
                                                [
                                                    -88.701,
                                                    -7.932
                                                ],
                                                [
                                                    -89.645,
                                                    -8.748
                                                ],
                                                [
                                                    -89.917,
                                                    -9.9
                                                ],
                                                [
                                                    -89.085,
                                                    -11.756
                                                ],
                                                [
                                                    -86.701,
                                                    -12.492
                                                ],
                                                [
                                                    -84.877,
                                                    -12.092
                                                ],
                                                [
                                                    -83.788,
                                                    -11.084
                                                ],
                                                [
                                                    -83.34,
                                                    -9.772
                                                ],
                                                [
                                                    -84.748,
                                                    -9.676
                                                ],
                                                [
                                                    -84.989,
                                                    -10.428
                                                ],
                                                [
                                                    -85.613,
                                                    -10.988
                                                ],
                                                [
                                                    -86.733,
                                                    -11.212
                                                ],
                                                [
                                                    -88.076,
                                                    -10.86
                                                ],
                                                [
                                                    -88.508,
                                                    -9.964
                                                ],
                                                [
                                                    -88.349,
                                                    -9.276
                                                ],
                                                [
                                                    -87.757,
                                                    -8.844
                                                ],
                                                [
                                                    -86.589,
                                                    -8.556
                                                ],
                                                [
                                                    -84.636,
                                                    -8.028
                                                ],
                                                [
                                                    -83.66,
                                                    -7.228
                                                ],
                                                [
                                                    -83.372,
                                                    -6.092
                                                ],
                                                [
                                                    -84.284,
                                                    -4.268
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.373,
                                                    0.352
                                                ],
                                                [
                                                    0,
                                                    0.747
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.171,
                                                    -0.149
                                                ],
                                                [
                                                    -0.352,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.769,
                                                    0
                                                ],
                                                [
                                                    -0.363,
                                                    -0.352
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.384
                                                ],
                                                [
                                                    0.172,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -74.26,
                                                    -3.82
                                                ],
                                                [
                                                    -75.973,
                                                    -4.348
                                                ],
                                                [
                                                    -76.517,
                                                    -5.996
                                                ],
                                                [
                                                    -76.517,
                                                    -14.284
                                                ],
                                                [
                                                    -75.173,
                                                    -14.284
                                                ],
                                                [
                                                    -75.173,
                                                    -6.028
                                                ],
                                                [
                                                    -74.917,
                                                    -5.228
                                                ],
                                                [
                                                    -74.132,
                                                    -5.004
                                                ],
                                                [
                                                    -72.917,
                                                    -5.004
                                                ],
                                                [
                                                    -72.917,
                                                    -3.82
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -77.765,
                                                    -11.116
                                                ],
                                                [
                                                    -77.765,
                                                    -12.3
                                                ],
                                                [
                                                    -72.917,
                                                    -12.3
                                                ],
                                                [
                                                    -72.917,
                                                    -11.116
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 14",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.778,
                                                    0
                                                ],
                                                [
                                                    0.587,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.32,
                                                    0.661
                                                ],
                                                [
                                                    -0.587,
                                                    0.363
                                                ],
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.575,
                                                    -0.363
                                                ],
                                                [
                                                    -0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.907
                                                ],
                                                [
                                                    0.32,
                                                    -0.672
                                                ],
                                                [
                                                    0.586,
                                                    -0.363
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.587,
                                                    -0.363
                                                ],
                                                [
                                                    -0.32,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.907
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.587,
                                                    -0.363
                                                ],
                                                [
                                                    0.778,
                                                    0
                                                ],
                                                [
                                                    0.586,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.32,
                                                    0.661
                                                ],
                                                [
                                                    -0.575,
                                                    0.363
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -68.036,
                                                    -3.628
                                                ],
                                                [
                                                    -70.085,
                                                    -4.172
                                                ],
                                                [
                                                    -71.445,
                                                    -5.708
                                                ],
                                                [
                                                    -71.924,
                                                    -8.06
                                                ],
                                                [
                                                    -71.445,
                                                    -10.412
                                                ],
                                                [
                                                    -70.085,
                                                    -11.948
                                                ],
                                                [
                                                    -68.036,
                                                    -12.492
                                                ],
                                                [
                                                    -66.005,
                                                    -11.948
                                                ],
                                                [
                                                    -64.645,
                                                    -10.412
                                                ],
                                                [
                                                    -64.164,
                                                    -8.06
                                                ],
                                                [
                                                    -64.645,
                                                    -5.708
                                                ],
                                                [
                                                    -66.005,
                                                    -4.172
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 15",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0.981
                                                ],
                                                [
                                                    0.437,
                                                    0.555
                                                ],
                                                [
                                                    0.778,
                                                    0
                                                ],
                                                [
                                                    0.437,
                                                    -0.565
                                                ],
                                                [
                                                    0,
                                                    -0.981
                                                ],
                                                [
                                                    -0.438,
                                                    -0.565
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.778,
                                                    0
                                                ],
                                                [
                                                    0.437,
                                                    -0.565
                                                ],
                                                [
                                                    0,
                                                    -0.981
                                                ],
                                                [
                                                    -0.427,
                                                    -0.565
                                                ],
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.438,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0.981
                                                ],
                                                [
                                                    0.437,
                                                    0.555
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -68.036,
                                                    -4.908
                                                ],
                                                [
                                                    -66.229,
                                                    -5.74
                                                ],
                                                [
                                                    -65.573,
                                                    -8.06
                                                ],
                                                [
                                                    -66.229,
                                                    -10.364
                                                ],
                                                [
                                                    -68.036,
                                                    -11.212
                                                ],
                                                [
                                                    -69.861,
                                                    -10.364
                                                ],
                                                [
                                                    -70.517,
                                                    -8.06
                                                ],
                                                [
                                                    -69.861,
                                                    -5.74
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 16",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -61.984,
                                                    -3.82
                                                ],
                                                [
                                                    -61.984,
                                                    -5.628
                                                ],
                                                [
                                                    -60.176,
                                                    -5.628
                                                ],
                                                [
                                                    -60.176,
                                                    -3.82
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 17",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -61.984,
                                                    -10.108
                                                ],
                                                [
                                                    -61.984,
                                                    -11.916
                                                ],
                                                [
                                                    -60.176,
                                                    -11.916
                                                ],
                                                [
                                                    -60.176,
                                                    -10.108
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 18",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -50.979,
                                                    -3.82
                                                ],
                                                [
                                                    -50.979,
                                                    -13.836
                                                ],
                                                [
                                                    -54.514,
                                                    -13.836
                                                ],
                                                [
                                                    -54.514,
                                                    -15.18
                                                ],
                                                [
                                                    -46.066,
                                                    -15.18
                                                ],
                                                [
                                                    -46.066,
                                                    -13.836
                                                ],
                                                [
                                                    -49.602,
                                                    -13.836
                                                ],
                                                [
                                                    -49.602,
                                                    -3.82
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 19",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -45.083,
                                                    -3.82
                                                ],
                                                [
                                                    -45.083,
                                                    -12.3
                                                ],
                                                [
                                                    -43.74,
                                                    -12.3
                                                ],
                                                [
                                                    -43.74,
                                                    -3.82
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 20",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -45.115,
                                                    -13.628
                                                ],
                                                [
                                                    -45.115,
                                                    -15.196
                                                ],
                                                [
                                                    -43.708,
                                                    -15.196
                                                ],
                                                [
                                                    -43.708,
                                                    -13.628
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 21",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.651,
                                                    0
                                                ],
                                                [
                                                    0.586,
                                                    0.363
                                                ],
                                                [
                                                    0.321,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.319,
                                                    0.661
                                                ],
                                                [
                                                    -0.576,
                                                    0.363
                                                ],
                                                [
                                                    -0.79,
                                                    0
                                                ],
                                                [
                                                    -0.5,
                                                    -0.235
                                                ],
                                                [
                                                    -0.319,
                                                    -0.437
                                                ],
                                                [
                                                    -0.097,
                                                    -0.629
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.395,
                                                    0.299
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0.438,
                                                    -0.565
                                                ],
                                                [
                                                    0,
                                                    -0.981
                                                ],
                                                [
                                                    -0.437,
                                                    -0.565
                                                ],
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.394,
                                                    0.32
                                                ],
                                                [
                                                    -0.097,
                                                    0.64
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.321,
                                                    -0.469
                                                ],
                                                [
                                                    0.513,
                                                    -0.256
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.79,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.363
                                                ],
                                                [
                                                    -0.319,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.321,
                                                    -0.661
                                                ],
                                                [
                                                    0.586,
                                                    -0.373
                                                ],
                                                [
                                                    0.651,
                                                    0
                                                ],
                                                [
                                                    0.513,
                                                    0.224
                                                ],
                                                [
                                                    0.321,
                                                    0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.097,
                                                    -0.565
                                                ],
                                                [
                                                    -0.394,
                                                    -0.309
                                                ],
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.437,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0.981
                                                ],
                                                [
                                                    0.438,
                                                    0.555
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0.395,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.097,
                                                    0.629
                                                ],
                                                [
                                                    -0.319,
                                                    0.459
                                                ],
                                                [
                                                    -0.5,
                                                    0.256
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -38.021,
                                                    -3.628
                                                ],
                                                [
                                                    -40.085,
                                                    -4.172
                                                ],
                                                [
                                                    -41.43,
                                                    -5.708
                                                ],
                                                [
                                                    -41.91,
                                                    -8.06
                                                ],
                                                [
                                                    -41.43,
                                                    -10.396
                                                ],
                                                [
                                                    -40.085,
                                                    -11.932
                                                ],
                                                [
                                                    -38.021,
                                                    -12.492
                                                ],
                                                [
                                                    -36.294,
                                                    -12.14
                                                ],
                                                [
                                                    -35.046,
                                                    -11.148
                                                ],
                                                [
                                                    -34.421,
                                                    -9.548
                                                ],
                                                [
                                                    -35.829,
                                                    -9.452
                                                ],
                                                [
                                                    -36.566,
                                                    -10.748
                                                ],
                                                [
                                                    -38.021,
                                                    -11.212
                                                ],
                                                [
                                                    -39.846,
                                                    -10.364
                                                ],
                                                [
                                                    -40.501,
                                                    -8.06
                                                ],
                                                [
                                                    -39.846,
                                                    -5.74
                                                ],
                                                [
                                                    -38.021,
                                                    -4.908
                                                ],
                                                [
                                                    -36.566,
                                                    -5.388
                                                ],
                                                [
                                                    -35.829,
                                                    -6.828
                                                ],
                                                [
                                                    -34.421,
                                                    -6.732
                                                ],
                                                [
                                                    -35.046,
                                                    -5.084
                                                ],
                                                [
                                                    -36.294,
                                                    -4.012
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 22",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -32.755,
                                                    -3.82
                                                ],
                                                [
                                                    -32.755,
                                                    -15.18
                                                ],
                                                [
                                                    -31.411,
                                                    -15.18
                                                ],
                                                [
                                                    -31.411,
                                                    -7.74
                                                ],
                                                [
                                                    -27.284,
                                                    -12.3
                                                ],
                                                [
                                                    -25.492,
                                                    -12.3
                                                ],
                                                [
                                                    -28.835,
                                                    -8.7
                                                ],
                                                [
                                                    -25.348,
                                                    -3.82
                                                ],
                                                [
                                                    -26.98,
                                                    -3.82
                                                ],
                                                [
                                                    -29.747,
                                                    -7.788
                                                ],
                                                [
                                                    -31.411,
                                                    -6.028
                                                ],
                                                [
                                                    -31.411,
                                                    -3.82
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 23",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.897,
                                                    0
                                                ],
                                                [
                                                    0.587,
                                                    0.363
                                                ],
                                                [
                                                    0.321,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.309,
                                                    0.661
                                                ],
                                                [
                                                    -0.566,
                                                    0.363
                                                ],
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    -0.352
                                                ],
                                                [
                                                    -0.309,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.949
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    -0.459
                                                ],
                                                [
                                                    -0.735,
                                                    0
                                                ],
                                                [
                                                    -0.351,
                                                    0.256
                                                ],
                                                [
                                                    -0.138,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.629,
                                                    -0.491
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.799,
                                                    0
                                                ],
                                                [
                                                    -0.575,
                                                    -0.363
                                                ],
                                                [
                                                    -0.309,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.321,
                                                    -0.661
                                                ],
                                                [
                                                    0.576,
                                                    -0.373
                                                ],
                                                [
                                                    0.737,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    0.341
                                                ],
                                                [
                                                    0.319,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.053,
                                                    0.907
                                                ],
                                                [
                                                    0.437,
                                                    0.459
                                                ],
                                                [
                                                    0.556,
                                                    0
                                                ],
                                                [
                                                    0.364,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    0.757
                                                ],
                                                [
                                                    -0.619,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -20.803,
                                                    -3.628
                                                ],
                                                [
                                                    -22.883,
                                                    -4.172
                                                ],
                                                [
                                                    -24.227,
                                                    -5.708
                                                ],
                                                [
                                                    -24.691,
                                                    -8.06
                                                ],
                                                [
                                                    -24.227,
                                                    -10.396
                                                ],
                                                [
                                                    -22.898,
                                                    -11.932
                                                ],
                                                [
                                                    -20.867,
                                                    -12.492
                                                ],
                                                [
                                                    -18.915,
                                                    -11.964
                                                ],
                                                [
                                                    -17.602,
                                                    -10.46
                                                ],
                                                [
                                                    -17.122,
                                                    -8.044
                                                ],
                                                [
                                                    -17.122,
                                                    -7.644
                                                ],
                                                [
                                                    -23.283,
                                                    -7.644
                                                ],
                                                [
                                                    -22.563,
                                                    -5.596
                                                ],
                                                [
                                                    -20.803,
                                                    -4.908
                                                ],
                                                [
                                                    -19.443,
                                                    -5.292
                                                ],
                                                [
                                                    -18.691,
                                                    -6.332
                                                ],
                                                [
                                                    -17.251,
                                                    -6.22
                                                ],
                                                [
                                                    -18.531,
                                                    -4.348
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 24",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.118,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    0.384
                                                ],
                                                [
                                                    0.629,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    -0.405
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.065,
                                                    -0.821
                                                ],
                                                [
                                                    -0.405,
                                                    -0.384
                                                ],
                                                [
                                                    -0.651,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.395
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -23.283,
                                                    -8.828
                                                ],
                                                [
                                                    -18.594,
                                                    -8.828
                                                ],
                                                [
                                                    -19.314,
                                                    -10.636
                                                ],
                                                [
                                                    -20.867,
                                                    -11.212
                                                ],
                                                [
                                                    -22.482,
                                                    -10.604
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 25",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.373,
                                                    0.352
                                                ],
                                                [
                                                    0,
                                                    0.747
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.17,
                                                    -0.149
                                                ],
                                                [
                                                    -0.353,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.767,
                                                    0
                                                ],
                                                [
                                                    -0.362,
                                                    -0.352
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.384
                                                ],
                                                [
                                                    0.17,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -12.527,
                                                    -3.82
                                                ],
                                                [
                                                    -14.238,
                                                    -4.348
                                                ],
                                                [
                                                    -14.783,
                                                    -5.996
                                                ],
                                                [
                                                    -14.783,
                                                    -14.284
                                                ],
                                                [
                                                    -13.439,
                                                    -14.284
                                                ],
                                                [
                                                    -13.439,
                                                    -6.028
                                                ],
                                                [
                                                    -13.182,
                                                    -5.228
                                                ],
                                                [
                                                    -12.398,
                                                    -5.004
                                                ],
                                                [
                                                    -11.182,
                                                    -5.004
                                                ],
                                                [
                                                    -11.182,
                                                    -3.82
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 26",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -16.031,
                                                    -11.116
                                                ],
                                                [
                                                    -16.031,
                                                    -12.3
                                                ],
                                                [
                                                    -11.182,
                                                    -12.3
                                                ],
                                                [
                                                    -11.182,
                                                    -11.116
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 27",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.94,
                                                    0
                                                ],
                                                [
                                                    0.533,
                                                    0.245
                                                ],
                                                [
                                                    0.287,
                                                    0.427
                                                ],
                                                [
                                                    0.043,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.331,
                                                    -0.309
                                                ],
                                                [
                                                    -0.746,
                                                    0
                                                ],
                                                [
                                                    -0.309,
                                                    0.181
                                                ],
                                                [
                                                    0,
                                                    0.416
                                                ],
                                                [
                                                    0.107,
                                                    0.149
                                                ],
                                                [
                                                    0.3,
                                                    0.107
                                                ],
                                                [
                                                    0.577,
                                                    0.107
                                                ],
                                                [
                                                    0.448,
                                                    0.224
                                                ],
                                                [
                                                    0.181,
                                                    0.32
                                                ],
                                                [
                                                    0,
                                                    0.448
                                                ],
                                                [
                                                    -0.554,
                                                    0.48
                                                ],
                                                [
                                                    -1.024,
                                                    0
                                                ],
                                                [
                                                    -0.47,
                                                    -0.267
                                                ],
                                                [
                                                    -0.244,
                                                    -0.416
                                                ],
                                                [
                                                    -0.052,
                                                    -0.459
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.138,
                                                    0.235
                                                ],
                                                [
                                                    0.278,
                                                    0.139
                                                ],
                                                [
                                                    0.469,
                                                    0
                                                ],
                                                [
                                                    0.287,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    -0.363
                                                ],
                                                [
                                                    -0.107,
                                                    -0.181
                                                ],
                                                [
                                                    -0.276,
                                                    -0.117
                                                ],
                                                [
                                                    -0.491,
                                                    -0.085
                                                ],
                                                [
                                                    -0.47,
                                                    -0.213
                                                ],
                                                [
                                                    -0.181,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.448
                                                ],
                                                [
                                                    0.608,
                                                    -0.437
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.523,
                                                    -0.245
                                                ],
                                                [
                                                    -0.278,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.086,
                                                    0.512
                                                ],
                                                [
                                                    0.341,
                                                    0.299
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0.321,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    -0.224
                                                ],
                                                [
                                                    -0.097,
                                                    -0.149
                                                ],
                                                [
                                                    -0.299,
                                                    -0.117
                                                ],
                                                [
                                                    -0.789,
                                                    -0.149
                                                ],
                                                [
                                                    -0.448,
                                                    -0.224
                                                ],
                                                [
                                                    -0.181,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.757
                                                ],
                                                [
                                                    0.565,
                                                    -0.491
                                                ],
                                                [
                                                    0.748,
                                                    0
                                                ],
                                                [
                                                    0.479,
                                                    0.256
                                                ],
                                                [
                                                    0.245,
                                                    0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.021,
                                                    -0.267
                                                ],
                                                [
                                                    -0.14,
                                                    -0.235
                                                ],
                                                [
                                                    -0.276,
                                                    -0.149
                                                ],
                                                [
                                                    -0.608,
                                                    0
                                                ],
                                                [
                                                    -0.289,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0.277
                                                ],
                                                [
                                                    0.117,
                                                    0.171
                                                ],
                                                [
                                                    0.289,
                                                    0.107
                                                ],
                                                [
                                                    0.832,
                                                    0.139
                                                ],
                                                [
                                                    0.469,
                                                    0.213
                                                ],
                                                [
                                                    0.192,
                                                    0.309
                                                ],
                                                [
                                                    0,
                                                    0.779
                                                ],
                                                [
                                                    -0.597,
                                                    0.427
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -2.277,
                                                    -3.628
                                                ],
                                                [
                                                    -4.245,
                                                    -3.996
                                                ],
                                                [
                                                    -5.46,
                                                    -5.004
                                                ],
                                                [
                                                    -5.941,
                                                    -6.492
                                                ],
                                                [
                                                    -4.533,
                                                    -6.588
                                                ],
                                                [
                                                    -3.909,
                                                    -5.356
                                                ],
                                                [
                                                    -2.277,
                                                    -4.908
                                                ],
                                                [
                                                    -0.949,
                                                    -5.18
                                                ],
                                                [
                                                    -0.469,
                                                    -6.092
                                                ],
                                                [
                                                    -0.628,
                                                    -6.652
                                                ],
                                                [
                                                    -1.221,
                                                    -7.036
                                                ],
                                                [
                                                    -2.533,
                                                    -7.372
                                                ],
                                                [
                                                    -4.389,
                                                    -7.932
                                                ],
                                                [
                                                    -5.333,
                                                    -8.748
                                                ],
                                                [
                                                    -5.605,
                                                    -9.9
                                                ],
                                                [
                                                    -4.773,
                                                    -11.756
                                                ],
                                                [
                                                    -2.389,
                                                    -12.492
                                                ],
                                                [
                                                    -0.564,
                                                    -12.092
                                                ],
                                                [
                                                    0.523,
                                                    -11.084
                                                ],
                                                [
                                                    0.971,
                                                    -9.772
                                                ],
                                                [
                                                    -0.437,
                                                    -9.676
                                                ],
                                                [
                                                    -0.676,
                                                    -10.428
                                                ],
                                                [
                                                    -1.301,
                                                    -10.988
                                                ],
                                                [
                                                    -2.421,
                                                    -11.212
                                                ],
                                                [
                                                    -3.764,
                                                    -10.86
                                                ],
                                                [
                                                    -4.197,
                                                    -9.964
                                                ],
                                                [
                                                    -4.036,
                                                    -9.276
                                                ],
                                                [
                                                    -3.445,
                                                    -8.844
                                                ],
                                                [
                                                    -2.277,
                                                    -8.556
                                                ],
                                                [
                                                    -0.324,
                                                    -8.028
                                                ],
                                                [
                                                    0.652,
                                                    -7.228
                                                ],
                                                [
                                                    0.939,
                                                    -6.092
                                                ],
                                                [
                                                    0.027,
                                                    -4.268
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 28",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.138,
                                                    0.096
                                                ],
                                                [
                                                    -0.075,
                                                    0.203
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.213
                                                ],
                                                [
                                                    0.565,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.299,
                                                    0
                                                ],
                                                [
                                                    0.149,
                                                    -0.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.159,
                                                    0.459
                                                ],
                                                [
                                                    -0.32,
                                                    0.213
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.91,
                                                    -1.42
                                                ],
                                                [
                                                    2.91,
                                                    -2.604
                                                ],
                                                [
                                                    3.885,
                                                    -2.604
                                                ],
                                                [
                                                    4.542,
                                                    -2.748
                                                ],
                                                [
                                                    4.878,
                                                    -3.18
                                                ],
                                                [
                                                    5.182,
                                                    -3.98
                                                ],
                                                [
                                                    4.717,
                                                    -3.98
                                                ],
                                                [
                                                    1.613,
                                                    -12.3
                                                ],
                                                [
                                                    3.085,
                                                    -12.3
                                                ],
                                                [
                                                    5.613,
                                                    -5.228
                                                ],
                                                [
                                                    8.029,
                                                    -12.3
                                                ],
                                                [
                                                    9.501,
                                                    -12.3
                                                ],
                                                [
                                                    6.061,
                                                    -2.748
                                                ],
                                                [
                                                    5.341,
                                                    -1.74
                                                ],
                                                [
                                                    4.014,
                                                    -1.42
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 29",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.939,
                                                    0
                                                ],
                                                [
                                                    0.534,
                                                    0.245
                                                ],
                                                [
                                                    0.289,
                                                    0.427
                                                ],
                                                [
                                                    0.043,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.33,
                                                    -0.309
                                                ],
                                                [
                                                    -0.746,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    0.181
                                                ],
                                                [
                                                    0,
                                                    0.416
                                                ],
                                                [
                                                    0.108,
                                                    0.149
                                                ],
                                                [
                                                    0.299,
                                                    0.107
                                                ],
                                                [
                                                    0.576,
                                                    0.107
                                                ],
                                                [
                                                    0.448,
                                                    0.224
                                                ],
                                                [
                                                    0.181,
                                                    0.32
                                                ],
                                                [
                                                    0,
                                                    0.448
                                                ],
                                                [
                                                    -0.554,
                                                    0.48
                                                ],
                                                [
                                                    -1.024,
                                                    0
                                                ],
                                                [
                                                    -0.47,
                                                    -0.267
                                                ],
                                                [
                                                    -0.245,
                                                    -0.416
                                                ],
                                                [
                                                    -0.052,
                                                    -0.459
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.138,
                                                    0.235
                                                ],
                                                [
                                                    0.278,
                                                    0.139
                                                ],
                                                [
                                                    0.468,
                                                    0
                                                ],
                                                [
                                                    0.289,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    -0.363
                                                ],
                                                [
                                                    -0.108,
                                                    -0.181
                                                ],
                                                [
                                                    -0.276,
                                                    -0.117
                                                ],
                                                [
                                                    -0.49,
                                                    -0.085
                                                ],
                                                [
                                                    -0.469,
                                                    -0.213
                                                ],
                                                [
                                                    -0.181,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.448
                                                ],
                                                [
                                                    0.609,
                                                    -0.437
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.522,
                                                    -0.245
                                                ],
                                                [
                                                    -0.277,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.084,
                                                    0.512
                                                ],
                                                [
                                                    0.341,
                                                    0.299
                                                ],
                                                [
                                                    0.577,
                                                    0
                                                ],
                                                [
                                                    0.319,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    -0.224
                                                ],
                                                [
                                                    -0.095,
                                                    -0.149
                                                ],
                                                [
                                                    -0.298,
                                                    -0.117
                                                ],
                                                [
                                                    -0.789,
                                                    -0.149
                                                ],
                                                [
                                                    -0.447,
                                                    -0.224
                                                ],
                                                [
                                                    -0.181,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.757
                                                ],
                                                [
                                                    0.565,
                                                    -0.491
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.479,
                                                    0.256
                                                ],
                                                [
                                                    0.244,
                                                    0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.021,
                                                    -0.267
                                                ],
                                                [
                                                    -0.14,
                                                    -0.235
                                                ],
                                                [
                                                    -0.276,
                                                    -0.149
                                                ],
                                                [
                                                    -0.609,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0.277
                                                ],
                                                [
                                                    0.116,
                                                    0.171
                                                ],
                                                [
                                                    0.288,
                                                    0.107
                                                ],
                                                [
                                                    0.832,
                                                    0.139
                                                ],
                                                [
                                                    0.47,
                                                    0.213
                                                ],
                                                [
                                                    0.192,
                                                    0.309
                                                ],
                                                [
                                                    0,
                                                    0.779
                                                ],
                                                [
                                                    -0.597,
                                                    0.427
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    13.801,
                                                    -3.628
                                                ],
                                                [
                                                    11.833,
                                                    -3.996
                                                ],
                                                [
                                                    10.617,
                                                    -5.004
                                                ],
                                                [
                                                    10.137,
                                                    -6.492
                                                ],
                                                [
                                                    11.546,
                                                    -6.588
                                                ],
                                                [
                                                    12.169,
                                                    -5.356
                                                ],
                                                [
                                                    13.801,
                                                    -4.908
                                                ],
                                                [
                                                    15.13,
                                                    -5.18
                                                ],
                                                [
                                                    15.609,
                                                    -6.092
                                                ],
                                                [
                                                    15.449,
                                                    -6.652
                                                ],
                                                [
                                                    14.857,
                                                    -7.036
                                                ],
                                                [
                                                    13.546,
                                                    -7.372
                                                ],
                                                [
                                                    11.689,
                                                    -7.932
                                                ],
                                                [
                                                    10.745,
                                                    -8.748
                                                ],
                                                [
                                                    10.473,
                                                    -9.9
                                                ],
                                                [
                                                    11.305,
                                                    -11.756
                                                ],
                                                [
                                                    13.689,
                                                    -12.492
                                                ],
                                                [
                                                    15.514,
                                                    -12.092
                                                ],
                                                [
                                                    16.602,
                                                    -11.084
                                                ],
                                                [
                                                    17.049,
                                                    -9.772
                                                ],
                                                [
                                                    15.641,
                                                    -9.676
                                                ],
                                                [
                                                    15.402,
                                                    -10.428
                                                ],
                                                [
                                                    14.777,
                                                    -10.988
                                                ],
                                                [
                                                    13.658,
                                                    -11.212
                                                ],
                                                [
                                                    12.313,
                                                    -10.86
                                                ],
                                                [
                                                    11.882,
                                                    -9.964
                                                ],
                                                [
                                                    12.042,
                                                    -9.276
                                                ],
                                                [
                                                    12.633,
                                                    -8.844
                                                ],
                                                [
                                                    13.801,
                                                    -8.556
                                                ],
                                                [
                                                    15.753,
                                                    -8.028
                                                ],
                                                [
                                                    16.729,
                                                    -7.228
                                                ],
                                                [
                                                    17.018,
                                                    -6.092
                                                ],
                                                [
                                                    16.105,
                                                    -4.268
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 30",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.373,
                                                    0.352
                                                ],
                                                [
                                                    0,
                                                    0.747
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.17,
                                                    -0.149
                                                ],
                                                [
                                                    -0.352,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.767,
                                                    0
                                                ],
                                                [
                                                    -0.362,
                                                    -0.352
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.384
                                                ],
                                                [
                                                    0.17,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    21.645,
                                                    -3.82
                                                ],
                                                [
                                                    19.934,
                                                    -4.348
                                                ],
                                                [
                                                    19.389,
                                                    -5.996
                                                ],
                                                [
                                                    19.389,
                                                    -14.284
                                                ],
                                                [
                                                    20.734,
                                                    -14.284
                                                ],
                                                [
                                                    20.734,
                                                    -6.028
                                                ],
                                                [
                                                    20.99,
                                                    -5.228
                                                ],
                                                [
                                                    21.773,
                                                    -5.004
                                                ],
                                                [
                                                    22.99,
                                                    -5.004
                                                ],
                                                [
                                                    22.99,
                                                    -3.82
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 31",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.141,
                                                    -11.116
                                                ],
                                                [
                                                    18.141,
                                                    -12.3
                                                ],
                                                [
                                                    22.99,
                                                    -12.3
                                                ],
                                                [
                                                    22.99,
                                                    -11.116
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 32",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.896,
                                                    0
                                                ],
                                                [
                                                    0.586,
                                                    0.363
                                                ],
                                                [
                                                    0.321,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.308,
                                                    0.661
                                                ],
                                                [
                                                    -0.565,
                                                    0.363
                                                ],
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.564,
                                                    -0.352
                                                ],
                                                [
                                                    -0.31,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.949
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    -0.459
                                                ],
                                                [
                                                    -0.737,
                                                    0
                                                ],
                                                [
                                                    -0.351,
                                                    0.256
                                                ],
                                                [
                                                    -0.14,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.629,
                                                    -0.491
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.8,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.363
                                                ],
                                                [
                                                    -0.308,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.321,
                                                    -0.661
                                                ],
                                                [
                                                    0.577,
                                                    -0.373
                                                ],
                                                [
                                                    0.737,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    0.341
                                                ],
                                                [
                                                    0.319,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.054,
                                                    0.907
                                                ],
                                                [
                                                    0.437,
                                                    0.459
                                                ],
                                                [
                                                    0.554,
                                                    0
                                                ],
                                                [
                                                    0.363,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    0.757
                                                ],
                                                [
                                                    -0.618,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    27.87,
                                                    -3.628
                                                ],
                                                [
                                                    25.79,
                                                    -4.172
                                                ],
                                                [
                                                    24.445,
                                                    -5.708
                                                ],
                                                [
                                                    23.982,
                                                    -8.06
                                                ],
                                                [
                                                    24.445,
                                                    -10.396
                                                ],
                                                [
                                                    25.773,
                                                    -11.932
                                                ],
                                                [
                                                    27.805,
                                                    -12.492
                                                ],
                                                [
                                                    29.757,
                                                    -11.964
                                                ],
                                                [
                                                    31.07,
                                                    -10.46
                                                ],
                                                [
                                                    31.549,
                                                    -8.044
                                                ],
                                                [
                                                    31.549,
                                                    -7.644
                                                ],
                                                [
                                                    25.389,
                                                    -7.644
                                                ],
                                                [
                                                    26.109,
                                                    -5.596
                                                ],
                                                [
                                                    27.87,
                                                    -4.908
                                                ],
                                                [
                                                    29.229,
                                                    -5.292
                                                ],
                                                [
                                                    29.982,
                                                    -6.332
                                                ],
                                                [
                                                    31.421,
                                                    -6.22
                                                ],
                                                [
                                                    30.141,
                                                    -4.348
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 33",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.118,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    0.384
                                                ],
                                                [
                                                    0.629,
                                                    0
                                                ],
                                                [
                                                    0.428,
                                                    -0.405
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.063,
                                                    -0.821
                                                ],
                                                [
                                                    -0.405,
                                                    -0.384
                                                ],
                                                [
                                                    -0.651,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.395
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    25.389,
                                                    -8.828
                                                ],
                                                [
                                                    30.077,
                                                    -8.828
                                                ],
                                                [
                                                    29.357,
                                                    -10.636
                                                ],
                                                [
                                                    27.805,
                                                    -11.212
                                                ],
                                                [
                                                    26.189,
                                                    -10.604
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 34",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    0.331
                                                ],
                                                [
                                                    -0.353,
                                                    0.181
                                                ],
                                                [
                                                    -0.427,
                                                    0
                                                ],
                                                [
                                                    -0.457,
                                                    -0.405
                                                ],
                                                [
                                                    -0.117,
                                                    -0.725
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.225,
                                                    0.331
                                                ],
                                                [
                                                    -0.362,
                                                    0.181
                                                ],
                                                [
                                                    -0.47,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    -0.256
                                                ],
                                                [
                                                    -0.212,
                                                    -0.48
                                                ],
                                                [
                                                    0,
                                                    -0.683
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.299,
                                                    0.384
                                                ],
                                                [
                                                    0.588,
                                                    0
                                                ],
                                                [
                                                    0.298,
                                                    -0.192
                                                ],
                                                [
                                                    0.159,
                                                    -0.363
                                                ],
                                                [
                                                    0,
                                                    -0.512
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.267,
                                                    0.427
                                                ],
                                                [
                                                    0.629,
                                                    0
                                                ],
                                                [
                                                    0.3,
                                                    -0.192
                                                ],
                                                [
                                                    0.17,
                                                    -0.363
                                                ],
                                                [
                                                    0,
                                                    -0.501
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.095,
                                                    -0.469
                                                ],
                                                [
                                                    0.245,
                                                    -0.341
                                                ],
                                                [
                                                    0.351,
                                                    -0.192
                                                ],
                                                [
                                                    0.735,
                                                    0
                                                ],
                                                [
                                                    0.47,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.086,
                                                    -0.491
                                                ],
                                                [
                                                    0.234,
                                                    -0.341
                                                ],
                                                [
                                                    0.362,
                                                    -0.181
                                                ],
                                                [
                                                    0.608,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    0.245
                                                ],
                                                [
                                                    0.215,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.768
                                                ],
                                                [
                                                    -0.298,
                                                    -0.395
                                                ],
                                                [
                                                    -0.394,
                                                    0
                                                ],
                                                [
                                                    -0.289,
                                                    0.192
                                                ],
                                                [
                                                    -0.16,
                                                    0.352
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.757
                                                ],
                                                [
                                                    -0.265,
                                                    -0.427
                                                ],
                                                [
                                                    -0.394,
                                                    0
                                                ],
                                                [
                                                    -0.287,
                                                    0.192
                                                ],
                                                [
                                                    -0.16,
                                                    0.363
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    33.37,
                                                    -3.82
                                                ],
                                                [
                                                    33.37,
                                                    -12.3
                                                ],
                                                [
                                                    34.602,
                                                    -12.3
                                                ],
                                                [
                                                    34.65,
                                                    -10.156
                                                ],
                                                [
                                                    34.458,
                                                    -10.22
                                                ],
                                                [
                                                    34.954,
                                                    -11.42
                                                ],
                                                [
                                                    35.85,
                                                    -12.204
                                                ],
                                                [
                                                    37.018,
                                                    -12.492
                                                ],
                                                [
                                                    38.809,
                                                    -11.884
                                                ],
                                                [
                                                    39.689,
                                                    -10.188
                                                ],
                                                [
                                                    39.434,
                                                    -10.204
                                                ],
                                                [
                                                    39.898,
                                                    -11.436
                                                ],
                                                [
                                                    40.794,
                                                    -12.22
                                                ],
                                                [
                                                    42.042,
                                                    -12.492
                                                ],
                                                [
                                                    43.577,
                                                    -12.108
                                                ],
                                                [
                                                    44.521,
                                                    -11.02
                                                ],
                                                [
                                                    44.841,
                                                    -9.276
                                                ],
                                                [
                                                    44.841,
                                                    -3.82
                                                ],
                                                [
                                                    43.497,
                                                    -3.82
                                                ],
                                                [
                                                    43.497,
                                                    -8.988
                                                ],
                                                [
                                                    43.049,
                                                    -10.716
                                                ],
                                                [
                                                    41.721,
                                                    -11.308
                                                ],
                                                [
                                                    40.682,
                                                    -11.02
                                                ],
                                                [
                                                    40.01,
                                                    -10.188
                                                ],
                                                [
                                                    39.77,
                                                    -8.892
                                                ],
                                                [
                                                    39.77,
                                                    -3.82
                                                ],
                                                [
                                                    38.426,
                                                    -3.82
                                                ],
                                                [
                                                    38.426,
                                                    -8.892
                                                ],
                                                [
                                                    38.025,
                                                    -10.668
                                                ],
                                                [
                                                    36.682,
                                                    -11.308
                                                ],
                                                [
                                                    35.641,
                                                    -11.02
                                                ],
                                                [
                                                    34.954,
                                                    -10.188
                                                ],
                                                [
                                                    34.714,
                                                    -8.892
                                                ],
                                                [
                                                    34.714,
                                                    -3.82
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 35",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.373,
                                                    0
                                                ],
                                                [
                                                    0.265,
                                                    0.149
                                                ],
                                                [
                                                    0.149,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0.331
                                                ],
                                                [
                                                    -0.138,
                                                    0.256
                                                ],
                                                [
                                                    -0.267,
                                                    0.149
                                                ],
                                                [
                                                    -0.374,
                                                    0
                                                ],
                                                [
                                                    -0.266,
                                                    -0.149
                                                ],
                                                [
                                                    -0.14,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    -0.341
                                                ],
                                                [
                                                    0.149,
                                                    -0.267
                                                ],
                                                [
                                                    0.267,
                                                    -0.149
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.374,
                                                    0
                                                ],
                                                [
                                                    -0.267,
                                                    -0.149
                                                ],
                                                [
                                                    -0.138,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    -0.341
                                                ],
                                                [
                                                    0.149,
                                                    -0.267
                                                ],
                                                [
                                                    0.265,
                                                    -0.149
                                                ],
                                                [
                                                    0.373,
                                                    0
                                                ],
                                                [
                                                    0.267,
                                                    0.149
                                                ],
                                                [
                                                    0.149,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0.331
                                                ],
                                                [
                                                    -0.14,
                                                    0.256
                                                ],
                                                [
                                                    -0.266,
                                                    0.149
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    52.617,
                                                    -7.068
                                                ],
                                                [
                                                    51.658,
                                                    -7.292
                                                ],
                                                [
                                                    51.033,
                                                    -7.9
                                                ],
                                                [
                                                    50.826,
                                                    -8.796
                                                ],
                                                [
                                                    51.033,
                                                    -9.692
                                                ],
                                                [
                                                    51.658,
                                                    -10.316
                                                ],
                                                [
                                                    52.617,
                                                    -10.54
                                                ],
                                                [
                                                    53.577,
                                                    -10.316
                                                ],
                                                [
                                                    54.186,
                                                    -9.692
                                                ],
                                                [
                                                    54.41,
                                                    -8.796
                                                ],
                                                [
                                                    54.186,
                                                    -7.9
                                                ],
                                                [
                                                    53.577,
                                                    -7.292
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 36",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    60.577,
                                                    -3.82
                                                ],
                                                [
                                                    60.577,
                                                    -15.18
                                                ],
                                                [
                                                    61.954,
                                                    -15.18
                                                ],
                                                [
                                                    61.954,
                                                    -3.82
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 37",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.265,
                                                    0.32
                                                ],
                                                [
                                                    -0.372,
                                                    0.16
                                                ],
                                                [
                                                    -0.437,
                                                    0
                                                ],
                                                [
                                                    -0.415,
                                                    -0.288
                                                ],
                                                [
                                                    -0.202,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    -0.597
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.129,
                                                    0.352
                                                ],
                                                [
                                                    0.267,
                                                    0.181
                                                ],
                                                [
                                                    0.427,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.107,
                                                    -0.501
                                                ],
                                                [
                                                    0.267,
                                                    -0.331
                                                ],
                                                [
                                                    0.384,
                                                    -0.16
                                                ],
                                                [
                                                    0.651,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    0.288
                                                ],
                                                [
                                                    0.215,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    -0.116,
                                                    -0.363
                                                ],
                                                [
                                                    -0.265,
                                                    -0.192
                                                ],
                                                [
                                                    -0.65,
                                                    0
                                                ],
                                                [
                                                    -0.415,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    64.792,
                                                    -3.82
                                                ],
                                                [
                                                    64.792,
                                                    -12.3
                                                ],
                                                [
                                                    66.023,
                                                    -12.3
                                                ],
                                                [
                                                    66.072,
                                                    -10.14
                                                ],
                                                [
                                                    65.911,
                                                    -10.284
                                                ],
                                                [
                                                    66.471,
                                                    -11.516
                                                ],
                                                [
                                                    67.431,
                                                    -12.252
                                                ],
                                                [
                                                    68.664,
                                                    -12.492
                                                ],
                                                [
                                                    70.263,
                                                    -12.06
                                                ],
                                                [
                                                    71.207,
                                                    -10.892
                                                ],
                                                [
                                                    71.527,
                                                    -9.276
                                                ],
                                                [
                                                    71.527,
                                                    -3.82
                                                ],
                                                [
                                                    70.184,
                                                    -3.82
                                                ],
                                                [
                                                    70.184,
                                                    -8.892
                                                ],
                                                [
                                                    69.991,
                                                    -10.204
                                                ],
                                                [
                                                    69.415,
                                                    -11.02
                                                ],
                                                [
                                                    68.375,
                                                    -11.308
                                                ],
                                                [
                                                    66.759,
                                                    -10.684
                                                ],
                                                [
                                                    66.135,
                                                    -8.892
                                                ],
                                                [
                                                    66.135,
                                                    -3.82
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 38",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.374,
                                                    0.352
                                                ],
                                                [
                                                    0,
                                                    0.747
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.171,
                                                    -0.149
                                                ],
                                                [
                                                    -0.353,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.768,
                                                    0
                                                ],
                                                [
                                                    -0.362,
                                                    -0.352
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.384
                                                ],
                                                [
                                                    0.17,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    76.552,
                                                    -3.82
                                                ],
                                                [
                                                    74.84,
                                                    -4.348
                                                ],
                                                [
                                                    74.297,
                                                    -5.996
                                                ],
                                                [
                                                    74.297,
                                                    -14.284
                                                ],
                                                [
                                                    75.641,
                                                    -14.284
                                                ],
                                                [
                                                    75.641,
                                                    -6.028
                                                ],
                                                [
                                                    75.896,
                                                    -5.228
                                                ],
                                                [
                                                    76.681,
                                                    -5.004
                                                ],
                                                [
                                                    77.896,
                                                    -5.004
                                                ],
                                                [
                                                    77.896,
                                                    -3.82
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 39",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    73.048,
                                                    -11.116
                                                ],
                                                [
                                                    73.048,
                                                    -12.3
                                                ],
                                                [
                                                    77.896,
                                                    -12.3
                                                ],
                                                [
                                                    77.896,
                                                    -11.116
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 40",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.896,
                                                    0
                                                ],
                                                [
                                                    0.588,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.309,
                                                    0.661
                                                ],
                                                [
                                                    -0.565,
                                                    0.363
                                                ],
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    -0.352
                                                ],
                                                [
                                                    -0.308,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.949
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    -0.459
                                                ],
                                                [
                                                    -0.737,
                                                    0
                                                ],
                                                [
                                                    -0.351,
                                                    0.256
                                                ],
                                                [
                                                    -0.139,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.63,
                                                    -0.491
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.801,
                                                    0
                                                ],
                                                [
                                                    -0.575,
                                                    -0.363
                                                ],
                                                [
                                                    -0.309,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.575,
                                                    -0.373
                                                ],
                                                [
                                                    0.737,
                                                    0
                                                ],
                                                [
                                                    0.564,
                                                    0.341
                                                ],
                                                [
                                                    0.321,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.053,
                                                    0.907
                                                ],
                                                [
                                                    0.436,
                                                    0.459
                                                ],
                                                [
                                                    0.555,
                                                    0
                                                ],
                                                [
                                                    0.364,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    0.757
                                                ],
                                                [
                                                    -0.619,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    82.776,
                                                    -3.628
                                                ],
                                                [
                                                    80.695,
                                                    -4.172
                                                ],
                                                [
                                                    79.352,
                                                    -5.708
                                                ],
                                                [
                                                    78.888,
                                                    -8.06
                                                ],
                                                [
                                                    79.352,
                                                    -10.396
                                                ],
                                                [
                                                    80.68,
                                                    -11.932
                                                ],
                                                [
                                                    82.711,
                                                    -12.492
                                                ],
                                                [
                                                    84.664,
                                                    -11.964
                                                ],
                                                [
                                                    85.975,
                                                    -10.46
                                                ],
                                                [
                                                    86.456,
                                                    -8.044
                                                ],
                                                [
                                                    86.456,
                                                    -7.644
                                                ],
                                                [
                                                    80.296,
                                                    -7.644
                                                ],
                                                [
                                                    81.016,
                                                    -5.596
                                                ],
                                                [
                                                    82.776,
                                                    -4.908
                                                ],
                                                [
                                                    84.135,
                                                    -5.292
                                                ],
                                                [
                                                    84.888,
                                                    -6.332
                                                ],
                                                [
                                                    86.327,
                                                    -6.22
                                                ],
                                                [
                                                    85.047,
                                                    -4.348
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 41",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.117,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.417,
                                                    0.384
                                                ],
                                                [
                                                    0.629,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    -0.405
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.821
                                                ],
                                                [
                                                    -0.405,
                                                    -0.384
                                                ],
                                                [
                                                    -0.651,
                                                    0
                                                ],
                                                [
                                                    -0.415,
                                                    0.395
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    80.296,
                                                    -8.828
                                                ],
                                                [
                                                    84.983,
                                                    -8.828
                                                ],
                                                [
                                                    84.263,
                                                    -10.636
                                                ],
                                                [
                                                    82.711,
                                                    -11.212
                                                ],
                                                [
                                                    81.095,
                                                    -10.604
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 42",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.331
                                                ],
                                                [
                                                    -0.598,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.16
                                                ],
                                                [
                                                    0.15,
                                                    -0.309
                                                ],
                                                [
                                                    0,
                                                    -0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.107,
                                                    -0.725
                                                ],
                                                [
                                                    0.362,
                                                    -0.341
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    0
                                                ],
                                                [
                                                    -0.279,
                                                    0.149
                                                ],
                                                [
                                                    -0.138,
                                                    0.299
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    88.276,
                                                    -3.82
                                                ],
                                                [
                                                    88.276,
                                                    -12.3
                                                ],
                                                [
                                                    89.461,
                                                    -12.3
                                                ],
                                                [
                                                    89.525,
                                                    -10.156
                                                ],
                                                [
                                                    89.396,
                                                    -10.204
                                                ],
                                                [
                                                    90.085,
                                                    -11.788
                                                ],
                                                [
                                                    91.525,
                                                    -12.3
                                                ],
                                                [
                                                    92.357,
                                                    -12.3
                                                ],
                                                [
                                                    92.357,
                                                    -11.02
                                                ],
                                                [
                                                    91.54,
                                                    -11.02
                                                ],
                                                [
                                                    90.469,
                                                    -10.78
                                                ],
                                                [
                                                    89.828,
                                                    -10.092
                                                ],
                                                [
                                                    89.621,
                                                    -8.94
                                                ],
                                                [
                                                    89.621,
                                                    -3.82
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 43",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.267,
                                                    0.32
                                                ],
                                                [
                                                    -0.374,
                                                    0.16
                                                ],
                                                [
                                                    -0.437,
                                                    0
                                                ],
                                                [
                                                    -0.417,
                                                    -0.288
                                                ],
                                                [
                                                    -0.204,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    -0.597
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.128,
                                                    0.352
                                                ],
                                                [
                                                    0.266,
                                                    0.181
                                                ],
                                                [
                                                    0.425,
                                                    0
                                                ],
                                                [
                                                    0.425,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.105,
                                                    -0.501
                                                ],
                                                [
                                                    0.266,
                                                    -0.331
                                                ],
                                                [
                                                    0.384,
                                                    -0.16
                                                ],
                                                [
                                                    0.65,
                                                    0
                                                ],
                                                [
                                                    0.425,
                                                    0.288
                                                ],
                                                [
                                                    0.212,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    -0.118,
                                                    -0.363
                                                ],
                                                [
                                                    -0.267,
                                                    -0.192
                                                ],
                                                [
                                                    -0.651,
                                                    0
                                                ],
                                                [
                                                    -0.417,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    93.698,
                                                    -3.82
                                                ],
                                                [
                                                    93.698,
                                                    -12.3
                                                ],
                                                [
                                                    94.931,
                                                    -12.3
                                                ],
                                                [
                                                    94.978,
                                                    -10.14
                                                ],
                                                [
                                                    94.819,
                                                    -10.284
                                                ],
                                                [
                                                    95.379,
                                                    -11.516
                                                ],
                                                [
                                                    96.339,
                                                    -12.252
                                                ],
                                                [
                                                    97.57,
                                                    -12.492
                                                ],
                                                [
                                                    99.171,
                                                    -12.06
                                                ],
                                                [
                                                    100.115,
                                                    -10.892
                                                ],
                                                [
                                                    100.435,
                                                    -9.276
                                                ],
                                                [
                                                    100.435,
                                                    -3.82
                                                ],
                                                [
                                                    99.09,
                                                    -3.82
                                                ],
                                                [
                                                    99.09,
                                                    -8.892
                                                ],
                                                [
                                                    98.898,
                                                    -10.204
                                                ],
                                                [
                                                    98.323,
                                                    -11.02
                                                ],
                                                [
                                                    97.283,
                                                    -11.308
                                                ],
                                                [
                                                    95.667,
                                                    -10.684
                                                ],
                                                [
                                                    95.043,
                                                    -8.892
                                                ],
                                                [
                                                    95.043,
                                                    -3.82
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 44",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.481,
                                                    0
                                                ],
                                                [
                                                    0.523,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    -0.427,
                                                    0.416
                                                ],
                                                [
                                                    -0.928,
                                                    0.171
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.34,
                                                    0.352
                                                ],
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.341,
                                                    -0.267
                                                ],
                                                [
                                                    0.127,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.608,
                                                    0.491
                                                ],
                                                [
                                                    -0.961,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.619
                                                ],
                                                [
                                                    0,
                                                    -1.077
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.085
                                                ],
                                                [
                                                    -0.16,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.096,
                                                    0
                                                ],
                                                [
                                                    0.106,
                                                    0
                                                ],
                                                [
                                                    0.244,
                                                    0.117
                                                ],
                                                [
                                                    0.107,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.287,
                                                    -0.299
                                                ],
                                                [
                                                    0.427,
                                                    -0.171
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.875,
                                                    0
                                                ],
                                                [
                                                    -0.512,
                                                    -0.405
                                                ],
                                                [
                                                    0,
                                                    -0.725
                                                ],
                                                [
                                                    0.427,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.715
                                                ],
                                                [
                                                    -0.332,
                                                    -0.352
                                                ],
                                                [
                                                    -0.587,
                                                    0
                                                ],
                                                [
                                                    -0.34,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.16,
                                                    -0.8
                                                ],
                                                [
                                                    0.618,
                                                    -0.501
                                                ],
                                                [
                                                    1.087,
                                                    0
                                                ],
                                                [
                                                    0.577,
                                                    0.608
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.192
                                                ],
                                                [
                                                    0.074,
                                                    0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.043,
                                                    0.011
                                                ],
                                                [
                                                    -0.095,
                                                    0.011
                                                ],
                                                [
                                                    -0.385,
                                                    0
                                                ],
                                                [
                                                    -0.236,
                                                    -0.128
                                                ],
                                                [
                                                    -0.107,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.076,
                                                    0.363
                                                ],
                                                [
                                                    -0.288,
                                                    0.288
                                                ],
                                                [
                                                    -0.427,
                                                    0.16
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    105.126,
                                                    -3.628
                                                ],
                                                [
                                                    103.03,
                                                    -4.236
                                                ],
                                                [
                                                    102.263,
                                                    -5.932
                                                ],
                                                [
                                                    102.902,
                                                    -7.644
                                                ],
                                                [
                                                    104.935,
                                                    -8.524
                                                ],
                                                [
                                                    107.943,
                                                    -9.084
                                                ],
                                                [
                                                    107.431,
                                                    -10.684
                                                ],
                                                [
                                                    105.927,
                                                    -11.212
                                                ],
                                                [
                                                    104.534,
                                                    -10.812
                                                ],
                                                [
                                                    103.831,
                                                    -9.692
                                                ],
                                                [
                                                    102.406,
                                                    -9.804
                                                ],
                                                [
                                                    103.559,
                                                    -11.74
                                                ],
                                                [
                                                    105.927,
                                                    -12.492
                                                ],
                                                [
                                                    108.422,
                                                    -11.564
                                                ],
                                                [
                                                    109.286,
                                                    -9.036
                                                ],
                                                [
                                                    109.286,
                                                    -5.532
                                                ],
                                                [
                                                    109.383,
                                                    -5.116
                                                ],
                                                [
                                                    109.734,
                                                    -5.004
                                                ],
                                                [
                                                    110.07,
                                                    -5.004
                                                ],
                                                [
                                                    110.07,
                                                    -3.82
                                                ],
                                                [
                                                    109.862,
                                                    -3.804
                                                ],
                                                [
                                                    109.559,
                                                    -3.788
                                                ],
                                                [
                                                    108.615,
                                                    -3.964
                                                ],
                                                [
                                                    108.103,
                                                    -4.54
                                                ],
                                                [
                                                    107.943,
                                                    -5.58
                                                ],
                                                [
                                                    108.103,
                                                    -5.548
                                                ],
                                                [
                                                    107.559,
                                                    -4.556
                                                ],
                                                [
                                                    106.487,
                                                    -3.868
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 45",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.491,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    0.213
                                                ],
                                                [
                                                    -0.213,
                                                    0.373
                                                ],
                                                [
                                                    0,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.224,
                                                    -0.224
                                                ],
                                                [
                                                    0,
                                                    -0.352
                                                ],
                                                [
                                                    -0.276,
                                                    -0.224
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.565,
                                                    0
                                                ],
                                                [
                                                    0.405,
                                                    -0.224
                                                ],
                                                [
                                                    0.214,
                                                    -0.384
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.575,
                                                    0.107
                                                ],
                                                [
                                                    -0.214,
                                                    0.213
                                                ],
                                                [
                                                    0,
                                                    0.395
                                                ],
                                                [
                                                    0.289,
                                                    0.213
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    105.254,
                                                    -4.812
                                                ],
                                                [
                                                    106.694,
                                                    -5.132
                                                ],
                                                [
                                                    107.622,
                                                    -6.028
                                                ],
                                                [
                                                    107.943,
                                                    -7.308
                                                ],
                                                [
                                                    107.943,
                                                    -7.916
                                                ],
                                                [
                                                    105.19,
                                                    -7.404
                                                ],
                                                [
                                                    103.991,
                                                    -6.908
                                                ],
                                                [
                                                    103.671,
                                                    -6.06
                                                ],
                                                [
                                                    104.086,
                                                    -5.132
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 46",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.31,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.084,
                                                    -0.096
                                                ],
                                                [
                                                    -0.169,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.491,
                                                    0
                                                ],
                                                [
                                                    -0.308,
                                                    -0.256
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.171
                                                ],
                                                [
                                                    0.097,
                                                    0.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    113.159,
                                                    -3.82
                                                ],
                                                [
                                                    111.958,
                                                    -4.204
                                                ],
                                                [
                                                    111.495,
                                                    -5.42
                                                ],
                                                [
                                                    111.495,
                                                    -15.18
                                                ],
                                                [
                                                    112.839,
                                                    -15.18
                                                ],
                                                [
                                                    112.839,
                                                    -5.532
                                                ],
                                                [
                                                    112.966,
                                                    -5.132
                                                ],
                                                [
                                                    113.366,
                                                    -5.004
                                                ],
                                                [
                                                    114.103,
                                                    -5.004
                                                ],
                                                [
                                                    114.103,
                                                    -3.82
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 47",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    118.801,
                                                    -3.82
                                                ],
                                                [
                                                    122.896,
                                                    -15.18
                                                ],
                                                [
                                                    124.753,
                                                    -15.18
                                                ],
                                                [
                                                    128.849,
                                                    -3.82
                                                ],
                                                [
                                                    127.345,
                                                    -3.82
                                                ],
                                                [
                                                    126.208,
                                                    -7.052
                                                ],
                                                [
                                                    121.44,
                                                    -7.052
                                                ],
                                                [
                                                    120.305,
                                                    -3.82
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 48",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    121.905,
                                                    -8.396
                                                ],
                                                [
                                                    125.745,
                                                    -8.396
                                                ],
                                                [
                                                    123.824,
                                                    -13.98
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 49",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.703,
                                                    -0.608
                                                ],
                                                [
                                                    0,
                                                    -1.077
                                                ],
                                                [
                                                    0.319,
                                                    -0.533
                                                ],
                                                [
                                                    0.596,
                                                    -0.277
                                                ],
                                                [
                                                    0.842,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.269,
                                                    0
                                                ],
                                                [
                                                    0.705,
                                                    0.608
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    -0.32,
                                                    0.523
                                                ],
                                                [
                                                    -0.598,
                                                    0.277
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    130.327,
                                                    -3.82
                                                ],
                                                [
                                                    130.327,
                                                    -15.18
                                                ],
                                                [
                                                    134.408,
                                                    -15.18
                                                ],
                                                [
                                                    137.367,
                                                    -14.268
                                                ],
                                                [
                                                    138.423,
                                                    -11.74
                                                ],
                                                [
                                                    137.944,
                                                    -9.852
                                                ],
                                                [
                                                    136.568,
                                                    -8.652
                                                ],
                                                [
                                                    134.408,
                                                    -8.236
                                                ],
                                                [
                                                    131.703,
                                                    -8.236
                                                ],
                                                [
                                                    131.703,
                                                    -3.82
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 50",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.426,
                                                    0.363
                                                ],
                                                [
                                                    0,
                                                    0.715
                                                ],
                                                [
                                                    0.437,
                                                    0.352
                                                ],
                                                [
                                                    0.852,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.852,
                                                    0
                                                ],
                                                [
                                                    0.437,
                                                    -0.363
                                                ],
                                                [
                                                    0,
                                                    -0.693
                                                ],
                                                [
                                                    -0.426,
                                                    -0.352
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    131.703,
                                                    -9.58
                                                ],
                                                [
                                                    134.408,
                                                    -9.58
                                                ],
                                                [
                                                    136.327,
                                                    -10.124
                                                ],
                                                [
                                                    136.983,
                                                    -11.74
                                                ],
                                                [
                                                    136.327,
                                                    -13.308
                                                ],
                                                [
                                                    134.408,
                                                    -13.836
                                                ],
                                                [
                                                    131.703,
                                                    -13.836
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 51",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    140.422,
                                                    -3.82
                                                ],
                                                [
                                                    140.422,
                                                    -15.18
                                                ],
                                                [
                                                    141.797,
                                                    -15.18
                                                ],
                                                [
                                                    141.797,
                                                    -3.82
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 52",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.374,
                                                    0
                                                ],
                                                [
                                                    0.268,
                                                    0.149
                                                ],
                                                [
                                                    0.15,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0.331
                                                ],
                                                [
                                                    -0.138,
                                                    0.256
                                                ],
                                                [
                                                    -0.266,
                                                    0.149
                                                ],
                                                [
                                                    -0.374,
                                                    0
                                                ],
                                                [
                                                    -0.265,
                                                    -0.149
                                                ],
                                                [
                                                    -0.138,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    -0.341
                                                ],
                                                [
                                                    0.149,
                                                    -0.267
                                                ],
                                                [
                                                    0.267,
                                                    -0.149
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.374,
                                                    0
                                                ],
                                                [
                                                    -0.266,
                                                    -0.149
                                                ],
                                                [
                                                    -0.138,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    -0.341
                                                ],
                                                [
                                                    0.15,
                                                    -0.267
                                                ],
                                                [
                                                    0.268,
                                                    -0.149
                                                ],
                                                [
                                                    0.374,
                                                    0
                                                ],
                                                [
                                                    0.267,
                                                    0.149
                                                ],
                                                [
                                                    0.149,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0.331
                                                ],
                                                [
                                                    -0.138,
                                                    0.256
                                                ],
                                                [
                                                    -0.265,
                                                    0.149
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    149.758,
                                                    -7.068
                                                ],
                                                [
                                                    148.797,
                                                    -7.292
                                                ],
                                                [
                                                    148.173,
                                                    -7.9
                                                ],
                                                [
                                                    147.965,
                                                    -8.796
                                                ],
                                                [
                                                    148.173,
                                                    -9.692
                                                ],
                                                [
                                                    148.797,
                                                    -10.316
                                                ],
                                                [
                                                    149.758,
                                                    -10.54
                                                ],
                                                [
                                                    150.717,
                                                    -10.316
                                                ],
                                                [
                                                    151.326,
                                                    -9.692
                                                ],
                                                [
                                                    151.549,
                                                    -8.796
                                                ],
                                                [
                                                    151.326,
                                                    -7.9
                                                ],
                                                [
                                                    150.717,
                                                    -7.292
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 53",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.906,
                                                    0
                                                ],
                                                [
                                                    0.767,
                                                    0.469
                                                ],
                                                [
                                                    0.427,
                                                    0.885
                                                ],
                                                [
                                                    0,
                                                    1.227
                                                ],
                                                [
                                                    -0.426,
                                                    0.885
                                                ],
                                                [
                                                    -0.768,
                                                    0.48
                                                ],
                                                [
                                                    -1.014,
                                                    0
                                                ],
                                                [
                                                    -0.758,
                                                    -0.693
                                                ],
                                                [
                                                    -0.234,
                                                    -1.195
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.523,
                                                    0.469
                                                ],
                                                [
                                                    0.949,
                                                    0
                                                ],
                                                [
                                                    0.555,
                                                    -0.373
                                                ],
                                                [
                                                    0.31,
                                                    -0.693
                                                ],
                                                [
                                                    0,
                                                    -0.96
                                                ],
                                                [
                                                    -0.309,
                                                    -0.683
                                                ],
                                                [
                                                    -0.544,
                                                    -0.363
                                                ],
                                                [
                                                    -0.726,
                                                    0
                                                ],
                                                [
                                                    -0.544,
                                                    0.512
                                                ],
                                                [
                                                    -0.139,
                                                    0.885
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    -0.619
                                                ],
                                                [
                                                    0.672,
                                                    -0.352
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.014,
                                                    0
                                                ],
                                                [
                                                    -0.768,
                                                    -0.48
                                                ],
                                                [
                                                    -0.426,
                                                    -0.885
                                                ],
                                                [
                                                    0,
                                                    -1.227
                                                ],
                                                [
                                                    0.427,
                                                    -0.896
                                                ],
                                                [
                                                    0.767,
                                                    -0.48
                                                ],
                                                [
                                                    1.375,
                                                    0
                                                ],
                                                [
                                                    0.757,
                                                    0.693
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.16,
                                                    -0.811
                                                ],
                                                [
                                                    -0.522,
                                                    -0.469
                                                ],
                                                [
                                                    -0.726,
                                                    0
                                                ],
                                                [
                                                    -0.544,
                                                    0.363
                                                ],
                                                [
                                                    -0.309,
                                                    0.683
                                                ],
                                                [
                                                    0,
                                                    0.96
                                                ],
                                                [
                                                    0.31,
                                                    0.683
                                                ],
                                                [
                                                    0.555,
                                                    0.363
                                                ],
                                                [
                                                    0.992,
                                                    0
                                                ],
                                                [
                                                    0.544,
                                                    -0.523
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.139,
                                                    0.821
                                                ],
                                                [
                                                    -0.405,
                                                    0.619
                                                ],
                                                [
                                                    -0.661,
                                                    0.341
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -146.445,
                                                    15.436
                                                ],
                                                [
                                                    -149.117,
                                                    14.732
                                                ],
                                                [
                                                    -150.91,
                                                    12.684
                                                ],
                                                [
                                                    -151.549,
                                                    9.516
                                                ],
                                                [
                                                    -150.91,
                                                    6.348
                                                ],
                                                [
                                                    -149.117,
                                                    4.284
                                                ],
                                                [
                                                    -146.445,
                                                    3.564
                                                ],
                                                [
                                                    -143.245,
                                                    4.604
                                                ],
                                                [
                                                    -141.758,
                                                    7.436
                                                ],
                                                [
                                                    -143.214,
                                                    7.532
                                                ],
                                                [
                                                    -144.238,
                                                    5.612
                                                ],
                                                [
                                                    -146.445,
                                                    4.908
                                                ],
                                                [
                                                    -148.366,
                                                    5.468
                                                ],
                                                [
                                                    -149.646,
                                                    7.052
                                                ],
                                                [
                                                    -150.109,
                                                    9.516
                                                ],
                                                [
                                                    -149.646,
                                                    11.98
                                                ],
                                                [
                                                    -148.366,
                                                    13.548
                                                ],
                                                [
                                                    -146.445,
                                                    14.092
                                                ],
                                                [
                                                    -144.142,
                                                    13.324
                                                ],
                                                [
                                                    -143.117,
                                                    11.212
                                                ],
                                                [
                                                    -141.661,
                                                    11.308
                                                ],
                                                [
                                                    -142.478,
                                                    13.468
                                                ],
                                                [
                                                    -144.094,
                                                    14.924
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 54",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.726,
                                                    0
                                                ],
                                                [
                                                    0.512,
                                                    0.565
                                                ],
                                                [
                                                    0,
                                                    1.003
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    -0.395
                                                ],
                                                [
                                                    -0.608,
                                                    0
                                                ],
                                                [
                                                    -0.384,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0.757
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    -0.384
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.842,
                                                    0
                                                ],
                                                [
                                                    -0.501,
                                                    -0.576
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ],
                                                [
                                                    0.299,
                                                    0.384
                                                ],
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.384,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.17,
                                                    0.693
                                                ],
                                                [
                                                    -0.48,
                                                    0.373
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -137.112,
                                                    15.372
                                                ],
                                                [
                                                    -139.144,
                                                    14.524
                                                ],
                                                [
                                                    -139.896,
                                                    12.156
                                                ],
                                                [
                                                    -139.896,
                                                    6.7
                                                ],
                                                [
                                                    -138.552,
                                                    6.7
                                                ],
                                                [
                                                    -138.552,
                                                    11.788
                                                ],
                                                [
                                                    -138.12,
                                                    13.612
                                                ],
                                                [
                                                    -136.76,
                                                    14.188
                                                ],
                                                [
                                                    -135.176,
                                                    13.548
                                                ],
                                                [
                                                    -134.6,
                                                    11.756
                                                ],
                                                [
                                                    -134.6,
                                                    6.7
                                                ],
                                                [
                                                    -133.256,
                                                    6.7
                                                ],
                                                [
                                                    -133.256,
                                                    15.18
                                                ],
                                                [
                                                    -134.536,
                                                    15.18
                                                ],
                                                [
                                                    -134.536,
                                                    13.084
                                                ],
                                                [
                                                    -134.328,
                                                    13.196
                                                ],
                                                [
                                                    -135.304,
                                                    14.812
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 55",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.939,
                                                    0
                                                ],
                                                [
                                                    0.534,
                                                    0.245
                                                ],
                                                [
                                                    0.288,
                                                    0.427
                                                ],
                                                [
                                                    0.043,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.33,
                                                    -0.309
                                                ],
                                                [
                                                    -0.747,
                                                    0
                                                ],
                                                [
                                                    -0.309,
                                                    0.181
                                                ],
                                                [
                                                    0,
                                                    0.416
                                                ],
                                                [
                                                    0.107,
                                                    0.149
                                                ],
                                                [
                                                    0.299,
                                                    0.107
                                                ],
                                                [
                                                    0.576,
                                                    0.107
                                                ],
                                                [
                                                    0.448,
                                                    0.224
                                                ],
                                                [
                                                    0.182,
                                                    0.32
                                                ],
                                                [
                                                    0,
                                                    0.448
                                                ],
                                                [
                                                    -0.554,
                                                    0.48
                                                ],
                                                [
                                                    -1.024,
                                                    0
                                                ],
                                                [
                                                    -0.469,
                                                    -0.267
                                                ],
                                                [
                                                    -0.245,
                                                    -0.416
                                                ],
                                                [
                                                    -0.053,
                                                    -0.459
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.139,
                                                    0.235
                                                ],
                                                [
                                                    0.278,
                                                    0.139
                                                ],
                                                [
                                                    0.469,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    -0.363
                                                ],
                                                [
                                                    -0.107,
                                                    -0.181
                                                ],
                                                [
                                                    -0.277,
                                                    -0.117
                                                ],
                                                [
                                                    -0.49,
                                                    -0.085
                                                ],
                                                [
                                                    -0.469,
                                                    -0.213
                                                ],
                                                [
                                                    -0.181,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.448
                                                ],
                                                [
                                                    0.608,
                                                    -0.437
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.522,
                                                    -0.245
                                                ],
                                                [
                                                    -0.277,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.085,
                                                    0.512
                                                ],
                                                [
                                                    0.342,
                                                    0.299
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    -0.224
                                                ],
                                                [
                                                    -0.096,
                                                    -0.149
                                                ],
                                                [
                                                    -0.299,
                                                    -0.117
                                                ],
                                                [
                                                    -0.789,
                                                    -0.149
                                                ],
                                                [
                                                    -0.448,
                                                    -0.224
                                                ],
                                                [
                                                    -0.181,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.757
                                                ],
                                                [
                                                    0.566,
                                                    -0.491
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    0.256
                                                ],
                                                [
                                                    0.245,
                                                    0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.021,
                                                    -0.267
                                                ],
                                                [
                                                    -0.138,
                                                    -0.235
                                                ],
                                                [
                                                    -0.277,
                                                    -0.149
                                                ],
                                                [
                                                    -0.608,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0.277
                                                ],
                                                [
                                                    0.117,
                                                    0.171
                                                ],
                                                [
                                                    0.288,
                                                    0.107
                                                ],
                                                [
                                                    0.832,
                                                    0.139
                                                ],
                                                [
                                                    0.469,
                                                    0.213
                                                ],
                                                [
                                                    0.192,
                                                    0.309
                                                ],
                                                [
                                                    0,
                                                    0.779
                                                ],
                                                [
                                                    -0.597,
                                                    0.427
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -127.761,
                                                    15.372
                                                ],
                                                [
                                                    -129.729,
                                                    15.004
                                                ],
                                                [
                                                    -130.945,
                                                    13.996
                                                ],
                                                [
                                                    -131.425,
                                                    12.508
                                                ],
                                                [
                                                    -130.017,
                                                    12.412
                                                ],
                                                [
                                                    -129.393,
                                                    13.644
                                                ],
                                                [
                                                    -127.761,
                                                    14.092
                                                ],
                                                [
                                                    -126.433,
                                                    13.82
                                                ],
                                                [
                                                    -125.953,
                                                    12.908
                                                ],
                                                [
                                                    -126.113,
                                                    12.348
                                                ],
                                                [
                                                    -126.705,
                                                    11.964
                                                ],
                                                [
                                                    -128.017,
                                                    11.628
                                                ],
                                                [
                                                    -129.873,
                                                    11.068
                                                ],
                                                [
                                                    -130.817,
                                                    10.252
                                                ],
                                                [
                                                    -131.089,
                                                    9.1
                                                ],
                                                [
                                                    -130.257,
                                                    7.244
                                                ],
                                                [
                                                    -127.873,
                                                    6.508
                                                ],
                                                [
                                                    -126.049,
                                                    6.908
                                                ],
                                                [
                                                    -124.961,
                                                    7.916
                                                ],
                                                [
                                                    -124.513,
                                                    9.228
                                                ],
                                                [
                                                    -125.921,
                                                    9.324
                                                ],
                                                [
                                                    -126.161,
                                                    8.572
                                                ],
                                                [
                                                    -126.785,
                                                    8.012
                                                ],
                                                [
                                                    -127.905,
                                                    7.788
                                                ],
                                                [
                                                    -129.249,
                                                    8.14
                                                ],
                                                [
                                                    -129.681,
                                                    9.036
                                                ],
                                                [
                                                    -129.521,
                                                    9.724
                                                ],
                                                [
                                                    -128.929,
                                                    10.156
                                                ],
                                                [
                                                    -127.761,
                                                    10.444
                                                ],
                                                [
                                                    -125.809,
                                                    10.972
                                                ],
                                                [
                                                    -124.833,
                                                    11.772
                                                ],
                                                [
                                                    -124.545,
                                                    12.908
                                                ],
                                                [
                                                    -125.457,
                                                    14.732
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 56",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.374,
                                                    0.352
                                                ],
                                                [
                                                    0,
                                                    0.747
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.17,
                                                    -0.149
                                                ],
                                                [
                                                    -0.352,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.768,
                                                    0
                                                ],
                                                [
                                                    -0.362,
                                                    -0.352
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.384
                                                ],
                                                [
                                                    0.171,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -119.917,
                                                    15.18
                                                ],
                                                [
                                                    -121.629,
                                                    14.652
                                                ],
                                                [
                                                    -122.173,
                                                    13.004
                                                ],
                                                [
                                                    -122.173,
                                                    4.716
                                                ],
                                                [
                                                    -120.829,
                                                    4.716
                                                ],
                                                [
                                                    -120.829,
                                                    12.972
                                                ],
                                                [
                                                    -120.573,
                                                    13.772
                                                ],
                                                [
                                                    -119.789,
                                                    13.996
                                                ],
                                                [
                                                    -118.573,
                                                    13.996
                                                ],
                                                [
                                                    -118.573,
                                                    15.18
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 57",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -123.421,
                                                    7.884
                                                ],
                                                [
                                                    -123.421,
                                                    6.7
                                                ],
                                                [
                                                    -118.573,
                                                    6.7
                                                ],
                                                [
                                                    -118.573,
                                                    7.884
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 58",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.779,
                                                    0
                                                ],
                                                [
                                                    0.586,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.32,
                                                    0.661
                                                ],
                                                [
                                                    -0.587,
                                                    0.363
                                                ],
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.363
                                                ],
                                                [
                                                    -0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.907
                                                ],
                                                [
                                                    0.32,
                                                    -0.672
                                                ],
                                                [
                                                    0.586,
                                                    -0.363
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.587,
                                                    -0.363
                                                ],
                                                [
                                                    -0.32,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.907
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.586,
                                                    -0.363
                                                ],
                                                [
                                                    0.779,
                                                    0
                                                ],
                                                [
                                                    0.586,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.32,
                                                    0.661
                                                ],
                                                [
                                                    -0.576,
                                                    0.363
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -113.693,
                                                    15.372
                                                ],
                                                [
                                                    -115.741,
                                                    14.828
                                                ],
                                                [
                                                    -117.101,
                                                    13.292
                                                ],
                                                [
                                                    -117.581,
                                                    10.94
                                                ],
                                                [
                                                    -117.101,
                                                    8.588
                                                ],
                                                [
                                                    -115.741,
                                                    7.052
                                                ],
                                                [
                                                    -113.693,
                                                    6.508
                                                ],
                                                [
                                                    -111.661,
                                                    7.052
                                                ],
                                                [
                                                    -110.301,
                                                    8.588
                                                ],
                                                [
                                                    -109.821,
                                                    10.94
                                                ],
                                                [
                                                    -110.301,
                                                    13.292
                                                ],
                                                [
                                                    -111.661,
                                                    14.828
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 59",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0.981
                                                ],
                                                [
                                                    0.437,
                                                    0.555
                                                ],
                                                [
                                                    0.779,
                                                    0
                                                ],
                                                [
                                                    0.437,
                                                    -0.565
                                                ],
                                                [
                                                    0,
                                                    -0.981
                                                ],
                                                [
                                                    -0.437,
                                                    -0.565
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.779,
                                                    0
                                                ],
                                                [
                                                    0.437,
                                                    -0.565
                                                ],
                                                [
                                                    0,
                                                    -0.981
                                                ],
                                                [
                                                    -0.427,
                                                    -0.565
                                                ],
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.437,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0.981
                                                ],
                                                [
                                                    0.437,
                                                    0.555
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -113.693,
                                                    14.092
                                                ],
                                                [
                                                    -111.885,
                                                    13.26
                                                ],
                                                [
                                                    -111.229,
                                                    10.94
                                                ],
                                                [
                                                    -111.885,
                                                    8.636
                                                ],
                                                [
                                                    -113.693,
                                                    7.788
                                                ],
                                                [
                                                    -115.517,
                                                    8.636
                                                ],
                                                [
                                                    -116.173,
                                                    10.94
                                                ],
                                                [
                                                    -115.517,
                                                    13.26
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 60",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.234,
                                                    0.331
                                                ],
                                                [
                                                    -0.353,
                                                    0.181
                                                ],
                                                [
                                                    -0.427,
                                                    0
                                                ],
                                                [
                                                    -0.459,
                                                    -0.405
                                                ],
                                                [
                                                    -0.117,
                                                    -0.725
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    0.331
                                                ],
                                                [
                                                    -0.363,
                                                    0.181
                                                ],
                                                [
                                                    -0.47,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    -0.256
                                                ],
                                                [
                                                    -0.213,
                                                    -0.48
                                                ],
                                                [
                                                    0,
                                                    -0.683
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.299,
                                                    0.384
                                                ],
                                                [
                                                    0.586,
                                                    0
                                                ],
                                                [
                                                    0.298,
                                                    -0.192
                                                ],
                                                [
                                                    0.161,
                                                    -0.363
                                                ],
                                                [
                                                    0,
                                                    -0.512
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.267,
                                                    0.427
                                                ],
                                                [
                                                    0.629,
                                                    0
                                                ],
                                                [
                                                    0.298,
                                                    -0.192
                                                ],
                                                [
                                                    0.171,
                                                    -0.363
                                                ],
                                                [
                                                    0,
                                                    -0.501
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.096,
                                                    -0.469
                                                ],
                                                [
                                                    0.246,
                                                    -0.341
                                                ],
                                                [
                                                    0.351,
                                                    -0.192
                                                ],
                                                [
                                                    0.736,
                                                    0
                                                ],
                                                [
                                                    0.469,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.085,
                                                    -0.491
                                                ],
                                                [
                                                    0.235,
                                                    -0.341
                                                ],
                                                [
                                                    0.362,
                                                    -0.181
                                                ],
                                                [
                                                    0.607,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    0.245
                                                ],
                                                [
                                                    0.214,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.768
                                                ],
                                                [
                                                    -0.298,
                                                    -0.395
                                                ],
                                                [
                                                    -0.395,
                                                    0
                                                ],
                                                [
                                                    -0.289,
                                                    0.192
                                                ],
                                                [
                                                    -0.159,
                                                    0.352
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.757
                                                ],
                                                [
                                                    -0.266,
                                                    -0.427
                                                ],
                                                [
                                                    -0.395,
                                                    0
                                                ],
                                                [
                                                    -0.289,
                                                    0.192
                                                ],
                                                [
                                                    -0.159,
                                                    0.363
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -107.99,
                                                    15.18
                                                ],
                                                [
                                                    -107.99,
                                                    6.7
                                                ],
                                                [
                                                    -106.757,
                                                    6.7
                                                ],
                                                [
                                                    -106.71,
                                                    8.844
                                                ],
                                                [
                                                    -106.902,
                                                    8.78
                                                ],
                                                [
                                                    -106.406,
                                                    7.58
                                                ],
                                                [
                                                    -105.509,
                                                    6.796
                                                ],
                                                [
                                                    -104.341,
                                                    6.508
                                                ],
                                                [
                                                    -102.549,
                                                    7.116
                                                ],
                                                [
                                                    -101.67,
                                                    8.812
                                                ],
                                                [
                                                    -101.925,
                                                    8.796
                                                ],
                                                [
                                                    -101.462,
                                                    7.564
                                                ],
                                                [
                                                    -100.565,
                                                    6.78
                                                ],
                                                [
                                                    -99.317,
                                                    6.508
                                                ],
                                                [
                                                    -97.782,
                                                    6.892
                                                ],
                                                [
                                                    -96.838,
                                                    7.98
                                                ],
                                                [
                                                    -96.518,
                                                    9.724
                                                ],
                                                [
                                                    -96.518,
                                                    15.18
                                                ],
                                                [
                                                    -97.862,
                                                    15.18
                                                ],
                                                [
                                                    -97.862,
                                                    10.012
                                                ],
                                                [
                                                    -98.31,
                                                    8.284
                                                ],
                                                [
                                                    -99.637,
                                                    7.692
                                                ],
                                                [
                                                    -100.677,
                                                    7.98
                                                ],
                                                [
                                                    -101.35,
                                                    8.812
                                                ],
                                                [
                                                    -101.59,
                                                    10.108
                                                ],
                                                [
                                                    -101.59,
                                                    15.18
                                                ],
                                                [
                                                    -102.934,
                                                    15.18
                                                ],
                                                [
                                                    -102.934,
                                                    10.108
                                                ],
                                                [
                                                    -103.334,
                                                    8.332
                                                ],
                                                [
                                                    -104.677,
                                                    7.692
                                                ],
                                                [
                                                    -105.717,
                                                    7.98
                                                ],
                                                [
                                                    -106.406,
                                                    8.812
                                                ],
                                                [
                                                    -106.646,
                                                    10.108
                                                ],
                                                [
                                                    -106.646,
                                                    15.18
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 61",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.897,
                                                    0
                                                ],
                                                [
                                                    0.587,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.309,
                                                    0.661
                                                ],
                                                [
                                                    -0.565,
                                                    0.363
                                                ],
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    -0.352
                                                ],
                                                [
                                                    -0.311,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.949
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.426,
                                                    -0.459
                                                ],
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.256
                                                ],
                                                [
                                                    -0.139,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.629,
                                                    -0.491
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.8,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.363
                                                ],
                                                [
                                                    -0.309,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.576,
                                                    -0.373
                                                ],
                                                [
                                                    0.737,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    0.341
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.054,
                                                    0.907
                                                ],
                                                [
                                                    0.438,
                                                    0.459
                                                ],
                                                [
                                                    0.555,
                                                    0
                                                ],
                                                [
                                                    0.362,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    0.757
                                                ],
                                                [
                                                    -0.619,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -90.834,
                                                    15.372
                                                ],
                                                [
                                                    -92.914,
                                                    14.828
                                                ],
                                                [
                                                    -94.258,
                                                    13.292
                                                ],
                                                [
                                                    -94.722,
                                                    10.94
                                                ],
                                                [
                                                    -94.258,
                                                    8.604
                                                ],
                                                [
                                                    -92.93,
                                                    7.068
                                                ],
                                                [
                                                    -90.898,
                                                    6.508
                                                ],
                                                [
                                                    -88.946,
                                                    7.036
                                                ],
                                                [
                                                    -87.633,
                                                    8.54
                                                ],
                                                [
                                                    -87.154,
                                                    10.956
                                                ],
                                                [
                                                    -87.154,
                                                    11.356
                                                ],
                                                [
                                                    -93.314,
                                                    11.356
                                                ],
                                                [
                                                    -92.594,
                                                    13.404
                                                ],
                                                [
                                                    -90.834,
                                                    14.092
                                                ],
                                                [
                                                    -89.474,
                                                    13.708
                                                ],
                                                [
                                                    -88.722,
                                                    12.668
                                                ],
                                                [
                                                    -87.282,
                                                    12.78
                                                ],
                                                [
                                                    -88.562,
                                                    14.652
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 62",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.118,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.415,
                                                    0.384
                                                ],
                                                [
                                                    0.629,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    -0.405
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.063,
                                                    -0.821
                                                ],
                                                [
                                                    -0.407,
                                                    -0.384
                                                ],
                                                [
                                                    -0.65,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.395
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -93.314,
                                                    10.172
                                                ],
                                                [
                                                    -88.626,
                                                    10.172
                                                ],
                                                [
                                                    -89.345,
                                                    8.364
                                                ],
                                                [
                                                    -90.898,
                                                    7.788
                                                ],
                                                [
                                                    -92.514,
                                                    8.396
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 63",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.353,
                                                    0.331
                                                ],
                                                [
                                                    -0.597,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.16
                                                ],
                                                [
                                                    0.15,
                                                    -0.309
                                                ],
                                                [
                                                    0,
                                                    -0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.108,
                                                    -0.725
                                                ],
                                                [
                                                    0.363,
                                                    -0.341
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.425,
                                                    0
                                                ],
                                                [
                                                    -0.277,
                                                    0.149
                                                ],
                                                [
                                                    -0.138,
                                                    0.299
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -85.334,
                                                    15.18
                                                ],
                                                [
                                                    -85.334,
                                                    6.7
                                                ],
                                                [
                                                    -84.149,
                                                    6.7
                                                ],
                                                [
                                                    -84.086,
                                                    8.844
                                                ],
                                                [
                                                    -84.214,
                                                    8.796
                                                ],
                                                [
                                                    -83.525,
                                                    7.212
                                                ],
                                                [
                                                    -82.086,
                                                    6.7
                                                ],
                                                [
                                                    -81.254,
                                                    6.7
                                                ],
                                                [
                                                    -81.254,
                                                    7.98
                                                ],
                                                [
                                                    -82.07,
                                                    7.98
                                                ],
                                                [
                                                    -83.142,
                                                    8.22
                                                ],
                                                [
                                                    -83.782,
                                                    8.908
                                                ],
                                                [
                                                    -83.99,
                                                    10.06
                                                ],
                                                [
                                                    -83.99,
                                                    15.18
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 64",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.596,
                                                    0
                                                ],
                                                [
                                                    0.544,
                                                    0.363
                                                ],
                                                [
                                                    0.287,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.907
                                                ],
                                                [
                                                    -0.288,
                                                    0.661
                                                ],
                                                [
                                                    -0.533,
                                                    0.363
                                                ],
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.47,
                                                    -0.245
                                                ],
                                                [
                                                    -0.235,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.479,
                                                    -0.267
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.533,
                                                    -0.363
                                                ],
                                                [
                                                    -0.288,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.907
                                                ],
                                                [
                                                    0.287,
                                                    -0.661
                                                ],
                                                [
                                                    0.544,
                                                    -0.363
                                                ],
                                                [
                                                    0.564,
                                                    0
                                                ],
                                                [
                                                    0.469,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    0.459
                                                ],
                                                [
                                                    -0.481,
                                                    0.256
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -72.262,
                                                    15.372
                                                ],
                                                [
                                                    -74.183,
                                                    14.828
                                                ],
                                                [
                                                    -75.414,
                                                    13.292
                                                ],
                                                [
                                                    -75.847,
                                                    10.94
                                                ],
                                                [
                                                    -75.414,
                                                    8.588
                                                ],
                                                [
                                                    -74.183,
                                                    7.052
                                                ],
                                                [
                                                    -72.262,
                                                    6.508
                                                ],
                                                [
                                                    -70.711,
                                                    6.876
                                                ],
                                                [
                                                    -69.655,
                                                    7.884
                                                ],
                                                [
                                                    -69.655,
                                                    3.82
                                                ],
                                                [
                                                    -68.311,
                                                    3.82
                                                ],
                                                [
                                                    -68.311,
                                                    15.18
                                                ],
                                                [
                                                    -69.527,
                                                    15.18
                                                ],
                                                [
                                                    -69.575,
                                                    13.9
                                                ],
                                                [
                                                    -70.646,
                                                    14.988
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 65",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.747,
                                                    0
                                                ],
                                                [
                                                    -0.342,
                                                    0.256
                                                ],
                                                [
                                                    -0.182,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0.64
                                                ],
                                                [
                                                    0.181,
                                                    0.469
                                                ],
                                                [
                                                    0.352,
                                                    0.245
                                                ],
                                                [
                                                    0.501,
                                                    0
                                                ],
                                                [
                                                    0.448,
                                                    -0.565
                                                ],
                                                [
                                                    0,
                                                    -0.981
                                                ],
                                                [
                                                    -0.437,
                                                    -0.565
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.501,
                                                    0
                                                ],
                                                [
                                                    0.352,
                                                    -0.256
                                                ],
                                                [
                                                    0.181,
                                                    -0.48
                                                ],
                                                [
                                                    0,
                                                    -0.661
                                                ],
                                                [
                                                    -0.182,
                                                    -0.469
                                                ],
                                                [
                                                    -0.342,
                                                    -0.256
                                                ],
                                                [
                                                    -0.747,
                                                    0
                                                ],
                                                [
                                                    -0.437,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0.971
                                                ],
                                                [
                                                    0.448,
                                                    0.565
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -71.991,
                                                    14.092
                                                ],
                                                [
                                                    -70.727,
                                                    13.708
                                                ],
                                                [
                                                    -69.926,
                                                    12.62
                                                ],
                                                [
                                                    -69.655,
                                                    10.94
                                                ],
                                                [
                                                    -69.926,
                                                    9.244
                                                ],
                                                [
                                                    -70.727,
                                                    8.172
                                                ],
                                                [
                                                    -71.991,
                                                    7.788
                                                ],
                                                [
                                                    -73.783,
                                                    8.636
                                                ],
                                                [
                                                    -74.438,
                                                    10.94
                                                ],
                                                [
                                                    -73.783,
                                                    13.244
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 66",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.479,
                                                    0
                                                ],
                                                [
                                                    0.522,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    -0.426,
                                                    0.416
                                                ],
                                                [
                                                    -0.928,
                                                    0.171
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.341,
                                                    0.352
                                                ],
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.34,
                                                    -0.267
                                                ],
                                                [
                                                    0.128,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.608,
                                                    0.491
                                                ],
                                                [
                                                    -0.96,
                                                    0
                                                ],
                                                [
                                                    -0.577,
                                                    -0.619
                                                ],
                                                [
                                                    0,
                                                    -1.077
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.085
                                                ],
                                                [
                                                    -0.16,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.095,
                                                    0
                                                ],
                                                [
                                                    0.106,
                                                    0
                                                ],
                                                [
                                                    0.244,
                                                    0.117
                                                ],
                                                [
                                                    0.108,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.287,
                                                    -0.299
                                                ],
                                                [
                                                    0.427,
                                                    -0.171
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.875,
                                                    0
                                                ],
                                                [
                                                    -0.512,
                                                    -0.405
                                                ],
                                                [
                                                    0,
                                                    -0.725
                                                ],
                                                [
                                                    0.427,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.715
                                                ],
                                                [
                                                    -0.33,
                                                    -0.352
                                                ],
                                                [
                                                    -0.586,
                                                    0
                                                ],
                                                [
                                                    -0.342,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.159,
                                                    -0.8
                                                ],
                                                [
                                                    0.618,
                                                    -0.501
                                                ],
                                                [
                                                    1.088,
                                                    0
                                                ],
                                                [
                                                    0.576,
                                                    0.608
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.192
                                                ],
                                                [
                                                    0.076,
                                                    0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.043,
                                                    0.011
                                                ],
                                                [
                                                    -0.097,
                                                    0.011
                                                ],
                                                [
                                                    -0.385,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    -0.128
                                                ],
                                                [
                                                    -0.107,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    0.363
                                                ],
                                                [
                                                    -0.289,
                                                    0.288
                                                ],
                                                [
                                                    -0.426,
                                                    0.16
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -63.623,
                                                    15.372
                                                ],
                                                [
                                                    -65.719,
                                                    14.764
                                                ],
                                                [
                                                    -66.488,
                                                    13.068
                                                ],
                                                [
                                                    -65.848,
                                                    11.356
                                                ],
                                                [
                                                    -63.815,
                                                    10.476
                                                ],
                                                [
                                                    -60.807,
                                                    9.916
                                                ],
                                                [
                                                    -61.32,
                                                    8.316
                                                ],
                                                [
                                                    -62.824,
                                                    7.788
                                                ],
                                                [
                                                    -64.215,
                                                    8.188
                                                ],
                                                [
                                                    -64.92,
                                                    9.308
                                                ],
                                                [
                                                    -66.343,
                                                    9.196
                                                ],
                                                [
                                                    -65.191,
                                                    7.26
                                                ],
                                                [
                                                    -62.824,
                                                    6.508
                                                ],
                                                [
                                                    -60.327,
                                                    7.436
                                                ],
                                                [
                                                    -59.464,
                                                    9.964
                                                ],
                                                [
                                                    -59.464,
                                                    13.468
                                                ],
                                                [
                                                    -59.368,
                                                    13.884
                                                ],
                                                [
                                                    -59.016,
                                                    13.996
                                                ],
                                                [
                                                    -58.68,
                                                    13.996
                                                ],
                                                [
                                                    -58.68,
                                                    15.18
                                                ],
                                                [
                                                    -58.887,
                                                    15.196
                                                ],
                                                [
                                                    -59.191,
                                                    15.212
                                                ],
                                                [
                                                    -60.135,
                                                    15.036
                                                ],
                                                [
                                                    -60.648,
                                                    14.46
                                                ],
                                                [
                                                    -60.807,
                                                    13.42
                                                ],
                                                [
                                                    -60.648,
                                                    13.452
                                                ],
                                                [
                                                    -61.191,
                                                    14.444
                                                ],
                                                [
                                                    -62.264,
                                                    15.132
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 67",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.492,
                                                    0
                                                ],
                                                [
                                                    -0.396,
                                                    0.213
                                                ],
                                                [
                                                    -0.212,
                                                    0.373
                                                ],
                                                [
                                                    0,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.224,
                                                    -0.224
                                                ],
                                                [
                                                    0,
                                                    -0.352
                                                ],
                                                [
                                                    -0.277,
                                                    -0.224
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.564,
                                                    0
                                                ],
                                                [
                                                    0.405,
                                                    -0.224
                                                ],
                                                [
                                                    0.213,
                                                    -0.384
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.575,
                                                    0.107
                                                ],
                                                [
                                                    -0.214,
                                                    0.213
                                                ],
                                                [
                                                    0,
                                                    0.395
                                                ],
                                                [
                                                    0.287,
                                                    0.213
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -63.495,
                                                    14.188
                                                ],
                                                [
                                                    -62.055,
                                                    13.868
                                                ],
                                                [
                                                    -61.128,
                                                    12.972
                                                ],
                                                [
                                                    -60.807,
                                                    11.692
                                                ],
                                                [
                                                    -60.807,
                                                    11.084
                                                ],
                                                [
                                                    -63.56,
                                                    11.596
                                                ],
                                                [
                                                    -64.759,
                                                    12.092
                                                ],
                                                [
                                                    -65.079,
                                                    12.94
                                                ],
                                                [
                                                    -64.663,
                                                    13.868
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 68",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.373,
                                                    0.352
                                                ],
                                                [
                                                    0,
                                                    0.747
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.171,
                                                    -0.149
                                                ],
                                                [
                                                    -0.353,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.767,
                                                    0
                                                ],
                                                [
                                                    -0.364,
                                                    -0.352
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.384
                                                ],
                                                [
                                                    0.17,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -54.792,
                                                    15.18
                                                ],
                                                [
                                                    -56.503,
                                                    14.652
                                                ],
                                                [
                                                    -57.048,
                                                    13.004
                                                ],
                                                [
                                                    -57.048,
                                                    4.716
                                                ],
                                                [
                                                    -55.704,
                                                    4.716
                                                ],
                                                [
                                                    -55.704,
                                                    12.972
                                                ],
                                                [
                                                    -55.447,
                                                    13.772
                                                ],
                                                [
                                                    -54.663,
                                                    13.996
                                                ],
                                                [
                                                    -53.447,
                                                    13.996
                                                ],
                                                [
                                                    -53.447,
                                                    15.18
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 69",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -58.296,
                                                    7.884
                                                ],
                                                [
                                                    -58.296,
                                                    6.7
                                                ],
                                                [
                                                    -53.447,
                                                    6.7
                                                ],
                                                [
                                                    -53.447,
                                                    7.884
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 70",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.481,
                                                    0
                                                ],
                                                [
                                                    0.522,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    -0.427,
                                                    0.416
                                                ],
                                                [
                                                    -0.927,
                                                    0.171
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.341,
                                                    0.352
                                                ],
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.341,
                                                    -0.267
                                                ],
                                                [
                                                    0.127,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.608,
                                                    0.491
                                                ],
                                                [
                                                    -0.96,
                                                    0
                                                ],
                                                [
                                                    -0.577,
                                                    -0.619
                                                ],
                                                [
                                                    0,
                                                    -1.077
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.085
                                                ],
                                                [
                                                    -0.16,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.095,
                                                    0
                                                ],
                                                [
                                                    0.106,
                                                    0
                                                ],
                                                [
                                                    0.244,
                                                    0.117
                                                ],
                                                [
                                                    0.108,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.287,
                                                    -0.299
                                                ],
                                                [
                                                    0.427,
                                                    -0.171
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.875,
                                                    0
                                                ],
                                                [
                                                    -0.513,
                                                    -0.405
                                                ],
                                                [
                                                    0,
                                                    -0.725
                                                ],
                                                [
                                                    0.427,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.715
                                                ],
                                                [
                                                    -0.33,
                                                    -0.352
                                                ],
                                                [
                                                    -0.587,
                                                    0
                                                ],
                                                [
                                                    -0.342,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.16,
                                                    -0.8
                                                ],
                                                [
                                                    0.619,
                                                    -0.501
                                                ],
                                                [
                                                    1.088,
                                                    0
                                                ],
                                                [
                                                    0.576,
                                                    0.608
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.192
                                                ],
                                                [
                                                    0.076,
                                                    0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.043,
                                                    0.011
                                                ],
                                                [
                                                    -0.097,
                                                    0.011
                                                ],
                                                [
                                                    -0.385,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    -0.128
                                                ],
                                                [
                                                    -0.107,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    0.363
                                                ],
                                                [
                                                    -0.289,
                                                    0.288
                                                ],
                                                [
                                                    -0.427,
                                                    0.16
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -49.499,
                                                    15.372
                                                ],
                                                [
                                                    -51.594,
                                                    14.764
                                                ],
                                                [
                                                    -52.363,
                                                    13.068
                                                ],
                                                [
                                                    -51.723,
                                                    11.356
                                                ],
                                                [
                                                    -49.691,
                                                    10.476
                                                ],
                                                [
                                                    -46.682,
                                                    9.916
                                                ],
                                                [
                                                    -47.195,
                                                    8.316
                                                ],
                                                [
                                                    -48.699,
                                                    7.788
                                                ],
                                                [
                                                    -50.09,
                                                    8.188
                                                ],
                                                [
                                                    -50.794,
                                                    9.308
                                                ],
                                                [
                                                    -52.219,
                                                    9.196
                                                ],
                                                [
                                                    -51.066,
                                                    7.26
                                                ],
                                                [
                                                    -48.699,
                                                    6.508
                                                ],
                                                [
                                                    -46.202,
                                                    7.436
                                                ],
                                                [
                                                    -45.339,
                                                    9.964
                                                ],
                                                [
                                                    -45.339,
                                                    13.468
                                                ],
                                                [
                                                    -45.243,
                                                    13.884
                                                ],
                                                [
                                                    -44.891,
                                                    13.996
                                                ],
                                                [
                                                    -44.555,
                                                    13.996
                                                ],
                                                [
                                                    -44.555,
                                                    15.18
                                                ],
                                                [
                                                    -44.762,
                                                    15.196
                                                ],
                                                [
                                                    -45.066,
                                                    15.212
                                                ],
                                                [
                                                    -46.01,
                                                    15.036
                                                ],
                                                [
                                                    -46.523,
                                                    14.46
                                                ],
                                                [
                                                    -46.682,
                                                    13.42
                                                ],
                                                [
                                                    -46.523,
                                                    13.452
                                                ],
                                                [
                                                    -47.066,
                                                    14.444
                                                ],
                                                [
                                                    -48.139,
                                                    15.132
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 71",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.491,
                                                    0
                                                ],
                                                [
                                                    -0.396,
                                                    0.213
                                                ],
                                                [
                                                    -0.212,
                                                    0.373
                                                ],
                                                [
                                                    0,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.224,
                                                    -0.224
                                                ],
                                                [
                                                    0,
                                                    -0.352
                                                ],
                                                [
                                                    -0.278,
                                                    -0.224
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.565,
                                                    0
                                                ],
                                                [
                                                    0.405,
                                                    -0.224
                                                ],
                                                [
                                                    0.213,
                                                    -0.384
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    0.107
                                                ],
                                                [
                                                    -0.213,
                                                    0.213
                                                ],
                                                [
                                                    0,
                                                    0.395
                                                ],
                                                [
                                                    0.287,
                                                    0.213
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -49.37,
                                                    14.188
                                                ],
                                                [
                                                    -47.93,
                                                    13.868
                                                ],
                                                [
                                                    -47.003,
                                                    12.972
                                                ],
                                                [
                                                    -46.682,
                                                    11.692
                                                ],
                                                [
                                                    -46.682,
                                                    11.084
                                                ],
                                                [
                                                    -49.434,
                                                    11.596
                                                ],
                                                [
                                                    -50.635,
                                                    12.092
                                                ],
                                                [
                                                    -50.954,
                                                    12.94
                                                ],
                                                [
                                                    -50.538,
                                                    13.868
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 72",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.745,
                                                    0
                                                ],
                                                [
                                                    0.459,
                                                    0.256
                                                ],
                                                [
                                                    0.245,
                                                    0.459
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.448,
                                                    0.277
                                                ],
                                                [
                                                    -0.588,
                                                    0
                                                ],
                                                [
                                                    -0.543,
                                                    -0.363
                                                ],
                                                [
                                                    -0.299,
                                                    -0.661
                                                ],
                                                [
                                                    -0.001,
                                                    -0.907
                                                ],
                                                [
                                                    0.298,
                                                    -0.661
                                                ],
                                                [
                                                    0.545,
                                                    -0.363
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.588,
                                                    0
                                                ],
                                                [
                                                    -0.459,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.213,
                                                    -0.352
                                                ],
                                                [
                                                    0.448,
                                                    -0.288
                                                ],
                                                [
                                                    0.745,
                                                    0
                                                ],
                                                [
                                                    0.545,
                                                    0.363
                                                ],
                                                [
                                                    0.298,
                                                    0.661
                                                ],
                                                [
                                                    -0.001,
                                                    0.907
                                                ],
                                                [
                                                    -0.299,
                                                    0.661
                                                ],
                                                [
                                                    -0.543,
                                                    0.363
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -39.21,
                                                    15.372
                                                ],
                                                [
                                                    -40.779,
                                                    14.988
                                                ],
                                                [
                                                    -41.835,
                                                    13.9
                                                ],
                                                [
                                                    -41.883,
                                                    15.18
                                                ],
                                                [
                                                    -43.098,
                                                    15.18
                                                ],
                                                [
                                                    -43.098,
                                                    3.82
                                                ],
                                                [
                                                    -41.755,
                                                    3.82
                                                ],
                                                [
                                                    -41.755,
                                                    7.884
                                                ],
                                                [
                                                    -40.762,
                                                    6.94
                                                ],
                                                [
                                                    -39.21,
                                                    6.508
                                                ],
                                                [
                                                    -37.275,
                                                    7.052
                                                ],
                                                [
                                                    -36.01,
                                                    8.588
                                                ],
                                                [
                                                    -35.562,
                                                    10.94
                                                ],
                                                [
                                                    -36.01,
                                                    13.292
                                                ],
                                                [
                                                    -37.275,
                                                    14.828
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 73",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.513,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.565
                                                ],
                                                [
                                                    0,
                                                    0.971
                                                ],
                                                [
                                                    0.416,
                                                    0.555
                                                ],
                                                [
                                                    0.692,
                                                    0
                                                ],
                                                [
                                                    0.372,
                                                    -0.256
                                                ],
                                                [
                                                    0.203,
                                                    -0.469
                                                ],
                                                [
                                                    0,
                                                    -0.661
                                                ],
                                                [
                                                    -0.192,
                                                    -0.48
                                                ],
                                                [
                                                    -0.364,
                                                    -0.256
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.713,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    -0.565
                                                ],
                                                [
                                                    0,
                                                    -0.981
                                                ],
                                                [
                                                    -0.416,
                                                    -0.565
                                                ],
                                                [
                                                    -0.523,
                                                    0
                                                ],
                                                [
                                                    -0.375,
                                                    0.245
                                                ],
                                                [
                                                    -0.192,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0.64
                                                ],
                                                [
                                                    0.203,
                                                    0.469
                                                ],
                                                [
                                                    0.373,
                                                    0.256
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -39.29,
                                                    14.092
                                                ],
                                                [
                                                    -37.594,
                                                    13.244
                                                ],
                                                [
                                                    -36.971,
                                                    10.94
                                                ],
                                                [
                                                    -37.594,
                                                    8.636
                                                ],
                                                [
                                                    -39.258,
                                                    7.788
                                                ],
                                                [
                                                    -40.602,
                                                    8.172
                                                ],
                                                [
                                                    -41.467,
                                                    9.244
                                                ],
                                                [
                                                    -41.755,
                                                    10.94
                                                ],
                                                [
                                                    -41.467,
                                                    12.62
                                                ],
                                                [
                                                    -40.618,
                                                    13.708
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 74",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.479,
                                                    0
                                                ],
                                                [
                                                    0.522,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    -0.427,
                                                    0.416
                                                ],
                                                [
                                                    -0.928,
                                                    0.171
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.341,
                                                    0.352
                                                ],
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.34,
                                                    -0.267
                                                ],
                                                [
                                                    0.129,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.608,
                                                    0.491
                                                ],
                                                [
                                                    -0.961,
                                                    0
                                                ],
                                                [
                                                    -0.575,
                                                    -0.619
                                                ],
                                                [
                                                    0,
                                                    -1.077
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.063,
                                                    -0.085
                                                ],
                                                [
                                                    -0.161,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.097,
                                                    0
                                                ],
                                                [
                                                    0.106,
                                                    0
                                                ],
                                                [
                                                    0.246,
                                                    0.117
                                                ],
                                                [
                                                    0.107,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.289,
                                                    -0.299
                                                ],
                                                [
                                                    0.425,
                                                    -0.171
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.875,
                                                    0
                                                ],
                                                [
                                                    -0.511,
                                                    -0.405
                                                ],
                                                [
                                                    0,
                                                    -0.725
                                                ],
                                                [
                                                    0.425,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.715
                                                ],
                                                [
                                                    -0.332,
                                                    -0.352
                                                ],
                                                [
                                                    -0.588,
                                                    0
                                                ],
                                                [
                                                    -0.343,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.16,
                                                    -0.8
                                                ],
                                                [
                                                    0.619,
                                                    -0.501
                                                ],
                                                [
                                                    1.088,
                                                    0
                                                ],
                                                [
                                                    0.576,
                                                    0.608
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.192
                                                ],
                                                [
                                                    0.075,
                                                    0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.043,
                                                    0.011
                                                ],
                                                [
                                                    -0.095,
                                                    0.011
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    -0.128
                                                ],
                                                [
                                                    -0.106,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.074,
                                                    0.363
                                                ],
                                                [
                                                    -0.288,
                                                    0.288
                                                ],
                                                [
                                                    -0.427,
                                                    0.16
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -31.232,
                                                    15.372
                                                ],
                                                [
                                                    -33.329,
                                                    14.764
                                                ],
                                                [
                                                    -34.096,
                                                    13.068
                                                ],
                                                [
                                                    -33.456,
                                                    11.356
                                                ],
                                                [
                                                    -31.424,
                                                    10.476
                                                ],
                                                [
                                                    -28.417,
                                                    9.916
                                                ],
                                                [
                                                    -28.928,
                                                    8.316
                                                ],
                                                [
                                                    -30.432,
                                                    7.788
                                                ],
                                                [
                                                    -31.824,
                                                    8.188
                                                ],
                                                [
                                                    -32.529,
                                                    9.308
                                                ],
                                                [
                                                    -33.952,
                                                    9.196
                                                ],
                                                [
                                                    -32.801,
                                                    7.26
                                                ],
                                                [
                                                    -30.432,
                                                    6.508
                                                ],
                                                [
                                                    -27.937,
                                                    7.436
                                                ],
                                                [
                                                    -27.072,
                                                    9.964
                                                ],
                                                [
                                                    -27.072,
                                                    13.468
                                                ],
                                                [
                                                    -26.977,
                                                    13.884
                                                ],
                                                [
                                                    -26.624,
                                                    13.996
                                                ],
                                                [
                                                    -26.288,
                                                    13.996
                                                ],
                                                [
                                                    -26.288,
                                                    15.18
                                                ],
                                                [
                                                    -26.497,
                                                    15.196
                                                ],
                                                [
                                                    -26.801,
                                                    15.212
                                                ],
                                                [
                                                    -27.745,
                                                    15.036
                                                ],
                                                [
                                                    -28.257,
                                                    14.46
                                                ],
                                                [
                                                    -28.417,
                                                    13.42
                                                ],
                                                [
                                                    -28.257,
                                                    13.452
                                                ],
                                                [
                                                    -28.801,
                                                    14.444
                                                ],
                                                [
                                                    -29.872,
                                                    15.132
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 75",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.491,
                                                    0
                                                ],
                                                [
                                                    -0.394,
                                                    0.213
                                                ],
                                                [
                                                    -0.215,
                                                    0.373
                                                ],
                                                [
                                                    0,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.223,
                                                    -0.224
                                                ],
                                                [
                                                    0,
                                                    -0.352
                                                ],
                                                [
                                                    -0.278,
                                                    -0.224
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.565,
                                                    0
                                                ],
                                                [
                                                    0.405,
                                                    -0.224
                                                ],
                                                [
                                                    0.213,
                                                    -0.384
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    0.107
                                                ],
                                                [
                                                    -0.215,
                                                    0.213
                                                ],
                                                [
                                                    0,
                                                    0.395
                                                ],
                                                [
                                                    0.289,
                                                    0.213
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -31.105,
                                                    14.188
                                                ],
                                                [
                                                    -29.665,
                                                    13.868
                                                ],
                                                [
                                                    -28.736,
                                                    12.972
                                                ],
                                                [
                                                    -28.417,
                                                    11.692
                                                ],
                                                [
                                                    -28.417,
                                                    11.084
                                                ],
                                                [
                                                    -31.169,
                                                    11.596
                                                ],
                                                [
                                                    -32.368,
                                                    12.092
                                                ],
                                                [
                                                    -32.689,
                                                    12.94
                                                ],
                                                [
                                                    -32.273,
                                                    13.868
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 76",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.939,
                                                    0
                                                ],
                                                [
                                                    0.534,
                                                    0.245
                                                ],
                                                [
                                                    0.289,
                                                    0.427
                                                ],
                                                [
                                                    0.043,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.33,
                                                    -0.309
                                                ],
                                                [
                                                    -0.746,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    0.181
                                                ],
                                                [
                                                    0,
                                                    0.416
                                                ],
                                                [
                                                    0.106,
                                                    0.149
                                                ],
                                                [
                                                    0.299,
                                                    0.107
                                                ],
                                                [
                                                    0.578,
                                                    0.107
                                                ],
                                                [
                                                    0.448,
                                                    0.224
                                                ],
                                                [
                                                    0.181,
                                                    0.32
                                                ],
                                                [
                                                    0,
                                                    0.448
                                                ],
                                                [
                                                    -0.554,
                                                    0.48
                                                ],
                                                [
                                                    -1.024,
                                                    0
                                                ],
                                                [
                                                    -0.47,
                                                    -0.267
                                                ],
                                                [
                                                    -0.247,
                                                    -0.416
                                                ],
                                                [
                                                    -0.055,
                                                    -0.459
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.138,
                                                    0.235
                                                ],
                                                [
                                                    0.278,
                                                    0.139
                                                ],
                                                [
                                                    0.47,
                                                    0
                                                ],
                                                [
                                                    0.289,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    -0.363
                                                ],
                                                [
                                                    -0.108,
                                                    -0.181
                                                ],
                                                [
                                                    -0.278,
                                                    -0.117
                                                ],
                                                [
                                                    -0.49,
                                                    -0.085
                                                ],
                                                [
                                                    -0.47,
                                                    -0.213
                                                ],
                                                [
                                                    -0.181,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.448
                                                ],
                                                [
                                                    0.608,
                                                    -0.437
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.522,
                                                    -0.245
                                                ],
                                                [
                                                    -0.278,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.086,
                                                    0.512
                                                ],
                                                [
                                                    0.341,
                                                    0.299
                                                ],
                                                [
                                                    0.577,
                                                    0
                                                ],
                                                [
                                                    0.319,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    -0.224
                                                ],
                                                [
                                                    -0.095,
                                                    -0.149
                                                ],
                                                [
                                                    -0.298,
                                                    -0.117
                                                ],
                                                [
                                                    -0.789,
                                                    -0.149
                                                ],
                                                [
                                                    -0.447,
                                                    -0.224
                                                ],
                                                [
                                                    -0.182,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.757
                                                ],
                                                [
                                                    0.565,
                                                    -0.491
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    0.256
                                                ],
                                                [
                                                    0.244,
                                                    0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.022,
                                                    -0.267
                                                ],
                                                [
                                                    -0.14,
                                                    -0.235
                                                ],
                                                [
                                                    -0.278,
                                                    -0.149
                                                ],
                                                [
                                                    -0.606,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0.277
                                                ],
                                                [
                                                    0.116,
                                                    0.171
                                                ],
                                                [
                                                    0.288,
                                                    0.107
                                                ],
                                                [
                                                    0.832,
                                                    0.139
                                                ],
                                                [
                                                    0.47,
                                                    0.213
                                                ],
                                                [
                                                    0.192,
                                                    0.309
                                                ],
                                                [
                                                    0,
                                                    0.779
                                                ],
                                                [
                                                    -0.599,
                                                    0.427
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -21.714,
                                                    15.372
                                                ],
                                                [
                                                    -23.682,
                                                    15.004
                                                ],
                                                [
                                                    -24.898,
                                                    13.996
                                                ],
                                                [
                                                    -25.378,
                                                    12.508
                                                ],
                                                [
                                                    -23.971,
                                                    12.412
                                                ],
                                                [
                                                    -23.346,
                                                    13.644
                                                ],
                                                [
                                                    -21.714,
                                                    14.092
                                                ],
                                                [
                                                    -20.385,
                                                    13.82
                                                ],
                                                [
                                                    -19.906,
                                                    12.908
                                                ],
                                                [
                                                    -20.066,
                                                    12.348
                                                ],
                                                [
                                                    -20.658,
                                                    11.964
                                                ],
                                                [
                                                    -21.971,
                                                    11.628
                                                ],
                                                [
                                                    -23.826,
                                                    11.068
                                                ],
                                                [
                                                    -24.77,
                                                    10.252
                                                ],
                                                [
                                                    -25.042,
                                                    9.1
                                                ],
                                                [
                                                    -24.21,
                                                    7.244
                                                ],
                                                [
                                                    -21.826,
                                                    6.508
                                                ],
                                                [
                                                    -20.001,
                                                    6.908
                                                ],
                                                [
                                                    -18.913,
                                                    7.916
                                                ],
                                                [
                                                    -18.465,
                                                    9.228
                                                ],
                                                [
                                                    -19.874,
                                                    9.324
                                                ],
                                                [
                                                    -20.113,
                                                    8.572
                                                ],
                                                [
                                                    -20.738,
                                                    8.012
                                                ],
                                                [
                                                    -21.859,
                                                    7.788
                                                ],
                                                [
                                                    -23.202,
                                                    8.14
                                                ],
                                                [
                                                    -23.633,
                                                    9.036
                                                ],
                                                [
                                                    -23.473,
                                                    9.724
                                                ],
                                                [
                                                    -22.882,
                                                    10.156
                                                ],
                                                [
                                                    -21.714,
                                                    10.444
                                                ],
                                                [
                                                    -19.762,
                                                    10.972
                                                ],
                                                [
                                                    -18.786,
                                                    11.772
                                                ],
                                                [
                                                    -18.497,
                                                    12.908
                                                ],
                                                [
                                                    -19.409,
                                                    14.732
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 77",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.896,
                                                    0
                                                ],
                                                [
                                                    0.586,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.31,
                                                    0.661
                                                ],
                                                [
                                                    -0.565,
                                                    0.363
                                                ],
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.567,
                                                    -0.352
                                                ],
                                                [
                                                    -0.31,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.949
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    -0.459
                                                ],
                                                [
                                                    -0.737,
                                                    0
                                                ],
                                                [
                                                    -0.353,
                                                    0.256
                                                ],
                                                [
                                                    -0.14,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.63,
                                                    -0.491
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.8,
                                                    0
                                                ],
                                                [
                                                    -0.577,
                                                    -0.363
                                                ],
                                                [
                                                    -0.31,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.576,
                                                    -0.373
                                                ],
                                                [
                                                    0.737,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    0.341
                                                ],
                                                [
                                                    0.319,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.054,
                                                    0.907
                                                ],
                                                [
                                                    0.438,
                                                    0.459
                                                ],
                                                [
                                                    0.554,
                                                    0
                                                ],
                                                [
                                                    0.362,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    0.757
                                                ],
                                                [
                                                    -0.618,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -13.333,
                                                    15.372
                                                ],
                                                [
                                                    -15.413,
                                                    14.828
                                                ],
                                                [
                                                    -16.758,
                                                    13.292
                                                ],
                                                [
                                                    -17.221,
                                                    10.94
                                                ],
                                                [
                                                    -16.758,
                                                    8.604
                                                ],
                                                [
                                                    -15.43,
                                                    7.068
                                                ],
                                                [
                                                    -13.398,
                                                    6.508
                                                ],
                                                [
                                                    -11.445,
                                                    7.036
                                                ],
                                                [
                                                    -10.133,
                                                    8.54
                                                ],
                                                [
                                                    -9.654,
                                                    10.956
                                                ],
                                                [
                                                    -9.654,
                                                    11.356
                                                ],
                                                [
                                                    -15.814,
                                                    11.356
                                                ],
                                                [
                                                    -15.094,
                                                    13.404
                                                ],
                                                [
                                                    -13.333,
                                                    14.092
                                                ],
                                                [
                                                    -11.973,
                                                    13.708
                                                ],
                                                [
                                                    -11.221,
                                                    12.668
                                                ],
                                                [
                                                    -9.781,
                                                    12.78
                                                ],
                                                [
                                                    -11.062,
                                                    14.652
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 78",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.117,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    0.384
                                                ],
                                                [
                                                    0.63,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    -0.405
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.063,
                                                    -0.821
                                                ],
                                                [
                                                    -0.405,
                                                    -0.384
                                                ],
                                                [
                                                    -0.651,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.395
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -15.814,
                                                    10.172
                                                ],
                                                [
                                                    -11.126,
                                                    10.172
                                                ],
                                                [
                                                    -11.846,
                                                    8.364
                                                ],
                                                [
                                                    -13.398,
                                                    7.788
                                                ],
                                                [
                                                    -15.014,
                                                    8.396
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4588,
                                            0.4588,
                                            0.4588
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            190.27,
                                            447.82
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 10",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.088,
                                                    0
                                                ],
                                                [
                                                    0.779,
                                                    0.469
                                                ],
                                                [
                                                    0.415,
                                                    0.885
                                                ],
                                                [
                                                    0,
                                                    1.227
                                                ],
                                                [
                                                    -0.416,
                                                    0.885
                                                ],
                                                [
                                                    -0.767,
                                                    0.48
                                                ],
                                                [
                                                    -1.077,
                                                    0
                                                ],
                                                [
                                                    -0.769,
                                                    -0.48
                                                ],
                                                [
                                                    -0.416,
                                                    -0.896
                                                ],
                                                [
                                                    0,
                                                    -1.227
                                                ],
                                                [
                                                    0.416,
                                                    -0.885
                                                ],
                                                [
                                                    0.778,
                                                    -0.48
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.077,
                                                    0
                                                ],
                                                [
                                                    -0.767,
                                                    -0.48
                                                ],
                                                [
                                                    -0.416,
                                                    -0.885
                                                ],
                                                [
                                                    0,
                                                    -1.227
                                                ],
                                                [
                                                    0.415,
                                                    -0.896
                                                ],
                                                [
                                                    0.779,
                                                    -0.48
                                                ],
                                                [
                                                    1.088,
                                                    0
                                                ],
                                                [
                                                    0.778,
                                                    0.48
                                                ],
                                                [
                                                    0.416,
                                                    0.885
                                                ],
                                                [
                                                    0,
                                                    1.227
                                                ],
                                                [
                                                    -0.416,
                                                    0.885
                                                ],
                                                [
                                                    -0.769,
                                                    0.469
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -57.785,
                                                    4.864
                                                ],
                                                [
                                                    -60.569,
                                                    4.16
                                                ],
                                                [
                                                    -62.344,
                                                    2.112
                                                ],
                                                [
                                                    -62.968,
                                                    -1.056
                                                ],
                                                [
                                                    -62.344,
                                                    -4.224
                                                ],
                                                [
                                                    -60.569,
                                                    -6.288
                                                ],
                                                [
                                                    -57.785,
                                                    -7.008
                                                ],
                                                [
                                                    -55,
                                                    -6.288
                                                ],
                                                [
                                                    -53.208,
                                                    -4.224
                                                ],
                                                [
                                                    -52.585,
                                                    -1.056
                                                ],
                                                [
                                                    -53.208,
                                                    2.112
                                                ],
                                                [
                                                    -55,
                                                    4.16
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.554,
                                                    0.363
                                                ],
                                                [
                                                    -0.299,
                                                    0.683
                                                ],
                                                [
                                                    0,
                                                    0.96
                                                ],
                                                [
                                                    0.298,
                                                    0.683
                                                ],
                                                [
                                                    0.566,
                                                    0.363
                                                ],
                                                [
                                                    0.79,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    -0.373
                                                ],
                                                [
                                                    0.298,
                                                    -0.693
                                                ],
                                                [
                                                    0,
                                                    -0.96
                                                ],
                                                [
                                                    -0.299,
                                                    -0.683
                                                ],
                                                [
                                                    -0.555,
                                                    -0.363
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.79,
                                                    0
                                                ],
                                                [
                                                    0.566,
                                                    -0.363
                                                ],
                                                [
                                                    0.298,
                                                    -0.683
                                                ],
                                                [
                                                    0,
                                                    -0.96
                                                ],
                                                [
                                                    -0.299,
                                                    -0.693
                                                ],
                                                [
                                                    -0.554,
                                                    -0.373
                                                ],
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.555,
                                                    0.363
                                                ],
                                                [
                                                    -0.299,
                                                    0.683
                                                ],
                                                [
                                                    0,
                                                    0.96
                                                ],
                                                [
                                                    0.298,
                                                    0.683
                                                ],
                                                [
                                                    0.565,
                                                    0.363
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -57.785,
                                                    3.52
                                                ],
                                                [
                                                    -55.769,
                                                    2.976
                                                ],
                                                [
                                                    -54.472,
                                                    1.408
                                                ],
                                                [
                                                    -54.024,
                                                    -1.056
                                                ],
                                                [
                                                    -54.472,
                                                    -3.52
                                                ],
                                                [
                                                    -55.769,
                                                    -5.104
                                                ],
                                                [
                                                    -57.785,
                                                    -5.664
                                                ],
                                                [
                                                    -59.8,
                                                    -5.104
                                                ],
                                                [
                                                    -61.08,
                                                    -3.52
                                                ],
                                                [
                                                    -61.528,
                                                    -1.056
                                                ],
                                                [
                                                    -61.08,
                                                    1.408
                                                ],
                                                [
                                                    -59.8,
                                                    2.976
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -49.119,
                                                    4.608
                                                ],
                                                [
                                                    -51.743,
                                                    -3.872
                                                ],
                                                [
                                                    -50.271,
                                                    -3.872
                                                ],
                                                [
                                                    -48.287,
                                                    3.2
                                                ],
                                                [
                                                    -46.271,
                                                    -3.872
                                                ],
                                                [
                                                    -44.831,
                                                    -3.872
                                                ],
                                                [
                                                    -42.815,
                                                    3.2
                                                ],
                                                [
                                                    -40.815,
                                                    -3.872
                                                ],
                                                [
                                                    -39.343,
                                                    -3.872
                                                ],
                                                [
                                                    -41.967,
                                                    4.608
                                                ],
                                                [
                                                    -43.663,
                                                    4.608
                                                ],
                                                [
                                                    -45.551,
                                                    -1.84
                                                ],
                                                [
                                                    -47.439,
                                                    4.608
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.267,
                                                    0.32
                                                ],
                                                [
                                                    -0.373,
                                                    0.16
                                                ],
                                                [
                                                    -0.437,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    -0.288
                                                ],
                                                [
                                                    -0.203,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    -0.597
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.128,
                                                    0.352
                                                ],
                                                [
                                                    0.267,
                                                    0.181
                                                ],
                                                [
                                                    0.427,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.107,
                                                    -0.501
                                                ],
                                                [
                                                    0.267,
                                                    -0.331
                                                ],
                                                [
                                                    0.384,
                                                    -0.16
                                                ],
                                                [
                                                    0.651,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    0.288
                                                ],
                                                [
                                                    0.213,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    -0.117,
                                                    -0.363
                                                ],
                                                [
                                                    -0.267,
                                                    -0.192
                                                ],
                                                [
                                                    -0.651,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -38.096,
                                                    4.608
                                                ],
                                                [
                                                    -38.096,
                                                    -3.872
                                                ],
                                                [
                                                    -36.864,
                                                    -3.872
                                                ],
                                                [
                                                    -36.816,
                                                    -1.712
                                                ],
                                                [
                                                    -36.976,
                                                    -1.856
                                                ],
                                                [
                                                    -36.416,
                                                    -3.088
                                                ],
                                                [
                                                    -35.456,
                                                    -3.824
                                                ],
                                                [
                                                    -34.224,
                                                    -4.064
                                                ],
                                                [
                                                    -32.624,
                                                    -3.632
                                                ],
                                                [
                                                    -31.68,
                                                    -2.464
                                                ],
                                                [
                                                    -31.36,
                                                    -0.848
                                                ],
                                                [
                                                    -31.36,
                                                    4.608
                                                ],
                                                [
                                                    -32.704,
                                                    4.608
                                                ],
                                                [
                                                    -32.704,
                                                    -0.464
                                                ],
                                                [
                                                    -32.896,
                                                    -1.776
                                                ],
                                                [
                                                    -33.472,
                                                    -2.592
                                                ],
                                                [
                                                    -34.512,
                                                    -2.88
                                                ],
                                                [
                                                    -36.128,
                                                    -2.256
                                                ],
                                                [
                                                    -36.752,
                                                    -0.464
                                                ],
                                                [
                                                    -36.752,
                                                    4.608
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.896,
                                                    0
                                                ],
                                                [
                                                    0.587,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.309,
                                                    0.661
                                                ],
                                                [
                                                    -0.565,
                                                    0.363
                                                ],
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    -0.352
                                                ],
                                                [
                                                    -0.309,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.949
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.426,
                                                    -0.459
                                                ],
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.256
                                                ],
                                                [
                                                    -0.138,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.63,
                                                    -0.491
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.8,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.363
                                                ],
                                                [
                                                    -0.309,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.576,
                                                    -0.373
                                                ],
                                                [
                                                    0.736,
                                                    0
                                                ],
                                                [
                                                    0.566,
                                                    0.341
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.054,
                                                    0.907
                                                ],
                                                [
                                                    0.438,
                                                    0.459
                                                ],
                                                [
                                                    0.555,
                                                    0
                                                ],
                                                [
                                                    0.363,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    0.757
                                                ],
                                                [
                                                    -0.618,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -25.675,
                                                    4.8
                                                ],
                                                [
                                                    -27.755,
                                                    4.256
                                                ],
                                                [
                                                    -29.099,
                                                    2.72
                                                ],
                                                [
                                                    -29.563,
                                                    0.368
                                                ],
                                                [
                                                    -29.099,
                                                    -1.968
                                                ],
                                                [
                                                    -27.771,
                                                    -3.504
                                                ],
                                                [
                                                    -25.739,
                                                    -4.064
                                                ],
                                                [
                                                    -23.787,
                                                    -3.536
                                                ],
                                                [
                                                    -22.475,
                                                    -2.032
                                                ],
                                                [
                                                    -21.995,
                                                    0.384
                                                ],
                                                [
                                                    -21.995,
                                                    0.784
                                                ],
                                                [
                                                    -28.155,
                                                    0.784
                                                ],
                                                [
                                                    -27.435,
                                                    2.832
                                                ],
                                                [
                                                    -25.675,
                                                    3.52
                                                ],
                                                [
                                                    -24.315,
                                                    3.136
                                                ],
                                                [
                                                    -23.563,
                                                    2.096
                                                ],
                                                [
                                                    -22.123,
                                                    2.208
                                                ],
                                                [
                                                    -23.403,
                                                    4.08
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.118,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    0.384
                                                ],
                                                [
                                                    0.63,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    -0.405
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.821
                                                ],
                                                [
                                                    -0.405,
                                                    -0.384
                                                ],
                                                [
                                                    -0.65,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.395
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -28.155,
                                                    -0.4
                                                ],
                                                [
                                                    -23.467,
                                                    -0.4
                                                ],
                                                [
                                                    -24.187,
                                                    -2.208
                                                ],
                                                [
                                                    -25.739,
                                                    -2.784
                                                ],
                                                [
                                                    -27.355,
                                                    -2.176
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.351,
                                                    0.331
                                                ],
                                                [
                                                    -0.597,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.16
                                                ],
                                                [
                                                    0.15,
                                                    -0.309
                                                ],
                                                [
                                                    0,
                                                    -0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.106,
                                                    -0.725
                                                ],
                                                [
                                                    0.363,
                                                    -0.341
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    0
                                                ],
                                                [
                                                    -0.277,
                                                    0.149
                                                ],
                                                [
                                                    -0.138,
                                                    0.299
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -20.174,
                                                    4.608
                                                ],
                                                [
                                                    -20.174,
                                                    -3.872
                                                ],
                                                [
                                                    -18.991,
                                                    -3.872
                                                ],
                                                [
                                                    -18.926,
                                                    -1.728
                                                ],
                                                [
                                                    -19.054,
                                                    -1.776
                                                ],
                                                [
                                                    -18.367,
                                                    -3.36
                                                ],
                                                [
                                                    -16.926,
                                                    -3.872
                                                ],
                                                [
                                                    -16.094,
                                                    -3.872
                                                ],
                                                [
                                                    -16.094,
                                                    -2.592
                                                ],
                                                [
                                                    -16.91,
                                                    -2.592
                                                ],
                                                [
                                                    -17.982,
                                                    -2.352
                                                ],
                                                [
                                                    -18.622,
                                                    -1.664
                                                ],
                                                [
                                                    -18.83,
                                                    -0.512
                                                ],
                                                [
                                                    -18.83,
                                                    4.608
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -14.716,
                                                    4.608
                                                ],
                                                [
                                                    -14.716,
                                                    2.8
                                                ],
                                                [
                                                    -12.909,
                                                    2.8
                                                ],
                                                [
                                                    -12.909,
                                                    4.608
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -14.716,
                                                    -1.68
                                                ],
                                                [
                                                    -14.716,
                                                    -3.488
                                                ],
                                                [
                                                    -12.909,
                                                    -3.488
                                                ],
                                                [
                                                    -12.909,
                                                    -1.68
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.705,
                                                    -0.608
                                                ],
                                                [
                                                    0,
                                                    -1.077
                                                ],
                                                [
                                                    0.32,
                                                    -0.533
                                                ],
                                                [
                                                    0.597,
                                                    -0.277
                                                ],
                                                [
                                                    0.842,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.268,
                                                    0
                                                ],
                                                [
                                                    0.704,
                                                    0.608
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    -0.32,
                                                    0.523
                                                ],
                                                [
                                                    -0.597,
                                                    0.277
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -5.966,
                                                    4.608
                                                ],
                                                [
                                                    -5.966,
                                                    -6.752
                                                ],
                                                [
                                                    -1.886,
                                                    -6.752
                                                ],
                                                [
                                                    1.074,
                                                    -5.84
                                                ],
                                                [
                                                    2.13,
                                                    -3.312
                                                ],
                                                [
                                                    1.649,
                                                    -1.424
                                                ],
                                                [
                                                    0.273,
                                                    -0.224
                                                ],
                                                [
                                                    -1.886,
                                                    0.192
                                                ],
                                                [
                                                    -4.59,
                                                    0.192
                                                ],
                                                [
                                                    -4.59,
                                                    4.608
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.428,
                                                    0.363
                                                ],
                                                [
                                                    0,
                                                    0.715
                                                ],
                                                [
                                                    0.436,
                                                    0.352
                                                ],
                                                [
                                                    0.852,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.852,
                                                    0
                                                ],
                                                [
                                                    0.436,
                                                    -0.363
                                                ],
                                                [
                                                    0,
                                                    -0.693
                                                ],
                                                [
                                                    -0.428,
                                                    -0.352
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -4.59,
                                                    -1.152
                                                ],
                                                [
                                                    -1.886,
                                                    -1.152
                                                ],
                                                [
                                                    0.034,
                                                    -1.696
                                                ],
                                                [
                                                    0.689,
                                                    -3.312
                                                ],
                                                [
                                                    0.034,
                                                    -4.88
                                                ],
                                                [
                                                    -1.886,
                                                    -5.408
                                                ],
                                                [
                                                    -4.59,
                                                    -5.408
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.351,
                                                    0.331
                                                ],
                                                [
                                                    -0.597,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.287,
                                                    -0.16
                                                ],
                                                [
                                                    0.149,
                                                    -0.309
                                                ],
                                                [
                                                    0,
                                                    -0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.107,
                                                    -0.725
                                                ],
                                                [
                                                    0.363,
                                                    -0.341
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    0
                                                ],
                                                [
                                                    -0.277,
                                                    0.149
                                                ],
                                                [
                                                    -0.139,
                                                    0.299
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.091,
                                                    4.608
                                                ],
                                                [
                                                    4.091,
                                                    -3.872
                                                ],
                                                [
                                                    5.275,
                                                    -3.872
                                                ],
                                                [
                                                    5.34,
                                                    -1.728
                                                ],
                                                [
                                                    5.212,
                                                    -1.776
                                                ],
                                                [
                                                    5.899,
                                                    -3.36
                                                ],
                                                [
                                                    7.34,
                                                    -3.872
                                                ],
                                                [
                                                    8.172,
                                                    -3.872
                                                ],
                                                [
                                                    8.172,
                                                    -2.592
                                                ],
                                                [
                                                    7.356,
                                                    -2.592
                                                ],
                                                [
                                                    6.284,
                                                    -2.352
                                                ],
                                                [
                                                    5.644,
                                                    -1.664
                                                ],
                                                [
                                                    5.436,
                                                    -0.512
                                                ],
                                                [
                                                    5.436,
                                                    4.608
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.67,
                                                    4.608
                                                ],
                                                [
                                                    9.67,
                                                    -3.872
                                                ],
                                                [
                                                    11.013,
                                                    -3.872
                                                ],
                                                [
                                                    11.013,
                                                    4.608
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 14",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    9.638,
                                                    -5.2
                                                ],
                                                [
                                                    9.638,
                                                    -6.768
                                                ],
                                                [
                                                    11.045,
                                                    -6.768
                                                ],
                                                [
                                                    11.045,
                                                    -5.2
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 15",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.14,
                                                    0.096
                                                ],
                                                [
                                                    -0.075,
                                                    0.203
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.319,
                                                    -0.213
                                                ],
                                                [
                                                    0.565,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.3,
                                                    0
                                                ],
                                                [
                                                    0.149,
                                                    -0.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.16,
                                                    0.459
                                                ],
                                                [
                                                    -0.321,
                                                    0.213
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    13.787,
                                                    7.008
                                                ],
                                                [
                                                    13.787,
                                                    5.824
                                                ],
                                                [
                                                    14.763,
                                                    5.824
                                                ],
                                                [
                                                    15.42,
                                                    5.68
                                                ],
                                                [
                                                    15.756,
                                                    5.248
                                                ],
                                                [
                                                    16.06,
                                                    4.448
                                                ],
                                                [
                                                    15.595,
                                                    4.448
                                                ],
                                                [
                                                    12.491,
                                                    -3.872
                                                ],
                                                [
                                                    13.963,
                                                    -3.872
                                                ],
                                                [
                                                    16.491,
                                                    3.2
                                                ],
                                                [
                                                    18.907,
                                                    -3.872
                                                ],
                                                [
                                                    20.379,
                                                    -3.872
                                                ],
                                                [
                                                    16.94,
                                                    5.68
                                                ],
                                                [
                                                    16.22,
                                                    6.688
                                                ],
                                                [
                                                    14.892,
                                                    7.008
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 16",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.48,
                                                    0
                                                ],
                                                [
                                                    0.522,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    -0.427,
                                                    0.416
                                                ],
                                                [
                                                    -0.927,
                                                    0.171
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.342,
                                                    0.352
                                                ],
                                                [
                                                    0.671,
                                                    0
                                                ],
                                                [
                                                    0.341,
                                                    -0.267
                                                ],
                                                [
                                                    0.127,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.606,
                                                    0.491
                                                ],
                                                [
                                                    -0.961,
                                                    0
                                                ],
                                                [
                                                    -0.577,
                                                    -0.619
                                                ],
                                                [
                                                    0,
                                                    -1.077
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.085
                                                ],
                                                [
                                                    -0.16,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.095,
                                                    0
                                                ],
                                                [
                                                    0.108,
                                                    0
                                                ],
                                                [
                                                    0.244,
                                                    0.117
                                                ],
                                                [
                                                    0.106,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.287,
                                                    -0.299
                                                ],
                                                [
                                                    0.427,
                                                    -0.171
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.875,
                                                    0
                                                ],
                                                [
                                                    -0.513,
                                                    -0.405
                                                ],
                                                [
                                                    0,
                                                    -0.725
                                                ],
                                                [
                                                    0.426,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.715
                                                ],
                                                [
                                                    -0.33,
                                                    -0.352
                                                ],
                                                [
                                                    -0.588,
                                                    0
                                                ],
                                                [
                                                    -0.342,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.16,
                                                    -0.8
                                                ],
                                                [
                                                    0.62,
                                                    -0.501
                                                ],
                                                [
                                                    1.087,
                                                    0
                                                ],
                                                [
                                                    0.576,
                                                    0.608
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.192
                                                ],
                                                [
                                                    0.074,
                                                    0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.043,
                                                    0.011
                                                ],
                                                [
                                                    -0.097,
                                                    0.011
                                                ],
                                                [
                                                    -0.382,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    -0.128
                                                ],
                                                [
                                                    -0.106,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    0.363
                                                ],
                                                [
                                                    -0.289,
                                                    0.288
                                                ],
                                                [
                                                    -0.427,
                                                    0.16
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    23.942,
                                                    4.8
                                                ],
                                                [
                                                    21.847,
                                                    4.192
                                                ],
                                                [
                                                    21.078,
                                                    2.496
                                                ],
                                                [
                                                    21.718,
                                                    0.784
                                                ],
                                                [
                                                    23.75,
                                                    -0.096
                                                ],
                                                [
                                                    26.759,
                                                    -0.656
                                                ],
                                                [
                                                    26.246,
                                                    -2.256
                                                ],
                                                [
                                                    24.743,
                                                    -2.784
                                                ],
                                                [
                                                    23.351,
                                                    -2.384
                                                ],
                                                [
                                                    22.647,
                                                    -1.264
                                                ],
                                                [
                                                    21.222,
                                                    -1.376
                                                ],
                                                [
                                                    22.373,
                                                    -3.312
                                                ],
                                                [
                                                    24.743,
                                                    -4.064
                                                ],
                                                [
                                                    27.239,
                                                    -3.136
                                                ],
                                                [
                                                    28.103,
                                                    -0.608
                                                ],
                                                [
                                                    28.103,
                                                    2.896
                                                ],
                                                [
                                                    28.198,
                                                    3.312
                                                ],
                                                [
                                                    28.55,
                                                    3.424
                                                ],
                                                [
                                                    28.886,
                                                    3.424
                                                ],
                                                [
                                                    28.886,
                                                    4.608
                                                ],
                                                [
                                                    28.679,
                                                    4.624
                                                ],
                                                [
                                                    28.373,
                                                    4.64
                                                ],
                                                [
                                                    27.431,
                                                    4.464
                                                ],
                                                [
                                                    26.918,
                                                    3.888
                                                ],
                                                [
                                                    26.759,
                                                    2.848
                                                ],
                                                [
                                                    26.918,
                                                    2.88
                                                ],
                                                [
                                                    26.375,
                                                    3.872
                                                ],
                                                [
                                                    25.302,
                                                    4.56
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 17",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.491,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    0.213
                                                ],
                                                [
                                                    -0.214,
                                                    0.373
                                                ],
                                                [
                                                    0,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.224,
                                                    -0.224
                                                ],
                                                [
                                                    0,
                                                    -0.352
                                                ],
                                                [
                                                    -0.278,
                                                    -0.224
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.565,
                                                    0
                                                ],
                                                [
                                                    0.405,
                                                    -0.224
                                                ],
                                                [
                                                    0.213,
                                                    -0.384
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    0.107
                                                ],
                                                [
                                                    -0.213,
                                                    0.213
                                                ],
                                                [
                                                    0,
                                                    0.395
                                                ],
                                                [
                                                    0.287,
                                                    0.213
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    24.071,
                                                    3.616
                                                ],
                                                [
                                                    25.511,
                                                    3.296
                                                ],
                                                [
                                                    26.438,
                                                    2.4
                                                ],
                                                [
                                                    26.759,
                                                    1.12
                                                ],
                                                [
                                                    26.759,
                                                    0.512
                                                ],
                                                [
                                                    24.007,
                                                    1.024
                                                ],
                                                [
                                                    22.806,
                                                    1.52
                                                ],
                                                [
                                                    22.485,
                                                    2.368
                                                ],
                                                [
                                                    22.903,
                                                    3.296
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 18",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    34.659,
                                                    4.608
                                                ],
                                                [
                                                    34.659,
                                                    -6.752
                                                ],
                                                [
                                                    36.61,
                                                    -6.752
                                                ],
                                                [
                                                    42.226,
                                                    3.232
                                                ],
                                                [
                                                    42.226,
                                                    -6.752
                                                ],
                                                [
                                                    43.603,
                                                    -6.752
                                                ],
                                                [
                                                    43.603,
                                                    4.608
                                                ],
                                                [
                                                    41.554,
                                                    4.608
                                                ],
                                                [
                                                    36.035,
                                                    -5.184
                                                ],
                                                [
                                                    36.035,
                                                    4.608
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 19",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.479,
                                                    0
                                                ],
                                                [
                                                    0.524,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    -0.427,
                                                    0.416
                                                ],
                                                [
                                                    -0.928,
                                                    0.171
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.341,
                                                    0.352
                                                ],
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.342,
                                                    -0.267
                                                ],
                                                [
                                                    0.129,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.607,
                                                    0.491
                                                ],
                                                [
                                                    -0.961,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.619
                                                ],
                                                [
                                                    0,
                                                    -1.077
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.063,
                                                    -0.085
                                                ],
                                                [
                                                    -0.16,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.097,
                                                    0
                                                ],
                                                [
                                                    0.108,
                                                    0
                                                ],
                                                [
                                                    0.246,
                                                    0.117
                                                ],
                                                [
                                                    0.106,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.289,
                                                    -0.299
                                                ],
                                                [
                                                    0.427,
                                                    -0.171
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.875,
                                                    0
                                                ],
                                                [
                                                    -0.511,
                                                    -0.405
                                                ],
                                                [
                                                    0,
                                                    -0.725
                                                ],
                                                [
                                                    0.427,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.715
                                                ],
                                                [
                                                    -0.33,
                                                    -0.352
                                                ],
                                                [
                                                    -0.586,
                                                    0
                                                ],
                                                [
                                                    -0.341,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.16,
                                                    -0.8
                                                ],
                                                [
                                                    0.619,
                                                    -0.501
                                                ],
                                                [
                                                    1.088,
                                                    0
                                                ],
                                                [
                                                    0.575,
                                                    0.608
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.192
                                                ],
                                                [
                                                    0.075,
                                                    0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.043,
                                                    0.011
                                                ],
                                                [
                                                    -0.095,
                                                    0.011
                                                ],
                                                [
                                                    -0.383,
                                                    0
                                                ],
                                                [
                                                    -0.233,
                                                    -0.128
                                                ],
                                                [
                                                    -0.107,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    0.363
                                                ],
                                                [
                                                    -0.288,
                                                    0.288
                                                ],
                                                [
                                                    -0.427,
                                                    0.16
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    48.489,
                                                    4.8
                                                ],
                                                [
                                                    46.392,
                                                    4.192
                                                ],
                                                [
                                                    45.625,
                                                    2.496
                                                ],
                                                [
                                                    46.265,
                                                    0.784
                                                ],
                                                [
                                                    48.297,
                                                    -0.096
                                                ],
                                                [
                                                    51.304,
                                                    -0.656
                                                ],
                                                [
                                                    50.793,
                                                    -2.256
                                                ],
                                                [
                                                    49.289,
                                                    -2.784
                                                ],
                                                [
                                                    47.897,
                                                    -2.384
                                                ],
                                                [
                                                    47.192,
                                                    -1.264
                                                ],
                                                [
                                                    45.769,
                                                    -1.376
                                                ],
                                                [
                                                    46.92,
                                                    -3.312
                                                ],
                                                [
                                                    49.289,
                                                    -4.064
                                                ],
                                                [
                                                    51.785,
                                                    -3.136
                                                ],
                                                [
                                                    52.649,
                                                    -0.608
                                                ],
                                                [
                                                    52.649,
                                                    2.896
                                                ],
                                                [
                                                    52.744,
                                                    3.312
                                                ],
                                                [
                                                    53.097,
                                                    3.424
                                                ],
                                                [
                                                    53.433,
                                                    3.424
                                                ],
                                                [
                                                    53.433,
                                                    4.608
                                                ],
                                                [
                                                    53.224,
                                                    4.624
                                                ],
                                                [
                                                    52.92,
                                                    4.64
                                                ],
                                                [
                                                    51.976,
                                                    4.464
                                                ],
                                                [
                                                    51.465,
                                                    3.888
                                                ],
                                                [
                                                    51.304,
                                                    2.848
                                                ],
                                                [
                                                    51.465,
                                                    2.88
                                                ],
                                                [
                                                    50.92,
                                                    3.872
                                                ],
                                                [
                                                    49.849,
                                                    4.56
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 20",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.489,
                                                    0
                                                ],
                                                [
                                                    -0.394,
                                                    0.213
                                                ],
                                                [
                                                    -0.213,
                                                    0.373
                                                ],
                                                [
                                                    0,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.223,
                                                    -0.224
                                                ],
                                                [
                                                    0,
                                                    -0.352
                                                ],
                                                [
                                                    -0.276,
                                                    -0.224
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.567,
                                                    0
                                                ],
                                                [
                                                    0.407,
                                                    -0.224
                                                ],
                                                [
                                                    0.213,
                                                    -0.384
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    0.107
                                                ],
                                                [
                                                    -0.213,
                                                    0.213
                                                ],
                                                [
                                                    0,
                                                    0.395
                                                ],
                                                [
                                                    0.289,
                                                    0.213
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    48.616,
                                                    3.616
                                                ],
                                                [
                                                    50.056,
                                                    3.296
                                                ],
                                                [
                                                    50.985,
                                                    2.4
                                                ],
                                                [
                                                    51.304,
                                                    1.12
                                                ],
                                                [
                                                    51.304,
                                                    0.512
                                                ],
                                                [
                                                    48.552,
                                                    1.024
                                                ],
                                                [
                                                    47.353,
                                                    1.52
                                                ],
                                                [
                                                    47.032,
                                                    2.368
                                                ],
                                                [
                                                    47.448,
                                                    3.296
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 21",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    54.888,
                                                    4.608
                                                ],
                                                [
                                                    54.888,
                                                    -3.872
                                                ],
                                                [
                                                    56.233,
                                                    -3.872
                                                ],
                                                [
                                                    56.233,
                                                    4.608
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 22",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    54.856,
                                                    -5.2
                                                ],
                                                [
                                                    54.856,
                                                    -6.768
                                                ],
                                                [
                                                    56.265,
                                                    -6.768
                                                ],
                                                [
                                                    56.265,
                                                    -5.2
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 23",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.351,
                                                    0.331
                                                ],
                                                [
                                                    -0.597,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.289,
                                                    -0.16
                                                ],
                                                [
                                                    0.15,
                                                    -0.309
                                                ],
                                                [
                                                    0,
                                                    -0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.107,
                                                    -0.725
                                                ],
                                                [
                                                    0.364,
                                                    -0.341
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    0
                                                ],
                                                [
                                                    -0.276,
                                                    0.149
                                                ],
                                                [
                                                    -0.138,
                                                    0.299
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    58.888,
                                                    4.608
                                                ],
                                                [
                                                    58.888,
                                                    -3.872
                                                ],
                                                [
                                                    60.073,
                                                    -3.872
                                                ],
                                                [
                                                    60.136,
                                                    -1.728
                                                ],
                                                [
                                                    60.009,
                                                    -1.776
                                                ],
                                                [
                                                    60.696,
                                                    -3.36
                                                ],
                                                [
                                                    62.136,
                                                    -3.872
                                                ],
                                                [
                                                    62.968,
                                                    -3.872
                                                ],
                                                [
                                                    62.968,
                                                    -2.592
                                                ],
                                                [
                                                    62.153,
                                                    -2.592
                                                ],
                                                [
                                                    61.08,
                                                    -2.352
                                                ],
                                                [
                                                    60.44,
                                                    -1.664
                                                ],
                                                [
                                                    60.233,
                                                    -0.512
                                                ],
                                                [
                                                    60.233,
                                                    4.608
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4588,
                                            0.4588,
                                            0.4588
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            121.688,
                                            176.392
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 11",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.277
                                                ],
                                                [
                                                    -0.309,
                                                    -0.523
                                                ],
                                                [
                                                    0,
                                                    -0.704
                                                ],
                                                [
                                                    0.245,
                                                    -0.405
                                                ],
                                                [
                                                    0.373,
                                                    -0.235
                                                ],
                                                [
                                                    0.405,
                                                    -0.021
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    -0.32
                                                ],
                                                [
                                                    -0.064,
                                                    -0.704
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.299,
                                                    0.224
                                                ],
                                                [
                                                    0.661,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.8,
                                                    0
                                                ],
                                                [
                                                    0.576,
                                                    0.277
                                                ],
                                                [
                                                    0.32,
                                                    0.512
                                                ],
                                                [
                                                    0,
                                                    0.512
                                                ],
                                                [
                                                    -0.235,
                                                    0.395
                                                ],
                                                [
                                                    -0.373,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.693,
                                                    0
                                                ],
                                                [
                                                    0.405,
                                                    0.32
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.043,
                                                    -0.469
                                                ],
                                                [
                                                    -0.288,
                                                    -0.224
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -112.253,
                                                    4.392
                                                ],
                                                [
                                                    -112.253,
                                                    -6.968
                                                ],
                                                [
                                                    -107.949,
                                                    -6.968
                                                ],
                                                [
                                                    -105.885,
                                                    -6.552
                                                ],
                                                [
                                                    -104.557,
                                                    -5.352
                                                ],
                                                [
                                                    -104.077,
                                                    -3.528
                                                ],
                                                [
                                                    -104.445,
                                                    -2.152
                                                ],
                                                [
                                                    -105.357,
                                                    -1.208
                                                ],
                                                [
                                                    -106.525,
                                                    -0.824
                                                ],
                                                [
                                                    -106.621,
                                                    -0.968
                                                ],
                                                [
                                                    -104.989,
                                                    -0.488
                                                ],
                                                [
                                                    -104.285,
                                                    1.048
                                                ],
                                                [
                                                    -103.965,
                                                    4.392
                                                ],
                                                [
                                                    -105.357,
                                                    4.392
                                                ],
                                                [
                                                    -105.645,
                                                    1.192
                                                ],
                                                [
                                                    -106.157,
                                                    0.152
                                                ],
                                                [
                                                    -107.581,
                                                    -0.184
                                                ],
                                                [
                                                    -110.877,
                                                    -0.184
                                                ],
                                                [
                                                    -110.877,
                                                    4.392
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.405,
                                                    0.352
                                                ],
                                                [
                                                    0,
                                                    0.651
                                                ],
                                                [
                                                    0.416,
                                                    0.352
                                                ],
                                                [
                                                    0.789,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.693,
                                                    0
                                                ],
                                                [
                                                    0.405,
                                                    -0.352
                                                ],
                                                [
                                                    0,
                                                    -0.661
                                                ],
                                                [
                                                    -0.416,
                                                    -0.363
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -110.877,
                                                    -1.528
                                                ],
                                                [
                                                    -107.773,
                                                    -1.528
                                                ],
                                                [
                                                    -106.125,
                                                    -2.056
                                                ],
                                                [
                                                    -105.517,
                                                    -3.56
                                                ],
                                                [
                                                    -106.141,
                                                    -5.08
                                                ],
                                                [
                                                    -107.949,
                                                    -5.624
                                                ],
                                                [
                                                    -110.877,
                                                    -5.624
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.725,
                                                    0
                                                ],
                                                [
                                                    0.512,
                                                    0.565
                                                ],
                                                [
                                                    0,
                                                    1.003
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    -0.395
                                                ],
                                                [
                                                    -0.608,
                                                    0
                                                ],
                                                [
                                                    -0.384,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0.757
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    -0.384
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.843,
                                                    0
                                                ],
                                                [
                                                    -0.502,
                                                    -0.576
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ],
                                                [
                                                    0.298,
                                                    0.384
                                                ],
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.384,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.171,
                                                    0.693
                                                ],
                                                [
                                                    -0.48,
                                                    0.373
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -99.067,
                                                    4.584
                                                ],
                                                [
                                                    -101.099,
                                                    3.736
                                                ],
                                                [
                                                    -101.851,
                                                    1.368
                                                ],
                                                [
                                                    -101.851,
                                                    -4.088
                                                ],
                                                [
                                                    -100.507,
                                                    -4.088
                                                ],
                                                [
                                                    -100.507,
                                                    1
                                                ],
                                                [
                                                    -100.075,
                                                    2.824
                                                ],
                                                [
                                                    -98.715,
                                                    3.4
                                                ],
                                                [
                                                    -97.131,
                                                    2.76
                                                ],
                                                [
                                                    -96.555,
                                                    0.968
                                                ],
                                                [
                                                    -96.555,
                                                    -4.088
                                                ],
                                                [
                                                    -95.211,
                                                    -4.088
                                                ],
                                                [
                                                    -95.211,
                                                    4.392
                                                ],
                                                [
                                                    -96.491,
                                                    4.392
                                                ],
                                                [
                                                    -96.491,
                                                    2.296
                                                ],
                                                [
                                                    -96.283,
                                                    2.408
                                                ],
                                                [
                                                    -97.259,
                                                    4.024
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.267,
                                                    0.32
                                                ],
                                                [
                                                    -0.374,
                                                    0.16
                                                ],
                                                [
                                                    -0.438,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    -0.288
                                                ],
                                                [
                                                    -0.203,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    -0.597
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.128,
                                                    0.352
                                                ],
                                                [
                                                    0.266,
                                                    0.181
                                                ],
                                                [
                                                    0.426,
                                                    0
                                                ],
                                                [
                                                    0.426,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.106,
                                                    -0.501
                                                ],
                                                [
                                                    0.266,
                                                    -0.331
                                                ],
                                                [
                                                    0.384,
                                                    -0.16
                                                ],
                                                [
                                                    0.65,
                                                    0
                                                ],
                                                [
                                                    0.426,
                                                    0.288
                                                ],
                                                [
                                                    0.213,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    -0.118,
                                                    -0.363
                                                ],
                                                [
                                                    -0.267,
                                                    -0.192
                                                ],
                                                [
                                                    -0.651,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -92.648,
                                                    4.392
                                                ],
                                                [
                                                    -92.648,
                                                    -4.088
                                                ],
                                                [
                                                    -91.416,
                                                    -4.088
                                                ],
                                                [
                                                    -91.368,
                                                    -1.928
                                                ],
                                                [
                                                    -91.528,
                                                    -2.072
                                                ],
                                                [
                                                    -90.968,
                                                    -3.304
                                                ],
                                                [
                                                    -90.008,
                                                    -4.04
                                                ],
                                                [
                                                    -88.776,
                                                    -4.28
                                                ],
                                                [
                                                    -87.176,
                                                    -3.848
                                                ],
                                                [
                                                    -86.232,
                                                    -2.68
                                                ],
                                                [
                                                    -85.912,
                                                    -1.064
                                                ],
                                                [
                                                    -85.912,
                                                    4.392
                                                ],
                                                [
                                                    -87.256,
                                                    4.392
                                                ],
                                                [
                                                    -87.256,
                                                    -0.68
                                                ],
                                                [
                                                    -87.448,
                                                    -1.992
                                                ],
                                                [
                                                    -88.024,
                                                    -2.808
                                                ],
                                                [
                                                    -89.064,
                                                    -3.096
                                                ],
                                                [
                                                    -90.68,
                                                    -2.472
                                                ],
                                                [
                                                    -91.304,
                                                    -0.68
                                                ],
                                                [
                                                    -91.304,
                                                    4.392
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.266,
                                                    0.32
                                                ],
                                                [
                                                    -0.373,
                                                    0.16
                                                ],
                                                [
                                                    -0.437,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    -0.288
                                                ],
                                                [
                                                    -0.202,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    -0.597
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.128,
                                                    0.352
                                                ],
                                                [
                                                    0.267,
                                                    0.181
                                                ],
                                                [
                                                    0.427,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.107,
                                                    -0.501
                                                ],
                                                [
                                                    0.267,
                                                    -0.331
                                                ],
                                                [
                                                    0.384,
                                                    -0.16
                                                ],
                                                [
                                                    0.651,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    0.288
                                                ],
                                                [
                                                    0.214,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    -0.117,
                                                    -0.363
                                                ],
                                                [
                                                    -0.266,
                                                    -0.192
                                                ],
                                                [
                                                    -0.65,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -83.664,
                                                    4.392
                                                ],
                                                [
                                                    -83.664,
                                                    -4.088
                                                ],
                                                [
                                                    -82.432,
                                                    -4.088
                                                ],
                                                [
                                                    -82.384,
                                                    -1.928
                                                ],
                                                [
                                                    -82.544,
                                                    -2.072
                                                ],
                                                [
                                                    -81.984,
                                                    -3.304
                                                ],
                                                [
                                                    -81.024,
                                                    -4.04
                                                ],
                                                [
                                                    -79.792,
                                                    -4.28
                                                ],
                                                [
                                                    -78.192,
                                                    -3.848
                                                ],
                                                [
                                                    -77.248,
                                                    -2.68
                                                ],
                                                [
                                                    -76.928,
                                                    -1.064
                                                ],
                                                [
                                                    -76.928,
                                                    4.392
                                                ],
                                                [
                                                    -78.272,
                                                    4.392
                                                ],
                                                [
                                                    -78.272,
                                                    -0.68
                                                ],
                                                [
                                                    -78.464,
                                                    -1.992
                                                ],
                                                [
                                                    -79.04,
                                                    -2.808
                                                ],
                                                [
                                                    -80.08,
                                                    -3.096
                                                ],
                                                [
                                                    -81.696,
                                                    -2.472
                                                ],
                                                [
                                                    -82.32,
                                                    -0.68
                                                ],
                                                [
                                                    -82.32,
                                                    4.392
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -74.461,
                                                    4.392
                                                ],
                                                [
                                                    -74.461,
                                                    -4.088
                                                ],
                                                [
                                                    -73.117,
                                                    -4.088
                                                ],
                                                [
                                                    -73.117,
                                                    4.392
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -74.493,
                                                    -5.416
                                                ],
                                                [
                                                    -74.493,
                                                    -6.984
                                                ],
                                                [
                                                    -73.085,
                                                    -6.984
                                                ],
                                                [
                                                    -73.085,
                                                    -5.416
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.266,
                                                    0.32
                                                ],
                                                [
                                                    -0.373,
                                                    0.16
                                                ],
                                                [
                                                    -0.437,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    -0.288
                                                ],
                                                [
                                                    -0.202,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    -0.597
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.128,
                                                    0.352
                                                ],
                                                [
                                                    0.267,
                                                    0.181
                                                ],
                                                [
                                                    0.427,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.107,
                                                    -0.501
                                                ],
                                                [
                                                    0.267,
                                                    -0.331
                                                ],
                                                [
                                                    0.384,
                                                    -0.16
                                                ],
                                                [
                                                    0.651,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    0.288
                                                ],
                                                [
                                                    0.214,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    -0.117,
                                                    -0.363
                                                ],
                                                [
                                                    -0.266,
                                                    -0.192
                                                ],
                                                [
                                                    -0.65,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -70.461,
                                                    4.392
                                                ],
                                                [
                                                    -70.461,
                                                    -4.088
                                                ],
                                                [
                                                    -69.229,
                                                    -4.088
                                                ],
                                                [
                                                    -69.181,
                                                    -1.928
                                                ],
                                                [
                                                    -69.341,
                                                    -2.072
                                                ],
                                                [
                                                    -68.781,
                                                    -3.304
                                                ],
                                                [
                                                    -67.821,
                                                    -4.04
                                                ],
                                                [
                                                    -66.589,
                                                    -4.28
                                                ],
                                                [
                                                    -64.989,
                                                    -3.848
                                                ],
                                                [
                                                    -64.045,
                                                    -2.68
                                                ],
                                                [
                                                    -63.725,
                                                    -1.064
                                                ],
                                                [
                                                    -63.725,
                                                    4.392
                                                ],
                                                [
                                                    -65.069,
                                                    4.392
                                                ],
                                                [
                                                    -65.069,
                                                    -0.68
                                                ],
                                                [
                                                    -65.261,
                                                    -1.992
                                                ],
                                                [
                                                    -65.837,
                                                    -2.808
                                                ],
                                                [
                                                    -66.877,
                                                    -3.096
                                                ],
                                                [
                                                    -68.493,
                                                    -2.472
                                                ],
                                                [
                                                    -69.117,
                                                    -0.68
                                                ],
                                                [
                                                    -69.117,
                                                    4.392
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.778,
                                                    0
                                                ],
                                                [
                                                    0.49,
                                                    0.203
                                                ],
                                                [
                                                    0.33,
                                                    0.373
                                                ],
                                                [
                                                    0.117,
                                                    0.491
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.32,
                                                    -0.224
                                                ],
                                                [
                                                    -0.651,
                                                    0
                                                ],
                                                [
                                                    -0.406,
                                                    0.309
                                                ],
                                                [
                                                    0,
                                                    0.619
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.448,
                                                    -0.267
                                                ],
                                                [
                                                    0.554,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    0.352
                                                ],
                                                [
                                                    0.32,
                                                    0.619
                                                ],
                                                [
                                                    0,
                                                    0.8
                                                ],
                                                [
                                                    -0.31,
                                                    0.608
                                                ],
                                                [
                                                    -0.544,
                                                    0.352
                                                ],
                                                [
                                                    -0.704,
                                                    0
                                                ],
                                                [
                                                    -0.47,
                                                    -0.277
                                                ],
                                                [
                                                    -0.192,
                                                    -0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.298,
                                                    -0.469
                                                ],
                                                [
                                                    0.554,
                                                    -0.245
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.608,
                                                    0
                                                ],
                                                [
                                                    -0.491,
                                                    -0.203
                                                ],
                                                [
                                                    -0.331,
                                                    -0.373
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.128,
                                                    0.395
                                                ],
                                                [
                                                    0.33,
                                                    0.235
                                                ],
                                                [
                                                    0.768,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    -0.309
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.203,
                                                    0.448
                                                ],
                                                [
                                                    -0.448,
                                                    0.267
                                                ],
                                                [
                                                    -0.715,
                                                    0
                                                ],
                                                [
                                                    -0.555,
                                                    -0.352
                                                ],
                                                [
                                                    -0.31,
                                                    -0.619
                                                ],
                                                [
                                                    0,
                                                    -0.811
                                                ],
                                                [
                                                    0.309,
                                                    -0.619
                                                ],
                                                [
                                                    0.554,
                                                    -0.352
                                                ],
                                                [
                                                    0.597,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    0.277
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.661
                                                ],
                                                [
                                                    -0.299,
                                                    0.48
                                                ],
                                                [
                                                    -0.555,
                                                    0.256
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -58.135,
                                                    6.984
                                                ],
                                                [
                                                    -59.783,
                                                    6.68
                                                ],
                                                [
                                                    -61.015,
                                                    5.816
                                                ],
                                                [
                                                    -61.687,
                                                    4.52
                                                ],
                                                [
                                                    -60.279,
                                                    4.424
                                                ],
                                                [
                                                    -59.607,
                                                    5.352
                                                ],
                                                [
                                                    -58.135,
                                                    5.704
                                                ],
                                                [
                                                    -56.375,
                                                    5.24
                                                ],
                                                [
                                                    -55.751,
                                                    3.848
                                                ],
                                                [
                                                    -55.751,
                                                    2.472
                                                ],
                                                [
                                                    -56.727,
                                                    3.544
                                                ],
                                                [
                                                    -58.231,
                                                    3.944
                                                ],
                                                [
                                                    -60.151,
                                                    3.416
                                                ],
                                                [
                                                    -61.463,
                                                    1.96
                                                ],
                                                [
                                                    -61.927,
                                                    -0.168
                                                ],
                                                [
                                                    -61.463,
                                                    -2.296
                                                ],
                                                [
                                                    -60.183,
                                                    -3.752
                                                ],
                                                [
                                                    -58.295,
                                                    -4.28
                                                ],
                                                [
                                                    -56.695,
                                                    -3.864
                                                ],
                                                [
                                                    -55.687,
                                                    -2.744
                                                ],
                                                [
                                                    -55.687,
                                                    -4.088
                                                ],
                                                [
                                                    -54.407,
                                                    -4.088
                                                ],
                                                [
                                                    -54.407,
                                                    3.816
                                                ],
                                                [
                                                    -54.855,
                                                    5.512
                                                ],
                                                [
                                                    -56.135,
                                                    6.6
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.726,
                                                    0
                                                ],
                                                [
                                                    -0.438,
                                                    0.501
                                                ],
                                                [
                                                    -0.011,
                                                    0.875
                                                ],
                                                [
                                                    0.202,
                                                    0.416
                                                ],
                                                [
                                                    0.373,
                                                    0.224
                                                ],
                                                [
                                                    0.49,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    -0.512
                                                ],
                                                [
                                                    0,
                                                    -0.875
                                                ],
                                                [
                                                    -0.416,
                                                    -0.512
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.725,
                                                    0
                                                ],
                                                [
                                                    0.437,
                                                    -0.512
                                                ],
                                                [
                                                    0.01,
                                                    -0.587
                                                ],
                                                [
                                                    -0.192,
                                                    -0.427
                                                ],
                                                [
                                                    -0.363,
                                                    -0.235
                                                ],
                                                [
                                                    -0.747,
                                                    0
                                                ],
                                                [
                                                    -0.406,
                                                    0.501
                                                ],
                                                [
                                                    0,
                                                    0.875
                                                ],
                                                [
                                                    0.426,
                                                    0.501
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -58.167,
                                                    2.664
                                                ],
                                                [
                                                    -56.423,
                                                    1.912
                                                ],
                                                [
                                                    -55.751,
                                                    -0.168
                                                ],
                                                [
                                                    -56.039,
                                                    -1.672
                                                ],
                                                [
                                                    -56.887,
                                                    -2.648
                                                ],
                                                [
                                                    -58.167,
                                                    -3
                                                ],
                                                [
                                                    -59.911,
                                                    -2.232
                                                ],
                                                [
                                                    -60.519,
                                                    -0.168
                                                ],
                                                [
                                                    -59.895,
                                                    1.912
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.48,
                                                    0
                                                ],
                                                [
                                                    0.522,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    -0.427,
                                                    0.416
                                                ],
                                                [
                                                    -0.928,
                                                    0.171
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.341,
                                                    0.352
                                                ],
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.341,
                                                    -0.267
                                                ],
                                                [
                                                    0.128,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.608,
                                                    0.491
                                                ],
                                                [
                                                    -0.96,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.619
                                                ],
                                                [
                                                    0,
                                                    -1.077
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.085
                                                ],
                                                [
                                                    -0.16,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.096,
                                                    0
                                                ],
                                                [
                                                    0.106,
                                                    0
                                                ],
                                                [
                                                    0.245,
                                                    0.117
                                                ],
                                                [
                                                    0.106,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.299
                                                ],
                                                [
                                                    0.426,
                                                    -0.171
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.875,
                                                    0
                                                ],
                                                [
                                                    -0.512,
                                                    -0.405
                                                ],
                                                [
                                                    0,
                                                    -0.725
                                                ],
                                                [
                                                    0.426,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.715
                                                ],
                                                [
                                                    -0.331,
                                                    -0.352
                                                ],
                                                [
                                                    -0.587,
                                                    0
                                                ],
                                                [
                                                    -0.342,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.16,
                                                    -0.8
                                                ],
                                                [
                                                    0.618,
                                                    -0.501
                                                ],
                                                [
                                                    1.088,
                                                    0
                                                ],
                                                [
                                                    0.576,
                                                    0.608
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.192
                                                ],
                                                [
                                                    0.074,
                                                    0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.043,
                                                    0.011
                                                ],
                                                [
                                                    -0.096,
                                                    0.011
                                                ],
                                                [
                                                    -0.384,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    -0.128
                                                ],
                                                [
                                                    -0.107,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    0.363
                                                ],
                                                [
                                                    -0.288,
                                                    0.288
                                                ],
                                                [
                                                    -0.427,
                                                    0.16
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -45.563,
                                                    4.584
                                                ],
                                                [
                                                    -47.659,
                                                    3.976
                                                ],
                                                [
                                                    -48.427,
                                                    2.28
                                                ],
                                                [
                                                    -47.787,
                                                    0.568
                                                ],
                                                [
                                                    -45.755,
                                                    -0.312
                                                ],
                                                [
                                                    -42.747,
                                                    -0.872
                                                ],
                                                [
                                                    -43.259,
                                                    -2.472
                                                ],
                                                [
                                                    -44.763,
                                                    -3
                                                ],
                                                [
                                                    -46.155,
                                                    -2.6
                                                ],
                                                [
                                                    -46.859,
                                                    -1.48
                                                ],
                                                [
                                                    -48.283,
                                                    -1.592
                                                ],
                                                [
                                                    -47.131,
                                                    -3.528
                                                ],
                                                [
                                                    -44.763,
                                                    -4.28
                                                ],
                                                [
                                                    -42.267,
                                                    -3.352
                                                ],
                                                [
                                                    -41.403,
                                                    -0.824
                                                ],
                                                [
                                                    -41.403,
                                                    2.68
                                                ],
                                                [
                                                    -41.307,
                                                    3.096
                                                ],
                                                [
                                                    -40.955,
                                                    3.208
                                                ],
                                                [
                                                    -40.619,
                                                    3.208
                                                ],
                                                [
                                                    -40.619,
                                                    4.392
                                                ],
                                                [
                                                    -40.827,
                                                    4.408
                                                ],
                                                [
                                                    -41.131,
                                                    4.424
                                                ],
                                                [
                                                    -42.075,
                                                    4.248
                                                ],
                                                [
                                                    -42.587,
                                                    3.672
                                                ],
                                                [
                                                    -42.747,
                                                    2.632
                                                ],
                                                [
                                                    -42.587,
                                                    2.664
                                                ],
                                                [
                                                    -43.131,
                                                    3.656
                                                ],
                                                [
                                                    -44.203,
                                                    4.344
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.491,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    0.213
                                                ],
                                                [
                                                    -0.214,
                                                    0.373
                                                ],
                                                [
                                                    0,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.224,
                                                    -0.224
                                                ],
                                                [
                                                    0,
                                                    -0.352
                                                ],
                                                [
                                                    -0.278,
                                                    -0.224
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.565,
                                                    0
                                                ],
                                                [
                                                    0.405,
                                                    -0.224
                                                ],
                                                [
                                                    0.213,
                                                    -0.384
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    0.107
                                                ],
                                                [
                                                    -0.214,
                                                    0.213
                                                ],
                                                [
                                                    0,
                                                    0.395
                                                ],
                                                [
                                                    0.288,
                                                    0.213
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -45.435,
                                                    3.4
                                                ],
                                                [
                                                    -43.995,
                                                    3.08
                                                ],
                                                [
                                                    -43.067,
                                                    2.184
                                                ],
                                                [
                                                    -42.747,
                                                    0.904
                                                ],
                                                [
                                                    -42.747,
                                                    0.296
                                                ],
                                                [
                                                    -45.499,
                                                    0.808
                                                ],
                                                [
                                                    -46.699,
                                                    1.304
                                                ],
                                                [
                                                    -47.019,
                                                    2.152
                                                ],
                                                [
                                                    -46.603,
                                                    3.08
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.938,
                                                    0
                                                ],
                                                [
                                                    0.533,
                                                    0.245
                                                ],
                                                [
                                                    0.288,
                                                    0.427
                                                ],
                                                [
                                                    0.042,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.331,
                                                    -0.309
                                                ],
                                                [
                                                    -0.747,
                                                    0
                                                ],
                                                [
                                                    -0.31,
                                                    0.181
                                                ],
                                                [
                                                    0,
                                                    0.416
                                                ],
                                                [
                                                    0.106,
                                                    0.149
                                                ],
                                                [
                                                    0.298,
                                                    0.107
                                                ],
                                                [
                                                    0.577,
                                                    0.107
                                                ],
                                                [
                                                    0.448,
                                                    0.224
                                                ],
                                                [
                                                    0.181,
                                                    0.32
                                                ],
                                                [
                                                    0,
                                                    0.448
                                                ],
                                                [
                                                    -0.555,
                                                    0.48
                                                ],
                                                [
                                                    -1.024,
                                                    0
                                                ],
                                                [
                                                    -0.47,
                                                    -0.267
                                                ],
                                                [
                                                    -0.246,
                                                    -0.416
                                                ],
                                                [
                                                    -0.054,
                                                    -0.459
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.138,
                                                    0.235
                                                ],
                                                [
                                                    0.277,
                                                    0.139
                                                ],
                                                [
                                                    0.47,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    -0.363
                                                ],
                                                [
                                                    -0.107,
                                                    -0.181
                                                ],
                                                [
                                                    -0.278,
                                                    -0.117
                                                ],
                                                [
                                                    -0.491,
                                                    -0.085
                                                ],
                                                [
                                                    -0.47,
                                                    -0.213
                                                ],
                                                [
                                                    -0.182,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.448
                                                ],
                                                [
                                                    0.608,
                                                    -0.437
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.523,
                                                    -0.245
                                                ],
                                                [
                                                    -0.278,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.086,
                                                    0.512
                                                ],
                                                [
                                                    0.341,
                                                    0.299
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    -0.224
                                                ],
                                                [
                                                    -0.096,
                                                    -0.149
                                                ],
                                                [
                                                    -0.299,
                                                    -0.117
                                                ],
                                                [
                                                    -0.789,
                                                    -0.149
                                                ],
                                                [
                                                    -0.448,
                                                    -0.224
                                                ],
                                                [
                                                    -0.182,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.757
                                                ],
                                                [
                                                    0.565,
                                                    -0.491
                                                ],
                                                [
                                                    0.746,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    0.256
                                                ],
                                                [
                                                    0.245,
                                                    0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.022,
                                                    -0.267
                                                ],
                                                [
                                                    -0.139,
                                                    -0.235
                                                ],
                                                [
                                                    -0.278,
                                                    -0.149
                                                ],
                                                [
                                                    -0.607,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0.277
                                                ],
                                                [
                                                    0.117,
                                                    0.171
                                                ],
                                                [
                                                    0.288,
                                                    0.107
                                                ],
                                                [
                                                    0.832,
                                                    0.139
                                                ],
                                                [
                                                    0.469,
                                                    0.213
                                                ],
                                                [
                                                    0.192,
                                                    0.309
                                                ],
                                                [
                                                    0,
                                                    0.779
                                                ],
                                                [
                                                    -0.598,
                                                    0.427
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -36.044,
                                                    4.584
                                                ],
                                                [
                                                    -38.012,
                                                    4.216
                                                ],
                                                [
                                                    -39.228,
                                                    3.208
                                                ],
                                                [
                                                    -39.708,
                                                    1.72
                                                ],
                                                [
                                                    -38.301,
                                                    1.624
                                                ],
                                                [
                                                    -37.676,
                                                    2.856
                                                ],
                                                [
                                                    -36.044,
                                                    3.304
                                                ],
                                                [
                                                    -34.716,
                                                    3.032
                                                ],
                                                [
                                                    -34.236,
                                                    2.12
                                                ],
                                                [
                                                    -34.396,
                                                    1.56
                                                ],
                                                [
                                                    -34.988,
                                                    1.176
                                                ],
                                                [
                                                    -36.301,
                                                    0.84
                                                ],
                                                [
                                                    -38.156,
                                                    0.28
                                                ],
                                                [
                                                    -39.1,
                                                    -0.536
                                                ],
                                                [
                                                    -39.372,
                                                    -1.688
                                                ],
                                                [
                                                    -38.54,
                                                    -3.544
                                                ],
                                                [
                                                    -36.156,
                                                    -4.28
                                                ],
                                                [
                                                    -34.332,
                                                    -3.88
                                                ],
                                                [
                                                    -33.244,
                                                    -2.872
                                                ],
                                                [
                                                    -32.796,
                                                    -1.56
                                                ],
                                                [
                                                    -34.204,
                                                    -1.464
                                                ],
                                                [
                                                    -34.444,
                                                    -2.216
                                                ],
                                                [
                                                    -35.068,
                                                    -2.776
                                                ],
                                                [
                                                    -36.189,
                                                    -3
                                                ],
                                                [
                                                    -37.532,
                                                    -2.648
                                                ],
                                                [
                                                    -37.964,
                                                    -1.752
                                                ],
                                                [
                                                    -37.804,
                                                    -1.064
                                                ],
                                                [
                                                    -37.212,
                                                    -0.632
                                                ],
                                                [
                                                    -36.044,
                                                    -0.344
                                                ],
                                                [
                                                    -34.092,
                                                    0.184
                                                ],
                                                [
                                                    -33.116,
                                                    0.984
                                                ],
                                                [
                                                    -32.828,
                                                    2.12
                                                ],
                                                [
                                                    -33.74,
                                                    3.944
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 14",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -30.628,
                                                    4.392
                                                ],
                                                [
                                                    -30.628,
                                                    2.584
                                                ],
                                                [
                                                    -28.82,
                                                    2.584
                                                ],
                                                [
                                                    -28.82,
                                                    4.392
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 15",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -30.628,
                                                    -1.896
                                                ],
                                                [
                                                    -30.628,
                                                    -3.704
                                                ],
                                                [
                                                    -28.82,
                                                    -3.704
                                                ],
                                                [
                                                    -28.82,
                                                    -1.896
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 16",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.939,
                                                    0
                                                ],
                                                [
                                                    0.533,
                                                    0.245
                                                ],
                                                [
                                                    0.288,
                                                    0.427
                                                ],
                                                [
                                                    0.043,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.331,
                                                    -0.309
                                                ],
                                                [
                                                    -0.747,
                                                    0
                                                ],
                                                [
                                                    -0.309,
                                                    0.181
                                                ],
                                                [
                                                    0,
                                                    0.416
                                                ],
                                                [
                                                    0.107,
                                                    0.149
                                                ],
                                                [
                                                    0.299,
                                                    0.107
                                                ],
                                                [
                                                    0.576,
                                                    0.107
                                                ],
                                                [
                                                    0.448,
                                                    0.224
                                                ],
                                                [
                                                    0.181,
                                                    0.32
                                                ],
                                                [
                                                    0,
                                                    0.448
                                                ],
                                                [
                                                    -0.555,
                                                    0.48
                                                ],
                                                [
                                                    -1.024,
                                                    0
                                                ],
                                                [
                                                    -0.469,
                                                    -0.267
                                                ],
                                                [
                                                    -0.245,
                                                    -0.416
                                                ],
                                                [
                                                    -0.053,
                                                    -0.459
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.139,
                                                    0.235
                                                ],
                                                [
                                                    0.277,
                                                    0.139
                                                ],
                                                [
                                                    0.469,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    -0.363
                                                ],
                                                [
                                                    -0.107,
                                                    -0.181
                                                ],
                                                [
                                                    -0.277,
                                                    -0.117
                                                ],
                                                [
                                                    -0.491,
                                                    -0.085
                                                ],
                                                [
                                                    -0.469,
                                                    -0.213
                                                ],
                                                [
                                                    -0.181,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.448
                                                ],
                                                [
                                                    0.608,
                                                    -0.437
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.523,
                                                    -0.245
                                                ],
                                                [
                                                    -0.277,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.085,
                                                    0.512
                                                ],
                                                [
                                                    0.341,
                                                    0.299
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    -0.224
                                                ],
                                                [
                                                    -0.096,
                                                    -0.149
                                                ],
                                                [
                                                    -0.299,
                                                    -0.117
                                                ],
                                                [
                                                    -0.789,
                                                    -0.149
                                                ],
                                                [
                                                    -0.448,
                                                    -0.224
                                                ],
                                                [
                                                    -0.181,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.757
                                                ],
                                                [
                                                    0.565,
                                                    -0.491
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    0.256
                                                ],
                                                [
                                                    0.245,
                                                    0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.021,
                                                    -0.267
                                                ],
                                                [
                                                    -0.139,
                                                    -0.235
                                                ],
                                                [
                                                    -0.277,
                                                    -0.149
                                                ],
                                                [
                                                    -0.608,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0.277
                                                ],
                                                [
                                                    0.117,
                                                    0.171
                                                ],
                                                [
                                                    0.288,
                                                    0.107
                                                ],
                                                [
                                                    0.832,
                                                    0.139
                                                ],
                                                [
                                                    0.469,
                                                    0.213
                                                ],
                                                [
                                                    0.192,
                                                    0.309
                                                ],
                                                [
                                                    0,
                                                    0.779
                                                ],
                                                [
                                                    -0.597,
                                                    0.427
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -18.982,
                                                    4.584
                                                ],
                                                [
                                                    -20.95,
                                                    4.216
                                                ],
                                                [
                                                    -22.166,
                                                    3.208
                                                ],
                                                [
                                                    -22.646,
                                                    1.72
                                                ],
                                                [
                                                    -21.238,
                                                    1.624
                                                ],
                                                [
                                                    -20.614,
                                                    2.856
                                                ],
                                                [
                                                    -18.982,
                                                    3.304
                                                ],
                                                [
                                                    -17.654,
                                                    3.032
                                                ],
                                                [
                                                    -17.174,
                                                    2.12
                                                ],
                                                [
                                                    -17.334,
                                                    1.56
                                                ],
                                                [
                                                    -17.926,
                                                    1.176
                                                ],
                                                [
                                                    -19.238,
                                                    0.84
                                                ],
                                                [
                                                    -21.094,
                                                    0.28
                                                ],
                                                [
                                                    -22.038,
                                                    -0.536
                                                ],
                                                [
                                                    -22.31,
                                                    -1.688
                                                ],
                                                [
                                                    -21.478,
                                                    -3.544
                                                ],
                                                [
                                                    -19.094,
                                                    -4.28
                                                ],
                                                [
                                                    -17.27,
                                                    -3.88
                                                ],
                                                [
                                                    -16.182,
                                                    -2.872
                                                ],
                                                [
                                                    -15.734,
                                                    -1.56
                                                ],
                                                [
                                                    -17.142,
                                                    -1.464
                                                ],
                                                [
                                                    -17.382,
                                                    -2.216
                                                ],
                                                [
                                                    -18.006,
                                                    -2.776
                                                ],
                                                [
                                                    -19.126,
                                                    -3
                                                ],
                                                [
                                                    -20.47,
                                                    -2.648
                                                ],
                                                [
                                                    -20.902,
                                                    -1.752
                                                ],
                                                [
                                                    -20.742,
                                                    -1.064
                                                ],
                                                [
                                                    -20.15,
                                                    -0.632
                                                ],
                                                [
                                                    -18.982,
                                                    -0.344
                                                ],
                                                [
                                                    -17.03,
                                                    0.184
                                                ],
                                                [
                                                    -16.054,
                                                    0.984
                                                ],
                                                [
                                                    -15.766,
                                                    2.12
                                                ],
                                                [
                                                    -16.678,
                                                    3.944
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 17",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -12.004,
                                                    4.392
                                                ],
                                                [
                                                    -15.092,
                                                    -4.088
                                                ],
                                                [
                                                    -13.62,
                                                    -4.088
                                                ],
                                                [
                                                    -11.156,
                                                    3.016
                                                ],
                                                [
                                                    -8.692,
                                                    -4.088
                                                ],
                                                [
                                                    -7.22,
                                                    -4.088
                                                ],
                                                [
                                                    -10.308,
                                                    4.392
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 18",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.65,
                                                    0
                                                ],
                                                [
                                                    0.586,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.32,
                                                    0.661
                                                ],
                                                [
                                                    -0.576,
                                                    0.363
                                                ],
                                                [
                                                    -0.79,
                                                    0
                                                ],
                                                [
                                                    -0.502,
                                                    -0.235
                                                ],
                                                [
                                                    -0.32,
                                                    -0.437
                                                ],
                                                [
                                                    -0.096,
                                                    -0.629
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.394,
                                                    0.299
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0.437,
                                                    -0.565
                                                ],
                                                [
                                                    0,
                                                    -0.981
                                                ],
                                                [
                                                    -0.438,
                                                    -0.565
                                                ],
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    0.32
                                                ],
                                                [
                                                    -0.096,
                                                    0.64
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.469
                                                ],
                                                [
                                                    0.512,
                                                    -0.256
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.79,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.363
                                                ],
                                                [
                                                    -0.32,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.586,
                                                    -0.373
                                                ],
                                                [
                                                    0.65,
                                                    0
                                                ],
                                                [
                                                    0.512,
                                                    0.224
                                                ],
                                                [
                                                    0.32,
                                                    0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.096,
                                                    -0.565
                                                ],
                                                [
                                                    -0.395,
                                                    -0.309
                                                ],
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.438,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0.981
                                                ],
                                                [
                                                    0.437,
                                                    0.555
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0.394,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.096,
                                                    0.629
                                                ],
                                                [
                                                    -0.32,
                                                    0.459
                                                ],
                                                [
                                                    -0.502,
                                                    0.256
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -2.695,
                                                    4.584
                                                ],
                                                [
                                                    -4.759,
                                                    4.04
                                                ],
                                                [
                                                    -6.103,
                                                    2.504
                                                ],
                                                [
                                                    -6.583,
                                                    0.152
                                                ],
                                                [
                                                    -6.103,
                                                    -2.184
                                                ],
                                                [
                                                    -4.759,
                                                    -3.72
                                                ],
                                                [
                                                    -2.695,
                                                    -4.28
                                                ],
                                                [
                                                    -0.967,
                                                    -3.928
                                                ],
                                                [
                                                    0.281,
                                                    -2.936
                                                ],
                                                [
                                                    0.905,
                                                    -1.336
                                                ],
                                                [
                                                    -0.503,
                                                    -1.24
                                                ],
                                                [
                                                    -1.239,
                                                    -2.536
                                                ],
                                                [
                                                    -2.695,
                                                    -3
                                                ],
                                                [
                                                    -4.519,
                                                    -2.152
                                                ],
                                                [
                                                    -5.176,
                                                    0.152
                                                ],
                                                [
                                                    -4.519,
                                                    2.472
                                                ],
                                                [
                                                    -2.695,
                                                    3.304
                                                ],
                                                [
                                                    -1.239,
                                                    2.824
                                                ],
                                                [
                                                    -0.503,
                                                    1.384
                                                ],
                                                [
                                                    0.905,
                                                    1.48
                                                ],
                                                [
                                                    0.281,
                                                    3.128
                                                ],
                                                [
                                                    -0.967,
                                                    4.2
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 19",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    2.151,
                                                    0.36
                                                ],
                                                [
                                                    2.151,
                                                    -0.904
                                                ],
                                                [
                                                    7.447,
                                                    -0.904
                                                ],
                                                [
                                                    7.447,
                                                    0.36
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 20",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.939,
                                                    0
                                                ],
                                                [
                                                    0.533,
                                                    0.245
                                                ],
                                                [
                                                    0.288,
                                                    0.427
                                                ],
                                                [
                                                    0.043,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.331,
                                                    -0.309
                                                ],
                                                [
                                                    -0.747,
                                                    0
                                                ],
                                                [
                                                    -0.309,
                                                    0.181
                                                ],
                                                [
                                                    0,
                                                    0.416
                                                ],
                                                [
                                                    0.107,
                                                    0.149
                                                ],
                                                [
                                                    0.299,
                                                    0.107
                                                ],
                                                [
                                                    0.576,
                                                    0.107
                                                ],
                                                [
                                                    0.448,
                                                    0.224
                                                ],
                                                [
                                                    0.181,
                                                    0.32
                                                ],
                                                [
                                                    0,
                                                    0.448
                                                ],
                                                [
                                                    -0.555,
                                                    0.48
                                                ],
                                                [
                                                    -1.024,
                                                    0
                                                ],
                                                [
                                                    -0.469,
                                                    -0.267
                                                ],
                                                [
                                                    -0.245,
                                                    -0.416
                                                ],
                                                [
                                                    -0.053,
                                                    -0.459
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.139,
                                                    0.235
                                                ],
                                                [
                                                    0.277,
                                                    0.139
                                                ],
                                                [
                                                    0.469,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.235
                                                ],
                                                [
                                                    0,
                                                    -0.363
                                                ],
                                                [
                                                    -0.107,
                                                    -0.181
                                                ],
                                                [
                                                    -0.277,
                                                    -0.117
                                                ],
                                                [
                                                    -0.491,
                                                    -0.085
                                                ],
                                                [
                                                    -0.469,
                                                    -0.213
                                                ],
                                                [
                                                    -0.181,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.448
                                                ],
                                                [
                                                    0.608,
                                                    -0.437
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.523,
                                                    -0.245
                                                ],
                                                [
                                                    -0.277,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.085,
                                                    0.512
                                                ],
                                                [
                                                    0.341,
                                                    0.299
                                                ],
                                                [
                                                    0.576,
                                                    0
                                                ],
                                                [
                                                    0.32,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    -0.224
                                                ],
                                                [
                                                    -0.096,
                                                    -0.149
                                                ],
                                                [
                                                    -0.299,
                                                    -0.117
                                                ],
                                                [
                                                    -0.789,
                                                    -0.149
                                                ],
                                                [
                                                    -0.448,
                                                    -0.224
                                                ],
                                                [
                                                    -0.181,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.757
                                                ],
                                                [
                                                    0.565,
                                                    -0.491
                                                ],
                                                [
                                                    0.747,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    0.256
                                                ],
                                                [
                                                    0.245,
                                                    0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.021,
                                                    -0.267
                                                ],
                                                [
                                                    -0.139,
                                                    -0.235
                                                ],
                                                [
                                                    -0.277,
                                                    -0.149
                                                ],
                                                [
                                                    -0.608,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0.277
                                                ],
                                                [
                                                    0.117,
                                                    0.171
                                                ],
                                                [
                                                    0.288,
                                                    0.107
                                                ],
                                                [
                                                    0.832,
                                                    0.139
                                                ],
                                                [
                                                    0.469,
                                                    0.213
                                                ],
                                                [
                                                    0.192,
                                                    0.309
                                                ],
                                                [
                                                    0,
                                                    0.779
                                                ],
                                                [
                                                    -0.597,
                                                    0.427
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    12.518,
                                                    4.584
                                                ],
                                                [
                                                    10.55,
                                                    4.216
                                                ],
                                                [
                                                    9.334,
                                                    3.208
                                                ],
                                                [
                                                    8.854,
                                                    1.72
                                                ],
                                                [
                                                    10.262,
                                                    1.624
                                                ],
                                                [
                                                    10.886,
                                                    2.856
                                                ],
                                                [
                                                    12.518,
                                                    3.304
                                                ],
                                                [
                                                    13.846,
                                                    3.032
                                                ],
                                                [
                                                    14.326,
                                                    2.12
                                                ],
                                                [
                                                    14.166,
                                                    1.56
                                                ],
                                                [
                                                    13.574,
                                                    1.176
                                                ],
                                                [
                                                    12.262,
                                                    0.84
                                                ],
                                                [
                                                    10.406,
                                                    0.28
                                                ],
                                                [
                                                    9.462,
                                                    -0.536
                                                ],
                                                [
                                                    9.19,
                                                    -1.688
                                                ],
                                                [
                                                    10.022,
                                                    -3.544
                                                ],
                                                [
                                                    12.406,
                                                    -4.28
                                                ],
                                                [
                                                    14.23,
                                                    -3.88
                                                ],
                                                [
                                                    15.318,
                                                    -2.872
                                                ],
                                                [
                                                    15.766,
                                                    -1.56
                                                ],
                                                [
                                                    14.358,
                                                    -1.464
                                                ],
                                                [
                                                    14.118,
                                                    -2.216
                                                ],
                                                [
                                                    13.494,
                                                    -2.776
                                                ],
                                                [
                                                    12.374,
                                                    -3
                                                ],
                                                [
                                                    11.03,
                                                    -2.648
                                                ],
                                                [
                                                    10.598,
                                                    -1.752
                                                ],
                                                [
                                                    10.758,
                                                    -1.064
                                                ],
                                                [
                                                    11.35,
                                                    -0.632
                                                ],
                                                [
                                                    12.518,
                                                    -0.344
                                                ],
                                                [
                                                    14.47,
                                                    0.184
                                                ],
                                                [
                                                    15.446,
                                                    0.984
                                                ],
                                                [
                                                    15.734,
                                                    2.12
                                                ],
                                                [
                                                    14.822,
                                                    3.944
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 21",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.726,
                                                    0
                                                ],
                                                [
                                                    0.512,
                                                    0.565
                                                ],
                                                [
                                                    0,
                                                    1.003
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    -0.395
                                                ],
                                                [
                                                    -0.608,
                                                    0
                                                ],
                                                [
                                                    -0.384,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0.757
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    -0.384
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.842,
                                                    0
                                                ],
                                                [
                                                    -0.501,
                                                    -0.576
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ],
                                                [
                                                    0.299,
                                                    0.384
                                                ],
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.384,
                                                    -0.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.17,
                                                    0.693
                                                ],
                                                [
                                                    -0.48,
                                                    0.373
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    20.37,
                                                    4.584
                                                ],
                                                [
                                                    18.338,
                                                    3.736
                                                ],
                                                [
                                                    17.586,
                                                    1.368
                                                ],
                                                [
                                                    17.586,
                                                    -4.088
                                                ],
                                                [
                                                    18.93,
                                                    -4.088
                                                ],
                                                [
                                                    18.93,
                                                    1
                                                ],
                                                [
                                                    19.362,
                                                    2.824
                                                ],
                                                [
                                                    20.722,
                                                    3.4
                                                ],
                                                [
                                                    22.306,
                                                    2.76
                                                ],
                                                [
                                                    22.882,
                                                    0.968
                                                ],
                                                [
                                                    22.882,
                                                    -4.088
                                                ],
                                                [
                                                    24.226,
                                                    -4.088
                                                ],
                                                [
                                                    24.226,
                                                    4.392
                                                ],
                                                [
                                                    22.946,
                                                    4.392
                                                ],
                                                [
                                                    22.946,
                                                    2.296
                                                ],
                                                [
                                                    23.154,
                                                    2.408
                                                ],
                                                [
                                                    22.178,
                                                    4.024
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 22",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.49,
                                                    0.32
                                                ],
                                                [
                                                    -0.65,
                                                    0
                                                ],
                                                [
                                                    -0.533,
                                                    -0.416
                                                ],
                                                [
                                                    -0.256,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.779
                                                ],
                                                [
                                                    0.267,
                                                    -0.672
                                                ],
                                                [
                                                    0.544,
                                                    -0.416
                                                ],
                                                [
                                                    0.843,
                                                    0
                                                ],
                                                [
                                                    0.384,
                                                    0.149
                                                ],
                                                [
                                                    0.267,
                                                    0.267
                                                ],
                                                [
                                                    0.096,
                                                    0.363
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.214,
                                                    -0.629
                                                ],
                                                [
                                                    0.502,
                                                    -0.331
                                                ],
                                                [
                                                    0.843,
                                                    0
                                                ],
                                                [
                                                    0.544,
                                                    0.416
                                                ],
                                                [
                                                    0.267,
                                                    0.672
                                                ],
                                                [
                                                    0,
                                                    0.779
                                                ],
                                                [
                                                    -0.256,
                                                    0.672
                                                ],
                                                [
                                                    -0.533,
                                                    0.416
                                                ],
                                                [
                                                    -0.437,
                                                    0
                                                ],
                                                [
                                                    -0.373,
                                                    -0.149
                                                ],
                                                [
                                                    -0.256,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    26.789,
                                                    6.792
                                                ],
                                                [
                                                    26.789,
                                                    -4.088
                                                ],
                                                [
                                                    28.037,
                                                    -4.088
                                                ],
                                                [
                                                    28.069,
                                                    -2.264
                                                ],
                                                [
                                                    27.877,
                                                    -2.36
                                                ],
                                                [
                                                    28.933,
                                                    -3.784
                                                ],
                                                [
                                                    30.661,
                                                    -4.28
                                                ],
                                                [
                                                    32.725,
                                                    -3.656
                                                ],
                                                [
                                                    33.925,
                                                    -2.024
                                                ],
                                                [
                                                    34.325,
                                                    0.152
                                                ],
                                                [
                                                    33.925,
                                                    2.328
                                                ],
                                                [
                                                    32.725,
                                                    3.96
                                                ],
                                                [
                                                    30.661,
                                                    4.584
                                                ],
                                                [
                                                    29.429,
                                                    4.36
                                                ],
                                                [
                                                    28.469,
                                                    3.736
                                                ],
                                                [
                                                    27.941,
                                                    2.792
                                                ],
                                                [
                                                    28.133,
                                                    2.568
                                                ],
                                                [
                                                    28.133,
                                                    6.792
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 23",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.49,
                                                    0
                                                ],
                                                [
                                                    -0.426,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0.992
                                                ],
                                                [
                                                    0.427,
                                                    0.555
                                                ],
                                                [
                                                    0.736,
                                                    0
                                                ],
                                                [
                                                    0.363,
                                                    -0.235
                                                ],
                                                [
                                                    0.203,
                                                    -0.469
                                                ],
                                                [
                                                    0,
                                                    -0.693
                                                ],
                                                [
                                                    -0.192,
                                                    -0.469
                                                ],
                                                [
                                                    -0.362,
                                                    -0.235
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.736,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    -0.555
                                                ],
                                                [
                                                    0,
                                                    -0.992
                                                ],
                                                [
                                                    -0.426,
                                                    -0.555
                                                ],
                                                [
                                                    -0.49,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.235
                                                ],
                                                [
                                                    -0.192,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0.693
                                                ],
                                                [
                                                    0.192,
                                                    0.469
                                                ],
                                                [
                                                    0.363,
                                                    0.235
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    30.533,
                                                    3.304
                                                ],
                                                [
                                                    32.277,
                                                    2.472
                                                ],
                                                [
                                                    32.917,
                                                    0.152
                                                ],
                                                [
                                                    32.277,
                                                    -2.168
                                                ],
                                                [
                                                    30.533,
                                                    -3
                                                ],
                                                [
                                                    29.253,
                                                    -2.648
                                                ],
                                                [
                                                    28.421,
                                                    -1.592
                                                ],
                                                [
                                                    28.133,
                                                    0.152
                                                ],
                                                [
                                                    28.421,
                                                    1.896
                                                ],
                                                [
                                                    29.253,
                                                    2.952
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 24",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.491,
                                                    0.32
                                                ],
                                                [
                                                    -0.651,
                                                    0
                                                ],
                                                [
                                                    -0.534,
                                                    -0.416
                                                ],
                                                [
                                                    -0.256,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.779
                                                ],
                                                [
                                                    0.266,
                                                    -0.672
                                                ],
                                                [
                                                    0.544,
                                                    -0.416
                                                ],
                                                [
                                                    0.842,
                                                    0
                                                ],
                                                [
                                                    0.384,
                                                    0.149
                                                ],
                                                [
                                                    0.266,
                                                    0.267
                                                ],
                                                [
                                                    0.096,
                                                    0.363
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.213,
                                                    -0.629
                                                ],
                                                [
                                                    0.501,
                                                    -0.331
                                                ],
                                                [
                                                    0.842,
                                                    0
                                                ],
                                                [
                                                    0.544,
                                                    0.416
                                                ],
                                                [
                                                    0.266,
                                                    0.672
                                                ],
                                                [
                                                    0,
                                                    0.779
                                                ],
                                                [
                                                    -0.256,
                                                    0.672
                                                ],
                                                [
                                                    -0.534,
                                                    0.416
                                                ],
                                                [
                                                    -0.438,
                                                    0
                                                ],
                                                [
                                                    -0.374,
                                                    -0.149
                                                ],
                                                [
                                                    -0.256,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    36.149,
                                                    6.792
                                                ],
                                                [
                                                    36.149,
                                                    -4.088
                                                ],
                                                [
                                                    37.397,
                                                    -4.088
                                                ],
                                                [
                                                    37.429,
                                                    -2.264
                                                ],
                                                [
                                                    37.237,
                                                    -2.36
                                                ],
                                                [
                                                    38.293,
                                                    -3.784
                                                ],
                                                [
                                                    40.021,
                                                    -4.28
                                                ],
                                                [
                                                    42.085,
                                                    -3.656
                                                ],
                                                [
                                                    43.285,
                                                    -2.024
                                                ],
                                                [
                                                    43.685,
                                                    0.152
                                                ],
                                                [
                                                    43.285,
                                                    2.328
                                                ],
                                                [
                                                    42.085,
                                                    3.96
                                                ],
                                                [
                                                    40.021,
                                                    4.584
                                                ],
                                                [
                                                    38.789,
                                                    4.36
                                                ],
                                                [
                                                    37.829,
                                                    3.736
                                                ],
                                                [
                                                    37.301,
                                                    2.792
                                                ],
                                                [
                                                    37.493,
                                                    2.568
                                                ],
                                                [
                                                    37.493,
                                                    6.792
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 25",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.491,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0.992
                                                ],
                                                [
                                                    0.426,
                                                    0.555
                                                ],
                                                [
                                                    0.736,
                                                    0
                                                ],
                                                [
                                                    0.362,
                                                    -0.235
                                                ],
                                                [
                                                    0.202,
                                                    -0.469
                                                ],
                                                [
                                                    0,
                                                    -0.693
                                                ],
                                                [
                                                    -0.192,
                                                    -0.469
                                                ],
                                                [
                                                    -0.363,
                                                    -0.235
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.736,
                                                    0
                                                ],
                                                [
                                                    0.426,
                                                    -0.555
                                                ],
                                                [
                                                    0,
                                                    -0.992
                                                ],
                                                [
                                                    -0.427,
                                                    -0.555
                                                ],
                                                [
                                                    -0.491,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.235
                                                ],
                                                [
                                                    -0.192,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0.693
                                                ],
                                                [
                                                    0.192,
                                                    0.469
                                                ],
                                                [
                                                    0.362,
                                                    0.235
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    39.893,
                                                    3.304
                                                ],
                                                [
                                                    41.637,
                                                    2.472
                                                ],
                                                [
                                                    42.277,
                                                    0.152
                                                ],
                                                [
                                                    41.637,
                                                    -2.168
                                                ],
                                                [
                                                    39.893,
                                                    -3
                                                ],
                                                [
                                                    38.613,
                                                    -2.648
                                                ],
                                                [
                                                    37.781,
                                                    -1.592
                                                ],
                                                [
                                                    37.493,
                                                    0.152
                                                ],
                                                [
                                                    37.781,
                                                    1.896
                                                ],
                                                [
                                                    38.613,
                                                    2.952
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 26",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.779,
                                                    0
                                                ],
                                                [
                                                    0.587,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.32,
                                                    0.661
                                                ],
                                                [
                                                    -0.587,
                                                    0.363
                                                ],
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.363
                                                ],
                                                [
                                                    -0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.907
                                                ],
                                                [
                                                    0.32,
                                                    -0.672
                                                ],
                                                [
                                                    0.587,
                                                    -0.363
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.587,
                                                    -0.363
                                                ],
                                                [
                                                    -0.32,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.907
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.587,
                                                    -0.363
                                                ],
                                                [
                                                    0.779,
                                                    0
                                                ],
                                                [
                                                    0.587,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.32,
                                                    0.661
                                                ],
                                                [
                                                    -0.576,
                                                    0.363
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    48.82,
                                                    4.584
                                                ],
                                                [
                                                    46.772,
                                                    4.04
                                                ],
                                                [
                                                    45.412,
                                                    2.504
                                                ],
                                                [
                                                    44.932,
                                                    0.152
                                                ],
                                                [
                                                    45.412,
                                                    -2.2
                                                ],
                                                [
                                                    46.772,
                                                    -3.736
                                                ],
                                                [
                                                    48.82,
                                                    -4.28
                                                ],
                                                [
                                                    50.852,
                                                    -3.736
                                                ],
                                                [
                                                    52.212,
                                                    -2.2
                                                ],
                                                [
                                                    52.692,
                                                    0.152
                                                ],
                                                [
                                                    52.212,
                                                    2.504
                                                ],
                                                [
                                                    50.852,
                                                    4.04
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 27",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0.981
                                                ],
                                                [
                                                    0.437,
                                                    0.555
                                                ],
                                                [
                                                    0.779,
                                                    0
                                                ],
                                                [
                                                    0.437,
                                                    -0.565
                                                ],
                                                [
                                                    0,
                                                    -0.981
                                                ],
                                                [
                                                    -0.437,
                                                    -0.565
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.779,
                                                    0
                                                ],
                                                [
                                                    0.437,
                                                    -0.565
                                                ],
                                                [
                                                    0,
                                                    -0.981
                                                ],
                                                [
                                                    -0.427,
                                                    -0.565
                                                ],
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.437,
                                                    0.555
                                                ],
                                                [
                                                    0,
                                                    0.981
                                                ],
                                                [
                                                    0.437,
                                                    0.555
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    48.82,
                                                    3.304
                                                ],
                                                [
                                                    50.628,
                                                    2.472
                                                ],
                                                [
                                                    51.284,
                                                    0.152
                                                ],
                                                [
                                                    50.628,
                                                    -2.152
                                                ],
                                                [
                                                    48.82,
                                                    -3
                                                ],
                                                [
                                                    46.996,
                                                    -2.152
                                                ],
                                                [
                                                    46.34,
                                                    0.152
                                                ],
                                                [
                                                    46.996,
                                                    2.472
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 28",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.331
                                                ],
                                                [
                                                    -0.598,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.16
                                                ],
                                                [
                                                    0.149,
                                                    -0.309
                                                ],
                                                [
                                                    0,
                                                    -0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.106,
                                                    -0.725
                                                ],
                                                [
                                                    0.362,
                                                    -0.341
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    0
                                                ],
                                                [
                                                    -0.278,
                                                    0.149
                                                ],
                                                [
                                                    -0.139,
                                                    0.299
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    54.524,
                                                    4.392
                                                ],
                                                [
                                                    54.524,
                                                    -4.088
                                                ],
                                                [
                                                    55.708,
                                                    -4.088
                                                ],
                                                [
                                                    55.772,
                                                    -1.944
                                                ],
                                                [
                                                    55.644,
                                                    -1.992
                                                ],
                                                [
                                                    56.332,
                                                    -3.576
                                                ],
                                                [
                                                    57.772,
                                                    -4.088
                                                ],
                                                [
                                                    58.604,
                                                    -4.088
                                                ],
                                                [
                                                    58.604,
                                                    -2.808
                                                ],
                                                [
                                                    57.788,
                                                    -2.808
                                                ],
                                                [
                                                    56.716,
                                                    -2.568
                                                ],
                                                [
                                                    56.076,
                                                    -1.88
                                                ],
                                                [
                                                    55.868,
                                                    -0.728
                                                ],
                                                [
                                                    55.868,
                                                    4.392
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 29",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.374,
                                                    0.352
                                                ],
                                                [
                                                    0,
                                                    0.747
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.17,
                                                    -0.149
                                                ],
                                                [
                                                    -0.352,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.768,
                                                    0
                                                ],
                                                [
                                                    -0.362,
                                                    -0.352
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.384
                                                ],
                                                [
                                                    0.171,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    62.893,
                                                    4.392
                                                ],
                                                [
                                                    61.181,
                                                    3.864
                                                ],
                                                [
                                                    60.637,
                                                    2.216
                                                ],
                                                [
                                                    60.637,
                                                    -6.072
                                                ],
                                                [
                                                    61.981,
                                                    -6.072
                                                ],
                                                [
                                                    61.981,
                                                    2.184
                                                ],
                                                [
                                                    62.237,
                                                    2.984
                                                ],
                                                [
                                                    63.021,
                                                    3.208
                                                ],
                                                [
                                                    64.237,
                                                    3.208
                                                ],
                                                [
                                                    64.237,
                                                    4.392
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 30",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    59.389,
                                                    -2.904
                                                ],
                                                [
                                                    59.389,
                                                    -4.088
                                                ],
                                                [
                                                    64.237,
                                                    -4.088
                                                ],
                                                [
                                                    64.237,
                                                    -2.904
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 31",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    64.995,
                                                    0.36
                                                ],
                                                [
                                                    64.995,
                                                    -0.904
                                                ],
                                                [
                                                    70.291,
                                                    -0.904
                                                ],
                                                [
                                                    70.291,
                                                    0.36
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 32",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.48,
                                                    0
                                                ],
                                                [
                                                    0.522,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    -0.427,
                                                    0.416
                                                ],
                                                [
                                                    -0.928,
                                                    0.171
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.341,
                                                    0.352
                                                ],
                                                [
                                                    0.672,
                                                    0
                                                ],
                                                [
                                                    0.341,
                                                    -0.267
                                                ],
                                                [
                                                    0.128,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.608,
                                                    0.491
                                                ],
                                                [
                                                    -0.96,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.619
                                                ],
                                                [
                                                    0,
                                                    -1.077
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.085
                                                ],
                                                [
                                                    -0.16,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.096,
                                                    0
                                                ],
                                                [
                                                    0.106,
                                                    0
                                                ],
                                                [
                                                    0.245,
                                                    0.117
                                                ],
                                                [
                                                    0.106,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.299
                                                ],
                                                [
                                                    0.426,
                                                    -0.171
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.875,
                                                    0
                                                ],
                                                [
                                                    -0.512,
                                                    -0.405
                                                ],
                                                [
                                                    0,
                                                    -0.725
                                                ],
                                                [
                                                    0.426,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.715
                                                ],
                                                [
                                                    -0.331,
                                                    -0.352
                                                ],
                                                [
                                                    -0.587,
                                                    0
                                                ],
                                                [
                                                    -0.342,
                                                    0.256
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.16,
                                                    -0.8
                                                ],
                                                [
                                                    0.618,
                                                    -0.501
                                                ],
                                                [
                                                    1.088,
                                                    0
                                                ],
                                                [
                                                    0.576,
                                                    0.608
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.192
                                                ],
                                                [
                                                    0.074,
                                                    0.075
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.043,
                                                    0.011
                                                ],
                                                [
                                                    -0.096,
                                                    0.011
                                                ],
                                                [
                                                    -0.384,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    -0.128
                                                ],
                                                [
                                                    -0.107,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.075,
                                                    0.363
                                                ],
                                                [
                                                    -0.288,
                                                    0.288
                                                ],
                                                [
                                                    -0.427,
                                                    0.16
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    74.562,
                                                    4.584
                                                ],
                                                [
                                                    72.466,
                                                    3.976
                                                ],
                                                [
                                                    71.698,
                                                    2.28
                                                ],
                                                [
                                                    72.338,
                                                    0.568
                                                ],
                                                [
                                                    74.37,
                                                    -0.312
                                                ],
                                                [
                                                    77.378,
                                                    -0.872
                                                ],
                                                [
                                                    76.866,
                                                    -2.472
                                                ],
                                                [
                                                    75.362,
                                                    -3
                                                ],
                                                [
                                                    73.97,
                                                    -2.6
                                                ],
                                                [
                                                    73.266,
                                                    -1.48
                                                ],
                                                [
                                                    71.842,
                                                    -1.592
                                                ],
                                                [
                                                    72.994,
                                                    -3.528
                                                ],
                                                [
                                                    75.362,
                                                    -4.28
                                                ],
                                                [
                                                    77.858,
                                                    -3.352
                                                ],
                                                [
                                                    78.722,
                                                    -0.824
                                                ],
                                                [
                                                    78.722,
                                                    2.68
                                                ],
                                                [
                                                    78.818,
                                                    3.096
                                                ],
                                                [
                                                    79.17,
                                                    3.208
                                                ],
                                                [
                                                    79.506,
                                                    3.208
                                                ],
                                                [
                                                    79.506,
                                                    4.392
                                                ],
                                                [
                                                    79.298,
                                                    4.408
                                                ],
                                                [
                                                    78.994,
                                                    4.424
                                                ],
                                                [
                                                    78.05,
                                                    4.248
                                                ],
                                                [
                                                    77.538,
                                                    3.672
                                                ],
                                                [
                                                    77.378,
                                                    2.632
                                                ],
                                                [
                                                    77.538,
                                                    2.664
                                                ],
                                                [
                                                    76.994,
                                                    3.656
                                                ],
                                                [
                                                    75.922,
                                                    4.344
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 33",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.491,
                                                    0
                                                ],
                                                [
                                                    -0.395,
                                                    0.213
                                                ],
                                                [
                                                    -0.214,
                                                    0.373
                                                ],
                                                [
                                                    0,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.224,
                                                    -0.224
                                                ],
                                                [
                                                    0,
                                                    -0.352
                                                ],
                                                [
                                                    -0.278,
                                                    -0.224
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.565,
                                                    0
                                                ],
                                                [
                                                    0.405,
                                                    -0.224
                                                ],
                                                [
                                                    0.213,
                                                    -0.384
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    0.107
                                                ],
                                                [
                                                    -0.214,
                                                    0.213
                                                ],
                                                [
                                                    0,
                                                    0.395
                                                ],
                                                [
                                                    0.288,
                                                    0.213
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    74.69,
                                                    3.4
                                                ],
                                                [
                                                    76.13,
                                                    3.08
                                                ],
                                                [
                                                    77.058,
                                                    2.184
                                                ],
                                                [
                                                    77.378,
                                                    0.904
                                                ],
                                                [
                                                    77.378,
                                                    0.296
                                                ],
                                                [
                                                    74.626,
                                                    0.808
                                                ],
                                                [
                                                    73.426,
                                                    1.304
                                                ],
                                                [
                                                    73.106,
                                                    2.152
                                                ],
                                                [
                                                    73.522,
                                                    3.08
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 34",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.778,
                                                    0
                                                ],
                                                [
                                                    0.49,
                                                    0.203
                                                ],
                                                [
                                                    0.33,
                                                    0.373
                                                ],
                                                [
                                                    0.117,
                                                    0.491
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.32,
                                                    -0.224
                                                ],
                                                [
                                                    -0.651,
                                                    0
                                                ],
                                                [
                                                    -0.406,
                                                    0.309
                                                ],
                                                [
                                                    0,
                                                    0.619
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.448,
                                                    -0.267
                                                ],
                                                [
                                                    0.554,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    0.352
                                                ],
                                                [
                                                    0.32,
                                                    0.619
                                                ],
                                                [
                                                    0,
                                                    0.8
                                                ],
                                                [
                                                    -0.31,
                                                    0.608
                                                ],
                                                [
                                                    -0.544,
                                                    0.352
                                                ],
                                                [
                                                    -0.704,
                                                    0
                                                ],
                                                [
                                                    -0.47,
                                                    -0.277
                                                ],
                                                [
                                                    -0.192,
                                                    -0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.298,
                                                    -0.469
                                                ],
                                                [
                                                    0.554,
                                                    -0.245
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.608,
                                                    0
                                                ],
                                                [
                                                    -0.491,
                                                    -0.203
                                                ],
                                                [
                                                    -0.331,
                                                    -0.373
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.129,
                                                    0.395
                                                ],
                                                [
                                                    0.33,
                                                    0.235
                                                ],
                                                [
                                                    0.768,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    -0.309
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.203,
                                                    0.448
                                                ],
                                                [
                                                    -0.448,
                                                    0.267
                                                ],
                                                [
                                                    -0.715,
                                                    0
                                                ],
                                                [
                                                    -0.555,
                                                    -0.352
                                                ],
                                                [
                                                    -0.31,
                                                    -0.619
                                                ],
                                                [
                                                    0,
                                                    -0.811
                                                ],
                                                [
                                                    0.309,
                                                    -0.619
                                                ],
                                                [
                                                    0.554,
                                                    -0.352
                                                ],
                                                [
                                                    0.597,
                                                    0
                                                ],
                                                [
                                                    0.48,
                                                    0.277
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.661
                                                ],
                                                [
                                                    -0.299,
                                                    0.48
                                                ],
                                                [
                                                    -0.555,
                                                    0.256
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    84.209,
                                                    6.984
                                                ],
                                                [
                                                    82.561,
                                                    6.68
                                                ],
                                                [
                                                    81.329,
                                                    5.816
                                                ],
                                                [
                                                    80.657,
                                                    4.52
                                                ],
                                                [
                                                    82.064,
                                                    4.424
                                                ],
                                                [
                                                    82.737,
                                                    5.352
                                                ],
                                                [
                                                    84.209,
                                                    5.704
                                                ],
                                                [
                                                    85.969,
                                                    5.24
                                                ],
                                                [
                                                    86.593,
                                                    3.848
                                                ],
                                                [
                                                    86.593,
                                                    2.472
                                                ],
                                                [
                                                    85.617,
                                                    3.544
                                                ],
                                                [
                                                    84.113,
                                                    3.944
                                                ],
                                                [
                                                    82.193,
                                                    3.416
                                                ],
                                                [
                                                    80.881,
                                                    1.96
                                                ],
                                                [
                                                    80.417,
                                                    -0.168
                                                ],
                                                [
                                                    80.881,
                                                    -2.296
                                                ],
                                                [
                                                    82.161,
                                                    -3.752
                                                ],
                                                [
                                                    84.049,
                                                    -4.28
                                                ],
                                                [
                                                    85.649,
                                                    -3.864
                                                ],
                                                [
                                                    86.657,
                                                    -2.744
                                                ],
                                                [
                                                    86.657,
                                                    -4.088
                                                ],
                                                [
                                                    87.936,
                                                    -4.088
                                                ],
                                                [
                                                    87.936,
                                                    3.816
                                                ],
                                                [
                                                    87.489,
                                                    5.512
                                                ],
                                                [
                                                    86.209,
                                                    6.6
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 35",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.726,
                                                    0
                                                ],
                                                [
                                                    -0.438,
                                                    0.501
                                                ],
                                                [
                                                    -0.011,
                                                    0.875
                                                ],
                                                [
                                                    0.202,
                                                    0.416
                                                ],
                                                [
                                                    0.373,
                                                    0.224
                                                ],
                                                [
                                                    0.49,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    -0.512
                                                ],
                                                [
                                                    0,
                                                    -0.875
                                                ],
                                                [
                                                    -0.416,
                                                    -0.512
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.725,
                                                    0
                                                ],
                                                [
                                                    0.437,
                                                    -0.512
                                                ],
                                                [
                                                    0.01,
                                                    -0.587
                                                ],
                                                [
                                                    -0.192,
                                                    -0.427
                                                ],
                                                [
                                                    -0.363,
                                                    -0.235
                                                ],
                                                [
                                                    -0.747,
                                                    0
                                                ],
                                                [
                                                    -0.406,
                                                    0.501
                                                ],
                                                [
                                                    0,
                                                    0.875
                                                ],
                                                [
                                                    0.426,
                                                    0.501
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    84.177,
                                                    2.664
                                                ],
                                                [
                                                    85.921,
                                                    1.912
                                                ],
                                                [
                                                    86.593,
                                                    -0.168
                                                ],
                                                [
                                                    86.305,
                                                    -1.672
                                                ],
                                                [
                                                    85.457,
                                                    -2.648
                                                ],
                                                [
                                                    84.177,
                                                    -3
                                                ],
                                                [
                                                    82.433,
                                                    -2.232
                                                ],
                                                [
                                                    81.824,
                                                    -0.168
                                                ],
                                                [
                                                    82.449,
                                                    1.912
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 36",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.896,
                                                    0
                                                ],
                                                [
                                                    0.587,
                                                    0.363
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.309,
                                                    0.661
                                                ],
                                                [
                                                    -0.565,
                                                    0.363
                                                ],
                                                [
                                                    -0.778,
                                                    0
                                                ],
                                                [
                                                    -0.565,
                                                    -0.352
                                                ],
                                                [
                                                    -0.309,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    -0.949
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.426,
                                                    -0.459
                                                ],
                                                [
                                                    -0.736,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.256
                                                ],
                                                [
                                                    -0.138,
                                                    0.427
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.63,
                                                    -0.491
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.8,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.363
                                                ],
                                                [
                                                    -0.309,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.32,
                                                    -0.661
                                                ],
                                                [
                                                    0.576,
                                                    -0.373
                                                ],
                                                [
                                                    0.736,
                                                    0
                                                ],
                                                [
                                                    0.566,
                                                    0.341
                                                ],
                                                [
                                                    0.32,
                                                    0.661
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.054,
                                                    0.907
                                                ],
                                                [
                                                    0.438,
                                                    0.459
                                                ],
                                                [
                                                    0.555,
                                                    0
                                                ],
                                                [
                                                    0.363,
                                                    -0.267
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    0.757
                                                ],
                                                [
                                                    -0.618,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    93.648,
                                                    4.584
                                                ],
                                                [
                                                    91.568,
                                                    4.04
                                                ],
                                                [
                                                    90.224,
                                                    2.504
                                                ],
                                                [
                                                    89.76,
                                                    0.152
                                                ],
                                                [
                                                    90.224,
                                                    -2.184
                                                ],
                                                [
                                                    91.552,
                                                    -3.72
                                                ],
                                                [
                                                    93.584,
                                                    -4.28
                                                ],
                                                [
                                                    95.536,
                                                    -3.752
                                                ],
                                                [
                                                    96.848,
                                                    -2.248
                                                ],
                                                [
                                                    97.328,
                                                    0.168
                                                ],
                                                [
                                                    97.328,
                                                    0.568
                                                ],
                                                [
                                                    91.168,
                                                    0.568
                                                ],
                                                [
                                                    91.888,
                                                    2.616
                                                ],
                                                [
                                                    93.648,
                                                    3.304
                                                ],
                                                [
                                                    95.008,
                                                    2.92
                                                ],
                                                [
                                                    95.76,
                                                    1.88
                                                ],
                                                [
                                                    97.2,
                                                    1.992
                                                ],
                                                [
                                                    95.92,
                                                    3.864
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 37",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.118,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    0.384
                                                ],
                                                [
                                                    0.63,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    -0.405
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.821
                                                ],
                                                [
                                                    -0.405,
                                                    -0.384
                                                ],
                                                [
                                                    -0.65,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.395
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    91.168,
                                                    -0.616
                                                ],
                                                [
                                                    95.856,
                                                    -0.616
                                                ],
                                                [
                                                    95.136,
                                                    -2.424
                                                ],
                                                [
                                                    93.584,
                                                    -3
                                                ],
                                                [
                                                    91.968,
                                                    -2.392
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 38",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.267,
                                                    0.32
                                                ],
                                                [
                                                    -0.374,
                                                    0.16
                                                ],
                                                [
                                                    -0.438,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    -0.288
                                                ],
                                                [
                                                    -0.203,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    -0.597
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.128,
                                                    0.352
                                                ],
                                                [
                                                    0.266,
                                                    0.181
                                                ],
                                                [
                                                    0.426,
                                                    0
                                                ],
                                                [
                                                    0.426,
                                                    -0.416
                                                ],
                                                [
                                                    0,
                                                    -0.789
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.106,
                                                    -0.501
                                                ],
                                                [
                                                    0.266,
                                                    -0.331
                                                ],
                                                [
                                                    0.384,
                                                    -0.16
                                                ],
                                                [
                                                    0.65,
                                                    0
                                                ],
                                                [
                                                    0.426,
                                                    0.288
                                                ],
                                                [
                                                    0.213,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.523
                                                ],
                                                [
                                                    -0.118,
                                                    -0.363
                                                ],
                                                [
                                                    -0.267,
                                                    -0.192
                                                ],
                                                [
                                                    -0.651,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.405
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    99.149,
                                                    4.392
                                                ],
                                                [
                                                    99.149,
                                                    -4.088
                                                ],
                                                [
                                                    100.381,
                                                    -4.088
                                                ],
                                                [
                                                    100.429,
                                                    -1.928
                                                ],
                                                [
                                                    100.269,
                                                    -2.072
                                                ],
                                                [
                                                    100.829,
                                                    -3.304
                                                ],
                                                [
                                                    101.789,
                                                    -4.04
                                                ],
                                                [
                                                    103.021,
                                                    -4.28
                                                ],
                                                [
                                                    104.621,
                                                    -3.848
                                                ],
                                                [
                                                    105.565,
                                                    -2.68
                                                ],
                                                [
                                                    105.885,
                                                    -1.064
                                                ],
                                                [
                                                    105.885,
                                                    4.392
                                                ],
                                                [
                                                    104.541,
                                                    4.392
                                                ],
                                                [
                                                    104.541,
                                                    -0.68
                                                ],
                                                [
                                                    104.349,
                                                    -1.992
                                                ],
                                                [
                                                    103.773,
                                                    -2.808
                                                ],
                                                [
                                                    102.733,
                                                    -3.096
                                                ],
                                                [
                                                    101.117,
                                                    -2.472
                                                ],
                                                [
                                                    100.493,
                                                    -0.68
                                                ],
                                                [
                                                    100.493,
                                                    4.392
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 39",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.373,
                                                    0.352
                                                ],
                                                [
                                                    0,
                                                    0.747
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.171,
                                                    -0.149
                                                ],
                                                [
                                                    -0.352,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.768,
                                                    0
                                                ],
                                                [
                                                    -0.363,
                                                    -0.352
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.384
                                                ],
                                                [
                                                    0.171,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    110.909,
                                                    4.392
                                                ],
                                                [
                                                    109.197,
                                                    3.864
                                                ],
                                                [
                                                    108.653,
                                                    2.216
                                                ],
                                                [
                                                    108.653,
                                                    -6.072
                                                ],
                                                [
                                                    109.997,
                                                    -6.072
                                                ],
                                                [
                                                    109.997,
                                                    2.184
                                                ],
                                                [
                                                    110.253,
                                                    2.984
                                                ],
                                                [
                                                    111.037,
                                                    3.208
                                                ],
                                                [
                                                    112.253,
                                                    3.208
                                                ],
                                                [
                                                    112.253,
                                                    4.392
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 40",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    107.405,
                                                    -2.904
                                                ],
                                                [
                                                    107.405,
                                                    -4.088
                                                ],
                                                [
                                                    112.253,
                                                    -4.088
                                                ],
                                                [
                                                    112.253,
                                                    -2.904
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4588,
                                            0.4588,
                                            0.4588
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            171.725,
                                            149.608
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 12",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.009,
                                                    0
                                                ],
                                                [
                                                    0.792,
                                                    0.372
                                                ],
                                                [
                                                    0.444,
                                                    0.672
                                                ],
                                                [
                                                    0.06,
                                                    0.912
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.216,
                                                    -0.36
                                                ],
                                                [
                                                    -0.372,
                                                    -0.18
                                                ],
                                                [
                                                    -0.553,
                                                    0
                                                ],
                                                [
                                                    -0.313,
                                                    0.108
                                                ],
                                                [
                                                    -0.168,
                                                    0.216
                                                ],
                                                [
                                                    0,
                                                    0.324
                                                ],
                                                [
                                                    0.145,
                                                    0.216
                                                ],
                                                [
                                                    0.407,
                                                    0.18
                                                ],
                                                [
                                                    0.792,
                                                    0.18
                                                ],
                                                [
                                                    0.672,
                                                    0.312
                                                ],
                                                [
                                                    0.3,
                                                    0.468
                                                ],
                                                [
                                                    0,
                                                    0.72
                                                ],
                                                [
                                                    -0.372,
                                                    0.576
                                                ],
                                                [
                                                    -0.72,
                                                    0.324
                                                ],
                                                [
                                                    -0.996,
                                                    0
                                                ],
                                                [
                                                    -0.731,
                                                    -0.372
                                                ],
                                                [
                                                    -0.408,
                                                    -0.648
                                                ],
                                                [
                                                    -0.084,
                                                    -0.84
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.205,
                                                    0.324
                                                ],
                                                [
                                                    0.348,
                                                    0.18
                                                ],
                                                [
                                                    0.492,
                                                    0
                                                ],
                                                [
                                                    0.36,
                                                    -0.276
                                                ],
                                                [
                                                    0,
                                                    -0.444
                                                ],
                                                [
                                                    -0.156,
                                                    -0.216
                                                ],
                                                [
                                                    -0.372,
                                                    -0.156
                                                ],
                                                [
                                                    -0.697,
                                                    -0.144
                                                ],
                                                [
                                                    -0.683,
                                                    -0.372
                                                ],
                                                [
                                                    -0.288,
                                                    -0.504
                                                ],
                                                [
                                                    0,
                                                    -0.648
                                                ],
                                                [
                                                    0.408,
                                                    -0.588
                                                ],
                                                [
                                                    0.745,
                                                    -0.312
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.104,
                                                    0
                                                ],
                                                [
                                                    -0.792,
                                                    -0.372
                                                ],
                                                [
                                                    -0.444,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.072,
                                                    0.504
                                                ],
                                                [
                                                    0.228,
                                                    0.348
                                                ],
                                                [
                                                    0.384,
                                                    0.18
                                                ],
                                                [
                                                    0.456,
                                                    0
                                                ],
                                                [
                                                    0.323,
                                                    -0.108
                                                ],
                                                [
                                                    0.167,
                                                    -0.228
                                                ],
                                                [
                                                    0,
                                                    -0.3
                                                ],
                                                [
                                                    -0.144,
                                                    -0.228
                                                ],
                                                [
                                                    -0.409,
                                                    -0.192
                                                ],
                                                [
                                                    -1.092,
                                                    -0.252
                                                ],
                                                [
                                                    -0.66,
                                                    -0.312
                                                ],
                                                [
                                                    -0.3,
                                                    -0.48
                                                ],
                                                [
                                                    0,
                                                    -0.768
                                                ],
                                                [
                                                    0.384,
                                                    -0.576
                                                ],
                                                [
                                                    0.72,
                                                    -0.324
                                                ],
                                                [
                                                    1.056,
                                                    0
                                                ],
                                                [
                                                    0.732,
                                                    0.372
                                                ],
                                                [
                                                    0.421,
                                                    0.648
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.036,
                                                    -0.444
                                                ],
                                                [
                                                    -0.204,
                                                    -0.336
                                                ],
                                                [
                                                    -0.348,
                                                    -0.18
                                                ],
                                                [
                                                    -0.624,
                                                    0
                                                ],
                                                [
                                                    -0.348,
                                                    0.276
                                                ],
                                                [
                                                    0,
                                                    0.312
                                                ],
                                                [
                                                    0.168,
                                                    0.204
                                                ],
                                                [
                                                    0.384,
                                                    0.156
                                                ],
                                                [
                                                    1.187,
                                                    0.24
                                                ],
                                                [
                                                    0.696,
                                                    0.36
                                                ],
                                                [
                                                    0.288,
                                                    0.504
                                                ],
                                                [
                                                    0,
                                                    0.792
                                                ],
                                                [
                                                    -0.395,
                                                    0.576
                                                ],
                                                [
                                                    -0.732,
                                                    0.312
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -58.239,
                                                    5.364
                                                ],
                                                [
                                                    -61.083,
                                                    4.806
                                                ],
                                                [
                                                    -62.937,
                                                    3.24
                                                ],
                                                [
                                                    -63.693,
                                                    0.864
                                                ],
                                                [
                                                    -60.939,
                                                    0.738
                                                ],
                                                [
                                                    -60.507,
                                                    2.034
                                                ],
                                                [
                                                    -59.607,
                                                    2.826
                                                ],
                                                [
                                                    -58.202,
                                                    3.096
                                                ],
                                                [
                                                    -57.05,
                                                    2.934
                                                ],
                                                [
                                                    -56.312,
                                                    2.448
                                                ],
                                                [
                                                    -56.061,
                                                    1.62
                                                ],
                                                [
                                                    -56.277,
                                                    0.846
                                                ],
                                                [
                                                    -57.104,
                                                    0.234
                                                ],
                                                [
                                                    -58.905,
                                                    -0.324
                                                ],
                                                [
                                                    -61.551,
                                                    -1.17
                                                ],
                                                [
                                                    -62.991,
                                                    -2.34
                                                ],
                                                [
                                                    -63.441,
                                                    -4.14
                                                ],
                                                [
                                                    -62.883,
                                                    -6.156
                                                ],
                                                [
                                                    -61.227,
                                                    -7.506
                                                ],
                                                [
                                                    -58.653,
                                                    -7.992
                                                ],
                                                [
                                                    -55.971,
                                                    -7.434
                                                ],
                                                [
                                                    -54.261,
                                                    -5.904
                                                ],
                                                [
                                                    -53.505,
                                                    -3.672
                                                ],
                                                [
                                                    -56.241,
                                                    -3.528
                                                ],
                                                [
                                                    -56.601,
                                                    -4.68
                                                ],
                                                [
                                                    -57.429,
                                                    -5.454
                                                ],
                                                [
                                                    -58.689,
                                                    -5.724
                                                ],
                                                [
                                                    -60.165,
                                                    -5.31
                                                ],
                                                [
                                                    -60.687,
                                                    -4.23
                                                ],
                                                [
                                                    -60.453,
                                                    -3.438
                                                ],
                                                [
                                                    -59.643,
                                                    -2.898
                                                ],
                                                [
                                                    -58.022,
                                                    -2.448
                                                ],
                                                [
                                                    -55.215,
                                                    -1.53
                                                ],
                                                [
                                                    -53.739,
                                                    -0.234
                                                ],
                                                [
                                                    -53.307,
                                                    1.494
                                                ],
                                                [
                                                    -53.919,
                                                    3.564
                                                ],
                                                [
                                                    -55.629,
                                                    4.896
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.912,
                                                    0
                                                ],
                                                [
                                                    0.564,
                                                    0.636
                                                ],
                                                [
                                                    0,
                                                    1.152
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.229,
                                                    -0.348
                                                ],
                                                [
                                                    -0.492,
                                                    0
                                                ],
                                                [
                                                    -0.3,
                                                    0.372
                                                ],
                                                [
                                                    0,
                                                    0.756
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.539,
                                                    -0.492
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.996,
                                                    0
                                                ],
                                                [
                                                    -0.551,
                                                    -0.648
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.744
                                                ],
                                                [
                                                    0.227,
                                                    0.336
                                                ],
                                                [
                                                    0.552,
                                                    0
                                                ],
                                                [
                                                    0.312,
                                                    -0.384
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.144,
                                                    0.96
                                                ],
                                                [
                                                    -0.54,
                                                    0.492
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -48.021,
                                                    5.292
                                                ],
                                                [
                                                    -50.361,
                                                    4.338
                                                ],
                                                [
                                                    -51.188,
                                                    1.638
                                                ],
                                                [
                                                    -51.188,
                                                    -4.572
                                                ],
                                                [
                                                    -48.489,
                                                    -4.572
                                                ],
                                                [
                                                    -48.489,
                                                    1.008
                                                ],
                                                [
                                                    -48.146,
                                                    2.646
                                                ],
                                                [
                                                    -47.067,
                                                    3.15
                                                ],
                                                [
                                                    -45.789,
                                                    2.592
                                                ],
                                                [
                                                    -45.321,
                                                    0.882
                                                ],
                                                [
                                                    -45.321,
                                                    -4.572
                                                ],
                                                [
                                                    -42.62,
                                                    -4.572
                                                ],
                                                [
                                                    -42.62,
                                                    5.076
                                                ],
                                                [
                                                    -45.087,
                                                    5.076
                                                ],
                                                [
                                                    -45.159,
                                                    2.304
                                                ],
                                                [
                                                    -44.817,
                                                    2.376
                                                ],
                                                [
                                                    -45.842,
                                                    4.554
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.54,
                                                    0.372
                                                ],
                                                [
                                                    -0.72,
                                                    0
                                                ],
                                                [
                                                    -0.6,
                                                    -0.444
                                                ],
                                                [
                                                    -0.3,
                                                    -0.768
                                                ],
                                                [
                                                    0,
                                                    -0.948
                                                ],
                                                [
                                                    0.312,
                                                    -0.768
                                                ],
                                                [
                                                    0.612,
                                                    -0.444
                                                ],
                                                [
                                                    0.9,
                                                    0
                                                ],
                                                [
                                                    0.408,
                                                    0.168
                                                ],
                                                [
                                                    0.3,
                                                    0.312
                                                ],
                                                [
                                                    0.132,
                                                    0.432
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.24,
                                                    -0.696
                                                ],
                                                [
                                                    0.54,
                                                    -0.372
                                                ],
                                                [
                                                    0.9,
                                                    0
                                                ],
                                                [
                                                    0.6,
                                                    0.444
                                                ],
                                                [
                                                    0.312,
                                                    0.756
                                                ],
                                                [
                                                    0,
                                                    0.936
                                                ],
                                                [
                                                    -0.3,
                                                    0.768
                                                ],
                                                [
                                                    -0.6,
                                                    0.444
                                                ],
                                                [
                                                    -0.468,
                                                    0
                                                ],
                                                [
                                                    -0.408,
                                                    -0.18
                                                ],
                                                [
                                                    -0.288,
                                                    -0.312
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -40.255,
                                                    7.776
                                                ],
                                                [
                                                    -40.255,
                                                    -4.572
                                                ],
                                                [
                                                    -37.663,
                                                    -4.572
                                                ],
                                                [
                                                    -37.609,
                                                    -2.538
                                                ],
                                                [
                                                    -37.825,
                                                    -2.628
                                                ],
                                                [
                                                    -36.655,
                                                    -4.23
                                                ],
                                                [
                                                    -34.765,
                                                    -4.788
                                                ],
                                                [
                                                    -32.515,
                                                    -4.122
                                                ],
                                                [
                                                    -31.165,
                                                    -2.304
                                                ],
                                                [
                                                    -30.697,
                                                    0.252
                                                ],
                                                [
                                                    -31.165,
                                                    2.808
                                                ],
                                                [
                                                    -32.533,
                                                    4.626
                                                ],
                                                [
                                                    -34.783,
                                                    5.292
                                                ],
                                                [
                                                    -36.097,
                                                    5.04
                                                ],
                                                [
                                                    -37.159,
                                                    4.302
                                                ],
                                                [
                                                    -37.789,
                                                    3.186
                                                ],
                                                [
                                                    -37.555,
                                                    3.042
                                                ],
                                                [
                                                    -37.555,
                                                    7.776
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.42,
                                                    0
                                                ],
                                                [
                                                    -0.36,
                                                    0.528
                                                ],
                                                [
                                                    0,
                                                    0.924
                                                ],
                                                [
                                                    0.372,
                                                    0.528
                                                ],
                                                [
                                                    0.636,
                                                    0
                                                ],
                                                [
                                                    0.312,
                                                    -0.228
                                                ],
                                                [
                                                    0.168,
                                                    -0.444
                                                ],
                                                [
                                                    0,
                                                    -0.648
                                                ],
                                                [
                                                    -0.156,
                                                    -0.444
                                                ],
                                                [
                                                    -0.3,
                                                    -0.228
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.636,
                                                    0
                                                ],
                                                [
                                                    0.372,
                                                    -0.528
                                                ],
                                                [
                                                    0,
                                                    -0.924
                                                ],
                                                [
                                                    -0.36,
                                                    -0.528
                                                ],
                                                [
                                                    -0.42,
                                                    0
                                                ],
                                                [
                                                    -0.3,
                                                    0.216
                                                ],
                                                [
                                                    -0.156,
                                                    0.444
                                                ],
                                                [
                                                    0,
                                                    0.648
                                                ],
                                                [
                                                    0.168,
                                                    0.444
                                                ],
                                                [
                                                    0.312,
                                                    0.216
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -35.521,
                                                    3.222
                                                ],
                                                [
                                                    -34.027,
                                                    2.43
                                                ],
                                                [
                                                    -33.469,
                                                    0.252
                                                ],
                                                [
                                                    -34.027,
                                                    -1.926
                                                ],
                                                [
                                                    -35.521,
                                                    -2.718
                                                ],
                                                [
                                                    -36.619,
                                                    -2.376
                                                ],
                                                [
                                                    -37.321,
                                                    -1.386
                                                ],
                                                [
                                                    -37.555,
                                                    0.252
                                                ],
                                                [
                                                    -37.321,
                                                    1.89
                                                ],
                                                [
                                                    -36.619,
                                                    2.898
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.54,
                                                    0.372
                                                ],
                                                [
                                                    -0.72,
                                                    0
                                                ],
                                                [
                                                    -0.599,
                                                    -0.444
                                                ],
                                                [
                                                    -0.299,
                                                    -0.768
                                                ],
                                                [
                                                    0,
                                                    -0.948
                                                ],
                                                [
                                                    0.313,
                                                    -0.768
                                                ],
                                                [
                                                    0.612,
                                                    -0.444
                                                ],
                                                [
                                                    0.899,
                                                    0
                                                ],
                                                [
                                                    0.408,
                                                    0.168
                                                ],
                                                [
                                                    0.299,
                                                    0.312
                                                ],
                                                [
                                                    0.133,
                                                    0.432
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.239,
                                                    -0.696
                                                ],
                                                [
                                                    0.541,
                                                    -0.372
                                                ],
                                                [
                                                    0.901,
                                                    0
                                                ],
                                                [
                                                    0.6,
                                                    0.444
                                                ],
                                                [
                                                    0.313,
                                                    0.756
                                                ],
                                                [
                                                    0,
                                                    0.936
                                                ],
                                                [
                                                    -0.299,
                                                    0.768
                                                ],
                                                [
                                                    -0.601,
                                                    0.444
                                                ],
                                                [
                                                    -0.469,
                                                    0
                                                ],
                                                [
                                                    -0.407,
                                                    -0.18
                                                ],
                                                [
                                                    -0.289,
                                                    -0.312
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -29.022,
                                                    7.776
                                                ],
                                                [
                                                    -29.022,
                                                    -4.572
                                                ],
                                                [
                                                    -26.431,
                                                    -4.572
                                                ],
                                                [
                                                    -26.377,
                                                    -2.538
                                                ],
                                                [
                                                    -26.592,
                                                    -2.628
                                                ],
                                                [
                                                    -25.423,
                                                    -4.23
                                                ],
                                                [
                                                    -23.533,
                                                    -4.788
                                                ],
                                                [
                                                    -21.283,
                                                    -4.122
                                                ],
                                                [
                                                    -19.933,
                                                    -2.304
                                                ],
                                                [
                                                    -19.465,
                                                    0.252
                                                ],
                                                [
                                                    -19.933,
                                                    2.808
                                                ],
                                                [
                                                    -21.3,
                                                    4.626
                                                ],
                                                [
                                                    -23.55,
                                                    5.292
                                                ],
                                                [
                                                    -24.865,
                                                    5.04
                                                ],
                                                [
                                                    -25.926,
                                                    4.302
                                                ],
                                                [
                                                    -26.557,
                                                    3.186
                                                ],
                                                [
                                                    -26.323,
                                                    3.042
                                                ],
                                                [
                                                    -26.323,
                                                    7.776
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.42,
                                                    0
                                                ],
                                                [
                                                    -0.36,
                                                    0.528
                                                ],
                                                [
                                                    0,
                                                    0.924
                                                ],
                                                [
                                                    0.372,
                                                    0.528
                                                ],
                                                [
                                                    0.636,
                                                    0
                                                ],
                                                [
                                                    0.312,
                                                    -0.228
                                                ],
                                                [
                                                    0.168,
                                                    -0.444
                                                ],
                                                [
                                                    0,
                                                    -0.648
                                                ],
                                                [
                                                    -0.155,
                                                    -0.444
                                                ],
                                                [
                                                    -0.3,
                                                    -0.228
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.636,
                                                    0
                                                ],
                                                [
                                                    0.372,
                                                    -0.528
                                                ],
                                                [
                                                    0,
                                                    -0.924
                                                ],
                                                [
                                                    -0.36,
                                                    -0.528
                                                ],
                                                [
                                                    -0.42,
                                                    0
                                                ],
                                                [
                                                    -0.3,
                                                    0.216
                                                ],
                                                [
                                                    -0.155,
                                                    0.444
                                                ],
                                                [
                                                    0,
                                                    0.648
                                                ],
                                                [
                                                    0.168,
                                                    0.444
                                                ],
                                                [
                                                    0.312,
                                                    0.216
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -24.289,
                                                    3.222
                                                ],
                                                [
                                                    -22.795,
                                                    2.43
                                                ],
                                                [
                                                    -22.237,
                                                    0.252
                                                ],
                                                [
                                                    -22.795,
                                                    -1.926
                                                ],
                                                [
                                                    -24.289,
                                                    -2.718
                                                ],
                                                [
                                                    -25.387,
                                                    -2.376
                                                ],
                                                [
                                                    -26.089,
                                                    -1.386
                                                ],
                                                [
                                                    -26.323,
                                                    0.252
                                                ],
                                                [
                                                    -26.089,
                                                    1.89
                                                ],
                                                [
                                                    -25.387,
                                                    2.898
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.984,
                                                    0
                                                ],
                                                [
                                                    0.733,
                                                    0.408
                                                ],
                                                [
                                                    0.408,
                                                    0.756
                                                ],
                                                [
                                                    0,
                                                    1.02
                                                ],
                                                [
                                                    -0.408,
                                                    0.744
                                                ],
                                                [
                                                    -0.732,
                                                    0.42
                                                ],
                                                [
                                                    -0.984,
                                                    0
                                                ],
                                                [
                                                    -0.733,
                                                    -0.42
                                                ],
                                                [
                                                    -0.409,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.02
                                                ],
                                                [
                                                    0.407,
                                                    -0.756
                                                ],
                                                [
                                                    0.731,
                                                    -0.42
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.984,
                                                    0
                                                ],
                                                [
                                                    -0.732,
                                                    -0.42
                                                ],
                                                [
                                                    -0.408,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.02
                                                ],
                                                [
                                                    0.408,
                                                    -0.756
                                                ],
                                                [
                                                    0.733,
                                                    -0.42
                                                ],
                                                [
                                                    0.984,
                                                    0
                                                ],
                                                [
                                                    0.731,
                                                    0.42
                                                ],
                                                [
                                                    0.407,
                                                    0.744
                                                ],
                                                [
                                                    0,
                                                    1.02
                                                ],
                                                [
                                                    -0.409,
                                                    0.756
                                                ],
                                                [
                                                    -0.733,
                                                    0.408
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -13.417,
                                                    5.292
                                                ],
                                                [
                                                    -15.991,
                                                    4.68
                                                ],
                                                [
                                                    -17.701,
                                                    2.916
                                                ],
                                                [
                                                    -18.312,
                                                    0.252
                                                ],
                                                [
                                                    -17.701,
                                                    -2.394
                                                ],
                                                [
                                                    -15.991,
                                                    -4.158
                                                ],
                                                [
                                                    -13.417,
                                                    -4.788
                                                ],
                                                [
                                                    -10.842,
                                                    -4.158
                                                ],
                                                [
                                                    -9.132,
                                                    -2.394
                                                ],
                                                [
                                                    -8.521,
                                                    0.252
                                                ],
                                                [
                                                    -9.132,
                                                    2.916
                                                ],
                                                [
                                                    -10.842,
                                                    4.68
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.672,
                                                    0
                                                ],
                                                [
                                                    -0.372,
                                                    0.516
                                                ],
                                                [
                                                    0,
                                                    0.936
                                                ],
                                                [
                                                    0.372,
                                                    0.516
                                                ],
                                                [
                                                    0.673,
                                                    0
                                                ],
                                                [
                                                    0.371,
                                                    -0.528
                                                ],
                                                [
                                                    0,
                                                    -0.936
                                                ],
                                                [
                                                    -0.372,
                                                    -0.528
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.673,
                                                    0
                                                ],
                                                [
                                                    0.372,
                                                    -0.528
                                                ],
                                                [
                                                    0,
                                                    -0.936
                                                ],
                                                [
                                                    -0.372,
                                                    -0.528
                                                ],
                                                [
                                                    -0.672,
                                                    0
                                                ],
                                                [
                                                    -0.372,
                                                    0.516
                                                ],
                                                [
                                                    0,
                                                    0.936
                                                ],
                                                [
                                                    0.371,
                                                    0.516
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -13.417,
                                                    3.222
                                                ],
                                                [
                                                    -11.851,
                                                    2.448
                                                ],
                                                [
                                                    -11.293,
                                                    0.252
                                                ],
                                                [
                                                    -11.851,
                                                    -1.926
                                                ],
                                                [
                                                    -13.417,
                                                    -2.718
                                                ],
                                                [
                                                    -14.982,
                                                    -1.926
                                                ],
                                                [
                                                    -15.541,
                                                    0.252
                                                ],
                                                [
                                                    -14.982,
                                                    2.448
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.397,
                                                    0.432
                                                ],
                                                [
                                                    -0.696,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.325,
                                                    -0.132
                                                ],
                                                [
                                                    0.168,
                                                    -0.288
                                                ],
                                                [
                                                    0,
                                                    -0.492
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.156,
                                                    -0.972
                                                ],
                                                [
                                                    0.395,
                                                    -0.432
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.505,
                                                    0
                                                ],
                                                [
                                                    -0.324,
                                                    0.132
                                                ],
                                                [
                                                    -0.156,
                                                    0.288
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -6.839,
                                                    5.076
                                                ],
                                                [
                                                    -6.839,
                                                    -4.572
                                                ],
                                                [
                                                    -4.283,
                                                    -4.572
                                                ],
                                                [
                                                    -4.193,
                                                    -1.764
                                                ],
                                                [
                                                    -4.391,
                                                    -1.818
                                                ],
                                                [
                                                    -3.562,
                                                    -3.924
                                                ],
                                                [
                                                    -1.924,
                                                    -4.572
                                                ],
                                                [
                                                    -1.043,
                                                    -4.572
                                                ],
                                                [
                                                    -1.043,
                                                    -2.34
                                                ],
                                                [
                                                    -1.924,
                                                    -2.34
                                                ],
                                                [
                                                    -3.167,
                                                    -2.142
                                                ],
                                                [
                                                    -3.905,
                                                    -1.512
                                                ],
                                                [
                                                    -4.139,
                                                    -0.342
                                                ],
                                                [
                                                    -4.139,
                                                    5.076
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.468,
                                                    0.456
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    -0.168
                                                ],
                                                [
                                                    -0.397,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.995,
                                                    0
                                                ],
                                                [
                                                    -0.467,
                                                    -0.468
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.468
                                                ],
                                                [
                                                    0.205,
                                                    0.168
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.223,
                                                    5.076
                                                ],
                                                [
                                                    2.027,
                                                    4.392
                                                ],
                                                [
                                                    1.326,
                                                    2.178
                                                ],
                                                [
                                                    1.326,
                                                    -6.84
                                                ],
                                                [
                                                    4.025,
                                                    -6.84
                                                ],
                                                [
                                                    4.025,
                                                    1.854
                                                ],
                                                [
                                                    4.313,
                                                    2.808
                                                ],
                                                [
                                                    5.214,
                                                    3.06
                                                ],
                                                [
                                                    6.563,
                                                    3.06
                                                ],
                                                [
                                                    6.563,
                                                    5.076
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.223,
                                                    -2.556
                                                ],
                                                [
                                                    -0.223,
                                                    -4.572
                                                ],
                                                [
                                                    6.563,
                                                    -4.572
                                                ],
                                                [
                                                    6.563,
                                                    -2.556
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    11.493,
                                                    5.076
                                                ],
                                                [
                                                    16.101,
                                                    -7.704
                                                ],
                                                [
                                                    19.34,
                                                    -7.704
                                                ],
                                                [
                                                    23.948,
                                                    5.076
                                                ],
                                                [
                                                    21.104,
                                                    5.076
                                                ],
                                                [
                                                    20.168,
                                                    2.358
                                                ],
                                                [
                                                    15.254,
                                                    2.358
                                                ],
                                                [
                                                    14.319,
                                                    5.076
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    16.028,
                                                    0.108
                                                ],
                                                [
                                                    19.412,
                                                    0.108
                                                ],
                                                [
                                                    17.72,
                                                    -4.824
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 14",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.935,
                                                    0
                                                ],
                                                [
                                                    0.625,
                                                    0.228
                                                ],
                                                [
                                                    0.372,
                                                    0.408
                                                ],
                                                [
                                                    0.143,
                                                    0.528
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.263,
                                                    -0.18
                                                ],
                                                [
                                                    -0.552,
                                                    0
                                                ],
                                                [
                                                    -0.336,
                                                    0.312
                                                ],
                                                [
                                                    0,
                                                    0.672
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.504,
                                                    -0.276
                                                ],
                                                [
                                                    0.625,
                                                    0
                                                ],
                                                [
                                                    0.612,
                                                    0.384
                                                ],
                                                [
                                                    0.347,
                                                    0.696
                                                ],
                                                [
                                                    0,
                                                    0.948
                                                ],
                                                [
                                                    -0.337,
                                                    0.708
                                                ],
                                                [
                                                    -0.601,
                                                    0.396
                                                ],
                                                [
                                                    -0.779,
                                                    0
                                                ],
                                                [
                                                    -0.479,
                                                    -0.312
                                                ],
                                                [
                                                    -0.252,
                                                    -0.516
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.396,
                                                    -0.564
                                                ],
                                                [
                                                    0.707,
                                                    -0.288
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.925,
                                                    0
                                                ],
                                                [
                                                    -0.612,
                                                    -0.228
                                                ],
                                                [
                                                    -0.36,
                                                    -0.408
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.095,
                                                    0.312
                                                ],
                                                [
                                                    0.276,
                                                    0.18
                                                ],
                                                [
                                                    0.647,
                                                    0
                                                ],
                                                [
                                                    0.347,
                                                    -0.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.229,
                                                    0.444
                                                ],
                                                [
                                                    -0.504,
                                                    0.264
                                                ],
                                                [
                                                    -0.791,
                                                    0
                                                ],
                                                [
                                                    -0.612,
                                                    -0.396
                                                ],
                                                [
                                                    -0.337,
                                                    -0.708
                                                ],
                                                [
                                                    0,
                                                    -0.924
                                                ],
                                                [
                                                    0.347,
                                                    -0.708
                                                ],
                                                [
                                                    0.612,
                                                    -0.408
                                                ],
                                                [
                                                    0.708,
                                                    0
                                                ],
                                                [
                                                    0.493,
                                                    0.312
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.864
                                                ],
                                                [
                                                    -0.395,
                                                    0.576
                                                ],
                                                [
                                                    -0.709,
                                                    0.288
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29.351,
                                                    7.992
                                                ],
                                                [
                                                    27.028,
                                                    7.65
                                                ],
                                                [
                                                    25.552,
                                                    6.696
                                                ],
                                                [
                                                    24.797,
                                                    5.292
                                                ],
                                                [
                                                    27.569,
                                                    5.094
                                                ],
                                                [
                                                    28.108,
                                                    5.832
                                                ],
                                                [
                                                    29.351,
                                                    6.102
                                                ],
                                                [
                                                    30.827,
                                                    5.634
                                                ],
                                                [
                                                    31.349,
                                                    4.176
                                                ],
                                                [
                                                    31.349,
                                                    3.15
                                                ],
                                                [
                                                    30.25,
                                                    4.23
                                                ],
                                                [
                                                    28.558,
                                                    4.626
                                                ],
                                                [
                                                    26.452,
                                                    4.05
                                                ],
                                                [
                                                    25.013,
                                                    2.412
                                                ],
                                                [
                                                    24.508,
                                                    -0.072
                                                ],
                                                [
                                                    25.013,
                                                    -2.52
                                                ],
                                                [
                                                    26.435,
                                                    -4.176
                                                ],
                                                [
                                                    28.522,
                                                    -4.788
                                                ],
                                                [
                                                    30.304,
                                                    -4.32
                                                ],
                                                [
                                                    31.42,
                                                    -3.078
                                                ],
                                                [
                                                    31.42,
                                                    -4.572
                                                ],
                                                [
                                                    34.067,
                                                    -4.572
                                                ],
                                                [
                                                    34.067,
                                                    4.122
                                                ],
                                                [
                                                    33.472,
                                                    6.264
                                                ],
                                                [
                                                    31.817,
                                                    7.56
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 15",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.623,
                                                    0
                                                ],
                                                [
                                                    -0.36,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0.852
                                                ],
                                                [
                                                    0.168,
                                                    0.408
                                                ],
                                                [
                                                    0.312,
                                                    0.216
                                                ],
                                                [
                                                    0.42,
                                                    0
                                                ],
                                                [
                                                    0.36,
                                                    -0.492
                                                ],
                                                [
                                                    0,
                                                    -0.828
                                                ],
                                                [
                                                    -0.372,
                                                    -0.492
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.625,
                                                    0
                                                ],
                                                [
                                                    0.373,
                                                    -0.48
                                                ],
                                                [
                                                    0,
                                                    -0.564
                                                ],
                                                [
                                                    -0.155,
                                                    -0.408
                                                ],
                                                [
                                                    -0.3,
                                                    -0.216
                                                ],
                                                [
                                                    -0.647,
                                                    0
                                                ],
                                                [
                                                    -0.36,
                                                    0.492
                                                ],
                                                [
                                                    0,
                                                    0.84
                                                ],
                                                [
                                                    0.373,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29.332,
                                                    2.628
                                                ],
                                                [
                                                    30.808,
                                                    1.908
                                                ],
                                                [
                                                    31.366,
                                                    -0.09
                                                ],
                                                [
                                                    31.114,
                                                    -1.548
                                                ],
                                                [
                                                    30.412,
                                                    -2.484
                                                ],
                                                [
                                                    29.332,
                                                    -2.808
                                                ],
                                                [
                                                    27.821,
                                                    -2.07
                                                ],
                                                [
                                                    27.28,
                                                    -0.09
                                                ],
                                                [
                                                    27.838,
                                                    1.908
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 16",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    1.164,
                                                    0
                                                ],
                                                [
                                                    0.732,
                                                    0.408
                                                ],
                                                [
                                                    0.409,
                                                    0.756
                                                ],
                                                [
                                                    0,
                                                    1.02
                                                ],
                                                [
                                                    -0.396,
                                                    0.744
                                                ],
                                                [
                                                    -0.72,
                                                    0.42
                                                ],
                                                [
                                                    -0.983,
                                                    0
                                                ],
                                                [
                                                    -0.707,
                                                    -0.42
                                                ],
                                                [
                                                    -0.384,
                                                    -0.78
                                                ],
                                                [
                                                    0,
                                                    -1.08
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.371,
                                                    -0.372
                                                ],
                                                [
                                                    -0.625,
                                                    0
                                                ],
                                                [
                                                    -0.3,
                                                    0.192
                                                ],
                                                [
                                                    -0.131,
                                                    0.396
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.815,
                                                    -0.54
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.985,
                                                    0
                                                ],
                                                [
                                                    -0.72,
                                                    -0.42
                                                ],
                                                [
                                                    -0.396,
                                                    -0.756
                                                ],
                                                [
                                                    0,
                                                    -1.02
                                                ],
                                                [
                                                    0.409,
                                                    -0.756
                                                ],
                                                [
                                                    0.72,
                                                    -0.42
                                                ],
                                                [
                                                    0.961,
                                                    0
                                                ],
                                                [
                                                    0.709,
                                                    0.42
                                                ],
                                                [
                                                    0.396,
                                                    0.78
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.037,
                                                    0.768
                                                ],
                                                [
                                                    0.384,
                                                    0.372
                                                ],
                                                [
                                                    0.455,
                                                    0
                                                ],
                                                [
                                                    0.312,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.252,
                                                    0.96
                                                ],
                                                [
                                                    -0.817,
                                                    0.54
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    40.601,
                                                    5.292
                                                ],
                                                [
                                                    38.026,
                                                    4.68
                                                ],
                                                [
                                                    36.334,
                                                    2.916
                                                ],
                                                [
                                                    35.741,
                                                    0.252
                                                ],
                                                [
                                                    36.334,
                                                    -2.394
                                                ],
                                                [
                                                    38.026,
                                                    -4.158
                                                ],
                                                [
                                                    40.582,
                                                    -4.788
                                                ],
                                                [
                                                    43.084,
                                                    -4.158
                                                ],
                                                [
                                                    44.722,
                                                    -2.358
                                                ],
                                                [
                                                    45.317,
                                                    0.432
                                                ],
                                                [
                                                    45.317,
                                                    0.972
                                                ],
                                                [
                                                    38.53,
                                                    0.972
                                                ],
                                                [
                                                    39.142,
                                                    2.682
                                                ],
                                                [
                                                    40.655,
                                                    3.24
                                                ],
                                                [
                                                    41.789,
                                                    2.952
                                                ],
                                                [
                                                    42.454,
                                                    2.07
                                                ],
                                                [
                                                    45.172,
                                                    2.232
                                                ],
                                                [
                                                    43.571,
                                                    4.482
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 17",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.073,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.36,
                                                    0.348
                                                ],
                                                [
                                                    0.564,
                                                    0
                                                ],
                                                [
                                                    0.371,
                                                    -0.372
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.037,
                                                    -0.708
                                                ],
                                                [
                                                    -0.347,
                                                    -0.348
                                                ],
                                                [
                                                    -0.563,
                                                    0
                                                ],
                                                [
                                                    -0.36,
                                                    0.36
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    38.53,
                                                    -0.684
                                                ],
                                                [
                                                    42.545,
                                                    -0.684
                                                ],
                                                [
                                                    41.95,
                                                    -2.268
                                                ],
                                                [
                                                    40.582,
                                                    -2.79
                                                ],
                                                [
                                                    39.179,
                                                    -2.232
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 18",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.287,
                                                    0.432
                                                ],
                                                [
                                                    -0.444,
                                                    0.192
                                                ],
                                                [
                                                    -0.528,
                                                    0
                                                ],
                                                [
                                                    -0.479,
                                                    -0.3
                                                ],
                                                [
                                                    -0.252,
                                                    -0.552
                                                ],
                                                [
                                                    0,
                                                    -0.744
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.084,
                                                    0.36
                                                ],
                                                [
                                                    0.215,
                                                    0.18
                                                ],
                                                [
                                                    0.384,
                                                    0
                                                ],
                                                [
                                                    0.299,
                                                    -0.42
                                                ],
                                                [
                                                    0,
                                                    -0.78
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.097,
                                                    -0.72
                                                ],
                                                [
                                                    0.301,
                                                    -0.432
                                                ],
                                                [
                                                    0.444,
                                                    -0.192
                                                ],
                                                [
                                                    0.696,
                                                    0
                                                ],
                                                [
                                                    0.493,
                                                    0.3
                                                ],
                                                [
                                                    0.265,
                                                    0.54
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.516
                                                ],
                                                [
                                                    -0.084,
                                                    -0.36
                                                ],
                                                [
                                                    -0.216,
                                                    -0.192
                                                ],
                                                [
                                                    -0.563,
                                                    0
                                                ],
                                                [
                                                    -0.3,
                                                    0.408
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    46.985,
                                                    5.076
                                                ],
                                                [
                                                    46.985,
                                                    -4.572
                                                ],
                                                [
                                                    49.416,
                                                    -4.572
                                                ],
                                                [
                                                    49.523,
                                                    -1.746
                                                ],
                                                [
                                                    49.181,
                                                    -1.836
                                                ],
                                                [
                                                    49.757,
                                                    -3.564
                                                ],
                                                [
                                                    50.873,
                                                    -4.5
                                                ],
                                                [
                                                    52.332,
                                                    -4.788
                                                ],
                                                [
                                                    54.095,
                                                    -4.338
                                                ],
                                                [
                                                    55.211,
                                                    -3.06
                                                ],
                                                [
                                                    55.607,
                                                    -1.134
                                                ],
                                                [
                                                    55.607,
                                                    5.076
                                                ],
                                                [
                                                    52.907,
                                                    5.076
                                                ],
                                                [
                                                    52.907,
                                                    -0.234
                                                ],
                                                [
                                                    52.782,
                                                    -1.548
                                                ],
                                                [
                                                    52.332,
                                                    -2.358
                                                ],
                                                [
                                                    51.431,
                                                    -2.646
                                                ],
                                                [
                                                    50.136,
                                                    -2.016
                                                ],
                                                [
                                                    49.685,
                                                    -0.234
                                                ],
                                                [
                                                    49.685,
                                                    5.076
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 19",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.468,
                                                    0.456
                                                ],
                                                [
                                                    0,
                                                    1.008
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    -0.168
                                                ],
                                                [
                                                    -0.396,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.997,
                                                    0
                                                ],
                                                [
                                                    -0.469,
                                                    -0.468
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.468
                                                ],
                                                [
                                                    0.204,
                                                    0.168
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    61.353,
                                                    5.076
                                                ],
                                                [
                                                    59.157,
                                                    4.392
                                                ],
                                                [
                                                    58.454,
                                                    2.178
                                                ],
                                                [
                                                    58.454,
                                                    -6.84
                                                ],
                                                [
                                                    61.155,
                                                    -6.84
                                                ],
                                                [
                                                    61.155,
                                                    1.854
                                                ],
                                                [
                                                    61.442,
                                                    2.808
                                                ],
                                                [
                                                    62.342,
                                                    3.06
                                                ],
                                                [
                                                    63.692,
                                                    3.06
                                                ],
                                                [
                                                    63.692,
                                                    5.076
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 20",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    56.907,
                                                    -2.556
                                                ],
                                                [
                                                    56.907,
                                                    -4.572
                                                ],
                                                [
                                                    63.692,
                                                    -4.572
                                                ],
                                                [
                                                    63.692,
                                                    -2.556
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0,
                                            0
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            122.629,
                                            120.924
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 13",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -6.351,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -6.351
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    6.351,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    6.351
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    6.351,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    6.351
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -6.351,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -6.351
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -228.5,
                                                    -53.5
                                                ],
                                                [
                                                    228.5,
                                                    -53.5
                                                ],
                                                [
                                                    240,
                                                    -42
                                                ],
                                                [
                                                    240,
                                                    42
                                                ],
                                                [
                                                    228.5,
                                                    53.5
                                                ],
                                                [
                                                    -228.5,
                                                    53.5
                                                ],
                                                [
                                                    -240,
                                                    42
                                                ],
                                                [
                                                    -240,
                                                    -42
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 1,
                                    "lj": 1,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.8392,
                                            0.8392,
                                            0.8392
                                        ]
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.9373,
                                            0.9373,
                                            0.9373
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            278.5,
                                            147
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 14",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.784,
                                                    0
                                                ],
                                                [
                                                    0.584,
                                                    0.36
                                                ],
                                                [
                                                    0.312,
                                                    0.664
                                                ],
                                                [
                                                    0,
                                                    0.904
                                                ],
                                                [
                                                    -0.311,
                                                    0.672
                                                ],
                                                [
                                                    -0.576,
                                                    0.36
                                                ],
                                                [
                                                    -0.784,
                                                    0
                                                ],
                                                [
                                                    -0.577,
                                                    -0.36
                                                ],
                                                [
                                                    -0.312,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.912
                                                ],
                                                [
                                                    0.312,
                                                    -0.672
                                                ],
                                                [
                                                    0.583,
                                                    -0.36
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.784,
                                                    0
                                                ],
                                                [
                                                    -0.576,
                                                    -0.36
                                                ],
                                                [
                                                    -0.311,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.912
                                                ],
                                                [
                                                    0.312,
                                                    -0.672
                                                ],
                                                [
                                                    0.584,
                                                    -0.36
                                                ],
                                                [
                                                    0.784,
                                                    0
                                                ],
                                                [
                                                    0.583,
                                                    0.36
                                                ],
                                                [
                                                    0.312,
                                                    0.672
                                                ],
                                                [
                                                    0,
                                                    0.904
                                                ],
                                                [
                                                    -0.312,
                                                    0.664
                                                ],
                                                [
                                                    -0.577,
                                                    0.36
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -13.242,
                                                    4.452
                                                ],
                                                [
                                                    -15.294,
                                                    3.912
                                                ],
                                                [
                                                    -16.626,
                                                    2.376
                                                ],
                                                [
                                                    -17.094,
                                                    0.012
                                                ],
                                                [
                                                    -16.626,
                                                    -2.364
                                                ],
                                                [
                                                    -15.294,
                                                    -3.912
                                                ],
                                                [
                                                    -13.242,
                                                    -4.452
                                                ],
                                                [
                                                    -11.201,
                                                    -3.912
                                                ],
                                                [
                                                    -9.858,
                                                    -2.364
                                                ],
                                                [
                                                    -9.39,
                                                    0.012
                                                ],
                                                [
                                                    -9.858,
                                                    2.376
                                                ],
                                                [
                                                    -11.201,
                                                    3.912
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.6,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.264
                                                ],
                                                [
                                                    -0.216,
                                                    0.512
                                                ],
                                                [
                                                    0,
                                                    0.736
                                                ],
                                                [
                                                    0.216,
                                                    0.52
                                                ],
                                                [
                                                    0.416,
                                                    0.272
                                                ],
                                                [
                                                    0.6,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    -0.272
                                                ],
                                                [
                                                    0.216,
                                                    -0.52
                                                ],
                                                [
                                                    0,
                                                    -0.736
                                                ],
                                                [
                                                    -0.216,
                                                    -0.52
                                                ],
                                                [
                                                    -0.416,
                                                    -0.272
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.6,
                                                    0
                                                ],
                                                [
                                                    0.416,
                                                    -0.272
                                                ],
                                                [
                                                    0.216,
                                                    -0.52
                                                ],
                                                [
                                                    0,
                                                    -0.736
                                                ],
                                                [
                                                    -0.216,
                                                    -0.52
                                                ],
                                                [
                                                    -0.416,
                                                    -0.272
                                                ],
                                                [
                                                    -0.6,
                                                    0
                                                ],
                                                [
                                                    -0.416,
                                                    0.272
                                                ],
                                                [
                                                    -0.216,
                                                    0.52
                                                ],
                                                [
                                                    0,
                                                    0.736
                                                ],
                                                [
                                                    0.216,
                                                    0.512
                                                ],
                                                [
                                                    0.416,
                                                    0.264
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -13.242,
                                                    3.468
                                                ],
                                                [
                                                    -11.718,
                                                    3.072
                                                ],
                                                [
                                                    -10.77,
                                                    1.896
                                                ],
                                                [
                                                    -10.446,
                                                    0.012
                                                ],
                                                [
                                                    -10.77,
                                                    -1.872
                                                ],
                                                [
                                                    -11.718,
                                                    -3.06
                                                ],
                                                [
                                                    -13.242,
                                                    -3.468
                                                ],
                                                [
                                                    -14.766,
                                                    -3.06
                                                ],
                                                [
                                                    -15.714,
                                                    -1.872
                                                ],
                                                [
                                                    -16.038,
                                                    0.012
                                                ],
                                                [
                                                    -15.714,
                                                    1.896
                                                ],
                                                [
                                                    -14.766,
                                                    3.072
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.376,
                                                    0.272
                                                ],
                                                [
                                                    -0.528,
                                                    0
                                                ],
                                                [
                                                    -0.368,
                                                    -0.448
                                                ],
                                                [
                                                    0,
                                                    -0.712
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.096,
                                                    0.264
                                                ],
                                                [
                                                    0.2,
                                                    0.136
                                                ],
                                                [
                                                    0.32,
                                                    0
                                                ],
                                                [
                                                    0.304,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.584
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.104,
                                                    -0.544
                                                ],
                                                [
                                                    0.376,
                                                    -0.28
                                                ],
                                                [
                                                    0.696,
                                                    0
                                                ],
                                                [
                                                    0.368,
                                                    0.448
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.4
                                                ],
                                                [
                                                    -0.096,
                                                    -0.272
                                                ],
                                                [
                                                    -0.2,
                                                    -0.144
                                                ],
                                                [
                                                    -0.528,
                                                    0
                                                ],
                                                [
                                                    -0.304,
                                                    0.312
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -7.113,
                                                    -2.1
                                                ],
                                                [
                                                    -7.065,
                                                    -0.468
                                                ],
                                                [
                                                    -7.197,
                                                    -0.6
                                                ],
                                                [
                                                    -6.477,
                                                    -1.824
                                                ],
                                                [
                                                    -5.121,
                                                    -2.244
                                                ],
                                                [
                                                    -3.525,
                                                    -1.572
                                                ],
                                                [
                                                    -2.973,
                                                    0.168
                                                ],
                                                [
                                                    -2.973,
                                                    4.26
                                                ],
                                                [
                                                    -3.957,
                                                    4.26
                                                ],
                                                [
                                                    -3.957,
                                                    0.456
                                                ],
                                                [
                                                    -4.101,
                                                    -0.54
                                                ],
                                                [
                                                    -4.545,
                                                    -1.152
                                                ],
                                                [
                                                    -5.325,
                                                    -1.368
                                                ],
                                                [
                                                    -6.573,
                                                    -0.888
                                                ],
                                                [
                                                    -7.029,
                                                    0.456
                                                ],
                                                [
                                                    -7.029,
                                                    4.26
                                                ],
                                                [
                                                    -8.013,
                                                    4.26
                                                ],
                                                [
                                                    -8.013,
                                                    -2.1
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.064,
                                                    -0.064
                                                ],
                                                [
                                                    -0.136,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.232,
                                                    0.224
                                                ],
                                                [
                                                    0,
                                                    0.36
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.136
                                                ],
                                                [
                                                    0.072,
                                                    0.064
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.376,
                                                    0
                                                ],
                                                [
                                                    -0.224,
                                                    -0.232
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.161,
                                                    -4.26
                                                ],
                                                [
                                                    -0.161,
                                                    2.988
                                                ],
                                                [
                                                    -0.065,
                                                    3.288
                                                ],
                                                [
                                                    0.247,
                                                    3.384
                                                ],
                                                [
                                                    0.787,
                                                    3.384
                                                ],
                                                [
                                                    0.787,
                                                    4.26
                                                ],
                                                [
                                                    0.103,
                                                    4.26
                                                ],
                                                [
                                                    -0.809,
                                                    3.924
                                                ],
                                                [
                                                    -1.145,
                                                    3.036
                                                ],
                                                [
                                                    -1.145,
                                                    -4.26
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.178,
                                                    -2.1
                                                ],
                                                [
                                                    3.178,
                                                    4.26
                                                ],
                                                [
                                                    2.194,
                                                    4.26
                                                ],
                                                [
                                                    2.194,
                                                    -2.1
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.202,
                                                    -4.236
                                                ],
                                                [
                                                    3.202,
                                                    -3.096
                                                ],
                                                [
                                                    2.17,
                                                    -3.096
                                                ],
                                                [
                                                    2.17,
                                                    -4.236
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.376,
                                                    0.272
                                                ],
                                                [
                                                    -0.528,
                                                    0
                                                ],
                                                [
                                                    -0.368,
                                                    -0.448
                                                ],
                                                [
                                                    0,
                                                    -0.712
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.096,
                                                    0.264
                                                ],
                                                [
                                                    0.2,
                                                    0.136
                                                ],
                                                [
                                                    0.32,
                                                    0
                                                ],
                                                [
                                                    0.304,
                                                    -0.32
                                                ],
                                                [
                                                    0,
                                                    -0.584
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.104,
                                                    -0.544
                                                ],
                                                [
                                                    0.376,
                                                    -0.28
                                                ],
                                                [
                                                    0.696,
                                                    0
                                                ],
                                                [
                                                    0.368,
                                                    0.448
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.4
                                                ],
                                                [
                                                    -0.096,
                                                    -0.272
                                                ],
                                                [
                                                    -0.2,
                                                    -0.144
                                                ],
                                                [
                                                    -0.527,
                                                    0
                                                ],
                                                [
                                                    -0.304,
                                                    0.312
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    5.942,
                                                    -2.1
                                                ],
                                                [
                                                    5.99,
                                                    -0.468
                                                ],
                                                [
                                                    5.858,
                                                    -0.6
                                                ],
                                                [
                                                    6.578,
                                                    -1.824
                                                ],
                                                [
                                                    7.933,
                                                    -2.244
                                                ],
                                                [
                                                    9.529,
                                                    -1.572
                                                ],
                                                [
                                                    10.081,
                                                    0.168
                                                ],
                                                [
                                                    10.081,
                                                    4.26
                                                ],
                                                [
                                                    9.097,
                                                    4.26
                                                ],
                                                [
                                                    9.097,
                                                    0.456
                                                ],
                                                [
                                                    8.953,
                                                    -0.54
                                                ],
                                                [
                                                    8.509,
                                                    -1.152
                                                ],
                                                [
                                                    7.729,
                                                    -1.368
                                                ],
                                                [
                                                    6.482,
                                                    -0.888
                                                ],
                                                [
                                                    6.026,
                                                    0.456
                                                ],
                                                [
                                                    6.026,
                                                    4.26
                                                ],
                                                [
                                                    5.042,
                                                    4.26
                                                ],
                                                [
                                                    5.042,
                                                    -2.1
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0.672
                                                ],
                                                [
                                                    -0.24,
                                                    0.496
                                                ],
                                                [
                                                    -0.431,
                                                    0.272
                                                ],
                                                [
                                                    -0.584,
                                                    0
                                                ],
                                                [
                                                    -0.4,
                                                    -0.224
                                                ],
                                                [
                                                    -0.248,
                                                    -0.48
                                                ],
                                                [
                                                    -0.032,
                                                    -0.72
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.32,
                                                    -0.368
                                                ],
                                                [
                                                    -0.544,
                                                    0
                                                ],
                                                [
                                                    -0.288,
                                                    0.192
                                                ],
                                                [
                                                    -0.144,
                                                    0.336
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.488,
                                                    -0.352
                                                ],
                                                [
                                                    0.616,
                                                    0
                                                ],
                                                [
                                                    0.44,
                                                    0.272
                                                ],
                                                [
                                                    0.24,
                                                    0.496
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -0.672
                                                ],
                                                [
                                                    0.24,
                                                    -0.504
                                                ],
                                                [
                                                    0.44,
                                                    -0.272
                                                ],
                                                [
                                                    0.496,
                                                    0
                                                ],
                                                [
                                                    0.408,
                                                    0.224
                                                ],
                                                [
                                                    0.256,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.048,
                                                    0.656
                                                ],
                                                [
                                                    0.328,
                                                    0.36
                                                ],
                                                [
                                                    0.353,
                                                    0
                                                ],
                                                [
                                                    0.288,
                                                    -0.192
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.184,
                                                    0.592
                                                ],
                                                [
                                                    -0.488,
                                                    0.352
                                                ],
                                                [
                                                    -0.584,
                                                    0
                                                ],
                                                [
                                                    -0.431,
                                                    -0.272
                                                ],
                                                [
                                                    -0.24,
                                                    -0.504
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    11.417,
                                                    1.08
                                                ],
                                                [
                                                    11.777,
                                                    -0.672
                                                ],
                                                [
                                                    12.785,
                                                    -1.836
                                                ],
                                                [
                                                    14.321,
                                                    -2.244
                                                ],
                                                [
                                                    15.665,
                                                    -1.908
                                                ],
                                                [
                                                    16.649,
                                                    -0.852
                                                ],
                                                [
                                                    17.081,
                                                    0.948
                                                ],
                                                [
                                                    17.093,
                                                    1.392
                                                ],
                                                [
                                                    12.461,
                                                    1.392
                                                ],
                                                [
                                                    13.013,
                                                    2.928
                                                ],
                                                [
                                                    14.321,
                                                    3.468
                                                ],
                                                [
                                                    15.281,
                                                    3.18
                                                ],
                                                [
                                                    15.929,
                                                    2.388
                                                ],
                                                [
                                                    16.985,
                                                    2.46
                                                ],
                                                [
                                                    15.977,
                                                    3.876
                                                ],
                                                [
                                                    14.321,
                                                    4.404
                                                ],
                                                [
                                                    12.785,
                                                    3.996
                                                ],
                                                [
                                                    11.777,
                                                    2.844
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.304,
                                                    0.288
                                                ],
                                                [
                                                    0.432,
                                                    0
                                                ],
                                                [
                                                    0.312,
                                                    -0.32
                                                ],
                                                [
                                                    0.088,
                                                    -0.584
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.088,
                                                    -0.632
                                                ],
                                                [
                                                    -0.304,
                                                    -0.296
                                                ],
                                                [
                                                    -0.512,
                                                    0
                                                ],
                                                [
                                                    -0.312,
                                                    0.312
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    16.013,
                                                    0.516
                                                ],
                                                [
                                                    15.425,
                                                    -0.864
                                                ],
                                                [
                                                    14.321,
                                                    -1.308
                                                ],
                                                [
                                                    13.085,
                                                    -0.828
                                                ],
                                                [
                                                    12.485,
                                                    0.516
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.9333,
                                            0.9255,
                                            0.9255
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            92.682,
                                            43.24
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 15",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -2.485,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.485
                                                ],
                                                [
                                                    2.485,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.485
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    2.485,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    2.485
                                                ],
                                                [
                                                    -2.485,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -2.485
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    -4.5
                                                ],
                                                [
                                                    4.5,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    4.5
                                                ],
                                                [
                                                    -4.5,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.1216,
                                            0.7569,
                                            0.4196
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            62.5,
                                            43.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 16",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -54.146,
                                                    4.456
                                                ],
                                                [
                                                    -50.05,
                                                    -6.904
                                                ],
                                                [
                                                    -47.506,
                                                    -6.904
                                                ],
                                                [
                                                    -43.41,
                                                    4.456
                                                ],
                                                [
                                                    -45.587,
                                                    4.456
                                                ],
                                                [
                                                    -46.531,
                                                    1.768
                                                ],
                                                [
                                                    -51.027,
                                                    1.768
                                                ],
                                                [
                                                    -51.971,
                                                    4.456
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -50.418,
                                                    -0.008
                                                ],
                                                [
                                                    -47.139,
                                                    -0.008
                                                ],
                                                [
                                                    -48.771,
                                                    -4.808
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 3",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.811,
                                                    0
                                                ],
                                                [
                                                    0.534,
                                                    0.203
                                                ],
                                                [
                                                    0.331,
                                                    0.373
                                                ],
                                                [
                                                    0.128,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.256,
                                                    -0.181
                                                ],
                                                [
                                                    -0.554,
                                                    0
                                                ],
                                                [
                                                    -0.341,
                                                    0.288
                                                ],
                                                [
                                                    0,
                                                    0.597
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.448,
                                                    -0.256
                                                ],
                                                [
                                                    0.555,
                                                    0
                                                ],
                                                [
                                                    0.555,
                                                    0.341
                                                ],
                                                [
                                                    0.31,
                                                    0.619
                                                ],
                                                [
                                                    0,
                                                    0.821
                                                ],
                                                [
                                                    -0.298,
                                                    0.619
                                                ],
                                                [
                                                    -0.544,
                                                    0.352
                                                ],
                                                [
                                                    -0.704,
                                                    0
                                                ],
                                                [
                                                    -0.448,
                                                    -0.277
                                                ],
                                                [
                                                    -0.202,
                                                    -0.459
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.342,
                                                    -0.501
                                                ],
                                                [
                                                    0.608,
                                                    -0.245
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.746,
                                                    0
                                                ],
                                                [
                                                    -0.533,
                                                    -0.203
                                                ],
                                                [
                                                    -0.32,
                                                    -0.363
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.107,
                                                    0.32
                                                ],
                                                [
                                                    0.267,
                                                    0.181
                                                ],
                                                [
                                                    0.63,
                                                    0
                                                ],
                                                [
                                                    0.342,
                                                    -0.277
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.202,
                                                    0.416
                                                ],
                                                [
                                                    -0.448,
                                                    0.245
                                                ],
                                                [
                                                    -0.704,
                                                    0
                                                ],
                                                [
                                                    -0.544,
                                                    -0.352
                                                ],
                                                [
                                                    -0.309,
                                                    -0.629
                                                ],
                                                [
                                                    0,
                                                    -0.821
                                                ],
                                                [
                                                    0.31,
                                                    -0.629
                                                ],
                                                [
                                                    0.544,
                                                    -0.363
                                                ],
                                                [
                                                    0.619,
                                                    0
                                                ],
                                                [
                                                    0.448,
                                                    0.277
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.725
                                                ],
                                                [
                                                    -0.33,
                                                    0.501
                                                ],
                                                [
                                                    -0.597,
                                                    0.256
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -38.714,
                                                    7.048
                                                ],
                                                [
                                                    -40.634,
                                                    6.744
                                                ],
                                                [
                                                    -41.93,
                                                    5.88
                                                ],
                                                [
                                                    -42.602,
                                                    4.616
                                                ],
                                                [
                                                    -40.49,
                                                    4.472
                                                ],
                                                [
                                                    -39.946,
                                                    5.224
                                                ],
                                                [
                                                    -38.714,
                                                    5.496
                                                ],
                                                [
                                                    -37.258,
                                                    5.064
                                                ],
                                                [
                                                    -36.746,
                                                    3.752
                                                ],
                                                [
                                                    -36.746,
                                                    2.664
                                                ],
                                                [
                                                    -37.722,
                                                    3.672
                                                ],
                                                [
                                                    -39.226,
                                                    4.04
                                                ],
                                                [
                                                    -41.114,
                                                    3.528
                                                ],
                                                [
                                                    -42.394,
                                                    2.072
                                                ],
                                                [
                                                    -42.858,
                                                    -0.104
                                                ],
                                                [
                                                    -42.41,
                                                    -2.264
                                                ],
                                                [
                                                    -41.13,
                                                    -3.736
                                                ],
                                                [
                                                    -39.258,
                                                    -4.28
                                                ],
                                                [
                                                    -37.658,
                                                    -3.864
                                                ],
                                                [
                                                    -36.682,
                                                    -2.76
                                                ],
                                                [
                                                    -36.682,
                                                    -4.088
                                                ],
                                                [
                                                    -34.682,
                                                    -4.088
                                                ],
                                                [
                                                    -34.682,
                                                    3.704
                                                ],
                                                [
                                                    -35.194,
                                                    5.544
                                                ],
                                                [
                                                    -36.602,
                                                    6.664
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 4",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -0.608,
                                                    0
                                                ],
                                                [
                                                    -0.362,
                                                    0.448
                                                ],
                                                [
                                                    -0.01,
                                                    0.8
                                                ],
                                                [
                                                    0.171,
                                                    0.373
                                                ],
                                                [
                                                    0.31,
                                                    0.203
                                                ],
                                                [
                                                    0.416,
                                                    0
                                                ],
                                                [
                                                    0.352,
                                                    -0.469
                                                ],
                                                [
                                                    0,
                                                    -0.779
                                                ],
                                                [
                                                    -0.352,
                                                    -0.469
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.608,
                                                    0
                                                ],
                                                [
                                                    0.363,
                                                    -0.459
                                                ],
                                                [
                                                    0.011,
                                                    -0.533
                                                ],
                                                [
                                                    -0.16,
                                                    -0.384
                                                ],
                                                [
                                                    -0.298,
                                                    -0.213
                                                ],
                                                [
                                                    -0.629,
                                                    0
                                                ],
                                                [
                                                    -0.341,
                                                    0.459
                                                ],
                                                [
                                                    0,
                                                    0.779
                                                ],
                                                [
                                                    0.363,
                                                    0.459
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -38.746,
                                                    2.44
                                                ],
                                                [
                                                    -37.29,
                                                    1.768
                                                ],
                                                [
                                                    -36.73,
                                                    -0.12
                                                ],
                                                [
                                                    -36.97,
                                                    -1.48
                                                ],
                                                [
                                                    -37.674,
                                                    -2.36
                                                ],
                                                [
                                                    -38.746,
                                                    -2.68
                                                ],
                                                [
                                                    -40.218,
                                                    -1.976
                                                ],
                                                [
                                                    -40.73,
                                                    -0.12
                                                ],
                                                [
                                                    -40.202,
                                                    1.752
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 5",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.981,
                                                    0
                                                ],
                                                [
                                                    0.629,
                                                    0.363
                                                ],
                                                [
                                                    0.341,
                                                    0.672
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.342,
                                                    0.661
                                                ],
                                                [
                                                    -0.619,
                                                    0.373
                                                ],
                                                [
                                                    -0.832,
                                                    0
                                                ],
                                                [
                                                    -0.608,
                                                    -0.363
                                                ],
                                                [
                                                    -0.331,
                                                    -0.683
                                                ],
                                                [
                                                    0,
                                                    -0.96
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.363,
                                                    -0.384
                                                ],
                                                [
                                                    -0.608,
                                                    0
                                                ],
                                                [
                                                    -0.299,
                                                    0.203
                                                ],
                                                [
                                                    -0.118,
                                                    0.373
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.693,
                                                    -0.48
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.854,
                                                    0
                                                ],
                                                [
                                                    -0.63,
                                                    -0.373
                                                ],
                                                [
                                                    -0.342,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.341,
                                                    -0.672
                                                ],
                                                [
                                                    0.629,
                                                    -0.373
                                                ],
                                                [
                                                    0.811,
                                                    0
                                                ],
                                                [
                                                    0.619,
                                                    0.363
                                                ],
                                                [
                                                    0.331,
                                                    0.683
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.042,
                                                    0.747
                                                ],
                                                [
                                                    0.373,
                                                    0.373
                                                ],
                                                [
                                                    0.459,
                                                    0
                                                ],
                                                [
                                                    0.309,
                                                    -0.213
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    0.832
                                                ],
                                                [
                                                    -0.683,
                                                    0.48
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -28.9,
                                                    4.648
                                                ],
                                                [
                                                    -31.124,
                                                    4.104
                                                ],
                                                [
                                                    -32.58,
                                                    2.536
                                                ],
                                                [
                                                    -33.092,
                                                    0.184
                                                ],
                                                [
                                                    -32.58,
                                                    -2.152
                                                ],
                                                [
                                                    -31.14,
                                                    -3.72
                                                ],
                                                [
                                                    -28.948,
                                                    -4.28
                                                ],
                                                [
                                                    -26.82,
                                                    -3.736
                                                ],
                                                [
                                                    -25.396,
                                                    -2.168
                                                ],
                                                [
                                                    -24.9,
                                                    0.296
                                                ],
                                                [
                                                    -24.9,
                                                    0.76
                                                ],
                                                [
                                                    -30.964,
                                                    0.76
                                                ],
                                                [
                                                    -30.356,
                                                    2.456
                                                ],
                                                [
                                                    -28.884,
                                                    3.016
                                                ],
                                                [
                                                    -27.748,
                                                    2.712
                                                ],
                                                [
                                                    -27.108,
                                                    1.832
                                                ],
                                                [
                                                    -25.012,
                                                    1.96
                                                ],
                                                [
                                                    -26.404,
                                                    3.928
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 6",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.085,
                                                    -0.661
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.352,
                                                    0.331
                                                ],
                                                [
                                                    0.544,
                                                    0
                                                ],
                                                [
                                                    0.362,
                                                    -0.352
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.043,
                                                    -0.693
                                                ],
                                                [
                                                    -0.352,
                                                    -0.341
                                                ],
                                                [
                                                    -0.544,
                                                    0
                                                ],
                                                [
                                                    -0.352,
                                                    0.352
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -30.964,
                                                    -0.616
                                                ],
                                                [
                                                    -27.012,
                                                    -0.616
                                                ],
                                                [
                                                    -27.604,
                                                    -2.152
                                                ],
                                                [
                                                    -28.948,
                                                    -2.664
                                                ],
                                                [
                                                    -30.308,
                                                    -2.136
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 7",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.267,
                                                    0.363
                                                ],
                                                [
                                                    -0.384,
                                                    0.171
                                                ],
                                                [
                                                    -0.459,
                                                    0
                                                ],
                                                [
                                                    -0.427,
                                                    -0.277
                                                ],
                                                [
                                                    -0.224,
                                                    -0.491
                                                ],
                                                [
                                                    0,
                                                    -0.64
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.096,
                                                    0.331
                                                ],
                                                [
                                                    0.224,
                                                    0.171
                                                ],
                                                [
                                                    0.362,
                                                    0
                                                ],
                                                [
                                                    0.33,
                                                    -0.384
                                                ],
                                                [
                                                    0,
                                                    -0.725
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.085,
                                                    -0.597
                                                ],
                                                [
                                                    0.266,
                                                    -0.363
                                                ],
                                                [
                                                    0.384,
                                                    -0.171
                                                ],
                                                [
                                                    0.629,
                                                    0
                                                ],
                                                [
                                                    0.437,
                                                    0.277
                                                ],
                                                [
                                                    0.224,
                                                    0.48
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.48
                                                ],
                                                [
                                                    -0.096,
                                                    -0.331
                                                ],
                                                [
                                                    -0.214,
                                                    -0.181
                                                ],
                                                [
                                                    -0.544,
                                                    0
                                                ],
                                                [
                                                    -0.32,
                                                    0.384
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -23.299,
                                                    4.456
                                                ],
                                                [
                                                    -23.299,
                                                    -4.088
                                                ],
                                                [
                                                    -21.443,
                                                    -4.088
                                                ],
                                                [
                                                    -21.363,
                                                    -1.688
                                                ],
                                                [
                                                    -21.603,
                                                    -1.784
                                                ],
                                                [
                                                    -21.075,
                                                    -3.224
                                                ],
                                                [
                                                    -20.099,
                                                    -4.024
                                                ],
                                                [
                                                    -18.835,
                                                    -4.28
                                                ],
                                                [
                                                    -17.251,
                                                    -3.864
                                                ],
                                                [
                                                    -16.259,
                                                    -2.712
                                                ],
                                                [
                                                    -15.923,
                                                    -1.032
                                                ],
                                                [
                                                    -15.923,
                                                    4.456
                                                ],
                                                [
                                                    -17.971,
                                                    4.456
                                                ],
                                                [
                                                    -17.971,
                                                    -0.376
                                                ],
                                                [
                                                    -18.115,
                                                    -1.592
                                                ],
                                                [
                                                    -18.595,
                                                    -2.344
                                                ],
                                                [
                                                    -19.459,
                                                    -2.616
                                                ],
                                                [
                                                    -20.771,
                                                    -2.04
                                                ],
                                                [
                                                    -21.251,
                                                    -0.376
                                                ],
                                                [
                                                    -21.251,
                                                    4.456
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 8",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    0.395
                                                ],
                                                [
                                                    0,
                                                    0.843
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.171,
                                                    -0.16
                                                ],
                                                [
                                                    -0.363,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.854,
                                                    0
                                                ],
                                                [
                                                    -0.394,
                                                    -0.395
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.395
                                                ],
                                                [
                                                    0.17,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -10.859,
                                                    4.456
                                                ],
                                                [
                                                    -12.748,
                                                    3.864
                                                ],
                                                [
                                                    -13.34,
                                                    2.008
                                                ],
                                                [
                                                    -13.34,
                                                    -6.088
                                                ],
                                                [
                                                    -11.292,
                                                    -6.088
                                                ],
                                                [
                                                    -11.292,
                                                    1.816
                                                ],
                                                [
                                                    -11.035,
                                                    2.648
                                                ],
                                                [
                                                    -10.236,
                                                    2.872
                                                ],
                                                [
                                                    -9.035,
                                                    2.872
                                                ],
                                                [
                                                    -9.035,
                                                    4.456
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 9",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -14.684,
                                                    -2.504
                                                ],
                                                [
                                                    -14.684,
                                                    -4.088
                                                ],
                                                [
                                                    -9.035,
                                                    -4.088
                                                ],
                                                [
                                                    -9.035,
                                                    -2.504
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 10",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -4.491,
                                                    4.456
                                                ],
                                                [
                                                    -0.395,
                                                    -6.904
                                                ],
                                                [
                                                    2.149,
                                                    -6.904
                                                ],
                                                [
                                                    6.245,
                                                    4.456
                                                ],
                                                [
                                                    4.069,
                                                    4.456
                                                ],
                                                [
                                                    3.125,
                                                    1.768
                                                ],
                                                [
                                                    -1.37,
                                                    1.768
                                                ],
                                                [
                                                    -2.314,
                                                    4.456
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 11",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -0.762,
                                                    -0.008
                                                ],
                                                [
                                                    2.518,
                                                    -0.008
                                                ],
                                                [
                                                    0.885,
                                                    -4.808
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 12",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0.736,
                                                    0
                                                ],
                                                [
                                                    0.628,
                                                    0.363
                                                ],
                                                [
                                                    0.351,
                                                    0.672
                                                ],
                                                [
                                                    0,
                                                    0.896
                                                ],
                                                [
                                                    -0.342,
                                                    0.661
                                                ],
                                                [
                                                    -0.63,
                                                    0.373
                                                ],
                                                [
                                                    -0.854,
                                                    0
                                                ],
                                                [
                                                    -0.564,
                                                    -0.256
                                                ],
                                                [
                                                    -0.352,
                                                    -0.48
                                                ],
                                                [
                                                    -0.085,
                                                    -0.683
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.34,
                                                    0.277
                                                ],
                                                [
                                                    0.49,
                                                    0
                                                ],
                                                [
                                                    0.363,
                                                    -0.501
                                                ],
                                                [
                                                    0,
                                                    -0.875
                                                ],
                                                [
                                                    -0.363,
                                                    -0.491
                                                ],
                                                [
                                                    -0.662,
                                                    0
                                                ],
                                                [
                                                    -0.332,
                                                    0.288
                                                ],
                                                [
                                                    -0.076,
                                                    0.608
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.352,
                                                    -0.501
                                                ],
                                                [
                                                    0.565,
                                                    -0.277
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.854,
                                                    0
                                                ],
                                                [
                                                    -0.63,
                                                    -0.373
                                                ],
                                                [
                                                    -0.342,
                                                    -0.672
                                                ],
                                                [
                                                    0,
                                                    -0.896
                                                ],
                                                [
                                                    0.351,
                                                    -0.672
                                                ],
                                                [
                                                    0.628,
                                                    -0.373
                                                ],
                                                [
                                                    0.724,
                                                    0
                                                ],
                                                [
                                                    0.565,
                                                    0.256
                                                ],
                                                [
                                                    0.364,
                                                    0.469
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.085,
                                                    -0.544
                                                ],
                                                [
                                                    -0.331,
                                                    -0.288
                                                ],
                                                [
                                                    -0.662,
                                                    0
                                                ],
                                                [
                                                    -0.363,
                                                    0.491
                                                ],
                                                [
                                                    0,
                                                    0.885
                                                ],
                                                [
                                                    0.363,
                                                    0.491
                                                ],
                                                [
                                                    0.5,
                                                    0
                                                ],
                                                [
                                                    0.34,
                                                    -0.288
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.085,
                                                    0.683
                                                ],
                                                [
                                                    -0.353,
                                                    0.501
                                                ],
                                                [
                                                    -0.564,
                                                    0.267
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    11.007,
                                                    4.648
                                                ],
                                                [
                                                    8.783,
                                                    4.104
                                                ],
                                                [
                                                    7.311,
                                                    2.536
                                                ],
                                                [
                                                    6.799,
                                                    0.184
                                                ],
                                                [
                                                    7.311,
                                                    -2.152
                                                ],
                                                [
                                                    8.783,
                                                    -3.72
                                                ],
                                                [
                                                    11.007,
                                                    -4.28
                                                ],
                                                [
                                                    12.942,
                                                    -3.896
                                                ],
                                                [
                                                    14.318,
                                                    -2.792
                                                ],
                                                [
                                                    14.991,
                                                    -1.064
                                                ],
                                                [
                                                    12.879,
                                                    -0.952
                                                ],
                                                [
                                                    12.239,
                                                    -2.184
                                                ],
                                                [
                                                    11.007,
                                                    -2.616
                                                ],
                                                [
                                                    9.47,
                                                    -1.864
                                                ],
                                                [
                                                    8.926,
                                                    0.184
                                                ],
                                                [
                                                    9.47,
                                                    2.248
                                                ],
                                                [
                                                    11.007,
                                                    2.984
                                                ],
                                                [
                                                    12.255,
                                                    2.552
                                                ],
                                                [
                                                    12.879,
                                                    1.208
                                                ],
                                                [
                                                    14.991,
                                                    1.304
                                                ],
                                                [
                                                    14.335,
                                                    3.08
                                                ],
                                                [
                                                    12.958,
                                                    4.248
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 13",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.406,
                                                    0.395
                                                ],
                                                [
                                                    0,
                                                    0.843
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.171,
                                                    -0.16
                                                ],
                                                [
                                                    -0.364,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.853,
                                                    0
                                                ],
                                                [
                                                    -0.394,
                                                    -0.395
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.395
                                                ],
                                                [
                                                    0.172,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    19.546,
                                                    4.456
                                                ],
                                                [
                                                    17.658,
                                                    3.864
                                                ],
                                                [
                                                    17.066,
                                                    2.008
                                                ],
                                                [
                                                    17.066,
                                                    -6.088
                                                ],
                                                [
                                                    19.115,
                                                    -6.088
                                                ],
                                                [
                                                    19.115,
                                                    1.816
                                                ],
                                                [
                                                    19.37,
                                                    2.648
                                                ],
                                                [
                                                    20.171,
                                                    2.872
                                                ],
                                                [
                                                    21.37,
                                                    2.872
                                                ],
                                                [
                                                    21.37,
                                                    4.456
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 14",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    15.723,
                                                    -2.504
                                                ],
                                                [
                                                    15.723,
                                                    -4.088
                                                ],
                                                [
                                                    21.37,
                                                    -4.088
                                                ],
                                                [
                                                    21.37,
                                                    -2.504
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 15",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    22.747,
                                                    4.456
                                                ],
                                                [
                                                    22.747,
                                                    -4.088
                                                ],
                                                [
                                                    24.796,
                                                    -4.088
                                                ],
                                                [
                                                    24.796,
                                                    4.456
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 16",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    22.715,
                                                    -5.224
                                                ],
                                                [
                                                    22.715,
                                                    -7.048
                                                ],
                                                [
                                                    24.844,
                                                    -7.048
                                                ],
                                                [
                                                    24.844,
                                                    -5.224
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 17",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    29.225,
                                                    4.456
                                                ],
                                                [
                                                    26.104,
                                                    -4.088
                                                ],
                                                [
                                                    28.264,
                                                    -4.088
                                                ],
                                                [
                                                    30.441,
                                                    2.392
                                                ],
                                                [
                                                    32.617,
                                                    -4.088
                                                ],
                                                [
                                                    34.777,
                                                    -4.088
                                                ],
                                                [
                                                    31.656,
                                                    4.456
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 18",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    36.076,
                                                    4.456
                                                ],
                                                [
                                                    36.076,
                                                    -4.088
                                                ],
                                                [
                                                    38.124,
                                                    -4.088
                                                ],
                                                [
                                                    38.124,
                                                    4.456
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 19",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    36.044,
                                                    -5.224
                                                ],
                                                [
                                                    36.044,
                                                    -7.048
                                                ],
                                                [
                                                    38.171,
                                                    -7.048
                                                ],
                                                [
                                                    38.171,
                                                    -5.224
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 20",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.405,
                                                    0.395
                                                ],
                                                [
                                                    0,
                                                    0.843
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.17,
                                                    -0.16
                                                ],
                                                [
                                                    -0.362,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.853,
                                                    0
                                                ],
                                                [
                                                    -0.396,
                                                    -0.395
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0.395
                                                ],
                                                [
                                                    0.171,
                                                    0.149
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    43.266,
                                                    4.456
                                                ],
                                                [
                                                    41.378,
                                                    3.864
                                                ],
                                                [
                                                    40.785,
                                                    2.008
                                                ],
                                                [
                                                    40.785,
                                                    -6.088
                                                ],
                                                [
                                                    42.833,
                                                    -6.088
                                                ],
                                                [
                                                    42.833,
                                                    1.816
                                                ],
                                                [
                                                    43.089,
                                                    2.648
                                                ],
                                                [
                                                    43.889,
                                                    2.872
                                                ],
                                                [
                                                    45.089,
                                                    2.872
                                                ],
                                                [
                                                    45.089,
                                                    4.456
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 21",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    39.441,
                                                    -2.504
                                                ],
                                                [
                                                    39.441,
                                                    -4.088
                                                ],
                                                [
                                                    45.089,
                                                    -4.088
                                                ],
                                                [
                                                    45.089,
                                                    -2.504
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 22",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.128,
                                                    0.085
                                                ],
                                                [
                                                    -0.076,
                                                    0.203
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.353,
                                                    -0.235
                                                ],
                                                [
                                                    0.619,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.278,
                                                    0
                                                ],
                                                [
                                                    0.138,
                                                    -0.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.192,
                                                    0.533
                                                ],
                                                [
                                                    -0.341,
                                                    0.235
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    47.09,
                                                    6.856
                                                ],
                                                [
                                                    47.09,
                                                    5.272
                                                ],
                                                [
                                                    48.178,
                                                    5.272
                                                ],
                                                [
                                                    48.786,
                                                    5.144
                                                ],
                                                [
                                                    49.107,
                                                    4.712
                                                ],
                                                [
                                                    49.346,
                                                    4.12
                                                ],
                                                [
                                                    48.755,
                                                    4.12
                                                ],
                                                [
                                                    45.699,
                                                    -4.088
                                                ],
                                                [
                                                    47.826,
                                                    -4.088
                                                ],
                                                [
                                                    49.971,
                                                    2.2
                                                ],
                                                [
                                                    52.018,
                                                    -4.088
                                                ],
                                                [
                                                    54.146,
                                                    -4.088
                                                ],
                                                [
                                                    50.803,
                                                    5.352
                                                ],
                                                [
                                                    49.986,
                                                    6.504
                                                ],
                                                [
                                                    48.546,
                                                    6.856
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.9216,
                                            0.9216,
                                            0.9216
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            112.451,
                                            24.044
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 17",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.125,
                                                    0.359
                                                ],
                                                [
                                                    0.322,
                                                    0.203
                                                ],
                                                [
                                                    0.378,
                                                    -0.042
                                                ],
                                                [
                                                    0.269,
                                                    -0.268
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.064,
                                                    -0.325
                                                ],
                                                [
                                                    -0.127,
                                                    -0.306
                                                ],
                                                [
                                                    -0.276,
                                                    -0.184
                                                ],
                                                [
                                                    -0.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.08,
                                                    -0.041
                                                ],
                                                [
                                                    -0.052,
                                                    -0.072
                                                ],
                                                [
                                                    -0.012,
                                                    -0.089
                                                ],
                                                [
                                                    0.029,
                                                    -0.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.125,
                                                    -0.36
                                                ],
                                                [
                                                    -0.322,
                                                    -0.202
                                                ],
                                                [
                                                    -0.378,
                                                    0.042
                                                ],
                                                [
                                                    -0.269,
                                                    0.268
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.065,
                                                    0.325
                                                ],
                                                [
                                                    0.127,
                                                    0.306
                                                ],
                                                [
                                                    0.275,
                                                    0.184
                                                ],
                                                [
                                                    0.331,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.08,
                                                    0.041
                                                ],
                                                [
                                                    0.051,
                                                    0.073
                                                ],
                                                [
                                                    0.012,
                                                    0.088
                                                ],
                                                [
                                                    -0.03,
                                                    0.085
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.126,
                                                    -0.359
                                                ],
                                                [
                                                    -0.124,
                                                    -0.359
                                                ],
                                                [
                                                    -0.321,
                                                    -0.203
                                                ],
                                                [
                                                    -0.377,
                                                    0.042
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.235,
                                                    0.234
                                                ],
                                                [
                                                    -0.065,
                                                    0.325
                                                ],
                                                [
                                                    0.126,
                                                    0.306
                                                ],
                                                [
                                                    0.276,
                                                    0.185
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.089,
                                                    0
                                                ],
                                                [
                                                    0.079,
                                                    0.041
                                                ],
                                                [
                                                    0.051,
                                                    0.073
                                                ],
                                                [
                                                    0.012,
                                                    0.088
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.127,
                                                    0.359
                                                ],
                                                [
                                                    0.125,
                                                    0.359
                                                ],
                                                [
                                                    0.321,
                                                    0.203
                                                ],
                                                [
                                                    0.378,
                                                    -0.042
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.234,
                                                    -0.235
                                                ],
                                                [
                                                    0.064,
                                                    -0.326
                                                ],
                                                [
                                                    -0.127,
                                                    -0.306
                                                ],
                                                [
                                                    -0.276,
                                                    -0.184
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.09,
                                                    0
                                                ],
                                                [
                                                    -0.079,
                                                    -0.041
                                                ],
                                                [
                                                    -0.052,
                                                    -0.073
                                                ],
                                                [
                                                    -0.012,
                                                    -0.089
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    4.375,
                                                    -8.941
                                                ],
                                                [
                                                    4.377,
                                                    -10.049
                                                ],
                                                [
                                                    3.688,
                                                    -10.917
                                                ],
                                                [
                                                    2.608,
                                                    -11.165
                                                ],
                                                [
                                                    1.609,
                                                    -10.686
                                                ],
                                                [
                                                    -8.449,
                                                    -0.627
                                                ],
                                                [
                                                    -8.908,
                                                    0.231
                                                ],
                                                [
                                                    -8.813,
                                                    1.2
                                                ],
                                                [
                                                    -8.196,
                                                    1.952
                                                ],
                                                [
                                                    -7.265,
                                                    2.235
                                                ],
                                                [
                                                    -2.792,
                                                    2.235
                                                ],
                                                [
                                                    -2.535,
                                                    2.298
                                                ],
                                                [
                                                    -2.336,
                                                    2.471
                                                ],
                                                [
                                                    -2.239,
                                                    2.717
                                                ],
                                                [
                                                    -2.265,
                                                    2.98
                                                ],
                                                [
                                                    -4.374,
                                                    8.941
                                                ],
                                                [
                                                    -4.377,
                                                    10.05
                                                ],
                                                [
                                                    -3.687,
                                                    10.917
                                                ],
                                                [
                                                    -2.607,
                                                    11.165
                                                ],
                                                [
                                                    -1.608,
                                                    10.685
                                                ],
                                                [
                                                    8.451,
                                                    0.626
                                                ],
                                                [
                                                    8.909,
                                                    -0.232
                                                ],
                                                [
                                                    8.813,
                                                    -1.201
                                                ],
                                                [
                                                    8.196,
                                                    -1.953
                                                ],
                                                [
                                                    7.265,
                                                    -2.235
                                                ],
                                                [
                                                    2.798,
                                                    -2.235
                                                ],
                                                [
                                                    2.54,
                                                    -2.298
                                                ],
                                                [
                                                    2.341,
                                                    -2.471
                                                ],
                                                [
                                                    2.243,
                                                    -2.717
                                                ],
                                                [
                                                    2.27,
                                                    -2.981
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "gf",
                                    "nm": "Gradient Fill 1",
                                    "e": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            13.412
                                        ]
                                    },
                                    "g": {
                                        "p": 3,
                                        "k": {
                                            "a": 0,
                                            "k": [
                                                0,
                                                0.51372552,
                                                0.36078432,
                                                0.96078438,
                                                0.5,
                                                0.2941176635,
                                                0.6588235649999999,
                                                0.729411815,
                                                1,
                                                0.074509807,
                                                0.95686281,
                                                0.49803925
                                            ]
                                        }
                                    },
                                    "t": 1,
                                    "a": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "h": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            -13.412
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            33.999,
                                            31.998
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 18",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    -10.493,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -10.493
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    10.493,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    10.493
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    10.493,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    10.493
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -10.493,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -10.493
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    0,
                                                    -19
                                                ],
                                                [
                                                    0,
                                                    -19
                                                ],
                                                [
                                                    19,
                                                    0
                                                ],
                                                [
                                                    19,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    19
                                                ],
                                                [
                                                    0,
                                                    19
                                                ],
                                                [
                                                    -19,
                                                    0
                                                ],
                                                [
                                                    -19,
                                                    0
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.5255,
                                            0.3804,
                                            0.9529
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            34,
                                            32
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 19",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    3.624,
                                                    3.625
                                                ],
                                                [
                                                    -3.625,
                                                    -3.625
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "sh",
                                    "nm": "Path 2",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": false,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -3.624,
                                                    3.625
                                                ],
                                                [
                                                    3.625,
                                                    -3.625
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "mm",
                                    "nm": "Merge Paths 1",
                                    "mm": 1
                                },
                                {
                                    "ty": "st",
                                    "nm": "Stroke 1",
                                    "lc": 2,
                                    "lj": 2,
                                    "ml": 4,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    },
                                    "w": {
                                        "a": 0,
                                        "k": 1.813
                                    },
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            524.5,
                                            31.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 20",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    6.673
                                                ],
                                                [
                                                    6.674,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -6.673
                                                ],
                                                [
                                                    -6.673,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -6.673
                                                ],
                                                [
                                                    -6.673,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    6.673
                                                ],
                                                [
                                                    6.674,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    12.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -12.083
                                                ],
                                                [
                                                    -12.083,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    12.083
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.6863,
                                            0.5843,
                                            0.9961
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            524.5,
                                            31.501
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 21",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -13.255,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -13.255
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -13.255
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    13.255,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -278,
                                                    -7.5
                                                ],
                                                [
                                                    -254,
                                                    -31.5
                                                ],
                                                [
                                                    254,
                                                    -31.5
                                                ],
                                                [
                                                    278,
                                                    -7.5
                                                ],
                                                [
                                                    278,
                                                    31.5
                                                ],
                                                [
                                                    -278,
                                                    31.5
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.4196,
                                            0.2902,
                                            0.8
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            278,
                                            31.5
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        },
                        {
                            "ty": "gr",
                            "nm": "Group 22",
                            "it": [
                                {
                                    "ty": "sh",
                                    "nm": "Path 1",
                                    "d": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "c": true,
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -13.255,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -13.255
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    13.255,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    13.255
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0,
                                                    -13.255
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    13.255,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    13.255
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -13.255,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -278,
                                                    -242
                                                ],
                                                [
                                                    -254,
                                                    -266
                                                ],
                                                [
                                                    254,
                                                    -266
                                                ],
                                                [
                                                    278,
                                                    -242
                                                ],
                                                [
                                                    278,
                                                    242
                                                ],
                                                [
                                                    254,
                                                    266
                                                ],
                                                [
                                                    -254,
                                                    266
                                                ],
                                                [
                                                    -278,
                                                    242
                                                ]
                                            ]
                                        }
                                    }
                                },
                                {
                                    "ty": "fl",
                                    "nm": "Fill 1",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "r": 1,
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                },
                                {
                                    "ty": "tr",
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ]
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ]
                                    },
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            278,
                                            266
                                        ]
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100
                                    }
                                }
                            ]
                        }
                    ],
                    "ind": 1
                }
            ]
        }
    ]
};

//# sourceMappingURL=enterprise-ai-security-and-governance.ad9e2c53.js.map
